
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4340"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4340"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1Knfl", function(module, exports) {

$parcel$export(module.exports, "liteClient", () => $145c1e9185d1323a$export$f33d1b811c3510b4);
// lite/builds/browser.ts

var $2kcbl = parcelRequire("2kcbl");

var $1Rrjh = parcelRequire("1Rrjh");
var $145c1e9185d1323a$export$ad1dfbed11feb646 = "5.6.0";
function $145c1e9185d1323a$var$getDefaultHosts(appId) {
    return [
        {
            url: `${appId}-dsn.algolia.net`,
            accept: "read",
            protocol: "https"
        },
        {
            url: `${appId}.algolia.net`,
            accept: "write",
            protocol: "https"
        }
    ].concat((0, $2kcbl.shuffle)([
        {
            url: `${appId}-1.algolianet.com`,
            accept: "readWrite",
            protocol: "https"
        },
        {
            url: `${appId}-2.algolianet.com`,
            accept: "readWrite",
            protocol: "https"
        },
        {
            url: `${appId}-3.algolianet.com`,
            accept: "readWrite",
            protocol: "https"
        }
    ]));
}
function $145c1e9185d1323a$var$createLiteClient({ appId: appIdOption, apiKey: apiKeyOption, authMode: authMode, algoliaAgents: algoliaAgents, ...options }) {
    const auth = (0, $2kcbl.createAuth)(appIdOption, apiKeyOption, authMode);
    const transporter = (0, $2kcbl.createTransporter)({
        hosts: $145c1e9185d1323a$var$getDefaultHosts(appIdOption),
        ...options,
        algoliaAgent: (0, $2kcbl.getAlgoliaAgent)({
            algoliaAgents: algoliaAgents,
            client: "Lite",
            version: $145c1e9185d1323a$export$ad1dfbed11feb646
        }),
        baseHeaders: {
            "content-type": "text/plain",
            ...auth.headers(),
            ...options.baseHeaders
        },
        baseQueryParameters: {
            ...auth.queryParameters(),
            ...options.baseQueryParameters
        }
    });
    return {
        transporter: transporter,
        /**
     * The `appId` currently in use.
     */ appId: appIdOption,
        /**
     * Clears the cache of the transporter for the `requestsCache` and `responsesCache` properties.
     */ clearCache () {
            return Promise.all([
                transporter.requestsCache.clear(),
                transporter.responsesCache.clear()
            ]).then(()=>void 0);
        },
        /**
     * Get the value of the `algoliaAgent`, used by our libraries internally and telemetry system.
     */ get _ua () {
            return transporter.algoliaAgent.value;
        },
        /**
     * Adds a `segment` to the `x-algolia-agent` sent with every requests.
     *
     * @param segment - The algolia agent (user-agent) segment to add.
     * @param version - The version of the agent.
     */ addAlgoliaAgent (segment, version) {
            transporter.algoliaAgent.add({
                segment: segment,
                version: version
            });
        },
        /**
     * Helper method to switch the API key used to authenticate the requests.
     *
     * @param params - Method params.
     * @param params.apiKey - The new API Key to use.
     */ setClientApiKey ({ apiKey: apiKey }) {
            if (!authMode || authMode === "WithinHeaders") transporter.baseHeaders["x-algolia-api-key"] = apiKey;
            else transporter.baseQueryParameters["x-algolia-api-key"] = apiKey;
        },
        /**
     * Helper: calls the `search` method but with certainty that we will only request Algolia records (hits) and not facets.
     * Disclaimer: We don't assert that the parameters you pass to this method only contains `hits` requests to prevent impacting search performances, this helper is purely for typing purposes.
     *
     * @summary Search multiple indices for `hits`.
     * @param searchMethodParams - Query requests and strategies. Results will be received in the same order as the queries.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ searchForHits (searchMethodParams, requestOptions) {
            return this.search(searchMethodParams, requestOptions);
        },
        /**
     * Helper: calls the `search` method but with certainty that we will only request Algolia facets and not records (hits).
     * Disclaimer: We don't assert that the parameters you pass to this method only contains `facets` requests to prevent impacting search performances, this helper is purely for typing purposes.
     *
     * @summary Search multiple indices for `facets`.
     * @param searchMethodParams - Query requests and strategies. Results will be received in the same order as the queries.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ searchForFacets (searchMethodParams, requestOptions) {
            return this.search(searchMethodParams, requestOptions);
        },
        /**
     * This method allow you to send requests to the Algolia REST API.
     *
     * @param customPost - The customPost object.
     * @param customPost.path - Path of the endpoint, anything after \"/1\" must be specified.
     * @param customPost.parameters - Query parameters to apply to the current query.
     * @param customPost.body - Parameters to send with the custom request.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ customPost ({ path: path, parameters: parameters, body: body }, requestOptions) {
            if (!path) throw new Error("Parameter `path` is required when calling `customPost`.");
            const requestPath = "/{path}".replace("{path}", path);
            const headers = {};
            const queryParameters = parameters ? parameters : {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: body ? body : {}
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Retrieves recommendations from selected AI models.
     *
     * Required API Key ACLs:
     * - search.
     *
     * @param getRecommendationsParams - The getRecommendationsParams object.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ getRecommendations (getRecommendationsParams, requestOptions) {
            if (getRecommendationsParams && Array.isArray(getRecommendationsParams)) {
                const newSignatureRequest = {
                    requests: getRecommendationsParams
                };
                getRecommendationsParams = newSignatureRequest;
            }
            if (!getRecommendationsParams) throw new Error("Parameter `getRecommendationsParams` is required when calling `getRecommendations`.");
            if (!getRecommendationsParams.requests) throw new Error("Parameter `getRecommendationsParams.requests` is required when calling `getRecommendations`.");
            const requestPath = "/1/indexes/*/recommendations";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: getRecommendationsParams,
                useReadTransporter: true,
                cacheable: true
            };
            return transporter.request(request, requestOptions);
        },
        /**
     * Sends multiple search request to one or more indices.  This can be useful in these cases:  - Different indices for different purposes, such as, one index for products, another one for marketing content. - Multiple searches to the same index—for example, with different filters.
     *
     * Required API Key ACLs:
     * - search.
     *
     * @param searchMethodParams - Muli-search request body. Results are returned in the same order as the requests.
     * @param requestOptions - The requestOptions to send along with the query, they will be merged with the transporter requestOptions.
     */ search (searchMethodParams, requestOptions) {
            if (searchMethodParams && Array.isArray(searchMethodParams)) {
                const newSignatureRequest = {
                    requests: searchMethodParams.map(({ params: params, ...legacyRequest })=>{
                        if (legacyRequest.type === "facet") return {
                            ...legacyRequest,
                            ...params,
                            type: "facet"
                        };
                        return {
                            ...legacyRequest,
                            ...params,
                            facet: void 0,
                            maxFacetHits: void 0,
                            facetQuery: void 0
                        };
                    })
                };
                searchMethodParams = newSignatureRequest;
            }
            if (!searchMethodParams) throw new Error("Parameter `searchMethodParams` is required when calling `search`.");
            if (!searchMethodParams.requests) throw new Error("Parameter `searchMethodParams.requests` is required when calling `search`.");
            const requestPath = "/1/indexes/*/queries";
            const headers = {};
            const queryParameters = {};
            const request = {
                method: "POST",
                path: requestPath,
                queryParameters: queryParameters,
                headers: headers,
                data: searchMethodParams,
                useReadTransporter: true,
                cacheable: true
            };
            return transporter.request(request, requestOptions);
        }
    };
}
// lite/builds/browser.ts
function $145c1e9185d1323a$export$f33d1b811c3510b4(appId, apiKey, options) {
    if (!appId || typeof appId !== "string") throw new Error("`appId` is missing.");
    if (!apiKey || typeof apiKey !== "string") throw new Error("`apiKey` is missing.");
    return $145c1e9185d1323a$var$createLiteClient({
        appId: appId,
        apiKey: apiKey,
        timeouts: {
            connect: (0, $2kcbl.DEFAULT_CONNECT_TIMEOUT_BROWSER),
            read: (0, $2kcbl.DEFAULT_READ_TIMEOUT_BROWSER),
            write: (0, $2kcbl.DEFAULT_WRITE_TIMEOUT_BROWSER)
        },
        logger: (0, $2kcbl.createNullLogger)(),
        requester: (0, $1Rrjh.createXhrRequester)(),
        algoliaAgents: [
            {
                segment: "Browser"
            }
        ],
        authMode: "WithinQueryParameters",
        responsesCache: (0, $2kcbl.createMemoryCache)(),
        requestsCache: (0, $2kcbl.createMemoryCache)({
            serializable: false
        }),
        hostsCache: (0, $2kcbl.createFallbackableCache)({
            caches: [
                (0, $2kcbl.createBrowserLocalStorageCache)({
                    key: `${$145c1e9185d1323a$export$ad1dfbed11feb646}-${appId}`
                }),
                (0, $2kcbl.createMemoryCache)()
            ]
        }),
        ...options
    });
}

});
parcelRegister("2kcbl", function(module, exports) {

$parcel$export(module.exports, "createBrowserLocalStorageCache", () => $1b16e6171189b2b7$export$ca8cae1c5b20815a);
$parcel$export(module.exports, "createFallbackableCache", () => $1b16e6171189b2b7$export$8637a0800116df9b);
$parcel$export(module.exports, "createMemoryCache", () => $1b16e6171189b2b7$export$b1fc9484ccfcd328);
$parcel$export(module.exports, "DEFAULT_CONNECT_TIMEOUT_BROWSER", () => $1b16e6171189b2b7$export$1c9d677a000d9c75);
$parcel$export(module.exports, "DEFAULT_READ_TIMEOUT_BROWSER", () => $1b16e6171189b2b7$export$cc6130e78d57e416);
$parcel$export(module.exports, "DEFAULT_WRITE_TIMEOUT_BROWSER", () => $1b16e6171189b2b7$export$a36d433dda13154c);
$parcel$export(module.exports, "createAuth", () => $1b16e6171189b2b7$export$5f096e4c9da248bb);
$parcel$export(module.exports, "getAlgoliaAgent", () => $1b16e6171189b2b7$export$dc28410830ce888d);
$parcel$export(module.exports, "createNullLogger", () => $1b16e6171189b2b7$export$6d3f4ca34494bf2d);
$parcel$export(module.exports, "shuffle", () => $1b16e6171189b2b7$export$448332262467e042);
$parcel$export(module.exports, "createTransporter", () => $1b16e6171189b2b7$export$9f379e42258ad245);
// src/cache/createBrowserLocalStorageCache.ts
function $1b16e6171189b2b7$export$ca8cae1c5b20815a(options) {
    let storage;
    const namespaceKey = `algolia-client-js-${options.key}`;
    function getStorage() {
        if (storage === void 0) storage = options.localStorage || window.localStorage;
        return storage;
    }
    function getNamespace() {
        return JSON.parse(getStorage().getItem(namespaceKey) || "{}");
    }
    function setNamespace(namespace) {
        getStorage().setItem(namespaceKey, JSON.stringify(namespace));
    }
    function removeOutdatedCacheItems() {
        const timeToLive = options.timeToLive ? options.timeToLive * 1e3 : null;
        const namespace = getNamespace();
        const filteredNamespaceWithoutOldFormattedCacheItems = Object.fromEntries(Object.entries(namespace).filter(([, cacheItem])=>{
            return cacheItem.timestamp !== void 0;
        }));
        setNamespace(filteredNamespaceWithoutOldFormattedCacheItems);
        if (!timeToLive) return;
        const filteredNamespaceWithoutExpiredItems = Object.fromEntries(Object.entries(filteredNamespaceWithoutOldFormattedCacheItems).filter(([, cacheItem])=>{
            const currentTimestamp = /* @__PURE__ */ new Date().getTime();
            const isExpired = cacheItem.timestamp + timeToLive < currentTimestamp;
            return !isExpired;
        }));
        setNamespace(filteredNamespaceWithoutExpiredItems);
    }
    return {
        get (key, defaultValue, events = {
            miss: ()=>Promise.resolve()
        }) {
            return Promise.resolve().then(()=>{
                removeOutdatedCacheItems();
                return getNamespace()[JSON.stringify(key)];
            }).then((value)=>{
                return Promise.all([
                    value ? value.value : defaultValue(),
                    value !== void 0
                ]);
            }).then(([value, exists])=>{
                return Promise.all([
                    value,
                    exists || events.miss(value)
                ]);
            }).then(([value])=>value);
        },
        set (key, value) {
            return Promise.resolve().then(()=>{
                const namespace = getNamespace();
                namespace[JSON.stringify(key)] = {
                    timestamp: /* @__PURE__ */ new Date().getTime(),
                    value: value
                };
                getStorage().setItem(namespaceKey, JSON.stringify(namespace));
                return value;
            });
        },
        delete (key) {
            return Promise.resolve().then(()=>{
                const namespace = getNamespace();
                delete namespace[JSON.stringify(key)];
                getStorage().setItem(namespaceKey, JSON.stringify(namespace));
            });
        },
        clear () {
            return Promise.resolve().then(()=>{
                getStorage().removeItem(namespaceKey);
            });
        }
    };
}
// src/cache/createNullCache.ts
function $1b16e6171189b2b7$export$2774a8bf79d531b() {
    return {
        get (_key, defaultValue, events = {
            miss: ()=>Promise.resolve()
        }) {
            const value = defaultValue();
            return value.then((result)=>Promise.all([
                    result,
                    events.miss(result)
                ])).then(([result])=>result);
        },
        set (_key, value) {
            return Promise.resolve(value);
        },
        delete (_key) {
            return Promise.resolve();
        },
        clear () {
            return Promise.resolve();
        }
    };
}
// src/cache/createFallbackableCache.ts
function $1b16e6171189b2b7$export$8637a0800116df9b(options) {
    const caches = [
        ...options.caches
    ];
    const current = caches.shift();
    if (current === void 0) return $1b16e6171189b2b7$export$2774a8bf79d531b();
    return {
        get (key, defaultValue, events = {
            miss: ()=>Promise.resolve()
        }) {
            return current.get(key, defaultValue, events).catch(()=>{
                return $1b16e6171189b2b7$export$8637a0800116df9b({
                    caches: caches
                }).get(key, defaultValue, events);
            });
        },
        set (key, value) {
            return current.set(key, value).catch(()=>{
                return $1b16e6171189b2b7$export$8637a0800116df9b({
                    caches: caches
                }).set(key, value);
            });
        },
        delete (key) {
            return current.delete(key).catch(()=>{
                return $1b16e6171189b2b7$export$8637a0800116df9b({
                    caches: caches
                }).delete(key);
            });
        },
        clear () {
            return current.clear().catch(()=>{
                return $1b16e6171189b2b7$export$8637a0800116df9b({
                    caches: caches
                }).clear();
            });
        }
    };
}
// src/cache/createMemoryCache.ts
function $1b16e6171189b2b7$export$b1fc9484ccfcd328(options = {
    serializable: true
}) {
    let cache = {};
    return {
        get (key, defaultValue, events = {
            miss: ()=>Promise.resolve()
        }) {
            const keyAsString = JSON.stringify(key);
            if (keyAsString in cache) return Promise.resolve(options.serializable ? JSON.parse(cache[keyAsString]) : cache[keyAsString]);
            const promise = defaultValue();
            return promise.then((value)=>events.miss(value)).then(()=>promise);
        },
        set (key, value) {
            cache[JSON.stringify(key)] = options.serializable ? JSON.stringify(value) : value;
            return Promise.resolve(value);
        },
        delete (key) {
            delete cache[JSON.stringify(key)];
            return Promise.resolve();
        },
        clear () {
            cache = {};
            return Promise.resolve();
        }
    };
}
// src/constants.ts
var $1b16e6171189b2b7$export$1c9d677a000d9c75 = 1e3;
var $1b16e6171189b2b7$export$cc6130e78d57e416 = 2e3;
var $1b16e6171189b2b7$export$a36d433dda13154c = 3e4;
var $1b16e6171189b2b7$export$3d443caeeeeb0358 = 2e3;
var $1b16e6171189b2b7$export$da73fde44cbc636a = 5e3;
var $1b16e6171189b2b7$export$fdad022791f75c95 = 3e4;
// src/createAlgoliaAgent.ts
function $1b16e6171189b2b7$export$f3ef4b722067ac71(version) {
    const algoliaAgent = {
        value: `Algolia for JavaScript (${version})`,
        add (options) {
            const addedAlgoliaAgent = `; ${options.segment}${options.version !== void 0 ? ` (${options.version})` : ""}`;
            if (algoliaAgent.value.indexOf(addedAlgoliaAgent) === -1) algoliaAgent.value = `${algoliaAgent.value}${addedAlgoliaAgent}`;
            return algoliaAgent;
        }
    };
    return algoliaAgent;
}
// src/createAuth.ts
function $1b16e6171189b2b7$export$5f096e4c9da248bb(appId, apiKey, authMode = "WithinHeaders") {
    const credentials = {
        "x-algolia-api-key": apiKey,
        "x-algolia-application-id": appId
    };
    return {
        headers () {
            return authMode === "WithinHeaders" ? credentials : {};
        },
        queryParameters () {
            return authMode === "WithinQueryParameters" ? credentials : {};
        }
    };
}
// src/createIterablePromise.ts
function $1b16e6171189b2b7$export$d96db6d38a87ffce({ func: func, validate: validate, aggregator: aggregator, error: error, timeout: timeout = ()=>0 }) {
    const retry = (previousResponse)=>{
        return new Promise((resolve, reject)=>{
            func(previousResponse).then((response)=>{
                if (aggregator) aggregator(response);
                if (validate(response)) return resolve(response);
                if (error && error.validate(response)) return reject(new Error(error.message(response)));
                return setTimeout(()=>{
                    retry(response).then(resolve).catch(reject);
                }, timeout());
            }).catch((err)=>{
                reject(err);
            });
        });
    };
    return retry();
}
// src/getAlgoliaAgent.ts
function $1b16e6171189b2b7$export$dc28410830ce888d({ algoliaAgents: algoliaAgents, client: client, version: version }) {
    const defaultAlgoliaAgent = $1b16e6171189b2b7$export$f3ef4b722067ac71(version).add({
        segment: client,
        version: version
    });
    algoliaAgents.forEach((algoliaAgent)=>defaultAlgoliaAgent.add(algoliaAgent));
    return defaultAlgoliaAgent;
}
// src/logger/createNullLogger.ts
function $1b16e6171189b2b7$export$6d3f4ca34494bf2d() {
    return {
        debug (_message, _args) {
            return Promise.resolve();
        },
        info (_message, _args) {
            return Promise.resolve();
        },
        error (_message, _args) {
            return Promise.resolve();
        }
    };
}
// src/transporter/createStatefulHost.ts
var $1b16e6171189b2b7$var$EXPIRATION_DELAY = 120000;
function $1b16e6171189b2b7$export$3fb3dda619608b7(host, status = "up") {
    const lastUpdate = Date.now();
    function isUp() {
        return status === "up" || Date.now() - lastUpdate > $1b16e6171189b2b7$var$EXPIRATION_DELAY;
    }
    function isTimedOut() {
        return status === "timed out" && Date.now() - lastUpdate <= $1b16e6171189b2b7$var$EXPIRATION_DELAY;
    }
    return {
        ...host,
        status: status,
        lastUpdate: lastUpdate,
        isUp: isUp,
        isTimedOut: isTimedOut
    };
}
// src/transporter/errors.ts
var $1b16e6171189b2b7$export$94fb2163d3563f9d = class extends Error {
    name = "AlgoliaError";
    constructor(message, name){
        super(message);
        if (name) this.name = name;
    }
};
var $1b16e6171189b2b7$export$2fd7939d0c81cd0c = class extends $1b16e6171189b2b7$export$94fb2163d3563f9d {
    stackTrace;
    constructor(message, stackTrace, name){
        super(message, name);
        this.stackTrace = stackTrace;
    }
};
var $1b16e6171189b2b7$export$aa6cf8a4f695f0ee = class extends $1b16e6171189b2b7$export$2fd7939d0c81cd0c {
    constructor(stackTrace){
        super("Unreachable hosts - your application id may be incorrect. If the error persists, please reach out to the Algolia Support team: https://alg.li/support.", stackTrace, "RetryError");
    }
};
var $1b16e6171189b2b7$export$f2e832acab1bdd79 = class extends $1b16e6171189b2b7$export$2fd7939d0c81cd0c {
    status;
    constructor(message, status, stackTrace, name = "ApiError"){
        super(message, stackTrace, name);
        this.status = status;
    }
};
var $1b16e6171189b2b7$export$e711248598da7854 = class extends $1b16e6171189b2b7$export$94fb2163d3563f9d {
    response;
    constructor(message, response){
        super(message, "DeserializationError");
        this.response = response;
    }
};
var $1b16e6171189b2b7$export$5f44dadb2efd3cfb = class extends $1b16e6171189b2b7$export$f2e832acab1bdd79 {
    error;
    constructor(message, status, error, stackTrace){
        super(message, status, stackTrace, "DetailedApiError");
        this.error = error;
    }
};
// src/transporter/helpers.ts
function $1b16e6171189b2b7$export$448332262467e042(array) {
    const shuffledArray = array;
    for(let c = array.length - 1; c > 0; c--){
        const b = Math.floor(Math.random() * (c + 1));
        const a = array[c];
        shuffledArray[c] = array[b];
        shuffledArray[b] = a;
    }
    return shuffledArray;
}
function $1b16e6171189b2b7$export$102dee260a456972(host, path, queryParameters) {
    const queryParametersAsString = $1b16e6171189b2b7$export$b3f68c1f6e4b3e22(queryParameters);
    let url = `${host.protocol}://${host.url}${host.port ? `:${host.port}` : ""}/${path.charAt(0) === "/" ? path.substring(1) : path}`;
    if (queryParametersAsString.length) url += `?${queryParametersAsString}`;
    return url;
}
function $1b16e6171189b2b7$export$b3f68c1f6e4b3e22(parameters) {
    return Object.keys(parameters).filter((key)=>parameters[key] !== void 0).sort().map((key)=>`${key}=${encodeURIComponent(Object.prototype.toString.call(parameters[key]) === "[object Array]" ? parameters[key].join(",") : parameters[key]).replaceAll("+", "%20")}`).join("&");
}
function $1b16e6171189b2b7$export$b2290ffa247cf0a7(request, requestOptions) {
    if (request.method === "GET" || request.data === void 0 && requestOptions.data === void 0) return void 0;
    const data = Array.isArray(request.data) ? request.data : {
        ...request.data,
        ...requestOptions.data
    };
    return JSON.stringify(data);
}
function $1b16e6171189b2b7$export$dfd5dd9013041417(baseHeaders, requestHeaders, requestOptionsHeaders) {
    const headers = {
        Accept: "application/json",
        ...baseHeaders,
        ...requestHeaders,
        ...requestOptionsHeaders
    };
    const serializedHeaders = {};
    Object.keys(headers).forEach((header)=>{
        const value = headers[header];
        serializedHeaders[header.toLowerCase()] = value;
    });
    return serializedHeaders;
}
function $1b16e6171189b2b7$export$699210646009f15c(response) {
    try {
        return JSON.parse(response.content);
    } catch (e) {
        throw new $1b16e6171189b2b7$export$e711248598da7854(e.message, response);
    }
}
function $1b16e6171189b2b7$export$36794b0ec2a5c1b1({ content: content, status: status }, stackFrame) {
    try {
        const parsed = JSON.parse(content);
        if ("error" in parsed) return new $1b16e6171189b2b7$export$5f44dadb2efd3cfb(parsed.message, status, parsed.error, stackFrame);
        return new $1b16e6171189b2b7$export$f2e832acab1bdd79(parsed.message, status, stackFrame);
    } catch  {}
    return new $1b16e6171189b2b7$export$f2e832acab1bdd79(content, status, stackFrame);
}
// src/transporter/responses.ts
function $1b16e6171189b2b7$export$476aa014e2fd89d5({ isTimedOut: isTimedOut, status: status }) {
    return !isTimedOut && ~~status === 0;
}
function $1b16e6171189b2b7$export$f146c102d7613638({ isTimedOut: isTimedOut, status: status }) {
    return isTimedOut || $1b16e6171189b2b7$export$476aa014e2fd89d5({
        isTimedOut: isTimedOut,
        status: status
    }) || ~~(status / 100) !== 2 && ~~(status / 100) !== 4;
}
function $1b16e6171189b2b7$export$b0ac3e614a309be3({ status: status }) {
    return ~~(status / 100) === 2;
}
// src/transporter/stackTrace.ts
function $1b16e6171189b2b7$export$719a2b5349a98bb0(stackTrace) {
    return stackTrace.map((stackFrame)=>$1b16e6171189b2b7$export$e8a46da9420defe9(stackFrame));
}
function $1b16e6171189b2b7$export$e8a46da9420defe9(stackFrame) {
    const modifiedHeaders = stackFrame.request.headers["x-algolia-api-key"] ? {
        "x-algolia-api-key": "*****"
    } : {};
    return {
        ...stackFrame,
        request: {
            ...stackFrame.request,
            headers: {
                ...stackFrame.request.headers,
                ...modifiedHeaders
            }
        }
    };
}
// src/transporter/createTransporter.ts
function $1b16e6171189b2b7$export$9f379e42258ad245({ hosts: hosts, hostsCache: hostsCache, baseHeaders: baseHeaders, logger: logger, baseQueryParameters: baseQueryParameters, algoliaAgent: algoliaAgent, timeouts: timeouts, requester: requester, requestsCache: requestsCache, responsesCache: responsesCache }) {
    async function createRetryableOptions(compatibleHosts) {
        const statefulHosts = await Promise.all(compatibleHosts.map((compatibleHost)=>{
            return hostsCache.get(compatibleHost, ()=>{
                return Promise.resolve($1b16e6171189b2b7$export$3fb3dda619608b7(compatibleHost));
            });
        }));
        const hostsUp = statefulHosts.filter((host)=>host.isUp());
        const hostsTimedOut = statefulHosts.filter((host)=>host.isTimedOut());
        const hostsAvailable = [
            ...hostsUp,
            ...hostsTimedOut
        ];
        const compatibleHostsAvailable = hostsAvailable.length > 0 ? hostsAvailable : compatibleHosts;
        return {
            hosts: compatibleHostsAvailable,
            getTimeout (timeoutsCount, baseTimeout) {
                const timeoutMultiplier = hostsTimedOut.length === 0 && timeoutsCount === 0 ? 1 : hostsTimedOut.length + 3 + timeoutsCount;
                return timeoutMultiplier * baseTimeout;
            }
        };
    }
    async function retryableRequest(request, requestOptions, isRead = true) {
        const stackTrace = [];
        const data = $1b16e6171189b2b7$export$b2290ffa247cf0a7(request, requestOptions);
        const headers = $1b16e6171189b2b7$export$dfd5dd9013041417(baseHeaders, request.headers, requestOptions.headers);
        const dataQueryParameters = request.method === "GET" ? {
            ...request.data,
            ...requestOptions.data
        } : {};
        const queryParameters = {
            ...baseQueryParameters,
            ...request.queryParameters,
            ...dataQueryParameters
        };
        if (algoliaAgent.value) queryParameters["x-algolia-agent"] = algoliaAgent.value;
        if (requestOptions && requestOptions.queryParameters) {
            for (const key of Object.keys(requestOptions.queryParameters))if (!requestOptions.queryParameters[key] || Object.prototype.toString.call(requestOptions.queryParameters[key]) === "[object Object]") queryParameters[key] = requestOptions.queryParameters[key];
            else queryParameters[key] = requestOptions.queryParameters[key].toString();
        }
        let timeoutsCount = 0;
        const retry = async (retryableHosts, getTimeout)=>{
            const host = retryableHosts.pop();
            if (host === void 0) throw new $1b16e6171189b2b7$export$aa6cf8a4f695f0ee($1b16e6171189b2b7$export$719a2b5349a98bb0(stackTrace));
            const timeout = {
                ...timeouts,
                ...requestOptions.timeouts
            };
            const payload = {
                data: data,
                headers: headers,
                method: request.method,
                url: $1b16e6171189b2b7$export$102dee260a456972(host, request.path, queryParameters),
                connectTimeout: getTimeout(timeoutsCount, timeout.connect),
                responseTimeout: getTimeout(timeoutsCount, isRead ? timeout.read : timeout.write)
            };
            const pushToStackTrace = (response2)=>{
                const stackFrame = {
                    request: payload,
                    response: response2,
                    host: host,
                    triesLeft: retryableHosts.length
                };
                stackTrace.push(stackFrame);
                return stackFrame;
            };
            const response = await requester.send(payload);
            if ($1b16e6171189b2b7$export$f146c102d7613638(response)) {
                const stackFrame = pushToStackTrace(response);
                if (response.isTimedOut) timeoutsCount++;
                logger.info("Retryable failure", $1b16e6171189b2b7$export$e8a46da9420defe9(stackFrame));
                await hostsCache.set(host, $1b16e6171189b2b7$export$3fb3dda619608b7(host, response.isTimedOut ? "timed out" : "down"));
                return retry(retryableHosts, getTimeout);
            }
            if ($1b16e6171189b2b7$export$b0ac3e614a309be3(response)) return $1b16e6171189b2b7$export$699210646009f15c(response);
            pushToStackTrace(response);
            throw $1b16e6171189b2b7$export$36794b0ec2a5c1b1(response, stackTrace);
        };
        const compatibleHosts = hosts.filter((host)=>host.accept === "readWrite" || (isRead ? host.accept === "read" : host.accept === "write"));
        const options = await createRetryableOptions(compatibleHosts);
        return retry([
            ...options.hosts
        ].reverse(), options.getTimeout);
    }
    function createRequest(request, requestOptions = {}) {
        const isRead = request.useReadTransporter || request.method === "GET";
        if (!isRead) return retryableRequest(request, requestOptions, isRead);
        const createRetryableRequest = ()=>{
            return retryableRequest(request, requestOptions);
        };
        const cacheable = requestOptions.cacheable || request.cacheable;
        if (cacheable !== true) return createRetryableRequest();
        const key = {
            request: request,
            requestOptions: requestOptions,
            transporter: {
                queryParameters: baseQueryParameters,
                headers: baseHeaders
            }
        };
        return responsesCache.get(key, ()=>{
            return requestsCache.get(key, ()=>/**
             * Finally, if there is no request in progress with the same key,
             * this `createRetryableRequest()` will actually trigger the
             * retryable request.
             */ requestsCache.set(key, createRetryableRequest()).then((response)=>Promise.all([
                        requestsCache.delete(key),
                        response
                    ]), (err)=>Promise.all([
                        requestsCache.delete(key),
                        Promise.reject(err)
                    ])).then(([_, response])=>response));
        }, {
            /**
         * Of course, once we get this response back from the server, we
         * tell response cache to actually store the received response
         * to be used later.
         */ miss: (response)=>responsesCache.set(key, response)
        });
    }
    return {
        hostsCache: hostsCache,
        requester: requester,
        timeouts: timeouts,
        logger: logger,
        algoliaAgent: algoliaAgent,
        baseHeaders: baseHeaders,
        baseQueryParameters: baseQueryParameters,
        hosts: hosts,
        request: createRequest,
        requestsCache: requestsCache,
        responsesCache: responsesCache
    };
}
// src/types/logger.ts
var $1b16e6171189b2b7$export$d65602050420b80d = {
    Debug: 1,
    Info: 2,
    Error: 3
};

});

parcelRegister("1Rrjh", function(module, exports) {

$parcel$export(module.exports, "createXhrRequester", () => $15afecddb0111d91$export$2b053666affad54a);
function $15afecddb0111d91$export$2b053666affad54a() {
    function r(t) {
        return new Promise((s)=>{
            let e = new XMLHttpRequest;
            e.open(t.method, t.url, !0), Object.keys(t.headers).forEach((n)=>e.setRequestHeader(n, t.headers[n]));
            let i = (n, a)=>setTimeout(()=>{
                    e.abort(), s({
                        status: 0,
                        content: a,
                        isTimedOut: !0
                    });
                }, n), u = i(t.connectTimeout, "Connection timeout"), o;
            e.onreadystatechange = ()=>{
                e.readyState > e.OPENED && o === void 0 && (clearTimeout(u), o = i(t.responseTimeout, "Socket timeout"));
            }, e.onerror = ()=>{
                e.status === 0 && (clearTimeout(u), clearTimeout(o), s({
                    content: e.responseText || "Network request failed",
                    status: e.status,
                    isTimedOut: !1
                }));
            }, e.onload = ()=>{
                clearTimeout(u), clearTimeout(o), s({
                    content: e.responseText,
                    status: e.status,
                    isTimedOut: !1
                });
            }, e.send(t.data);
        });
    }
    return {
        send: r
    };
}

});


parcelRegister("kB2C5", function(module, exports) {

$parcel$export(module.exports, "default", () => $efe94a4e8e6788a3$export$2e2bcd8739ae039);

var $aLrwr = parcelRequire("aLrwr");
var $gFjXN = parcelRequire("gFjXN");
var $eFtWV = parcelRequire("eFtWV");
var $hLLYk = parcelRequire("hLLYk");
var $5Rcc1 = parcelRequire("5Rcc1");
var $fGOQ9 = parcelRequire("fGOQ9");

var $hPeWE = parcelRequire("hPeWE");

var $6dDrG = parcelRequire("6dDrG");

var $9KSsO = parcelRequire("9KSsO");

var $5vcx9 = parcelRequire("5vcx9");

/**
 * InstantSearch is the main component of InstantSearch.js. This object
 * manages the widget and lets you add new ones.
 *
 * Two parameters are required to get you started with InstantSearch.js:
 *  - `indexName`: the main index that you will use for your new search UI
 *  - `searchClient`: the search client to plug to InstantSearch.js
 *
 * The [search client provided by Algolia](algolia.com/doc/api-client/getting-started/what-is-the-api-client/javascript/)
 * needs an `appId` and an `apiKey`. Those parameters can be found in your
 * [Algolia dashboard](https://www.algolia.com/api-keys).
 *
 * If you want to get up and running quickly with InstantSearch.js, have a
 * look at the [getting started](https://www.algolia.com/doc/guides/building-search-ui/getting-started/js/).
 */ var $efe94a4e8e6788a3$var$instantsearch = function instantsearch(options) {
    return new (0, $6dDrG.default)(options);
};
$efe94a4e8e6788a3$var$instantsearch.version = (0, $5vcx9.default);
$efe94a4e8e6788a3$var$instantsearch.createInfiniteHitsSessionStorageCache = (0, $9KSsO.deprecate)((0, $hPeWE.default), "import { createInfiniteHitsSessionStorageCache } from 'instantsearch.js/es/lib/infiniteHitsCache'");
$efe94a4e8e6788a3$var$instantsearch.highlight = (0, $9KSsO.deprecate)((0, $gFjXN.default), "import { highlight } from 'instantsearch.js/es/helpers'");
$efe94a4e8e6788a3$var$instantsearch.reverseHighlight = (0, $9KSsO.deprecate)((0, $hLLYk.default), "import { reverseHighlight } from 'instantsearch.js/es/helpers'");
$efe94a4e8e6788a3$var$instantsearch.snippet = (0, $9KSsO.deprecate)((0, $fGOQ9.default), "import { snippet } from 'instantsearch.js/es/helpers'");
$efe94a4e8e6788a3$var$instantsearch.reverseSnippet = (0, $9KSsO.deprecate)((0, $5Rcc1.default), "import { reverseSnippet } from 'instantsearch.js/es/helpers'");
$efe94a4e8e6788a3$var$instantsearch.insights = (0, $eFtWV.default);
$efe94a4e8e6788a3$var$instantsearch.getInsightsAnonymousUserToken = (0, $aLrwr.default);
Object.defineProperty($efe94a4e8e6788a3$var$instantsearch, "widgets", {
    get: function get() {
        throw new ReferenceError("\"instantsearch.widgets\" are not available from the ES build.\n\nTo import the widgets:\n\nimport { searchBox } from 'instantsearch.js/es/widgets'");
    }
});
Object.defineProperty($efe94a4e8e6788a3$var$instantsearch, "connectors", {
    get: function get() {
        throw new ReferenceError("\"instantsearch.connectors\" are not available from the ES build.\n\nTo import the connectors:\n\nimport { connectSearchBox } from 'instantsearch.js/es/connectors'");
    }
});
Object.defineProperty($efe94a4e8e6788a3$var$instantsearch, "templates", {
    get: function get() {
        throw new ReferenceError("\"instantsearch.templates\" are not available from the ES build.\n\nTo import the templates:\n\nimport { carousel } from 'instantsearch.js/es/templates'");
    }
});
var $efe94a4e8e6788a3$export$2e2bcd8739ae039 = $efe94a4e8e6788a3$var$instantsearch;

});
parcelRegister("aLrwr", function(module, exports) {

$parcel$export(module.exports, "getInsightsAnonymousUserTokenInternal", () => $7d63a47d10d26a07$export$61f1c6e9cd2ed687);
$parcel$export(module.exports, "default", () => $7d63a47d10d26a07$export$2e2bcd8739ae039);

function $7d63a47d10d26a07$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $7d63a47d10d26a07$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $7d63a47d10d26a07$var$_typeof(obj);
}
var $7d63a47d10d26a07$export$d900da7fa9a86f36 = "_ALGOLIA";
function $7d63a47d10d26a07$var$getCookie(name) {
    if ((typeof document === "undefined" ? "undefined" : $7d63a47d10d26a07$var$_typeof(document)) !== "object" || typeof document.cookie !== "string") return undefined;
    var prefix = "".concat(name, "=");
    var cookies = document.cookie.split(";");
    for(var i = 0; i < cookies.length; i++){
        var cookie = cookies[i];
        while(cookie.charAt(0) === " ")cookie = cookie.substring(1);
        if (cookie.indexOf(prefix) === 0) return cookie.substring(prefix.length, cookie.length);
    }
    return undefined;
}
function $7d63a47d10d26a07$export$61f1c6e9cd2ed687() {
    return $7d63a47d10d26a07$var$getCookie($7d63a47d10d26a07$export$d900da7fa9a86f36);
}
function $7d63a47d10d26a07$export$2e2bcd8739ae039() {
    return $7d63a47d10d26a07$export$61f1c6e9cd2ed687();
}

});

parcelRegister("gFjXN", function(module, exports) {

$parcel$export(module.exports, "default", () => $c21ff5fce10d0c02$export$2e2bcd8739ae039);

var $ipedu = parcelRequire("ipedu");

var $bbXj3 = parcelRequire("bbXj3");
var $6ZYbr = parcelRequire("6ZYbr");
var $c21ff5fce10d0c02$var$suit = (0, $ipedu.component)("Highlight");
function $c21ff5fce10d0c02$export$2e2bcd8739ae039(_ref) {
    var attribute = _ref.attribute, _ref$highlightedTagNa = _ref.highlightedTagName, highlightedTagName = _ref$highlightedTagNa === void 0 ? "mark" : _ref$highlightedTagNa, hit = _ref.hit, _ref$cssClasses = _ref.cssClasses, cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
    var highlightAttributeResult = (0, $bbXj3.getPropertyByPath)(hit._highlightResult, attribute);
    var _ref2 = highlightAttributeResult || {}, _ref2$value = _ref2.value, attributeValue = _ref2$value === void 0 ? "" : _ref2$value;
    // cx is not used, since it would be bundled as a dependency for Vue
    var className = $c21ff5fce10d0c02$var$suit({
        descendantName: "highlighted"
    }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : "");
    return attributeValue.replace(new RegExp((0, $6ZYbr.TAG_REPLACEMENT).highlightPreTag, "g"), "<".concat(highlightedTagName, ' class="').concat(className, '">')).replace(new RegExp((0, $6ZYbr.TAG_REPLACEMENT).highlightPostTag, "g"), "</".concat(highlightedTagName, ">"));
}

});
parcelRegister("ipedu", function(module, exports) {

$parcel$export(module.exports, "component", () => $d66596ea0d1993d9$export$d8556a2a8f973135);
var $d66596ea0d1993d9$var$NAMESPACE = "ais";
var $d66596ea0d1993d9$export$d8556a2a8f973135 = function component(componentName) {
    return function() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, descendantName = _ref.descendantName, modifierName = _ref.modifierName;
        var descendent = descendantName ? "-".concat(descendantName) : "";
        var modifier = modifierName ? "--".concat(modifierName) : "";
        return "".concat($d66596ea0d1993d9$var$NAMESPACE, "-").concat(componentName).concat(descendent).concat(modifier);
    };
};

});

parcelRegister("bbXj3", function(module, exports) {

$parcel$export(module.exports, "getPropertyByPath", () => $825eb9c48970da3e$export$d14846335956eefa);
function $825eb9c48970da3e$export$d14846335956eefa(object, path) {
    var parts = Array.isArray(path) ? path : path.split(".");
    return parts.reduce(function(current, key) {
        return current && current[key];
    }, object);
}

});

parcelRegister("6ZYbr", function(module, exports) {

$parcel$export(module.exports, "TAG_PLACEHOLDER", () => $51871fc797d322c3$export$1e7338a8952eaf35);
$parcel$export(module.exports, "TAG_REPLACEMENT", () => $51871fc797d322c3$export$62e796b7905e8e6b);
$parcel$export(module.exports, "escapeHits", () => $51871fc797d322c3$export$9adb036445aab889);

var $5VBDn = parcelRequire("5VBDn");

var $9KXQK = parcelRequire("9KXQK");
function $51871fc797d322c3$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $51871fc797d322c3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $51871fc797d322c3$var$_typeof(obj);
}
function $51871fc797d322c3$var$_objectDestructuringEmpty(obj) {
    if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function $51871fc797d322c3$var$_extends() {
    $51871fc797d322c3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $51871fc797d322c3$var$_extends.apply(this, arguments);
}
function $51871fc797d322c3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $51871fc797d322c3$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $51871fc797d322c3$var$ownKeys(Object(source), !0).forEach(function(key) {
            $51871fc797d322c3$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $51871fc797d322c3$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $51871fc797d322c3$var$_defineProperty(obj, key, value) {
    key = $51871fc797d322c3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $51871fc797d322c3$var$_toPropertyKey(arg) {
    var key = $51871fc797d322c3$var$_toPrimitive(arg, "string");
    return $51871fc797d322c3$var$_typeof(key) === "symbol" ? key : String(key);
}
function $51871fc797d322c3$var$_toPrimitive(input, hint) {
    if ($51871fc797d322c3$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($51871fc797d322c3$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $51871fc797d322c3$export$1e7338a8952eaf35 = {
    highlightPreTag: "__ais-highlight__",
    highlightPostTag: "__/ais-highlight__"
};
var $51871fc797d322c3$export$62e796b7905e8e6b = {
    highlightPreTag: "<mark>",
    highlightPostTag: "</mark>"
};
// @MAJOR: in the future, this should only escape, not replace
function $51871fc797d322c3$var$replaceTagsAndEscape(value) {
    return (0, $5VBDn.escape)(value).replace(new RegExp($51871fc797d322c3$export$1e7338a8952eaf35.highlightPreTag, "g"), $51871fc797d322c3$export$62e796b7905e8e6b.highlightPreTag).replace(new RegExp($51871fc797d322c3$export$1e7338a8952eaf35.highlightPostTag, "g"), $51871fc797d322c3$export$62e796b7905e8e6b.highlightPostTag);
}
function $51871fc797d322c3$var$recursiveEscape(input) {
    if ((0, $9KXQK.isPlainObject)(input) && typeof input.value !== "string") return Object.keys(input).reduce(function(acc, key) {
        return $51871fc797d322c3$var$_objectSpread($51871fc797d322c3$var$_objectSpread({}, acc), {}, $51871fc797d322c3$var$_defineProperty({}, key, $51871fc797d322c3$var$recursiveEscape(input[key])));
    }, {});
    if (Array.isArray(input)) return input.map($51871fc797d322c3$var$recursiveEscape);
    return $51871fc797d322c3$var$_objectSpread($51871fc797d322c3$var$_objectSpread({}, input), {}, {
        value: $51871fc797d322c3$var$replaceTagsAndEscape(input.value)
    });
}
function $51871fc797d322c3$export$9adb036445aab889(hits) {
    if (hits.__escaped === undefined) {
        // We don't override the value on hit because it will mutate the raw results
        // instead we make a shallow copy and we assign the escaped values on it.
        hits = hits.map(function(_ref) {
            var hit = $51871fc797d322c3$var$_extends({}, ($51871fc797d322c3$var$_objectDestructuringEmpty(_ref), _ref));
            if (hit._highlightResult) hit._highlightResult = $51871fc797d322c3$var$recursiveEscape(hit._highlightResult);
            if (hit._snippetResult) hit._snippetResult = $51871fc797d322c3$var$recursiveEscape(hit._snippetResult);
            return hit;
        });
        hits.__escaped = true;
    }
    return hits;
}
function $51871fc797d322c3$export$9ae2e822836b2e1a(facetHits) {
    return facetHits.map(function(h) {
        return $51871fc797d322c3$var$_objectSpread($51871fc797d322c3$var$_objectSpread({}, h), {}, {
            highlighted: $51871fc797d322c3$var$replaceTagsAndEscape(h.highlighted)
        });
    });
}

});
parcelRegister("5VBDn", function(module, exports) {

$parcel$export(module.exports, "escape", () => $450f77f40abbd094$export$4e7f196112fea3c5);
$parcel$export(module.exports, "unescape", () => $450f77f40abbd094$export$e8bacd2802a88316);
/**
 * This implementation is taken from Lodash implementation.
 * See: https://github.com/lodash/lodash/blob/4.17.11-npm/escape.js
 */ // Used to map characters to HTML entities.
var $450f77f40abbd094$var$htmlEntities = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
};
// Used to match HTML entities and HTML characters.
var $450f77f40abbd094$var$regexUnescapedHtml = /[&<>"']/g;
var $450f77f40abbd094$var$regexHasUnescapedHtml = RegExp($450f77f40abbd094$var$regexUnescapedHtml.source);
function $450f77f40abbd094$export$4e7f196112fea3c5(value) {
    return value && $450f77f40abbd094$var$regexHasUnescapedHtml.test(value) ? value.replace($450f77f40abbd094$var$regexUnescapedHtml, function(character) {
        return $450f77f40abbd094$var$htmlEntities[character];
    }) : value;
}
/**
 * This implementation is taken from Lodash implementation.
 * See: https://github.com/lodash/lodash/blob/4.17.11-npm/unescape.js
 */ // Used to map HTML entities to characters.
var $450f77f40abbd094$var$htmlCharacters = {
    "&amp;": "&",
    "&lt;": "<",
    "&gt;": ">",
    "&quot;": '"',
    "&#39;": "'"
};
// Used to match HTML entities and HTML characters.
var $450f77f40abbd094$var$regexEscapedHtml = /&(amp|quot|lt|gt|#39);/g;
var $450f77f40abbd094$var$regexHasEscapedHtml = RegExp($450f77f40abbd094$var$regexEscapedHtml.source);
function $450f77f40abbd094$export$e8bacd2802a88316(value) {
    return value && $450f77f40abbd094$var$regexHasEscapedHtml.test(value) ? value.replace($450f77f40abbd094$var$regexEscapedHtml, function(character) {
        return $450f77f40abbd094$var$htmlCharacters[character];
    }) : value;
}

});

parcelRegister("9KXQK", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $71a6d5d45f5c7205$export$53b83ca8eaab0383);
function $71a6d5d45f5c7205$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $71a6d5d45f5c7205$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $71a6d5d45f5c7205$var$_typeof(obj);
}
/**
 * This implementation is taken from Lodash implementation.
 * See: https://github.com/lodash/lodash/blob/master/isPlainObject.js
 */ function $71a6d5d45f5c7205$var$getTag(value) {
    if (value === null) return value === undefined ? "[object Undefined]" : "[object Null]";
    return Object.prototype.toString.call(value);
}
function $71a6d5d45f5c7205$var$isObjectLike(value) {
    return $71a6d5d45f5c7205$var$_typeof(value) === "object" && value !== null;
}
function $71a6d5d45f5c7205$export$53b83ca8eaab0383(value) {
    if (!$71a6d5d45f5c7205$var$isObjectLike(value) || $71a6d5d45f5c7205$var$getTag(value) !== "[object Object]") return false;
    if (Object.getPrototypeOf(value) === null) return true;
    var proto = value;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(value) === proto;
}

});



parcelRegister("eFtWV", function(module, exports) {

$parcel$export(module.exports, "default", () => $aadc205643c2bd55$export$2e2bcd8739ae039);

var $hPGc5 = parcelRequire("hPGc5");
function $aadc205643c2bd55$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $aadc205643c2bd55$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $aadc205643c2bd55$var$_typeof(obj);
}
function $aadc205643c2bd55$export$cbcfede36ce7ab2e(domElement) {
    var method = domElement.getAttribute("data-insights-method");
    var serializedPayload = domElement.getAttribute("data-insights-payload");
    if (typeof serializedPayload !== "string") throw new Error("The insights helper expects `data-insights-payload` to be a base64-encoded JSON string.");
    try {
        var payload = (0, $hPGc5.deserializePayload)(serializedPayload);
        return {
            method: method,
            payload: payload
        };
    } catch (error) {
        throw new Error("The insights helper was unable to parse `data-insights-payload`.");
    }
}
function $aadc205643c2bd55$export$a3453cc0ced8b97c(_ref) {
    var method = _ref.method, payload = _ref.payload;
    if ($aadc205643c2bd55$var$_typeof(payload) !== "object") throw new Error("The insights helper expects the payload to be an object.");
    var serializedPayload;
    try {
        serializedPayload = (0, $hPGc5.serializePayload)(payload);
    } catch (error) {
        throw new Error("Could not JSON serialize the payload object.");
    }
    return 'data-insights-method="'.concat(method, '" data-insights-payload="').concat(serializedPayload, '"');
}
function $aadc205643c2bd55$export$2e2bcd8739ae039(method, payload) {
    return $aadc205643c2bd55$export$a3453cc0ced8b97c({
        method: method,
        payload: payload
    });
}

});
parcelRegister("hPGc5", function(module, exports) {

$parcel$export(module.exports, "serializePayload", () => $cfb7edf2f6aa7202$export$44b4521aa38272f2);
$parcel$export(module.exports, "deserializePayload", () => $cfb7edf2f6aa7202$export$706ea24b0964bee9);
function $cfb7edf2f6aa7202$export$44b4521aa38272f2(payload) {
    return btoa(encodeURIComponent(JSON.stringify(payload)));
}
function $cfb7edf2f6aa7202$export$706ea24b0964bee9(serialized) {
    return JSON.parse(decodeURIComponent(atob(serialized)));
}

});


parcelRegister("hLLYk", function(module, exports) {

$parcel$export(module.exports, "default", () => $0356a55140febf94$export$2e2bcd8739ae039);

var $ipedu = parcelRequire("ipedu");

var $ihYFA = parcelRequire("ihYFA");
var $lm4H5 = parcelRequire("lm4H5");
var $bbXj3 = parcelRequire("bbXj3");
var $vn9H0 = parcelRequire("vn9H0");
var $6ZYbr = parcelRequire("6ZYbr");
var $0356a55140febf94$var$suit = (0, $ipedu.component)("ReverseHighlight");
function $0356a55140febf94$export$2e2bcd8739ae039(_ref) {
    var attribute = _ref.attribute, _ref$highlightedTagNa = _ref.highlightedTagName, highlightedTagName = _ref$highlightedTagNa === void 0 ? "mark" : _ref$highlightedTagNa, hit = _ref.hit, _ref$cssClasses = _ref.cssClasses, cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
    var highlightAttributeResult = (0, $bbXj3.getPropertyByPath)(hit._highlightResult, attribute);
    var _ref2 = highlightAttributeResult || {}, _ref2$value = _ref2.value, attributeValue = _ref2$value === void 0 ? "" : _ref2$value;
    // cx is not used, since it would be bundled as a dependency for Vue
    var className = $0356a55140febf94$var$suit({
        descendantName: "highlighted"
    }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : "");
    var reverseHighlightedValue = (0, $ihYFA.concatHighlightedParts)((0, $vn9H0.reverseHighlightedParts)((0, $lm4H5.getHighlightedParts)(attributeValue)));
    return reverseHighlightedValue.replace(new RegExp((0, $6ZYbr.TAG_REPLACEMENT).highlightPreTag, "g"), "<".concat(highlightedTagName, ' class="').concat(className, '">')).replace(new RegExp((0, $6ZYbr.TAG_REPLACEMENT).highlightPostTag, "g"), "</".concat(highlightedTagName, ">"));
}

});
parcelRegister("ihYFA", function(module, exports) {

$parcel$export(module.exports, "concatHighlightedParts", () => $d508e04a9bd7ba33$export$a34fe2fceda1929e);

var $6ZYbr = parcelRequire("6ZYbr");
function $d508e04a9bd7ba33$export$a34fe2fceda1929e(parts) {
    var highlightPreTag = (0, $6ZYbr.TAG_REPLACEMENT).highlightPreTag, highlightPostTag = (0, $6ZYbr.TAG_REPLACEMENT).highlightPostTag;
    return parts.map(function(part) {
        return part.isHighlighted ? highlightPreTag + part.value + highlightPostTag : part.value;
    }).join("");
}

});

parcelRegister("lm4H5", function(module, exports) {

$parcel$export(module.exports, "getHighlightedParts", () => $f8bf4b2f3d897ff6$export$e04d28e65b830ebf);

var $6ZYbr = parcelRequire("6ZYbr");
function $f8bf4b2f3d897ff6$export$e04d28e65b830ebf(highlightedValue) {
    // @MAJOR: this should use TAG_PLACEHOLDER
    var highlightPostTag = (0, $6ZYbr.TAG_REPLACEMENT).highlightPostTag, highlightPreTag = (0, $6ZYbr.TAG_REPLACEMENT).highlightPreTag;
    var splitByPreTag = highlightedValue.split(highlightPreTag);
    var firstValue = splitByPreTag.shift();
    var elements = !firstValue ? [] : [
        {
            value: firstValue,
            isHighlighted: false
        }
    ];
    splitByPreTag.forEach(function(split) {
        var splitByPostTag = split.split(highlightPostTag);
        elements.push({
            value: splitByPostTag[0],
            isHighlighted: true
        });
        if (splitByPostTag[1] !== "") elements.push({
            value: splitByPostTag[1],
            isHighlighted: false
        });
    });
    return elements;
}

});

parcelRegister("vn9H0", function(module, exports) {

$parcel$export(module.exports, "reverseHighlightedParts", () => $05e4db8818f8ea22$export$8d1202a2cf66e93);

var $baIXl = parcelRequire("baIXl");
function $05e4db8818f8ea22$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $05e4db8818f8ea22$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $05e4db8818f8ea22$var$_typeof(obj);
}
function $05e4db8818f8ea22$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $05e4db8818f8ea22$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $05e4db8818f8ea22$var$ownKeys(Object(source), !0).forEach(function(key) {
            $05e4db8818f8ea22$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $05e4db8818f8ea22$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $05e4db8818f8ea22$var$_defineProperty(obj, key, value) {
    key = $05e4db8818f8ea22$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $05e4db8818f8ea22$var$_toPropertyKey(arg) {
    var key = $05e4db8818f8ea22$var$_toPrimitive(arg, "string");
    return $05e4db8818f8ea22$var$_typeof(key) === "symbol" ? key : String(key);
}
function $05e4db8818f8ea22$var$_toPrimitive(input, hint) {
    if ($05e4db8818f8ea22$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($05e4db8818f8ea22$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $05e4db8818f8ea22$export$8d1202a2cf66e93(parts) {
    if (!parts.some(function(part) {
        return part.isHighlighted;
    })) return parts.map(function(part) {
        return $05e4db8818f8ea22$var$_objectSpread($05e4db8818f8ea22$var$_objectSpread({}, part), {}, {
            isHighlighted: false
        });
    });
    return parts.map(function(part, i) {
        return $05e4db8818f8ea22$var$_objectSpread($05e4db8818f8ea22$var$_objectSpread({}, part), {}, {
            isHighlighted: !(0, $baIXl.getHighlightFromSiblings)(parts, i)
        });
    });
}

});
parcelRegister("baIXl", function(module, exports) {

$parcel$export(module.exports, "getHighlightFromSiblings", () => $82238039523259d7$export$60c97785b669d08a);

var $5VBDn = parcelRequire("5VBDn");
var $82238039523259d7$var$hasAlphanumeric = new RegExp(/\w/i);
function $82238039523259d7$export$60c97785b669d08a(parts, i) {
    var _parts, _parts2;
    var current = parts[i];
    var isNextHighlighted = ((_parts = parts[i + 1]) === null || _parts === void 0 ? void 0 : _parts.isHighlighted) || true;
    var isPreviousHighlighted = ((_parts2 = parts[i - 1]) === null || _parts2 === void 0 ? void 0 : _parts2.isHighlighted) || true;
    if (!$82238039523259d7$var$hasAlphanumeric.test((0, $5VBDn.unescape)(current.value)) && isPreviousHighlighted === isNextHighlighted) return isPreviousHighlighted;
    return current.isHighlighted;
}

});



parcelRegister("5Rcc1", function(module, exports) {

$parcel$export(module.exports, "default", () => $443b5c41f9a3037f$export$2e2bcd8739ae039);

var $ipedu = parcelRequire("ipedu");

var $ihYFA = parcelRequire("ihYFA");
var $lm4H5 = parcelRequire("lm4H5");
var $bbXj3 = parcelRequire("bbXj3");
var $vn9H0 = parcelRequire("vn9H0");
var $6ZYbr = parcelRequire("6ZYbr");
var $443b5c41f9a3037f$var$suit = (0, $ipedu.component)("ReverseSnippet");
function $443b5c41f9a3037f$export$2e2bcd8739ae039(_ref) {
    var attribute = _ref.attribute, _ref$highlightedTagNa = _ref.highlightedTagName, highlightedTagName = _ref$highlightedTagNa === void 0 ? "mark" : _ref$highlightedTagNa, hit = _ref.hit, _ref$cssClasses = _ref.cssClasses, cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
    var snippetAttributeResult = (0, $bbXj3.getPropertyByPath)(hit._snippetResult, attribute);
    var _ref2 = snippetAttributeResult || {}, _ref2$value = _ref2.value, attributeValue = _ref2$value === void 0 ? "" : _ref2$value;
    // cx is not used, since it would be bundled as a dependency for Vue
    var className = $443b5c41f9a3037f$var$suit({
        descendantName: "highlighted"
    }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : "");
    var reverseHighlightedValue = (0, $ihYFA.concatHighlightedParts)((0, $vn9H0.reverseHighlightedParts)((0, $lm4H5.getHighlightedParts)(attributeValue)));
    return reverseHighlightedValue.replace(new RegExp((0, $6ZYbr.TAG_REPLACEMENT).highlightPreTag, "g"), "<".concat(highlightedTagName, ' class="').concat(className, '">')).replace(new RegExp((0, $6ZYbr.TAG_REPLACEMENT).highlightPostTag, "g"), "</".concat(highlightedTagName, ">"));
}

});

parcelRegister("fGOQ9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6c2370707af3785$export$2e2bcd8739ae039);

var $ipedu = parcelRequire("ipedu");

var $bbXj3 = parcelRequire("bbXj3");
var $6ZYbr = parcelRequire("6ZYbr");
var $b6c2370707af3785$var$suit = (0, $ipedu.component)("Snippet");
function $b6c2370707af3785$export$2e2bcd8739ae039(_ref) {
    var attribute = _ref.attribute, _ref$highlightedTagNa = _ref.highlightedTagName, highlightedTagName = _ref$highlightedTagNa === void 0 ? "mark" : _ref$highlightedTagNa, hit = _ref.hit, _ref$cssClasses = _ref.cssClasses, cssClasses = _ref$cssClasses === void 0 ? {} : _ref$cssClasses;
    var snippetAttributeResult = (0, $bbXj3.getPropertyByPath)(hit._snippetResult, attribute);
    var _ref2 = snippetAttributeResult || {}, _ref2$value = _ref2.value, attributeValue = _ref2$value === void 0 ? "" : _ref2$value;
    // cx is not used, since it would be bundled as a dependency for Vue
    var className = $b6c2370707af3785$var$suit({
        descendantName: "highlighted"
    }) + (cssClasses.highlighted ? " ".concat(cssClasses.highlighted) : "");
    return attributeValue.replace(new RegExp((0, $6ZYbr.TAG_REPLACEMENT).highlightPreTag, "g"), "<".concat(highlightedTagName, ' class="').concat(className, '">')).replace(new RegExp((0, $6ZYbr.TAG_REPLACEMENT).highlightPostTag, "g"), "</".concat(highlightedTagName, ">"));
}

});

parcelRegister("hPeWE", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfa2cadf0c70c0a7$export$2e2bcd8739ae039);

var $hHEcB = parcelRequire("hHEcB");
var $93kMs = parcelRequire("93kMs");
var $cfa2cadf0c70c0a7$var$_excluded = [
    "page"
];
function $cfa2cadf0c70c0a7$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $cfa2cadf0c70c0a7$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $cfa2cadf0c70c0a7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $cfa2cadf0c70c0a7$var$getStateWithoutPage(state) {
    var _ref = state || {}, page = _ref.page, rest = $cfa2cadf0c70c0a7$var$_objectWithoutProperties(_ref, $cfa2cadf0c70c0a7$var$_excluded);
    return rest;
}
var $cfa2cadf0c70c0a7$var$KEY = "ais.infiniteHits";
function $cfa2cadf0c70c0a7$export$2e2bcd8739ae039() {
    return {
        read: function read(_ref2) {
            var state = _ref2.state;
            var sessionStorage = (0, $93kMs.safelyRunOnBrowser)(function(_ref3) {
                var window = _ref3.window;
                return window.sessionStorage;
            });
            if (!sessionStorage) return null;
            try {
                var cache = JSON.parse(// @ts-expect-error JSON.parse() requires a string, but it actually accepts null, too.
                sessionStorage.getItem($cfa2cadf0c70c0a7$var$KEY));
                return cache && (0, $hHEcB.isEqual)(cache.state, $cfa2cadf0c70c0a7$var$getStateWithoutPage(state)) ? cache.hits : null;
            } catch (error) {
                if (error instanceof SyntaxError) try {
                    sessionStorage.removeItem($cfa2cadf0c70c0a7$var$KEY);
                } catch (err) {
                // do nothing
                }
                return null;
            }
        },
        write: function write(_ref4) {
            var state = _ref4.state, hits = _ref4.hits;
            var sessionStorage = (0, $93kMs.safelyRunOnBrowser)(function(_ref5) {
                var window = _ref5.window;
                return window.sessionStorage;
            });
            if (!sessionStorage) return;
            try {
                sessionStorage.setItem($cfa2cadf0c70c0a7$var$KEY, JSON.stringify({
                    state: $cfa2cadf0c70c0a7$var$getStateWithoutPage(state),
                    hits: hits
                }));
            } catch (error) {
            // do nothing
            }
        }
    };
}

});
parcelRegister("hHEcB", function(module, exports) {

$parcel$export(module.exports, "isEqual", () => $ce35a32ac7d7f621$export$248d38f6296296c5);
function $ce35a32ac7d7f621$var$isPrimitive(obj) {
    return obj !== Object(obj);
}
function $ce35a32ac7d7f621$export$248d38f6296296c5(first, second) {
    if (first === second) return true;
    if ($ce35a32ac7d7f621$var$isPrimitive(first) || $ce35a32ac7d7f621$var$isPrimitive(second) || typeof first === "function" || typeof second === "function") return first === second;
    if (Object.keys(first).length !== Object.keys(second).length) return false;
    // @TODO avoid for..of because of the large polyfill
    // eslint-disable-next-line no-restricted-syntax
    for(var _i = 0, _Object$keys = Object.keys(first); _i < _Object$keys.length; _i++){
        var key = _Object$keys[_i];
        if (!(key in second)) return false;
        if (!$ce35a32ac7d7f621$export$248d38f6296296c5(first[key], second[key])) return false;
    }
    return true;
}

});

parcelRegister("93kMs", function(module, exports) {

$parcel$export(module.exports, "safelyRunOnBrowser", () => $69748373edddad9d$export$39f19eed34acd2f1);
// eslint-disable-next-line no-restricted-globals
/**
 * Runs code on browser environments safely.
 */ function $69748373edddad9d$export$39f19eed34acd2f1(callback) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        fallback: function fallback() {
            return undefined;
        }
    }, fallback = _ref.fallback;
    // eslint-disable-next-line no-restricted-globals
    if (typeof window === "undefined") return fallback();
    // eslint-disable-next-line no-restricted-globals
    return callback({
        window: window
    });
}

});


parcelRegister("6dDrG", function(module, exports) {

$parcel$export(module.exports, "default", () => $48728e0599915634$export$2e2bcd8739ae039);

var $je6gi = parcelRequire("je6gi");

var $3gYKj = parcelRequire("3gYKj");

var $5gdGA = parcelRequire("5gdGA");

var $hcwya = parcelRequire("hcwya");

var $3rHjr = parcelRequire("3rHjr");

var $fYhEq = parcelRequire("fYhEq");

var $1WQQ9 = parcelRequire("1WQQ9");

var $del55 = parcelRequire("del55");
var $9cl1f = parcelRequire("9cl1f");
var $a3Abi = parcelRequire("a3Abi");
var $6bAnG = parcelRequire("6bAnG");
var $iNPz2 = parcelRequire("iNPz2");
var $aD5BU = parcelRequire("aD5BU");

var $5vcx9 = parcelRequire("5vcx9");
function $48728e0599915634$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $48728e0599915634$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $48728e0599915634$var$_typeof(obj);
}
function $48728e0599915634$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $48728e0599915634$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $48728e0599915634$var$ownKeys(Object(source), !0).forEach(function(key) {
            $48728e0599915634$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $48728e0599915634$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $48728e0599915634$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $48728e0599915634$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $48728e0599915634$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $48728e0599915634$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $48728e0599915634$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $48728e0599915634$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $48728e0599915634$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $48728e0599915634$var$_setPrototypeOf(subClass, superClass);
}
function $48728e0599915634$var$_setPrototypeOf(o, p) {
    $48728e0599915634$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $48728e0599915634$var$_setPrototypeOf(o, p);
}
function $48728e0599915634$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $48728e0599915634$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $48728e0599915634$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $48728e0599915634$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $48728e0599915634$var$_possibleConstructorReturn(this, result);
    };
}
function $48728e0599915634$var$_possibleConstructorReturn(self, call) {
    if (call && ($48728e0599915634$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $48728e0599915634$var$_assertThisInitialized(self);
}
function $48728e0599915634$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $48728e0599915634$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $48728e0599915634$var$_getPrototypeOf(o) {
    $48728e0599915634$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $48728e0599915634$var$_getPrototypeOf(o);
}
function $48728e0599915634$var$_defineProperty(obj, key, value) {
    key = $48728e0599915634$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $48728e0599915634$var$_toPropertyKey(arg) {
    var key = $48728e0599915634$var$_toPrimitive(arg, "string");
    return $48728e0599915634$var$_typeof(key) === "symbol" ? key : String(key);
}
function $48728e0599915634$var$_toPrimitive(input, hint) {
    if ($48728e0599915634$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($48728e0599915634$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $48728e0599915634$var$withUsage = (0, $del55.createDocumentationMessageGenerator)({
    name: "instantsearch"
});
function $48728e0599915634$var$defaultCreateURL() {
    return "#";
}
var $48728e0599915634$export$8bd42a83af1ca676 = {
    preserveSharedStateOnUnmount: false,
    persistHierarchicalRootCount: false
};
/**
 * The actual implementation of the InstantSearch. This is
 * created using the `instantsearch` factory function.
 * It emits the 'render' event every time a search is done
 */ var $48728e0599915634$var$InstantSearch = /*#__PURE__*/ function(_EventEmitter) {
    $48728e0599915634$var$_inherits(InstantSearch, _EventEmitter);
    var _super = $48728e0599915634$var$_createSuper(InstantSearch);
    function InstantSearch(options) {
        var _options$future2;
        var _this;
        $48728e0599915634$var$_classCallCheck(this, InstantSearch);
        _this = _super.call(this);
        // prevent `render` event listening from causing a warning
        $48728e0599915634$var$_defineProperty($48728e0599915634$var$_assertThisInitialized(_this), "client", void 0);
        $48728e0599915634$var$_defineProperty($48728e0599915634$var$_assertThisInitialized(_this), "indexName", void 0);
        $48728e0599915634$var$_defineProperty($48728e0599915634$var$_assertThisInitialized(_this), "insightsClient", void 0);
        $48728e0599915634$var$_defineProperty($48728e0599915634$var$_assertThisInitialized(_this), "onStateChange", null);
        $48728e0599915634$var$_defineProperty($48728e0599915634$var$_assertThisInitialized(_this), "future", void 0);
        $48728e0599915634$var$_defineProperty($48728e0599915634$var$_assertThisInitialized(_this), "helper", void 0);
        $48728e0599915634$var$_defineProperty($48728e0599915634$var$_assertThisInitialized(_this), "mainHelper", void 0);
        $48728e0599915634$var$_defineProperty($48728e0599915634$var$_assertThisInitialized(_this), "mainIndex", void 0);
        $48728e0599915634$var$_defineProperty($48728e0599915634$var$_assertThisInitialized(_this), "started", void 0);
        $48728e0599915634$var$_defineProperty($48728e0599915634$var$_assertThisInitialized(_this), "templatesConfig", void 0);
        $48728e0599915634$var$_defineProperty($48728e0599915634$var$_assertThisInitialized(_this), "renderState", {});
        $48728e0599915634$var$_defineProperty($48728e0599915634$var$_assertThisInitialized(_this), "_stalledSearchDelay", void 0);
        $48728e0599915634$var$_defineProperty($48728e0599915634$var$_assertThisInitialized(_this), "_searchStalledTimer", void 0);
        $48728e0599915634$var$_defineProperty($48728e0599915634$var$_assertThisInitialized(_this), "_initialUiState", void 0);
        $48728e0599915634$var$_defineProperty($48728e0599915634$var$_assertThisInitialized(_this), "_initialResults", void 0);
        $48728e0599915634$var$_defineProperty($48728e0599915634$var$_assertThisInitialized(_this), "_createURL", void 0);
        $48728e0599915634$var$_defineProperty($48728e0599915634$var$_assertThisInitialized(_this), "_searchFunction", void 0);
        $48728e0599915634$var$_defineProperty($48728e0599915634$var$_assertThisInitialized(_this), "_mainHelperSearch", void 0);
        $48728e0599915634$var$_defineProperty($48728e0599915634$var$_assertThisInitialized(_this), "_hasSearchWidget", false);
        $48728e0599915634$var$_defineProperty($48728e0599915634$var$_assertThisInitialized(_this), "_hasRecommendWidget", false);
        $48728e0599915634$var$_defineProperty($48728e0599915634$var$_assertThisInitialized(_this), "_insights", void 0);
        $48728e0599915634$var$_defineProperty($48728e0599915634$var$_assertThisInitialized(_this), "middleware", []);
        $48728e0599915634$var$_defineProperty($48728e0599915634$var$_assertThisInitialized(_this), "sendEventToInsights", void 0);
        /**
     * The status of the search. Can be "idle", "loading", "stalled", or "error".
     */ $48728e0599915634$var$_defineProperty($48728e0599915634$var$_assertThisInitialized(_this), "status", "idle");
        /**
     * The last returned error from the Search API.
     * The error gets cleared when the next valid search response is rendered.
     */ $48728e0599915634$var$_defineProperty($48728e0599915634$var$_assertThisInitialized(_this), "error", undefined);
        $48728e0599915634$var$_defineProperty($48728e0599915634$var$_assertThisInitialized(_this), "scheduleSearch", (0, $9cl1f.defer)(function() {
            if (_this.started) _this.mainHelper.search();
        }));
        $48728e0599915634$var$_defineProperty($48728e0599915634$var$_assertThisInitialized(_this), "scheduleRender", (0, $9cl1f.defer)(function() {
            var _this$mainHelper;
            var shouldResetStatus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            if (!((_this$mainHelper = _this.mainHelper) !== null && _this$mainHelper !== void 0 && _this$mainHelper.hasPendingRequests())) {
                clearTimeout(_this._searchStalledTimer);
                _this._searchStalledTimer = null;
                if (shouldResetStatus) {
                    _this.status = "idle";
                    _this.error = undefined;
                }
            }
            _this.mainIndex.render({
                instantSearchInstance: $48728e0599915634$var$_assertThisInitialized(_this)
            });
            _this.emit("render");
        }));
        $48728e0599915634$var$_defineProperty($48728e0599915634$var$_assertThisInitialized(_this), "onInternalStateChange", (0, $9cl1f.defer)(function() {
            var nextUiState = _this.mainIndex.getWidgetUiState({});
            _this.middleware.forEach(function(_ref) {
                var instance = _ref.instance;
                instance.onStateChange({
                    uiState: nextUiState
                });
            });
        }));
        _this.setMaxListeners(100);
        var _options$indexName = options.indexName, indexName = _options$indexName === void 0 ? "" : _options$indexName, numberLocale = options.numberLocale, _options$initialUiSta = options.initialUiState, initialUiState = _options$initialUiSta === void 0 ? {} : _options$initialUiSta, _options$routing = options.routing, routing = _options$routing === void 0 ? null : _options$routing, _options$insights = options.insights, insights = _options$insights === void 0 ? undefined : _options$insights, searchFunction = options.searchFunction, _options$stalledSearc = options.stalledSearchDelay, stalledSearchDelay = _options$stalledSearc === void 0 ? 200 : _options$stalledSearc, _options$searchClient = options.searchClient, searchClient = _options$searchClient === void 0 ? null : _options$searchClient, _options$insightsClie = options.insightsClient, insightsClient = _options$insightsClie === void 0 ? null : _options$insightsClie, _options$onStateChang = options.onStateChange, onStateChange = _options$onStateChang === void 0 ? null : _options$onStateChang, _options$future = options.future, future = _options$future === void 0 ? $48728e0599915634$var$_objectSpread($48728e0599915634$var$_objectSpread({}, $48728e0599915634$export$8bd42a83af1ca676), options.future || {}) : _options$future;
        if (searchClient === null) throw new Error($48728e0599915634$var$withUsage("The `searchClient` option is required."));
        if (typeof searchClient.search !== "function") throw new Error("The `searchClient` must implement a `search` method.\n\nSee: https://www.algolia.com/doc/guides/building-search-ui/going-further/backend-search/in-depth/backend-instantsearch/js/");
        if (typeof searchClient.addAlgoliaAgent === "function") searchClient.addAlgoliaAgent("instantsearch.js (".concat((0, $5vcx9.default), ")"));
        if (insightsClient && typeof insightsClient !== "function") throw new Error($48728e0599915634$var$withUsage("The `insightsClient` option should be a function."));
        _this.client = searchClient;
        _this.future = future;
        _this.insightsClient = insightsClient;
        _this.indexName = indexName;
        _this.helper = null;
        _this.mainHelper = null;
        _this.mainIndex = (0, $fYhEq.default)({
            indexName: indexName
        });
        _this.onStateChange = onStateChange;
        _this.started = false;
        _this.templatesConfig = {
            helpers: (0, $1WQQ9.default)({
                numberLocale: numberLocale
            }),
            compileOptions: {}
        };
        _this._stalledSearchDelay = stalledSearchDelay;
        _this._searchStalledTimer = null;
        _this._createURL = $48728e0599915634$var$defaultCreateURL;
        _this._initialUiState = initialUiState;
        _this._initialResults = null;
        _this._insights = insights;
        if (searchFunction) _this._searchFunction = searchFunction;
        _this.sendEventToInsights = (0, $iNPz2.noop);
        if (routing) {
            var routerOptions = typeof routing === "boolean" ? {} : routing;
            routerOptions.$$internal = true;
            _this.use((0, $3rHjr.createRouterMiddleware)(routerOptions));
        }
        // This is the default Insights middleware,
        // added when `insights` is set to true by the user.
        // Any user-provided middleware will be added later and override this one.
        if (insights) {
            var insightsOptions = typeof insights === "boolean" ? {} : insights;
            insightsOptions.$$internal = true;
            _this.use((0, $5gdGA.createInsightsMiddleware)(insightsOptions));
        }
        if ((0, $hcwya.isMetadataEnabled)()) _this.use((0, $hcwya.createMetadataMiddleware)({
            $$internal: true
        }));
        return _this;
    }
    /**
   * Hooks a middleware into the InstantSearch lifecycle.
   */ $48728e0599915634$var$_createClass(InstantSearch, [
        {
            key: "_isSearchStalled",
            get: /**
     * @deprecated use `status === 'stalled'` instead
     */ function get() {
                return this.status === "stalled";
            }
        },
        {
            key: "use",
            value: function use() {
                var _this2 = this;
                for(var _len = arguments.length, middleware = new Array(_len), _key = 0; _key < _len; _key++)middleware[_key] = arguments[_key];
                var newMiddlewareList = middleware.map(function(fn) {
                    var newMiddleware = $48728e0599915634$var$_objectSpread({
                        $$type: "__unknown__",
                        $$internal: false,
                        subscribe: (0, $iNPz2.noop),
                        started: (0, $iNPz2.noop),
                        unsubscribe: (0, $iNPz2.noop),
                        onStateChange: (0, $iNPz2.noop)
                    }, fn({
                        instantSearchInstance: _this2
                    }));
                    _this2.middleware.push({
                        creator: fn,
                        instance: newMiddleware
                    });
                    return newMiddleware;
                });
                // If the instance has already started, we directly subscribe the
                // middleware so they're notified of changes.
                if (this.started) newMiddlewareList.forEach(function(m) {
                    m.subscribe();
                    m.started();
                });
                return this;
            }
        },
        {
            key: "unuse",
            value: function unuse() {
                for(var _len2 = arguments.length, middlewareToUnuse = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)middlewareToUnuse[_key2] = arguments[_key2];
                this.middleware.filter(function(m) {
                    return middlewareToUnuse.includes(m.creator);
                }).forEach(function(m) {
                    return m.instance.unsubscribe();
                });
                this.middleware = this.middleware.filter(function(m) {
                    return !middlewareToUnuse.includes(m.creator);
                });
                return this;
            }
        },
        {
            key: "EXPERIMENTAL_use",
            value: function EXPERIMENTAL_use() {
                return this.use.apply(this, arguments);
            }
        },
        {
            key: "addWidget",
            value: function addWidget(widget) {
                return this.addWidgets([
                    widget
                ]);
            }
        },
        {
            key: "addWidgets",
            value: function addWidgets(widgets) {
                if (!Array.isArray(widgets)) throw new Error($48728e0599915634$var$withUsage("The `addWidgets` method expects an array of widgets. Please use `addWidget`."));
                if (widgets.some(function(widget) {
                    return typeof widget.init !== "function" && typeof widget.render !== "function";
                })) throw new Error($48728e0599915634$var$withUsage("The widget definition expects a `render` and/or an `init` method."));
                this.mainIndex.addWidgets(widgets);
                return this;
            }
        },
        {
            key: "removeWidget",
            value: function removeWidget(widget) {
                return this.removeWidgets([
                    widget
                ]);
            }
        },
        {
            key: "removeWidgets",
            value: function removeWidgets(widgets) {
                if (!Array.isArray(widgets)) throw new Error($48728e0599915634$var$withUsage("The `removeWidgets` method expects an array of widgets. Please use `removeWidget`."));
                if (widgets.some(function(widget) {
                    return typeof widget.dispose !== "function";
                })) throw new Error($48728e0599915634$var$withUsage("The widget definition expects a `dispose` method."));
                this.mainIndex.removeWidgets(widgets);
                return this;
            }
        },
        {
            key: "start",
            value: function start() {
                var _this3 = this;
                if (this.started) throw new Error($48728e0599915634$var$withUsage("The `start` method has already been called once."));
                // This Helper is used for the queries, we don't care about its state. The
                // states are managed at the `index` level. We use this Helper to create
                // DerivedHelper scoped into the `index` widgets.
                // In Vue InstantSearch' hydrate, a main helper gets set before start, so
                // we need to respect this helper as a way to keep all listeners correct.
                var mainHelper = this.mainHelper || (0, (/*@__PURE__*/$parcel$interopDefault($3gYKj)))(this.client, this.indexName, undefined, {
                    persistHierarchicalRootCount: this.future.persistHierarchicalRootCount
                });
                mainHelper.search = function() {
                    _this3.status = "loading";
                    _this3.scheduleRender(false);
                    // This solution allows us to keep the exact same API for the users but
                    // under the hood, we have a different implementation. It should be
                    // completely transparent for the rest of the codebase. Only this module
                    // is impacted.
                    if (_this3._hasSearchWidget) mainHelper.searchOnlyWithDerivedHelpers();
                    if (_this3._hasRecommendWidget) mainHelper.recommend();
                    return mainHelper;
                };
                if (this._searchFunction) {
                    // this client isn't used to actually search, but required for the helper
                    // to not throw errors
                    var fakeClient = {
                        search: function search() {
                            return new Promise((0, $iNPz2.noop));
                        }
                    };
                    this._mainHelperSearch = mainHelper.search.bind(mainHelper);
                    mainHelper.search = function() {
                        var mainIndexHelper = _this3.mainIndex.getHelper();
                        var searchFunctionHelper = (0, (/*@__PURE__*/$parcel$interopDefault($3gYKj)))(fakeClient, mainIndexHelper.state.index, mainIndexHelper.state);
                        searchFunctionHelper.once("search", function(_ref2) {
                            var state = _ref2.state;
                            mainIndexHelper.overrideStateWithoutTriggeringChangeEvent(state);
                            _this3._mainHelperSearch();
                        });
                        // Forward state changes from `searchFunctionHelper` to `mainIndexHelper`
                        searchFunctionHelper.on("change", function(_ref3) {
                            var state = _ref3.state;
                            mainIndexHelper.setState(state);
                        });
                        _this3._searchFunction(searchFunctionHelper);
                        return mainHelper;
                    };
                }
                // Only the "main" Helper emits the `error` event vs the one for `search`
                // and `results` that are also emitted on the derived one.
                mainHelper.on("error", function(_ref4) {
                    var error = _ref4.error;
                    if (!(error instanceof Error)) {
                        // typescript lies here, error is in some cases { name: string, message: string }
                        var err = error;
                        error = Object.keys(err).reduce(function(acc, key) {
                            acc[key] = err[key];
                            return acc;
                        }, new Error(err.message));
                    }
                    // If an error is emitted, it is re-thrown by events. In previous versions
                    // we emitted {error}, which is thrown as:
                    // "Uncaught, unspecified \"error\" event. ([object Object])"
                    // To avoid breaking changes, we make the error available in both
                    // `error` and `error.error`
                    // @MAJOR emit only error
                    error.error = error;
                    _this3.error = error;
                    _this3.status = "error";
                    _this3.scheduleRender(false);
                    // This needs to execute last because it throws the error.
                    _this3.emit("error", error);
                });
                this.mainHelper = mainHelper;
                this.middleware.forEach(function(_ref5) {
                    var instance = _ref5.instance;
                    instance.subscribe();
                });
                this.mainIndex.init({
                    instantSearchInstance: this,
                    parent: null,
                    uiState: this._initialUiState
                });
                if (this._initialResults) {
                    (0, $6bAnG.hydrateSearchClient)(this.client, this._initialResults);
                    (0, $a3Abi.hydrateRecommendCache)(this.mainHelper, this._initialResults);
                    var originalScheduleSearch = this.scheduleSearch;
                    // We don't schedule a first search when initial results are provided
                    // because we already have the results to render. This skips the initial
                    // network request on the browser on `start`.
                    this.scheduleSearch = (0, $9cl1f.defer)((0, $iNPz2.noop));
                    // We also skip the initial network request when widgets are dynamically
                    // added in the first tick (that's the case in all the framework-based flavors).
                    // When we add a widget to `index`, it calls `scheduleSearch`. We can rely
                    // on our `defer` util to restore the original `scheduleSearch` value once
                    // widgets are added to hook back to the regular lifecycle.
                    (0, $9cl1f.defer)(function() {
                        _this3.scheduleSearch = originalScheduleSearch;
                    })();
                } else if (this.mainIndex.getWidgets().length > 0) this.scheduleSearch();
                // Keep the previous reference for legacy purpose, some pattern use
                // the direct Helper access `search.helper` (e.g multi-index).
                this.helper = this.mainIndex.getHelper();
                // track we started the search if we add more widgets,
                // to init them directly after add
                this.started = true;
                this.middleware.forEach(function(_ref6) {
                    var instance = _ref6.instance;
                    instance.started();
                });
                // This is the automatic Insights middleware,
                // added when `insights` is unset and the initial results possess `queryID`.
                // Any user-provided middleware will be added later and override this one.
                if (typeof this._insights === "undefined") mainHelper.derivedHelpers[0].once("result", function() {
                    var hasAutomaticInsights = _this3.mainIndex.getScopedResults().some(function(_ref7) {
                        var results = _ref7.results;
                        return results === null || results === void 0 ? void 0 : results._automaticInsights;
                    });
                    if (hasAutomaticInsights) _this3.use((0, $5gdGA.createInsightsMiddleware)({
                        $$internal: true,
                        $$automatic: true
                    }));
                });
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                var _this$mainHelper2;
                this.scheduleSearch.cancel();
                this.scheduleRender.cancel();
                clearTimeout(this._searchStalledTimer);
                this.removeWidgets(this.mainIndex.getWidgets());
                this.mainIndex.dispose();
                // You can not start an instance two times, therefore a disposed instance
                // needs to set started as false otherwise this can not be restarted at a
                // later point.
                this.started = false;
                // The helper needs to be reset to perform the next search from a fresh state.
                // If not reset, it would use the state stored before calling `dispose()`.
                this.removeAllListeners();
                (_this$mainHelper2 = this.mainHelper) === null || _this$mainHelper2 === void 0 || _this$mainHelper2.removeAllListeners();
                this.mainHelper = null;
                this.helper = null;
                this.middleware.forEach(function(_ref8) {
                    var instance = _ref8.instance;
                    instance.unsubscribe();
                });
            }
        },
        {
            key: "scheduleStalledRender",
            value: function scheduleStalledRender() {
                var _this4 = this;
                if (!this._searchStalledTimer) this._searchStalledTimer = setTimeout(function() {
                    _this4.status = "stalled";
                    _this4.scheduleRender();
                }, this._stalledSearchDelay);
            }
        },
        {
            key: "setUiState",
            value: function setUiState(uiState) {
                var _this5 = this;
                var callOnStateChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                if (!this.mainHelper) throw new Error($48728e0599915634$var$withUsage("The `start` method needs to be called before `setUiState`."));
                // We refresh the index UI state to update the local UI state that the
                // main index passes to the function form of `setUiState`.
                this.mainIndex.refreshUiState();
                var nextUiState = typeof uiState === "function" ? uiState(this.mainIndex.getWidgetUiState({})) : uiState;
                if (this.onStateChange && callOnStateChange) this.onStateChange({
                    uiState: nextUiState,
                    setUiState: function setUiState(finalUiState) {
                        (0, $aD5BU.setIndexHelperState)(typeof finalUiState === "function" ? finalUiState(nextUiState) : finalUiState, _this5.mainIndex);
                        _this5.scheduleSearch();
                        _this5.onInternalStateChange();
                    }
                });
                else {
                    (0, $aD5BU.setIndexHelperState)(nextUiState, this.mainIndex);
                    this.scheduleSearch();
                    this.onInternalStateChange();
                }
            }
        },
        {
            key: "getUiState",
            value: function getUiState() {
                if (this.started) // We refresh the index UI state to make sure changes from `refine` are taken in account
                this.mainIndex.refreshUiState();
                return this.mainIndex.getWidgetUiState({});
            }
        },
        {
            key: "createURL",
            value: function createURL() {
                var nextState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!this.started) throw new Error($48728e0599915634$var$withUsage("The `start` method needs to be called before `createURL`."));
                return this._createURL(nextState);
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                if (!this.mainHelper) throw new Error($48728e0599915634$var$withUsage("The `start` method needs to be called before `refresh`."));
                this.mainHelper.clearCache().search();
            }
        }
    ]);
    return InstantSearch;
}((0, (/*@__PURE__*/$parcel$interopDefault($je6gi))));
var $48728e0599915634$export$2e2bcd8739ae039 = $48728e0599915634$var$InstantSearch;

});
parcelRegister("je6gi", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
function $dff42e9643699667$var$EventEmitter() {
    this._events = this._events || {};
    this._maxListeners = this._maxListeners || undefined;
}
module.exports = $dff42e9643699667$var$EventEmitter;
// Backwards-compat with node 0.10.x
// EventEmitter.EventEmitter = EventEmitter;
$dff42e9643699667$var$EventEmitter.prototype._events = undefined;
$dff42e9643699667$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
$dff42e9643699667$var$EventEmitter.defaultMaxListeners = 10;
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$dff42e9643699667$var$EventEmitter.prototype.setMaxListeners = function(n) {
    if (!$dff42e9643699667$var$isNumber(n) || n < 0 || isNaN(n)) throw TypeError("n must be a positive number");
    this._maxListeners = n;
    return this;
};
$dff42e9643699667$var$EventEmitter.prototype.emit = function(type) {
    var er, handler, len, args, i, listeners;
    if (!this._events) this._events = {};
    // If there is no 'error' event listener then throw.
    if (type === "error") {
        if (!this._events.error || $dff42e9643699667$var$isObject(this._events.error) && !this._events.error.length) {
            er = arguments[1];
            if (er instanceof Error) throw er; // Unhandled 'error' event
            else {
                // At least give some kind of context to the user
                var err = new Error('Uncaught, unspecified "error" event. (' + er + ")");
                err.context = er;
                throw err;
            }
        }
    }
    handler = this._events[type];
    if ($dff42e9643699667$var$isUndefined(handler)) return false;
    if ($dff42e9643699667$var$isFunction(handler)) switch(arguments.length){
        // fast cases
        case 1:
            handler.call(this);
            break;
        case 2:
            handler.call(this, arguments[1]);
            break;
        case 3:
            handler.call(this, arguments[1], arguments[2]);
            break;
        // slower
        default:
            args = Array.prototype.slice.call(arguments, 1);
            handler.apply(this, args);
    }
    else if ($dff42e9643699667$var$isObject(handler)) {
        args = Array.prototype.slice.call(arguments, 1);
        listeners = handler.slice();
        len = listeners.length;
        for(i = 0; i < len; i++)listeners[i].apply(this, args);
    }
    return true;
};
$dff42e9643699667$var$EventEmitter.prototype.addListener = function(type, listener) {
    var m;
    if (!$dff42e9643699667$var$isFunction(listener)) throw TypeError("listener must be a function");
    if (!this._events) this._events = {};
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (this._events.newListener) this.emit("newListener", type, $dff42e9643699667$var$isFunction(listener.listener) ? listener.listener : listener);
    if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
    else if ($dff42e9643699667$var$isObject(this._events[type])) // If we've already got an array, just append.
    this._events[type].push(listener);
    else // Adding the second element, need to change to array.
    this._events[type] = [
        this._events[type],
        listener
    ];
    // Check for listener leak
    if ($dff42e9643699667$var$isObject(this._events[type]) && !this._events[type].warned) {
        if (!$dff42e9643699667$var$isUndefined(this._maxListeners)) m = this._maxListeners;
        else m = $dff42e9643699667$var$EventEmitter.defaultMaxListeners;
        if (m && m > 0 && this._events[type].length > m) {
            this._events[type].warned = true;
            console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.", this._events[type].length);
            if (typeof console.trace === "function") // not supported in IE 10
            console.trace();
        }
    }
    return this;
};
$dff42e9643699667$var$EventEmitter.prototype.on = $dff42e9643699667$var$EventEmitter.prototype.addListener;
$dff42e9643699667$var$EventEmitter.prototype.once = function(type, listener) {
    if (!$dff42e9643699667$var$isFunction(listener)) throw TypeError("listener must be a function");
    var fired = false;
    function g() {
        this.removeListener(type, g);
        if (!fired) {
            fired = true;
            listener.apply(this, arguments);
        }
    }
    g.listener = listener;
    this.on(type, g);
    return this;
};
// emits a 'removeListener' event iff the listener was removed
$dff42e9643699667$var$EventEmitter.prototype.removeListener = function(type, listener) {
    var list, position, length, i;
    if (!$dff42e9643699667$var$isFunction(listener)) throw TypeError("listener must be a function");
    if (!this._events || !this._events[type]) return this;
    list = this._events[type];
    length = list.length;
    position = -1;
    if (list === listener || $dff42e9643699667$var$isFunction(list.listener) && list.listener === listener) {
        delete this._events[type];
        if (this._events.removeListener) this.emit("removeListener", type, listener);
    } else if ($dff42e9643699667$var$isObject(list)) {
        for(i = length; i-- > 0;)if (list[i] === listener || list[i].listener && list[i].listener === listener) {
            position = i;
            break;
        }
        if (position < 0) return this;
        if (list.length === 1) {
            list.length = 0;
            delete this._events[type];
        } else list.splice(position, 1);
        if (this._events.removeListener) this.emit("removeListener", type, listener);
    }
    return this;
};
$dff42e9643699667$var$EventEmitter.prototype.removeAllListeners = function(type) {
    var key, listeners;
    if (!this._events) return this;
    // not listening for removeListener, no need to emit
    if (!this._events.removeListener) {
        if (arguments.length === 0) this._events = {};
        else if (this._events[type]) delete this._events[type];
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        for(key in this._events){
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = {};
        return this;
    }
    listeners = this._events[type];
    if ($dff42e9643699667$var$isFunction(listeners)) this.removeListener(type, listeners);
    else if (listeners) // LIFO order
    while(listeners.length)this.removeListener(type, listeners[listeners.length - 1]);
    delete this._events[type];
    return this;
};
$dff42e9643699667$var$EventEmitter.prototype.listeners = function(type) {
    var ret;
    if (!this._events || !this._events[type]) ret = [];
    else if ($dff42e9643699667$var$isFunction(this._events[type])) ret = [
        this._events[type]
    ];
    else ret = this._events[type].slice();
    return ret;
};
$dff42e9643699667$var$EventEmitter.prototype.listenerCount = function(type) {
    if (this._events) {
        var evlistener = this._events[type];
        if ($dff42e9643699667$var$isFunction(evlistener)) return 1;
        else if (evlistener) return evlistener.length;
    }
    return 0;
};
$dff42e9643699667$var$EventEmitter.listenerCount = function(emitter, type) {
    return emitter.listenerCount(type);
};
function $dff42e9643699667$var$isFunction(arg) {
    return typeof arg === "function";
}
function $dff42e9643699667$var$isNumber(arg) {
    return typeof arg === "number";
}
function $dff42e9643699667$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
function $dff42e9643699667$var$isUndefined(arg) {
    return arg === void 0;
}

});

parcelRegister("3gYKj", function(module, exports) {
"use strict";

var $gAmpq = parcelRequire("gAmpq");

var $431vc = parcelRequire("431vc");

var $6Jx1y = parcelRequire("6Jx1y");

var $gTeiS = parcelRequire("gTeiS");

var $bUiU2 = parcelRequire("bUiU2");
/**
 * The algoliasearchHelper module is the function that will let its
 * contains everything needed to use the Algoliasearch
 * Helper. It is a also a function that instanciate the helper.
 * To use the helper, you also need the Algolia JS client v3.
 * @example
 * //using the UMD build
 * var client = algoliasearch('latency', '6be0576ff61c053d5f9a3225e2a90f76');
 * var helper = algoliasearchHelper(client, 'bestbuy', {
 *   facets: ['shipping'],
 *   disjunctiveFacets: ['category']
 * });
 * helper.on('result', function(event) {
 *   console.log(event.results);
 * });
 * helper
 *   .toggleFacetRefinement('category', 'Movies & TV Shows')
 *   .toggleFacetRefinement('shipping', 'Free shipping')
 *   .search();
 * @example
 * // The helper is an event emitter using the node API
 * helper.on('result', updateTheResults);
 * helper.once('result', updateTheResults);
 * helper.removeListener('result', updateTheResults);
 * helper.removeAllListeners('result');
 * @module algoliasearchHelper
 * @param  {AlgoliaSearch} client an AlgoliaSearch client
 * @param  {string} index the name of the index to query
 * @param  {SearchParameters|object} opts an object defining the initial config of the search. It doesn't have to be a {SearchParameters}, just an object containing the properties you need from it.
 * @param {SearchResultsOptions|object} searchResultsOptions an object defining the options to use when creating the search results.
 * @return {AlgoliaSearchHelper} The helper instance
 */ function $2621fca0bea18d29$var$algoliasearchHelper(client, index, opts, searchResultsOptions) {
    return new $gAmpq(client, index, opts, searchResultsOptions);
}

/**
 * The version currently used
 * @member module:algoliasearchHelper.version
 * @type {number}
 */ $2621fca0bea18d29$var$algoliasearchHelper.version = (parcelRequire("4kbyH"));
/**
 * Constructor for the Helper.
 * @member module:algoliasearchHelper.AlgoliaSearchHelper
 * @type {AlgoliaSearchHelper}
 */ $2621fca0bea18d29$var$algoliasearchHelper.AlgoliaSearchHelper = $gAmpq;
/**
 * Constructor for the object containing all the parameters of the search.
 * @member module:algoliasearchHelper.SearchParameters
 * @type {SearchParameters}
 */ $2621fca0bea18d29$var$algoliasearchHelper.SearchParameters = $gTeiS;
/**
 * Constructor for the object containing all the parameters for Recommend.
 * @member module:algoliasearchHelper.RecommendParameters
 * @type {RecommendParameters}
 */ $2621fca0bea18d29$var$algoliasearchHelper.RecommendParameters = $431vc;
/**
 * Constructor for the object containing the results of the search.
 * @member module:algoliasearchHelper.SearchResults
 * @type {SearchResults}
 */ $2621fca0bea18d29$var$algoliasearchHelper.SearchResults = $bUiU2;
/**
 * Constructor for the object containing the results for Recommend.
 * @member module:algoliasearchHelper.RecommendResults
 * @type {RecommendResults}
 */ $2621fca0bea18d29$var$algoliasearchHelper.RecommendResults = $6Jx1y;
module.exports = $2621fca0bea18d29$var$algoliasearchHelper;

});
parcelRegister("gAmpq", function(module, exports) {
"use strict";

var $je6gi = parcelRequire("je6gi");

var $8fAjb = parcelRequire("8fAjb");

var $9IuIV = parcelRequire("9IuIV");
var $c131641798835750$require$escapeFacetValue = $9IuIV.escapeFacetValue;

var $TTPKp = parcelRequire("TTPKp");

var $cNauE = parcelRequire("cNauE");

var $hPi9R = parcelRequire("hPi9R");

var $2SavI = parcelRequire("2SavI");

var $431vc = parcelRequire("431vc");

var $6Jx1y = parcelRequire("6Jx1y");

var $dWBey = parcelRequire("dWBey");

var $gTeiS = parcelRequire("gTeiS");

var $bUiU2 = parcelRequire("bUiU2");

var $gll5V = parcelRequire("gll5V");

var $4kbyH = parcelRequire("4kbyH");
/**
 * Event triggered when a parameter is set or updated
 * @event AlgoliaSearchHelper#event:change
 * @property {object} event
 * @property {SearchParameters} event.state the current parameters with the latest changes applied
 * @property {SearchResults} event.results the previous results received from Algolia. `null` before the first request
 * @example
 * helper.on('change', function(event) {
 *   console.log('The parameters have changed');
 * });
 */ /**
 * Event triggered when a main search is sent to Algolia
 * @event AlgoliaSearchHelper#event:search
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search
 * @property {SearchResults} event.results the results from the previous search. `null` if it is the first search.
 * @example
 * helper.on('search', function(event) {
 *   console.log('Search sent');
 * });
 */ /**
 * Event triggered when a search using `searchForFacetValues` is sent to Algolia
 * @event AlgoliaSearchHelper#event:searchForFacetValues
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search it is the first search.
 * @property {string} event.facet the facet searched into
 * @property {string} event.query the query used to search in the facets
 * @example
 * helper.on('searchForFacetValues', function(event) {
 *   console.log('searchForFacetValues sent');
 * });
 */ /**
 * Event triggered when a search using `searchOnce` is sent to Algolia
 * @event AlgoliaSearchHelper#event:searchOnce
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search it is the first search.
 * @example
 * helper.on('searchOnce', function(event) {
 *   console.log('searchOnce sent');
 * });
 */ /**
 * Event triggered when the results are retrieved from Algolia
 * @event AlgoliaSearchHelper#event:result
 * @property {object} event
 * @property {SearchResults} event.results the results received from Algolia
 * @property {SearchParameters} event.state the parameters used to query Algolia. Those might be different from the one in the helper instance (for example if the network is unreliable).
 * @example
 * helper.on('result', function(event) {
 *   console.log('Search results received');
 * });
 */ /**
 * Event triggered when Algolia sends back an error. For example, if an unknown parameter is
 * used, the error can be caught using this event.
 * @event AlgoliaSearchHelper#event:error
 * @property {object} event
 * @property {Error} event.error the error returned by the Algolia.
 * @example
 * helper.on('error', function(event) {
 *   console.log('Houston we got a problem.');
 * });
 */ /**
 * Event triggered when the queue of queries have been depleted (with any result or outdated queries)
 * @event AlgoliaSearchHelper#event:searchQueueEmpty
 * @example
 * helper.on('searchQueueEmpty', function() {
 *   console.log('No more search pending');
 *   // This is received before the result event if we're not expecting new results
 * });
 *
 * helper.search();
 */ /**
 * Initialize a new AlgoliaSearchHelper
 * @class
 * @classdesc The AlgoliaSearchHelper is a class that ease the management of the
 * search. It provides an event based interface for search callbacks:
 *  - change: when the internal search state is changed.
 *    This event contains a {@link SearchParameters} object and the
 *    {@link SearchResults} of the last result if any.
 *  - search: when a search is triggered using the `search()` method.
 *  - result: when the response is retrieved from Algolia and is processed.
 *    This event contains a {@link SearchResults} object and the
 *    {@link SearchParameters} corresponding to this answer.
 *  - error: when the response is an error. This event contains the error returned by the server.
 * @param  {AlgoliaSearch} client an AlgoliaSearch client
 * @param  {string} index the index name to query
 * @param  {SearchParameters | object} options an object defining the initial
 * config of the search. It doesn't have to be a {SearchParameters},
 * just an object containing the properties you need from it.
 * @param {SearchResultsOptions|object} searchResultsOptions an object defining the options to use when creating the search results.
 */ function $c131641798835750$var$AlgoliaSearchHelper(client, index, options, searchResultsOptions) {
    if (typeof client.addAlgoliaAgent === "function") client.addAlgoliaAgent("JS Helper (" + $4kbyH + ")");
    this.setClient(client);
    var opts = options || {};
    opts.index = index;
    this.state = $gTeiS.make(opts);
    this.recommendState = new $431vc({
        params: opts.recommendState
    });
    this.lastResults = null;
    this.lastRecommendResults = null;
    this._queryId = 0;
    this._recommendQueryId = 0;
    this._lastQueryIdReceived = -1;
    this._lastRecommendQueryIdReceived = -1;
    this.derivedHelpers = [];
    this._currentNbQueries = 0;
    this._currentNbRecommendQueries = 0;
    this._searchResultsOptions = searchResultsOptions;
    this._recommendCache = {};
}
$TTPKp($c131641798835750$var$AlgoliaSearchHelper, $je6gi);
/**
 * Start the search with the parameters set in the state. When the
 * method is called, it triggers a `search` event. The results will
 * be available through the `result` event. If an error occurs, an
 * `error` will be fired instead.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires search
 * @fires result
 * @fires error
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.search = function() {
    this._search({
        onlyWithDerivedHelpers: false
    });
    return this;
};
$c131641798835750$var$AlgoliaSearchHelper.prototype.searchOnlyWithDerivedHelpers = function() {
    this._search({
        onlyWithDerivedHelpers: true
    });
    return this;
};
/**
 * Sends the recommendation queries set in the state. When the method is
 * called, it triggers a `fetch` event. The results will be available through
 * the `result` event. If an error occurs, an `error` will be fired instead.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires fetch
 * @fires result
 * @fires error
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.recommend = function() {
    this._recommend();
    return this;
};
/**
 * Gets the search query parameters that would be sent to the Algolia Client
 * for the hits
 * @return {object} Query Parameters
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.getQuery = function() {
    var state = this.state;
    return $dWBey._getHitsSearchParams(state);
};
/**
 * Start a search using a modified version of the current state. This method does
 * not trigger the helper lifecycle and does not modify the state kept internally
 * by the helper. This second aspect means that the next search call will be the
 * same as a search call before calling searchOnce.
 * @param {object} options can contain all the parameters that can be set to SearchParameters
 * plus the index
 * @param {function} [cb] optional callback executed when the response from the
 * server is back.
 * @return {promise|undefined} if a callback is passed the method returns undefined
 * otherwise it returns a promise containing an object with two keys :
 *  - content with a SearchResults
 *  - state with the state used for the query as a SearchParameters
 * @example
 * // Changing the number of records returned per page to 1
 * // This example uses the callback API
 * var state = helper.searchOnce({hitsPerPage: 1},
 *   function(error, content, state) {
 *     // if an error occurred it will be passed in error, otherwise its value is null
 *     // content contains the results formatted as a SearchResults
 *     // state is the instance of SearchParameters used for this search
 *   });
 * @example
 * // Changing the number of records returned per page to 1
 * // This example uses the promise API
 * var state1 = helper.searchOnce({hitsPerPage: 1})
 *                 .then(promiseHandler);
 *
 * function promiseHandler(res) {
 *   // res contains
 *   // {
 *   //   content : SearchResults
 *   //   state   : SearchParameters (the one used for this specific search)
 *   // }
 * }
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.searchOnce = function(options, cb) {
    var tempState = !options ? this.state : this.state.setQueryParameters(options);
    var queries = $dWBey._getQueries(tempState.index, tempState);
    // eslint-disable-next-line consistent-this
    var self = this;
    this._currentNbQueries++;
    this.emit("searchOnce", {
        state: tempState
    });
    if (cb) {
        this.client.search(queries).then(function(content) {
            self._currentNbQueries--;
            if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
            cb(null, new $bUiU2(tempState, content.results), tempState);
        }).catch(function(err) {
            self._currentNbQueries--;
            if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
            cb(err, null, tempState);
        });
        return undefined;
    }
    return this.client.search(queries).then(function(content) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
        return {
            content: new $bUiU2(tempState, content.results),
            state: tempState,
            _originalResponse: content
        };
    }, function(e) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
        throw e;
    });
};
/**
 * Start the search for answers with the parameters set in the state.
 * This method returns a promise.
 * @param {Object} options - the options for answers API call
 * @param {string[]} options.attributesForPrediction - Attributes to use for predictions. If empty, `searchableAttributes` is used instead.
 * @param {string[]} options.queryLanguages - The languages in the query. Currently only supports ['en'].
 * @param {number} options.nbHits - Maximum number of answers to retrieve from the Answers Engine. Cannot be greater than 1000.
 *
 * @return {promise} the answer results
 * @deprecated answers is deprecated and will be replaced with new initiatives
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.findAnswers = function(options) {
    // eslint-disable-next-line no-console
    console.warn("[algoliasearch-helper] answers is no longer supported");
    var state = this.state;
    var derivedHelper = this.derivedHelpers[0];
    if (!derivedHelper) return Promise.resolve([]);
    var derivedState = derivedHelper.getModifiedState(state);
    var data = $cNauE({
        attributesForPrediction: options.attributesForPrediction,
        nbHits: options.nbHits
    }, {
        params: $2SavI($dWBey._getHitsSearchParams(derivedState), [
            "attributesToSnippet",
            "hitsPerPage",
            "restrictSearchableAttributes",
            "snippetEllipsisText"
        ])
    });
    var errorMessage = "search for answers was called, but this client does not have a function client.initIndex(index).findAnswers";
    if (typeof this.client.initIndex !== "function") throw new Error(errorMessage);
    var index = this.client.initIndex(derivedState.index);
    if (typeof index.findAnswers !== "function") throw new Error(errorMessage);
    return index.findAnswers(derivedState.query, options.queryLanguages, data);
};
/**
 * Structure of each result when using
 * [`searchForFacetValues()`](reference.html#AlgoliaSearchHelper#searchForFacetValues)
 * @typedef FacetSearchHit
 * @type {object}
 * @property {string} value the facet value
 * @property {string} highlighted the facet value highlighted with the query string
 * @property {number} count number of occurrence of this facet value
 * @property {boolean} isRefined true if the value is already refined
 */ /**
 * Structure of the data resolved by the
 * [`searchForFacetValues()`](reference.html#AlgoliaSearchHelper#searchForFacetValues)
 * promise.
 * @typedef FacetSearchResult
 * @type {object}
 * @property {FacetSearchHit} facetHits the results for this search for facet values
 * @property {number} processingTimeMS time taken by the query inside the engine
 */ /**
 * Search for facet values based on an query and the name of a faceted attribute. This
 * triggers a search and will return a promise. On top of using the query, it also sends
 * the parameters from the state so that the search is narrowed down to only the possible values.
 *
 * See the description of [FacetSearchResult](reference.html#FacetSearchResult)
 * @param {string} facet the name of the faceted attribute
 * @param {string} query the string query for the search
 * @param {number} [maxFacetHits] the maximum number values returned. Should be > 0 and <= 100
 * @param {object} [userState] the set of custom parameters to use on top of the current state. Setting a property to `undefined` removes
 * it in the generated query.
 * @return {promise.<FacetSearchResult>} the results of the search
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.searchForFacetValues = function(facet, query, maxFacetHits, userState) {
    var clientHasSFFV = typeof this.client.searchForFacetValues === "function" && // v5 has a wrong sffv signature
    typeof this.client.searchForFacets !== "function";
    var clientHasInitIndex = typeof this.client.initIndex === "function";
    if (!clientHasSFFV && !clientHasInitIndex && typeof this.client.search !== "function") throw new Error("search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues or client.initIndex(index).searchForFacetValues");
    var state = this.state.setQueryParameters(userState || {});
    var isDisjunctive = state.isDisjunctiveFacet(facet);
    var algoliaQuery = $dWBey.getSearchForFacetQuery(facet, query, maxFacetHits, state);
    this._currentNbQueries++;
    // eslint-disable-next-line consistent-this
    var self = this;
    var searchForFacetValuesPromise;
    // newer algoliasearch ^3.27.1 - ~4.0.0
    if (clientHasSFFV) searchForFacetValuesPromise = this.client.searchForFacetValues([
        {
            indexName: state.index,
            params: algoliaQuery
        }
    ]);
    else if (clientHasInitIndex) searchForFacetValuesPromise = this.client.initIndex(state.index).searchForFacetValues(algoliaQuery);
    else {
        // @MAJOR only use client.search
        delete algoliaQuery.facetName;
        searchForFacetValuesPromise = this.client.search([
            {
                type: "facet",
                facet: facet,
                indexName: state.index,
                params: algoliaQuery
            }
        ]).then(function processResponse(response) {
            return response.results[0];
        });
    }
    this.emit("searchForFacetValues", {
        state: state,
        facet: facet,
        query: query
    });
    return searchForFacetValuesPromise.then(function addIsRefined(content) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
        content = Array.isArray(content) ? content[0] : content;
        content.facetHits.forEach(function(f) {
            f.escapedValue = $c131641798835750$require$escapeFacetValue(f.value);
            f.isRefined = isDisjunctive ? state.isDisjunctiveFacetRefined(facet, f.escapedValue) : state.isFacetRefined(facet, f.escapedValue);
        });
        return content;
    }, function(e) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit("searchQueueEmpty");
        throw e;
    });
};
/**
 * Sets the text query used for the search.
 *
 * This method resets the current page to 0.
 * @param  {string} q the user query
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.setQuery = function(q) {
    this._change({
        state: this.state.resetPage().setQuery(q),
        isPageReset: true
    });
    return this;
};
/**
 * Remove all the types of refinements except tags. A string can be provided to remove
 * only the refinements of a specific attribute. For more advanced use case, you can
 * provide a function instead. This function should follow the
 * [clearCallback definition](#SearchParameters.clearCallback).
 *
 * This method resets the current page to 0.
 * @param {string} [name] optional name of the facet / attribute on which we want to remove all refinements
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * // Removing all the refinements
 * helper.clearRefinements().search();
 * @example
 * // Removing all the filters on a the category attribute.
 * helper.clearRefinements('category').search();
 * @example
 * // Removing only the exclude filters on the category facet.
 * helper.clearRefinements(function(value, attribute, type) {
 *   return type === 'exclude' && attribute === 'category';
 * }).search();
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.clearRefinements = function(name) {
    this._change({
        state: this.state.resetPage().clearRefinements(name),
        isPageReset: true
    });
    return this;
};
/**
 * Remove all the tag filters.
 *
 * This method resets the current page to 0.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.clearTags = function() {
    this._change({
        state: this.state.resetPage().clearTags(),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a disjunctive filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.addDisjunctiveFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().addDisjunctiveFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addDisjunctiveFacetRefinement}
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.addDisjunctiveRefine = function() {
    return this.addDisjunctiveFacetRefinement.apply(this, arguments);
};
/**
 * Adds a refinement on a hierarchical facet. It will throw
 * an exception if the facet is not defined or if the facet
 * is already refined.
 *
 * This method resets the current page to 0.
 * @param {string} facet the facet name
 * @param {string} path the hierarchical facet path
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error if the facet is not defined or if the facet is refined
 * @chainable
 * @fires change
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.addHierarchicalFacetRefinement = function(facet, path) {
    this._change({
        state: this.state.resetPage().addHierarchicalFacetRefinement(facet, path),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a an numeric filter to an attribute with the `operator` and `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} attribute the attribute on which the numeric filter applies
 * @param  {string} operator the operator of the filter
 * @param  {number} value the value of the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.addNumericRefinement = function(attribute, operator, value) {
    this._change({
        state: this.state.resetPage().addNumericRefinement(attribute, operator, value),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.addFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().addFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addFacetRefinement}
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.addRefine = function() {
    return this.addFacetRefinement.apply(this, arguments);
};
/**
 * Adds a an exclusion filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.addFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().addExcludeRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addFacetExclusion}
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.addExclude = function() {
    return this.addFacetExclusion.apply(this, arguments);
};
/**
 * Adds a tag filter with the `tag` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param {string} tag the tag to add to the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.addTag = function(tag) {
    this._change({
        state: this.state.resetPage().addTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a "frequently bought together" recommendation query.
 *
 * @param {FrequentlyBoughtTogetherQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.addFrequentlyBoughtTogether = function(params) {
    this._recommendChange({
        state: this.recommendState.addFrequentlyBoughtTogether(params)
    });
    return this;
};
/**
 * Adds a "related products" recommendation query.
 *
 * @param {RelatedProductsQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.addRelatedProducts = function(params) {
    this._recommendChange({
        state: this.recommendState.addRelatedProducts(params)
    });
    return this;
};
/**
 * Adds a "trending items" recommendation query.
 *
 * @param {TrendingItemsQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.addTrendingItems = function(params) {
    this._recommendChange({
        state: this.recommendState.addTrendingItems(params)
    });
    return this;
};
/**
 * Adds a "trending facets" recommendation query.
 *
 * @param {TrendingFacetsQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.addTrendingFacets = function(params) {
    this._recommendChange({
        state: this.recommendState.addTrendingFacets(params)
    });
    return this;
};
/**
 * Adds a "looking similar" recommendation query.
 *
 * @param {LookingSimilarQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.addLookingSimilar = function(params) {
    this._recommendChange({
        state: this.recommendState.addLookingSimilar(params)
    });
    return this;
};
/**
 * Removes an numeric filter to an attribute with the `operator` and `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * Some parameters are optional, triggering different behavior:
 *  - if the value is not provided, then all the numeric value will be removed for the
 *  specified attribute/operator couple.
 *  - if the operator is not provided either, then all the numeric filter on this attribute
 *  will be removed.
 *
 * This method resets the current page to 0.
 * @param  {string} attribute the attribute on which the numeric filter applies
 * @param  {string} [operator] the operator of the filter
 * @param  {number} [value] the value of the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.removeNumericRefinement = function(attribute, operator, value) {
    this._change({
        state: this.state.resetPage().removeNumericRefinement(attribute, operator, value),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a disjunctive filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.removeDisjunctiveFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeDisjunctiveFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeDisjunctiveFacetRefinement}
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.removeDisjunctiveRefine = function() {
    return this.removeDisjunctiveFacetRefinement.apply(this, arguments);
};
/**
 * Removes the refinement set on a hierarchical facet.
 * @param {string} facet the facet name
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error if the facet is not defined or if the facet is not refined
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.removeHierarchicalFacetRefinement = function(facet) {
    this._change({
        state: this.state.resetPage().removeHierarchicalFacetRefinement(facet),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.removeFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeFacetRefinement}
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.removeRefine = function() {
    return this.removeFacetRefinement.apply(this, arguments);
};
/**
 * Removes an exclusion filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.removeFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeExcludeRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeFacetExclusion}
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.removeExclude = function() {
    return this.removeFacetExclusion.apply(this, arguments);
};
/**
 * Removes a tag filter with the `tag` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param {string} tag tag to remove from the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.removeTag = function(tag) {
    this._change({
        state: this.state.resetPage().removeTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a "frequently bought together" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.removeFrequentlyBoughtTogether = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "related products" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.removeRelatedProducts = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "trending items" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.removeTrendingItems = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "trending facets" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.removeTrendingFacets = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "looking similar" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.removeLookingSimilar = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Adds or removes an exclusion filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.toggleFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().toggleExcludeFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#toggleFacetExclusion}
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.toggleExclude = function() {
    return this.toggleFacetExclusion.apply(this, arguments);
};
/**
 * Adds or removes a filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method can be used for conjunctive, disjunctive and hierarchical filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error will throw an error if the facet is not declared in the settings of the helper
 * @fires change
 * @chainable
 * @deprecated since version 2.19.0, see {@link AlgoliaSearchHelper#toggleFacetRefinement}
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.toggleRefinement = function(facet, value) {
    return this.toggleFacetRefinement(facet, value);
};
/**
 * Adds or removes a filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method can be used for conjunctive, disjunctive and hierarchical filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error will throw an error if the facet is not declared in the settings of the helper
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.toggleFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().toggleFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#toggleFacetRefinement}
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.toggleRefine = function() {
    return this.toggleFacetRefinement.apply(this, arguments);
};
/**
 * Adds or removes a tag filter with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method resets the current page to 0.
 * @param {string} tag tag to remove or add
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.toggleTag = function(tag) {
    this._change({
        state: this.state.resetPage().toggleTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Increments the page number by one.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * helper.setPage(0).nextPage().getPage();
 * // returns 1
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.nextPage = function() {
    var page = this.state.page || 0;
    return this.setPage(page + 1);
};
/**
 * Decrements the page number by one.
 * @fires change
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @chainable
 * @example
 * helper.setPage(1).previousPage().getPage();
 * // returns 0
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.previousPage = function() {
    var page = this.state.page || 0;
    return this.setPage(page - 1);
};
/**
 * @private
 * @param {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @chainable
 * @fires change
 */ function $c131641798835750$var$setCurrentPage(page) {
    if (page < 0) throw new Error("Page requested below 0.");
    this._change({
        state: this.state.setPage(page),
        isPageReset: false
    });
    return this;
}
/**
 * Change the current page
 * @deprecated
 * @param  {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.setCurrentPage = $c131641798835750$var$setCurrentPage;
/**
 * Updates the current page.
 * @function
 * @param  {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.setPage = $c131641798835750$var$setCurrentPage;
/**
 * Updates the name of the index that will be targeted by the query.
 *
 * This method resets the current page to 0.
 * @param {string} name the index name
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.setIndex = function(name) {
    this._change({
        state: this.state.resetPage().setIndex(name),
        isPageReset: true
    });
    return this;
};
/**
 * Update a parameter of the search. This method reset the page
 *
 * The complete list of parameters is available on the
 * [Algolia website](https://www.algolia.com/doc/rest#query-an-index).
 * The most commonly used parameters have their own [shortcuts](#query-parameters-shortcuts)
 * or benefit from higher-level APIs (all the kind of filters and facets have their own API)
 *
 * This method resets the current page to 0.
 * @param {string} parameter name of the parameter to update
 * @param {any} value new value of the parameter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * helper.setQueryParameter('hitsPerPage', 20).search();
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.setQueryParameter = function(parameter, value) {
    this._change({
        state: this.state.resetPage().setQueryParameter(parameter, value),
        isPageReset: true
    });
    return this;
};
/**
 * Set the whole state (warning: will erase previous state)
 * @param {SearchParameters} newState the whole new state
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.setState = function(newState) {
    this._change({
        state: $gTeiS.make(newState),
        isPageReset: false
    });
    return this;
};
/**
 * Override the current state without triggering a change event.
 * Do not use this method unless you know what you are doing. (see the example
 * for a legit use case)
 * @param {SearchParameters} newState the whole new state
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @example
 *  helper.on('change', function(state){
 *    // In this function you might want to find a way to store the state in the url/history
 *    updateYourURL(state)
 *  })
 *  window.onpopstate = function(event){
 *    // This is naive though as you should check if the state is really defined etc.
 *    helper.overrideStateWithoutTriggeringChangeEvent(event.state).search()
 *  }
 * @chainable
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.overrideStateWithoutTriggeringChangeEvent = function(newState) {
    this.state = new $gTeiS(newState);
    return this;
};
/**
 * Check if an attribute has any numeric, conjunctive, disjunctive or hierarchical filters.
 * @param {string} attribute the name of the attribute
 * @return {boolean} true if the attribute is filtered by at least one value
 * @example
 * // hasRefinements works with numeric, conjunctive, disjunctive and hierarchical filters
 * helper.hasRefinements('price'); // false
 * helper.addNumericRefinement('price', '>', 100);
 * helper.hasRefinements('price'); // true
 *
 * helper.hasRefinements('color'); // false
 * helper.addFacetRefinement('color', 'blue');
 * helper.hasRefinements('color'); // true
 *
 * helper.hasRefinements('material'); // false
 * helper.addDisjunctiveFacetRefinement('material', 'plastic');
 * helper.hasRefinements('material'); // true
 *
 * helper.hasRefinements('categories'); // false
 * helper.toggleFacetRefinement('categories', 'kitchen > knife');
 * helper.hasRefinements('categories'); // true
 *
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.hasRefinements = function(attribute) {
    if ($hPi9R(this.state.getNumericRefinements(attribute))) return true;
    else if (this.state.isConjunctiveFacet(attribute)) return this.state.isFacetRefined(attribute);
    else if (this.state.isDisjunctiveFacet(attribute)) return this.state.isDisjunctiveFacetRefined(attribute);
    else if (this.state.isHierarchicalFacet(attribute)) return this.state.isHierarchicalFacetRefined(attribute);
    // there's currently no way to know that the user did call `addNumericRefinement` at some point
    // thus we cannot distinguish if there once was a numeric refinement that was cleared
    // so we will return false in every other situations to be consistent
    // while what we should do here is throw because we did not find the attribute in any type
    // of refinement
    return false;
};
/**
 * Check if a value is excluded for a specific faceted attribute. If the value
 * is omitted then the function checks if there is any excluding refinements.
 *
 * @param  {string}  facet name of the attribute for used for faceting
 * @param  {string}  [value] optional value. If passed will test that this value
 * is filtering the given facet.
 * @return {boolean} true if refined
 * @example
 * helper.isExcludeRefined('color'); // false
 * helper.isExcludeRefined('color', 'blue') // false
 * helper.isExcludeRefined('color', 'red') // false
 *
 * helper.addFacetExclusion('color', 'red');
 *
 * helper.isExcludeRefined('color'); // true
 * helper.isExcludeRefined('color', 'blue') // false
 * helper.isExcludeRefined('color', 'red') // true
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.isExcluded = function(facet, value) {
    return this.state.isExcludeRefined(facet, value);
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasRefinements}
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.isDisjunctiveRefined = function(facet, value) {
    return this.state.isDisjunctiveFacetRefined(facet, value);
};
/**
 * Check if the string is a currently filtering tag.
 * @param {string} tag tag to check
 * @return {boolean} true if the tag is currently refined
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.hasTag = function(tag) {
    return this.state.isTagRefined(tag);
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasTag}
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.isTagRefined = function() {
    return this.hasTagRefinements.apply(this, arguments);
};
/**
 * Get the name of the currently used index.
 * @return {string} name of the index
 * @example
 * helper.setIndex('highestPrice_products').getIndex();
 * // returns 'highestPrice_products'
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.getIndex = function() {
    return this.state.index;
};
function $c131641798835750$var$getCurrentPage() {
    return this.state.page;
}
/**
 * Get the currently selected page
 * @deprecated
 * @return {number} the current page
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.getCurrentPage = $c131641798835750$var$getCurrentPage;
/**
 * Get the currently selected page
 * @function
 * @return {number} the current page
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.getPage = $c131641798835750$var$getCurrentPage;
/**
 * Get all the tags currently set to filters the results.
 *
 * @return {string[]} The list of tags currently set.
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.getTags = function() {
    return this.state.tagRefinements;
};
/**
 * Get the list of refinements for a given attribute. This method works with
 * conjunctive, disjunctive, excluding and numerical filters.
 *
 * See also SearchResults#getRefinements
 *
 * @param {string} facetName attribute name used for faceting
 * @return {Array.<FacetRefinement|NumericRefinement>} All Refinement are objects that contain a value, and
 * a type. Numeric also contains an operator.
 * @example
 * helper.addNumericRefinement('price', '>', 100);
 * helper.getRefinements('price');
 * // [
 * //   {
 * //     "value": [
 * //       100
 * //     ],
 * //     "operator": ">",
 * //     "type": "numeric"
 * //   }
 * // ]
 * @example
 * helper.addFacetRefinement('color', 'blue');
 * helper.addFacetExclusion('color', 'red');
 * helper.getRefinements('color');
 * // [
 * //   {
 * //     "value": "blue",
 * //     "type": "conjunctive"
 * //   },
 * //   {
 * //     "value": "red",
 * //     "type": "exclude"
 * //   }
 * // ]
 * @example
 * helper.addDisjunctiveFacetRefinement('material', 'plastic');
 * // [
 * //   {
 * //     "value": "plastic",
 * //     "type": "disjunctive"
 * //   }
 * // ]
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.getRefinements = function(facetName) {
    var refinements = [];
    if (this.state.isConjunctiveFacet(facetName)) {
        var conjRefinements = this.state.getConjunctiveRefinements(facetName);
        conjRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: "conjunctive"
            });
        });
        var excludeRefinements = this.state.getExcludeRefinements(facetName);
        excludeRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: "exclude"
            });
        });
    } else if (this.state.isDisjunctiveFacet(facetName)) {
        var disjunctiveRefinements = this.state.getDisjunctiveRefinements(facetName);
        disjunctiveRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: "disjunctive"
            });
        });
    }
    var numericRefinements = this.state.getNumericRefinements(facetName);
    Object.keys(numericRefinements).forEach(function(operator) {
        var value = numericRefinements[operator];
        refinements.push({
            value: value,
            operator: operator,
            type: "numeric"
        });
    });
    return refinements;
};
/**
 * Return the current refinement for the (attribute, operator)
 * @param {string} attribute attribute in the record
 * @param {string} operator operator applied on the refined values
 * @return {Array.<number|number[]>} refined values
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.getNumericRefinement = function(attribute, operator) {
    return this.state.getNumericRefinement(attribute, operator);
};
/**
 * Get the current breadcrumb for a hierarchical facet, as an array
 * @param  {string} facetName Hierarchical facet name
 * @return {array.<string>} the path as an array of string
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.getHierarchicalFacetBreadcrumb = function(facetName) {
    return this.state.getHierarchicalFacetBreadcrumb(facetName);
};
// /////////// PRIVATE
/**
 * Perform the underlying queries
 * @private
 * @param {object} options options for the query
 * @param {boolean} [options.onlyWithDerivedHelpers=false] if true, only the derived helpers will be queried
 * @return {undefined} does not return anything
 * @fires search
 * @fires result
 * @fires error
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype._search = function(options) {
    var state = this.state;
    var states = [];
    var mainQueries = [];
    if (!options.onlyWithDerivedHelpers) {
        mainQueries = $dWBey._getQueries(state.index, state);
        states.push({
            state: state,
            queriesCount: mainQueries.length,
            helper: this
        });
        this.emit("search", {
            state: state,
            results: this.lastResults
        });
    }
    var derivedQueries = this.derivedHelpers.map(function(derivedHelper) {
        var derivedState = derivedHelper.getModifiedState(state);
        var derivedStateQueries = derivedState.index ? $dWBey._getQueries(derivedState.index, derivedState) : [];
        states.push({
            state: derivedState,
            queriesCount: derivedStateQueries.length,
            helper: derivedHelper
        });
        derivedHelper.emit("search", {
            state: derivedState,
            results: derivedHelper.lastResults
        });
        return derivedStateQueries;
    });
    var queries = Array.prototype.concat.apply(mainQueries, derivedQueries);
    var queryId = this._queryId++;
    this._currentNbQueries++;
    if (!queries.length) return Promise.resolve({
        results: []
    }).then(this._dispatchAlgoliaResponse.bind(this, states, queryId));
    try {
        this.client.search(queries).then(this._dispatchAlgoliaResponse.bind(this, states, queryId)).catch(this._dispatchAlgoliaError.bind(this, queryId));
    } catch (error) {
        // If we reach this part, we're in an internal error state
        this.emit("error", {
            error: error
        });
    }
    return undefined;
};
$c131641798835750$var$AlgoliaSearchHelper.prototype._recommend = function() {
    var searchState = this.state;
    var recommendState = this.recommendState;
    var index = this.getIndex();
    var states = [
        {
            state: recommendState,
            index: index,
            helper: this
        }
    ];
    var ids = recommendState.params.map(function(param) {
        return param.$$id;
    });
    this.emit("fetch", {
        recommend: {
            state: recommendState,
            results: this.lastRecommendResults
        }
    });
    var cache = this._recommendCache;
    var derivedQueries = this.derivedHelpers.map(function(derivedHelper) {
        var derivedIndex = derivedHelper.getModifiedState(searchState).index;
        if (!derivedIndex) return [];
        // Contrary to what is done when deriving the search state, we don't want to
        // provide the current recommend state to the derived helper, as it would
        // inherit unwanted queries. We instead provide an empty recommend state.
        var derivedState = derivedHelper.getModifiedRecommendState(new $431vc());
        states.push({
            state: derivedState,
            index: derivedIndex,
            helper: derivedHelper
        });
        ids = Array.prototype.concat.apply(ids, derivedState.params.map(function(param) {
            return param.$$id;
        }));
        derivedHelper.emit("fetch", {
            recommend: {
                state: derivedState,
                results: derivedHelper.lastRecommendResults
            }
        });
        return derivedState._buildQueries(derivedIndex, cache);
    });
    var queries = Array.prototype.concat.apply(this.recommendState._buildQueries(index, cache), derivedQueries);
    if (queries.length === 0) return;
    if (queries.length > 0 && typeof this.client.getRecommendations === "undefined") {
        // eslint-disable-next-line no-console
        console.warn("Please update algoliasearch/lite to the latest version in order to use recommend widgets.");
        return;
    }
    var queryId = this._recommendQueryId++;
    this._currentNbRecommendQueries++;
    try {
        this.client.getRecommendations(queries).then(this._dispatchRecommendResponse.bind(this, queryId, states, ids)).catch(this._dispatchRecommendError.bind(this, queryId));
    } catch (error) {
        // If we reach this part, we're in an internal error state
        this.emit("error", {
            error: error
        });
    }
    return;
};
/**
 * Transform the responses as sent by the server and transform them into a user
 * usable object that merge the results of all the batch requests. It will dispatch
 * over the different helper + derived helpers (when there are some).
 * @private
 * @param {array.<{SearchParameters, AlgoliaQueries, AlgoliaSearchHelper}>} states state used to generate the request
 * @param {number} queryId id of the current request
 * @param {object} content content of the response
 * @return {undefined}
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype._dispatchAlgoliaResponse = function(states, queryId, content) {
    // eslint-disable-next-line consistent-this
    var self = this;
    // @TODO remove the number of outdated queries discarded instead of just one
    if (queryId < this._lastQueryIdReceived) // Outdated answer
    return;
    this._currentNbQueries -= queryId - this._lastQueryIdReceived;
    this._lastQueryIdReceived = queryId;
    if (this._currentNbQueries === 0) this.emit("searchQueueEmpty");
    var results = content.results.slice();
    states.forEach(function(s) {
        var state = s.state;
        var queriesCount = s.queriesCount;
        var helper = s.helper;
        var specificResults = results.splice(0, queriesCount);
        if (!state.index) {
            helper.emit("result", {
                results: null,
                state: state
            });
            return;
        }
        helper.lastResults = new $bUiU2(state, specificResults, self._searchResultsOptions);
        helper.emit("result", {
            results: helper.lastResults,
            state: state
        });
    });
};
$c131641798835750$var$AlgoliaSearchHelper.prototype._dispatchRecommendResponse = function(queryId, states, ids, content) {
    // @TODO remove the number of outdated queries discarded instead of just one
    if (queryId < this._lastRecommendQueryIdReceived) // Outdated answer
    return;
    this._currentNbRecommendQueries -= queryId - this._lastRecommendQueryIdReceived;
    this._lastRecommendQueryIdReceived = queryId;
    if (this._currentNbRecommendQueries === 0) this.emit("recommendQueueEmpty");
    var cache = this._recommendCache;
    var idsMap = {};
    ids.filter(function(id) {
        return cache[id] === undefined;
    }).forEach(function(id, index) {
        if (!idsMap[id]) idsMap[id] = [];
        idsMap[id].push(index);
    });
    Object.keys(idsMap).forEach(function(id) {
        var indices = idsMap[id];
        var firstResult = content.results[indices[0]];
        if (indices.length === 1) {
            cache[id] = firstResult;
            return;
        }
        cache[id] = Object.assign({}, firstResult, {
            hits: $gll5V(indices.map(function(idx) {
                return content.results[idx].hits;
            }))
        });
    });
    var results = {};
    ids.forEach(function(id) {
        results[id] = cache[id];
    });
    states.forEach(function(s) {
        var state = s.state;
        var helper = s.helper;
        if (!s.index) {
            // eslint-disable-next-line no-warning-comments
            // TODO: emit "result" event when events for Recommend are implemented
            helper.emit("recommend:result", {
                results: null,
                state: state
            });
            return;
        }
        helper.lastRecommendResults = new $6Jx1y(state, results);
        // eslint-disable-next-line no-warning-comments
        // TODO: emit "result" event when events for Recommend are implemented
        helper.emit("recommend:result", {
            recommend: {
                results: helper.lastRecommendResults,
                state: state
            }
        });
    });
};
$c131641798835750$var$AlgoliaSearchHelper.prototype._dispatchAlgoliaError = function(queryId, error) {
    if (queryId < this._lastQueryIdReceived) // Outdated answer
    return;
    this._currentNbQueries -= queryId - this._lastQueryIdReceived;
    this._lastQueryIdReceived = queryId;
    this.emit("error", {
        error: error
    });
    if (this._currentNbQueries === 0) this.emit("searchQueueEmpty");
};
$c131641798835750$var$AlgoliaSearchHelper.prototype._dispatchRecommendError = function(queryId, error) {
    if (queryId < this._lastRecommendQueryIdReceived) // Outdated answer
    return;
    this._currentNbRecommendQueries -= queryId - this._lastRecommendQueryIdReceived;
    this._lastRecommendQueryIdReceived = queryId;
    this.emit("error", {
        error: error
    });
    if (this._currentNbRecommendQueries === 0) this.emit("recommendQueueEmpty");
};
$c131641798835750$var$AlgoliaSearchHelper.prototype.containsRefinement = function(query, facetFilters, numericFilters, tagFilters) {
    return query || facetFilters.length !== 0 || numericFilters.length !== 0 || tagFilters.length !== 0;
};
/**
 * Test if there are some disjunctive refinements on the facet
 * @private
 * @param {string} facet the attribute to test
 * @return {boolean} true if there are refinements on this attribute
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype._hasDisjunctiveRefinements = function(facet) {
    return this.state.disjunctiveRefinements[facet] && this.state.disjunctiveRefinements[facet].length > 0;
};
$c131641798835750$var$AlgoliaSearchHelper.prototype._change = function(event) {
    var state = event.state;
    var isPageReset = event.isPageReset;
    if (state !== this.state) {
        this.state = state;
        this.emit("change", {
            state: this.state,
            results: this.lastResults,
            isPageReset: isPageReset
        });
    }
};
$c131641798835750$var$AlgoliaSearchHelper.prototype._recommendChange = function(event) {
    var state = event.state;
    if (state !== this.recommendState) {
        this.recommendState = state;
        // eslint-disable-next-line no-warning-comments
        // TODO: emit "change" event when events for Recommend are implemented
        this.emit("recommend:change", {
            search: {
                results: this.lastResults,
                state: this.state
            },
            recommend: {
                results: this.lastRecommendResults,
                state: this.recommendState
            }
        });
    }
};
/**
 * Clears the cache of the underlying Algolia client.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.clearCache = function() {
    if (this.client.clearCache) this.client.clearCache();
    return this;
};
/**
 * Updates the internal client instance. If the reference of the clients
 * are equal then no update is actually done.
 * @param  {AlgoliaSearch} newClient an AlgoliaSearch client
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.setClient = function(newClient) {
    if (this.client === newClient) return this;
    if (typeof newClient.addAlgoliaAgent === "function") newClient.addAlgoliaAgent("JS Helper (" + $4kbyH + ")");
    this.client = newClient;
    return this;
};
/**
 * Gets the instance of the currently used client.
 * @return {AlgoliaSearch} the currently used client
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.getClient = function() {
    return this.client;
};
/**
 * Creates an derived instance of the Helper. A derived helper
 * is a way to request other indices synchronised with the lifecycle
 * of the main Helper. This mechanism uses the multiqueries feature
 * of Algolia to aggregate all the requests in a single network call.
 *
 * This method takes a function that is used to create a new SearchParameter
 * that will be used to create requests to Algolia. Those new requests
 * are created just before the `search` event. The signature of the function
 * is `SearchParameters -> SearchParameters`.
 *
 * This method returns a new DerivedHelper which is an EventEmitter
 * that fires the same `search`, `result` and `error` events. Those
 * events, however, will receive data specific to this DerivedHelper
 * and the SearchParameters that is returned by the call of the
 * parameter function.
 * @param {function} fn SearchParameters -> SearchParameters
 * @param {function} recommendFn RecommendParameters -> RecommendParameters
 * @return {DerivedHelper} a new DerivedHelper
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.derive = function(fn, recommendFn) {
    var derivedHelper = new $8fAjb(this, fn, recommendFn);
    this.derivedHelpers.push(derivedHelper);
    return derivedHelper;
};
/**
 * This method detaches a derived Helper from the main one. Prefer using the one from the
 * derived helper itself, to remove the event listeners too.
 * @private
 * @param  {DerivedHelper} derivedHelper the derived helper to detach
 * @return {undefined} nothing is returned
 * @throws Error
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.detachDerivedHelper = function(derivedHelper) {
    var pos = this.derivedHelpers.indexOf(derivedHelper);
    if (pos === -1) throw new Error("Derived helper already detached");
    this.derivedHelpers.splice(pos, 1);
};
/**
 * This method returns true if there is currently at least one on-going search.
 * @return {boolean} true if there is a search pending
 */ $c131641798835750$var$AlgoliaSearchHelper.prototype.hasPendingRequests = function() {
    return this._currentNbQueries > 0;
};
/**
 * @typedef AlgoliaSearchHelper.NumericRefinement
 * @type {object}
 * @property {number[]} value the numbers that are used for filtering this attribute with
 * the operator specified.
 * @property {string} operator the faceting data: value, number of entries
 * @property {string} type will be 'numeric'
 */ /**
 * @typedef AlgoliaSearchHelper.FacetRefinement
 * @type {object}
 * @property {string} value the string use to filter the attribute
 * @property {string} type the type of filter: 'conjunctive', 'disjunctive', 'exclude'
 */ module.exports = $c131641798835750$var$AlgoliaSearchHelper;

});
parcelRegister("8fAjb", function(module, exports) {
"use strict";

var $je6gi = parcelRequire("je6gi");

var $TTPKp = parcelRequire("TTPKp");
/**
 * A DerivedHelper is a way to create sub requests to
 * Algolia from a main helper.
 * @class
 * @classdesc The DerivedHelper provides an event based interface for search callbacks:
 *  - search: when a search is triggered using the `search()` method.
 *  - result: when the response is retrieved from Algolia and is processed.
 *    This event contains a {@link SearchResults} object and the
 *    {@link SearchParameters} corresponding to this answer.
 * @param {AlgoliaSearchHelper} mainHelper the main helper
 * @param {function} fn the function to create the derived state for search
 * @param {function} recommendFn the function to create the derived state for recommendations
 */ function $601be386601458f9$var$DerivedHelper(mainHelper, fn, recommendFn) {
    this.main = mainHelper;
    this.fn = fn;
    this.recommendFn = recommendFn;
    this.lastResults = null;
    this.lastRecommendResults = null;
}
$TTPKp($601be386601458f9$var$DerivedHelper, $je6gi);
/**
 * Detach this helper from the main helper
 * @return {undefined}
 * @throws Error if the derived helper is already detached
 */ $601be386601458f9$var$DerivedHelper.prototype.detach = function() {
    this.removeAllListeners();
    this.main.detachDerivedHelper(this);
};
$601be386601458f9$var$DerivedHelper.prototype.getModifiedState = function(parameters) {
    return this.fn(parameters);
};
$601be386601458f9$var$DerivedHelper.prototype.getModifiedRecommendState = function(parameters) {
    return this.recommendFn(parameters);
};
module.exports = $601be386601458f9$var$DerivedHelper;

});
parcelRegister("TTPKp", function(module, exports) {
"use strict";
function $0a80729110afa025$var$inherits(ctor, superCtor) {
    ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
}
module.exports = $0a80729110afa025$var$inherits;

});


parcelRegister("9IuIV", function(module, exports) {
"use strict";
/**
 * Replaces a leading - with \-
 * @private
 * @param {any} value the facet value to replace
 * @returns {any} the escaped facet value or the value if it was not a string
 */ function $71300e2cf2e578b3$var$escapeFacetValue(value) {
    if (typeof value !== "string") return value;
    return String(value).replace(/^-/, "\\-");
}
/**
 * Replaces a leading \- with -
 * @private
 * @param {any} value the escaped facet value
 * @returns {any} the unescaped facet value or the value if it was not a string
 */ function $71300e2cf2e578b3$var$unescapeFacetValue(value) {
    if (typeof value !== "string") return value;
    return value.replace(/^\\-/, "-");
}
module.exports = {
    escapeFacetValue: $71300e2cf2e578b3$var$escapeFacetValue,
    unescapeFacetValue: $71300e2cf2e578b3$var$unescapeFacetValue
};

});

parcelRegister("cNauE", function(module, exports) {
"use strict";
function $9502336ac3aed1e4$var$clone(value) {
    if (typeof value === "object" && value !== null) return $9502336ac3aed1e4$var$_merge(Array.isArray(value) ? [] : {}, value);
    return value;
}
function $9502336ac3aed1e4$var$isObjectOrArrayOrFunction(value) {
    return typeof value === "function" || Array.isArray(value) || Object.prototype.toString.call(value) === "[object Object]";
}
function $9502336ac3aed1e4$var$_merge(target, source) {
    if (target === source) return target;
    // eslint-disable-next-line no-restricted-syntax
    for(var key in source){
        if (!Object.prototype.hasOwnProperty.call(source, key) || key === "__proto__" || key === "constructor") continue;
        var sourceVal = source[key];
        var targetVal = target[key];
        if (typeof targetVal !== "undefined" && typeof sourceVal === "undefined") continue;
        if ($9502336ac3aed1e4$var$isObjectOrArrayOrFunction(targetVal) && $9502336ac3aed1e4$var$isObjectOrArrayOrFunction(sourceVal)) target[key] = $9502336ac3aed1e4$var$_merge(targetVal, sourceVal);
        else target[key] = $9502336ac3aed1e4$var$clone(sourceVal);
    }
    return target;
}
/**
 * This method is like Object.assign, but recursively merges own and inherited
 * enumerable keyed properties of source objects into the destination object.
 *
 * NOTE: this behaves like lodash/merge, but:
 * - does mutate functions if they are a source
 * - treats non-plain objects as plain
 * - does not work for circular objects
 * - treats sparse arrays as sparse
 * - does not convert Array-like objects (Arguments, NodeLists, etc.) to arrays
 *
 * @param {Object} target The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 */ function $9502336ac3aed1e4$var$merge(target) {
    if (!$9502336ac3aed1e4$var$isObjectOrArrayOrFunction(target)) target = {};
    for(var i = 1, l = arguments.length; i < l; i++){
        var source = arguments[i];
        if ($9502336ac3aed1e4$var$isObjectOrArrayOrFunction(source)) $9502336ac3aed1e4$var$_merge(target, source);
    }
    return target;
}
module.exports = $9502336ac3aed1e4$var$merge;

});

parcelRegister("hPi9R", function(module, exports) {
"use strict";
function $cfa548e7659f4e9f$var$objectHasKeys(obj) {
    return obj && Object.keys(obj).length > 0;
}
module.exports = $cfa548e7659f4e9f$var$objectHasKeys;

});

parcelRegister("2SavI", function(module, exports) {
"use strict";
// https://github.com/babel/babel/blob/3aaafae053fa75febb3aa45d45b6f00646e30ba4/packages/babel-helpers/src/helpers.js#L604-L620
function $2178c71501384235$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source === null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key;
    var i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        // eslint-disable-next-line no-continue
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
module.exports = $2178c71501384235$var$_objectWithoutPropertiesLoose;

});

parcelRegister("431vc", function(module, exports) {
"use strict";
/**
 * RecommendParameters is the data structure that contains all the information
 * usable for getting recommendations from the Algolia API. It doesn't do the
 * search itself, nor does it contains logic about the parameters.
 * It is an immutable object, therefore it has been created in a way that each
 * changes does not change the object itself but returns a copy with the
 * modification.
 * This object should probably not be instantiated outside of the helper. It
 * will be provided when needed.
 * @constructor
 * @classdesc contains all the parameters for recommendations
 * @param {RecommendParametersOptions} opts the options to create the object
 */ function $2f289b857d722988$var$RecommendParameters(opts) {
    opts = opts || {};
    this.params = opts.params || [];
}
$2f289b857d722988$var$RecommendParameters.prototype = {
    constructor: $2f289b857d722988$var$RecommendParameters,
    addParams: function(params) {
        var newParams = this.params.slice();
        newParams.push(params);
        return new $2f289b857d722988$var$RecommendParameters({
            params: newParams
        });
    },
    removeParams: function(id) {
        return new $2f289b857d722988$var$RecommendParameters({
            params: this.params.filter(function(param) {
                return param.$$id !== id;
            })
        });
    },
    addFrequentlyBoughtTogether: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: "bought-together"
        }));
    },
    addRelatedProducts: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: "related-products"
        }));
    },
    addTrendingItems: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: "trending-items"
        }));
    },
    addTrendingFacets: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: "trending-facets"
        }));
    },
    addLookingSimilar: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: "looking-similar"
        }));
    },
    _buildQueries: function(indexName, cache) {
        return this.params.filter(function(params) {
            return cache[params.$$id] === undefined;
        }).map(function(params) {
            var query = Object.assign({}, params, {
                indexName: indexName,
                // @TODO: remove this if it ever gets handled by the API
                threshold: params.threshold || 0
            });
            delete query.$$id;
            return query;
        });
    }
};
module.exports = $2f289b857d722988$var$RecommendParameters;

});

parcelRegister("6Jx1y", function(module, exports) {
"use strict";
/**
 * Constructor for SearchResults
 * @class
 * @classdesc SearchResults contains the results of a query to Algolia using the
 * {@link AlgoliaSearchHelper}.
 * @param {RecommendParameters} state state that led to the response
 * @param {Record<string,RecommendResultItem>} results the results from algolia client
 **/ function $4e708ff5b713845b$var$RecommendResults(state, results) {
    this._state = state;
    this._rawResults = {};
    // eslint-disable-next-line consistent-this
    var self = this;
    state.params.forEach(function(param) {
        var id = param.$$id;
        self[id] = results[id];
        self._rawResults[id] = results[id];
    });
}
$4e708ff5b713845b$var$RecommendResults.prototype = {
    constructor: $4e708ff5b713845b$var$RecommendResults
};
module.exports = $4e708ff5b713845b$var$RecommendResults;

});

parcelRegister("dWBey", function(module, exports) {
"use strict";

var $cNauE = parcelRequire("cNauE");
function $a26d92fd1efb8e0d$var$sortObject(obj) {
    return Object.keys(obj).sort().reduce(function(acc, curr) {
        acc[curr] = obj[curr];
        return acc;
    }, {});
}
var $a26d92fd1efb8e0d$var$requestBuilder = {
    /**
   * Get all the queries to send to the client, those queries can used directly
   * with the Algolia client.
   * @private
   * @param  {string} index The name of the index
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object[]} The queries
   */ _getQueries: function getQueries(index, state) {
        var queries = [];
        // One query for the hits
        queries.push({
            indexName: index,
            params: $a26d92fd1efb8e0d$var$requestBuilder._getHitsSearchParams(state)
        });
        // One for each disjunctive facets
        state.getRefinedDisjunctiveFacets().forEach(function(refinedFacet) {
            queries.push({
                indexName: index,
                params: $a26d92fd1efb8e0d$var$requestBuilder._getDisjunctiveFacetSearchParams(state, refinedFacet)
            });
        });
        // More to get the parent levels of the hierarchical facets when refined
        state.getRefinedHierarchicalFacets().forEach(function(refinedFacet) {
            var hierarchicalFacet = state.getHierarchicalFacetByName(refinedFacet);
            var currentRefinement = state.getHierarchicalRefinement(refinedFacet);
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            // If we are deeper than level 0 (starting from `beer > IPA`)
            // we want to get all parent values
            if (currentRefinement.length > 0 && currentRefinement[0].split(separator).length > 1) {
                // We generate a map of the filters we will use for our facet values queries
                var filtersMap = currentRefinement[0].split(separator).slice(0, -1).reduce(function createFiltersMap(map, segment, level) {
                    return map.concat({
                        attribute: hierarchicalFacet.attributes[level],
                        value: level === 0 ? segment : [
                            map[map.length - 1].value,
                            segment
                        ].join(separator)
                    });
                }, []);
                filtersMap.forEach(function(filter, level) {
                    var params = $a26d92fd1efb8e0d$var$requestBuilder._getDisjunctiveFacetSearchParams(state, filter.attribute, level === 0);
                    // Keep facet filters unrelated to current hierarchical attributes
                    function hasHierarchicalFacetFilter(value) {
                        return hierarchicalFacet.attributes.some(function(attribute) {
                            return attribute === value.split(":")[0];
                        });
                    }
                    var filteredFacetFilters = (params.facetFilters || []).reduce(function(acc, facetFilter) {
                        if (Array.isArray(facetFilter)) {
                            var filtered = facetFilter.filter(function(filterValue) {
                                return !hasHierarchicalFacetFilter(filterValue);
                            });
                            if (filtered.length > 0) acc.push(filtered);
                        }
                        if (typeof facetFilter === "string" && !hasHierarchicalFacetFilter(facetFilter)) acc.push(facetFilter);
                        return acc;
                    }, []);
                    var parent = filtersMap[level - 1];
                    if (level > 0) params.facetFilters = filteredFacetFilters.concat(parent.attribute + ":" + parent.value);
                    else if (filteredFacetFilters.length > 0) params.facetFilters = filteredFacetFilters;
                    else delete params.facetFilters;
                    queries.push({
                        indexName: index,
                        params: params
                    });
                });
            }
        });
        return queries;
    },
    /**
   * Build search parameters used to fetch hits
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object.<string, any>} The search parameters for hits
   */ _getHitsSearchParams: function(state) {
        var facets = state.facets.concat(state.disjunctiveFacets).concat($a26d92fd1efb8e0d$var$requestBuilder._getHitsHierarchicalFacetsAttributes(state)).sort();
        var facetFilters = $a26d92fd1efb8e0d$var$requestBuilder._getFacetFilters(state);
        var numericFilters = $a26d92fd1efb8e0d$var$requestBuilder._getNumericFilters(state);
        var tagFilters = $a26d92fd1efb8e0d$var$requestBuilder._getTagFilters(state);
        var additionalParams = {};
        if (facets.length > 0) additionalParams.facets = facets.indexOf("*") > -1 ? [
            "*"
        ] : facets;
        if (tagFilters.length > 0) additionalParams.tagFilters = tagFilters;
        if (facetFilters.length > 0) additionalParams.facetFilters = facetFilters;
        if (numericFilters.length > 0) additionalParams.numericFilters = numericFilters;
        return $a26d92fd1efb8e0d$var$sortObject($cNauE({}, state.getQueryParams(), additionalParams));
    },
    /**
   * Build search parameters used to fetch a disjunctive facet
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @param  {string} facet the associated facet name
   * @param  {boolean} hierarchicalRootLevel ?? FIXME
   * @return {object} The search parameters for a disjunctive facet
   */ _getDisjunctiveFacetSearchParams: function(state, facet, hierarchicalRootLevel) {
        var facetFilters = $a26d92fd1efb8e0d$var$requestBuilder._getFacetFilters(state, facet, hierarchicalRootLevel);
        var numericFilters = $a26d92fd1efb8e0d$var$requestBuilder._getNumericFilters(state, facet);
        var tagFilters = $a26d92fd1efb8e0d$var$requestBuilder._getTagFilters(state);
        var additionalParams = {
            hitsPerPage: 0,
            page: 0,
            analytics: false,
            clickAnalytics: false
        };
        if (tagFilters.length > 0) additionalParams.tagFilters = tagFilters;
        var hierarchicalFacet = state.getHierarchicalFacetByName(facet);
        if (hierarchicalFacet) additionalParams.facets = $a26d92fd1efb8e0d$var$requestBuilder._getDisjunctiveHierarchicalFacetAttribute(state, hierarchicalFacet, hierarchicalRootLevel);
        else additionalParams.facets = facet;
        if (numericFilters.length > 0) additionalParams.numericFilters = numericFilters;
        if (facetFilters.length > 0) additionalParams.facetFilters = facetFilters;
        return $a26d92fd1efb8e0d$var$sortObject($cNauE({}, state.getQueryParams(), additionalParams));
    },
    /**
   * Return the numeric filters in an algolia request fashion
   * @private
   * @param {SearchParameters} state the state from which to get the filters
   * @param {string} [facetName] the name of the attribute for which the filters should be excluded
   * @return {string[]} the numeric filters in the algolia format
   */ _getNumericFilters: function(state, facetName) {
        if (state.numericFilters) return state.numericFilters;
        var numericFilters = [];
        Object.keys(state.numericRefinements).forEach(function(attribute) {
            var operators = state.numericRefinements[attribute] || {};
            Object.keys(operators).forEach(function(operator) {
                var values = operators[operator] || [];
                if (facetName !== attribute) values.forEach(function(value) {
                    if (Array.isArray(value)) {
                        var vs = value.map(function(v) {
                            return attribute + operator + v;
                        });
                        numericFilters.push(vs);
                    } else numericFilters.push(attribute + operator + value);
                });
            });
        });
        return numericFilters;
    },
    /**
   * Return the tags filters depending on which format is used, either tagFilters or tagRefinements
   * @private
   * @param {SearchParameters} state the state from which to get the filters
   * @return {string} Tag filters in a single string
   */ _getTagFilters: function(state) {
        if (state.tagFilters) return state.tagFilters;
        return state.tagRefinements.join(",");
    },
    /**
   * Build facetFilters parameter based on current refinements. The array returned
   * contains strings representing the facet filters in the algolia format.
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @param  {string} [facet] if set, the current disjunctive facet
   * @param  {boolean} [hierarchicalRootLevel] ?? FIXME
   * @return {array.<string>} The facet filters in the algolia format
   */ _getFacetFilters: function(state, facet, hierarchicalRootLevel) {
        var facetFilters = [];
        var facetsRefinements = state.facetsRefinements || {};
        Object.keys(facetsRefinements).sort().forEach(function(facetName) {
            var facetValues = facetsRefinements[facetName] || [];
            facetValues.slice().sort().forEach(function(facetValue) {
                facetFilters.push(facetName + ":" + facetValue);
            });
        });
        var facetsExcludes = state.facetsExcludes || {};
        Object.keys(facetsExcludes).sort().forEach(function(facetName) {
            var facetValues = facetsExcludes[facetName] || [];
            facetValues.sort().forEach(function(facetValue) {
                facetFilters.push(facetName + ":-" + facetValue);
            });
        });
        var disjunctiveFacetsRefinements = state.disjunctiveFacetsRefinements || {};
        Object.keys(disjunctiveFacetsRefinements).sort().forEach(function(facetName) {
            var facetValues = disjunctiveFacetsRefinements[facetName] || [];
            if (facetName === facet || !facetValues || facetValues.length === 0) return;
            var orFilters = [];
            facetValues.slice().sort().forEach(function(facetValue) {
                orFilters.push(facetName + ":" + facetValue);
            });
            facetFilters.push(orFilters);
        });
        var hierarchicalFacetsRefinements = state.hierarchicalFacetsRefinements || {};
        Object.keys(hierarchicalFacetsRefinements).sort().forEach(function(facetName) {
            var facetValues = hierarchicalFacetsRefinements[facetName] || [];
            var facetValue = facetValues[0];
            if (facetValue === undefined) return;
            var hierarchicalFacet = state.getHierarchicalFacetByName(facetName);
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            var rootPath = state._getHierarchicalRootPath(hierarchicalFacet);
            var attributeToRefine;
            var attributesIndex;
            // we ask for parent facet values only when the `facet` is the current hierarchical facet
            if (facet === facetName) {
                // if we are at the root level already, no need to ask for facet values, we get them from
                // the hits query
                if (facetValue.indexOf(separator) === -1 || !rootPath && hierarchicalRootLevel === true || rootPath && rootPath.split(separator).length === facetValue.split(separator).length) return;
                if (!rootPath) {
                    attributesIndex = facetValue.split(separator).length - 2;
                    facetValue = facetValue.slice(0, facetValue.lastIndexOf(separator));
                } else {
                    attributesIndex = rootPath.split(separator).length - 1;
                    facetValue = rootPath;
                }
                attributeToRefine = hierarchicalFacet.attributes[attributesIndex];
            } else {
                attributesIndex = facetValue.split(separator).length - 1;
                attributeToRefine = hierarchicalFacet.attributes[attributesIndex];
            }
            if (attributeToRefine) facetFilters.push([
                attributeToRefine + ":" + facetValue
            ]);
        });
        return facetFilters;
    },
    _getHitsHierarchicalFacetsAttributes: function(state) {
        var out = [];
        return state.hierarchicalFacets.reduce(// ask for as much levels as there's hierarchical refinements
        function getHitsAttributesForHierarchicalFacet(allAttributes, hierarchicalFacet) {
            var hierarchicalRefinement = state.getHierarchicalRefinement(hierarchicalFacet.name)[0];
            // if no refinement, ask for root level
            if (!hierarchicalRefinement) {
                allAttributes.push(hierarchicalFacet.attributes[0]);
                return allAttributes;
            }
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            var level = hierarchicalRefinement.split(separator).length;
            var newAttributes = hierarchicalFacet.attributes.slice(0, level + 1);
            return allAttributes.concat(newAttributes);
        }, out);
    },
    _getDisjunctiveHierarchicalFacetAttribute: function(state, hierarchicalFacet, rootLevel) {
        var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        if (rootLevel === true) {
            var rootPath = state._getHierarchicalRootPath(hierarchicalFacet);
            var attributeIndex = 0;
            if (rootPath) attributeIndex = rootPath.split(separator).length;
            return [
                hierarchicalFacet.attributes[attributeIndex]
            ];
        }
        var hierarchicalRefinement = state.getHierarchicalRefinement(hierarchicalFacet.name)[0] || "";
        // if refinement is 'beers > IPA > Flying dog',
        // then we want `facets: ['beers > IPA']` as disjunctive facet (parent level values)
        var parentLevel = hierarchicalRefinement.split(separator).length - 1;
        return hierarchicalFacet.attributes.slice(0, parentLevel + 1);
    },
    getSearchForFacetQuery: function(facetName, query, maxFacetHits, state) {
        var stateForSearchForFacetValues = state.isDisjunctiveFacet(facetName) ? state.clearRefinements(facetName) : state;
        var searchForFacetSearchParameters = {
            facetQuery: query,
            facetName: facetName
        };
        if (typeof maxFacetHits === "number") searchForFacetSearchParameters.maxFacetHits = maxFacetHits;
        return $a26d92fd1efb8e0d$var$sortObject($cNauE({}, $a26d92fd1efb8e0d$var$requestBuilder._getHitsSearchParams(stateForSearchForFacetValues), searchForFacetSearchParameters));
    }
};
module.exports = $a26d92fd1efb8e0d$var$requestBuilder;

});

parcelRegister("gTeiS", function(module, exports) {
"use strict";

var $jGPgk = parcelRequire("jGPgk");

var $hmac5 = parcelRequire("hmac5");

var $7OPVH = parcelRequire("7OPVH");

var $cNauE = parcelRequire("cNauE");

var $hPi9R = parcelRequire("hPi9R");

var $2SavI = parcelRequire("2SavI");

var $bx4yd = parcelRequire("bx4yd");

var $jIrs2 = parcelRequire("jIrs2");

var $5s74r = parcelRequire("5s74r");
/**
 * isEqual, but only for numeric refinement values, possible values:
 * - 5
 * - [5]
 * - [[5]]
 * - [[5,5],[4]]
 * @param {any} a numeric refinement value
 * @param {any} b numeric refinement value
 * @return {boolean} true if the values are equal
 */ function $c4bce0c9191240d9$var$isEqualNumericRefinement(a, b) {
    if (Array.isArray(a) && Array.isArray(b)) return a.length === b.length && a.every(function(el, i) {
        return $c4bce0c9191240d9$var$isEqualNumericRefinement(b[i], el);
    });
    return a === b;
}
/**
 * like _.find but using deep equality to be able to use it
 * to find arrays.
 * @private
 * @param {any[]} array array to search into (elements are base or array of base)
 * @param {any} searchedValue the value we're looking for (base or array of base)
 * @return {any} the searched value or undefined
 */ function $c4bce0c9191240d9$var$findArray(array, searchedValue) {
    return $hmac5(array, function(currentValue) {
        return $c4bce0c9191240d9$var$isEqualNumericRefinement(currentValue, searchedValue);
    });
}
/**
 * The facet list is the structure used to store the list of values used to
 * filter a single attribute.
 * @typedef {string[]} SearchParameters.FacetList
 */ /**
 * Structure to store numeric filters with the operator as the key. The supported operators
 * are `=`, `>`, `<`, `>=`, `<=` and `!=`.
 * @typedef {Object.<string, Array.<number|number[]>>} SearchParameters.OperatorList
 */ /**
 * SearchParameters is the data structure that contains all the information
 * usable for making a search to Algolia API. It doesn't do the search itself,
 * nor does it contains logic about the parameters.
 * It is an immutable object, therefore it has been created in a way that each
 * changes does not change the object itself but returns a copy with the
 * modification.
 * This object should probably not be instantiated outside of the helper. It will
 * be provided when needed. This object is documented for reference as you'll
 * get it from events generated by the {@link AlgoliaSearchHelper}.
 * If need be, instantiate the Helper from the factory function {@link SearchParameters.make}
 * @constructor
 * @classdesc contains all the parameters of a search
 * @param {object|SearchParameters} newParameters existing parameters or partial object
 * for the properties of a new SearchParameters
 * @see SearchParameters.make
 * @example <caption>SearchParameters of the first query in
 *   <a href="http://demos.algolia.com/instant-search-demo/">the instant search demo</a></caption>
{
   "query": "",
   "disjunctiveFacets": [
      "customerReviewCount",
      "category",
      "salePrice_range",
      "manufacturer"
  ],
   "maxValuesPerFacet": 30,
   "page": 0,
   "hitsPerPage": 10,
   "facets": [
      "type",
      "shipping"
  ]
}
 */ function $c4bce0c9191240d9$var$SearchParameters(newParameters) {
    var params = newParameters ? $c4bce0c9191240d9$var$SearchParameters._parseNumbers(newParameters) : {};
    if (params.userToken !== undefined && !$jIrs2(params.userToken)) // eslint-disable-next-line no-console
    console.warn("[algoliasearch-helper] The `userToken` parameter is invalid. This can lead to wrong analytics.\n  - Format: [a-zA-Z0-9_-]{1,64}");
    /**
   * This attribute contains the list of all the conjunctive facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * @member {string[]}
   */ this.facets = params.facets || [];
    /**
   * This attribute contains the list of all the disjunctive facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * @member {string[]}
   */ this.disjunctiveFacets = params.disjunctiveFacets || [];
    /**
   * This attribute contains the list of all the hierarchical facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * Hierarchical facets are a sub type of disjunctive facets that
   * let you filter faceted attributes hierarchically.
   * @member {string[]|object[]}
   */ this.hierarchicalFacets = params.hierarchicalFacets || [];
    // Refinements
    /**
   * This attribute contains all the filters that need to be
   * applied on the conjunctive facets. Each facet must be properly
   * defined in the `facets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.facetsRefinements = params.facetsRefinements || {};
    /**
   * This attribute contains all the filters that need to be
   * excluded from the conjunctive facets. Each facet must be properly
   * defined in the `facets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters excluded for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.facetsExcludes = params.facetsExcludes || {};
    /**
   * This attribute contains all the filters that need to be
   * applied on the disjunctive facets. Each facet must be properly
   * defined in the `disjunctiveFacets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.disjunctiveFacetsRefinements = params.disjunctiveFacetsRefinements || {};
    /**
   * This attribute contains all the filters that need to be
   * applied on the numeric attributes.
   *
   * The key is the name of the attribute, and the value is the
   * filters to apply to this attribute.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `numericFilters` attribute.
   * @member {Object.<string, SearchParameters.OperatorList>}
   */ this.numericRefinements = params.numericRefinements || {};
    /**
   * This attribute contains all the tags used to refine the query.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `tagFilters` attribute.
   * @member {string[]}
   */ this.tagRefinements = params.tagRefinements || [];
    /**
   * This attribute contains all the filters that need to be
   * applied on the hierarchical facets. Each facet must be properly
   * defined in the `hierarchicalFacets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name. The FacetList values
   * are structured as a string that contain the values for each level
   * separated by the configured separator.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.hierarchicalFacetsRefinements = params.hierarchicalFacetsRefinements || {};
    // eslint-disable-next-line consistent-this
    var self = this;
    Object.keys(params).forEach(function(paramName) {
        var isKeyKnown = $c4bce0c9191240d9$var$SearchParameters.PARAMETERS.indexOf(paramName) !== -1;
        var isValueDefined = params[paramName] !== undefined;
        if (!isKeyKnown && isValueDefined) self[paramName] = params[paramName];
    });
}
/**
 * List all the properties in SearchParameters and therefore all the known Algolia properties
 * This doesn't contain any beta/hidden features.
 * @private
 */ $c4bce0c9191240d9$var$SearchParameters.PARAMETERS = Object.keys(new $c4bce0c9191240d9$var$SearchParameters());
/**
 * @private
 * @param {object} partialState full or part of a state
 * @return {object} a new object with the number keys as number
 */ $c4bce0c9191240d9$var$SearchParameters._parseNumbers = function(partialState) {
    // Do not parse numbers again in SearchParameters, they ought to be parsed already
    if (partialState instanceof $c4bce0c9191240d9$var$SearchParameters) return partialState;
    var numbers = {};
    var numberKeys = [
        "aroundPrecision",
        "aroundRadius",
        "getRankingInfo",
        "minWordSizefor2Typos",
        "minWordSizefor1Typo",
        "page",
        "maxValuesPerFacet",
        "distinct",
        "minimumAroundRadius",
        "hitsPerPage",
        "minProximity"
    ];
    numberKeys.forEach(function(k) {
        var value = partialState[k];
        if (typeof value === "string") {
            var parsedValue = parseFloat(value);
            // global isNaN is ok to use here, value is only number or NaN
            numbers[k] = isNaN(parsedValue) ? value : parsedValue;
        }
    });
    // there's two formats of insideBoundingBox, we need to parse
    // the one which is an array of float geo rectangles
    if (Array.isArray(partialState.insideBoundingBox)) numbers.insideBoundingBox = partialState.insideBoundingBox.map(function(geoRect) {
        if (Array.isArray(geoRect)) return geoRect.map(function(value) {
            return parseFloat(value);
        });
        return geoRect;
    });
    if (partialState.numericRefinements) {
        var numericRefinements = {};
        Object.keys(partialState.numericRefinements).forEach(function(attribute) {
            var operators = partialState.numericRefinements[attribute] || {};
            numericRefinements[attribute] = {};
            Object.keys(operators).forEach(function(operator) {
                var values = operators[operator];
                var parsedValues = values.map(function(v) {
                    if (Array.isArray(v)) return v.map(function(vPrime) {
                        if (typeof vPrime === "string") return parseFloat(vPrime);
                        return vPrime;
                    });
                    else if (typeof v === "string") return parseFloat(v);
                    return v;
                });
                numericRefinements[attribute][operator] = parsedValues;
            });
        });
        numbers.numericRefinements = numericRefinements;
    }
    return $cNauE(partialState, numbers);
};
/**
 * Factory for SearchParameters
 * @param {object|SearchParameters} newParameters existing parameters or partial
 * object for the properties of a new SearchParameters
 * @return {SearchParameters} frozen instance of SearchParameters
 */ $c4bce0c9191240d9$var$SearchParameters.make = function makeSearchParameters(newParameters) {
    var instance = new $c4bce0c9191240d9$var$SearchParameters(newParameters);
    var hierarchicalFacets = newParameters.hierarchicalFacets || [];
    hierarchicalFacets.forEach(function(facet) {
        if (facet.rootPath) {
            var currentRefinement = instance.getHierarchicalRefinement(facet.name);
            if (currentRefinement.length > 0 && currentRefinement[0].indexOf(facet.rootPath) !== 0) instance = instance.clearRefinements(facet.name);
            // get it again in case it has been cleared
            currentRefinement = instance.getHierarchicalRefinement(facet.name);
            if (currentRefinement.length === 0) instance = instance.toggleHierarchicalFacetRefinement(facet.name, facet.rootPath);
        }
    });
    return instance;
};
/**
 * Validates the new parameters based on the previous state
 * @param {SearchParameters} currentState the current state
 * @param {object|SearchParameters} parameters the new parameters to set
 * @return {Error|null} Error if the modification is invalid, null otherwise
 */ $c4bce0c9191240d9$var$SearchParameters.validate = function(currentState, parameters) {
    var params = parameters || {};
    if (currentState.tagFilters && params.tagRefinements && params.tagRefinements.length > 0) return new Error("[Tags] Cannot switch from the managed tag API to the advanced API. It is probably an error, if it is really what you want, you should first clear the tags with clearTags method.");
    if (currentState.tagRefinements.length > 0 && params.tagFilters) return new Error("[Tags] Cannot switch from the advanced tag API to the managed API. It is probably an error, if it is not, you should first clear the tags with clearTags method.");
    if (currentState.numericFilters && params.numericRefinements && $hPi9R(params.numericRefinements)) return new Error("[Numeric filters] Can't switch from the advanced to the managed API. It is probably an error, if this is really what you want, you have to first clear the numeric filters.");
    if ($hPi9R(currentState.numericRefinements) && params.numericFilters) return new Error("[Numeric filters] Can't switch from the managed API to the advanced. It is probably an error, if this is really what you want, you have to first clear the numeric filters.");
    return null;
};
$c4bce0c9191240d9$var$SearchParameters.prototype = {
    constructor: $c4bce0c9191240d9$var$SearchParameters,
    /**
   * Remove all refinements (disjunctive + conjunctive + excludes + numeric filters)
   * @method
   * @param {undefined|string|SearchParameters.clearCallback} [attribute] optional string or function
   * - If not given, means to clear all the filters.
   * - If `string`, means to clear all refinements for the `attribute` named filter.
   * - If `function`, means to clear all the refinements that return truthy values.
   * @return {SearchParameters} new instance with filters cleared
   */ clearRefinements: function clearRefinements(attribute) {
        var patch = {
            numericRefinements: this._clearNumericRefinements(attribute),
            facetsRefinements: $5s74r.clearRefinement(this.facetsRefinements, attribute, "conjunctiveFacet"),
            facetsExcludes: $5s74r.clearRefinement(this.facetsExcludes, attribute, "exclude"),
            disjunctiveFacetsRefinements: $5s74r.clearRefinement(this.disjunctiveFacetsRefinements, attribute, "disjunctiveFacet"),
            hierarchicalFacetsRefinements: $5s74r.clearRefinement(this.hierarchicalFacetsRefinements, attribute, "hierarchicalFacet")
        };
        if (patch.numericRefinements === this.numericRefinements && patch.facetsRefinements === this.facetsRefinements && patch.facetsExcludes === this.facetsExcludes && patch.disjunctiveFacetsRefinements === this.disjunctiveFacetsRefinements && patch.hierarchicalFacetsRefinements === this.hierarchicalFacetsRefinements) return this;
        return this.setQueryParameters(patch);
    },
    /**
   * Remove all the refined tags from the SearchParameters
   * @method
   * @return {SearchParameters} new instance with tags cleared
   */ clearTags: function clearTags() {
        if (this.tagFilters === undefined && this.tagRefinements.length === 0) return this;
        return this.setQueryParameters({
            tagFilters: undefined,
            tagRefinements: []
        });
    },
    /**
   * Set the index.
   * @method
   * @param {string} index the index name
   * @return {SearchParameters} new instance
   */ setIndex: function setIndex(index) {
        if (index === this.index) return this;
        return this.setQueryParameters({
            index: index
        });
    },
    /**
   * Query setter
   * @method
   * @param {string} newQuery value for the new query
   * @return {SearchParameters} new instance
   */ setQuery: function setQuery(newQuery) {
        if (newQuery === this.query) return this;
        return this.setQueryParameters({
            query: newQuery
        });
    },
    /**
   * Page setter
   * @method
   * @param {number} newPage new page number
   * @return {SearchParameters} new instance
   */ setPage: function setPage(newPage) {
        if (newPage === this.page) return this;
        return this.setQueryParameters({
            page: newPage
        });
    },
    /**
   * Facets setter
   * The facets are the simple facets, used for conjunctive (and) faceting.
   * @method
   * @param {string[]} facets all the attributes of the algolia records used for conjunctive faceting
   * @return {SearchParameters} new instance
   */ setFacets: function setFacets(facets) {
        return this.setQueryParameters({
            facets: facets
        });
    },
    /**
   * Disjunctive facets setter
   * Change the list of disjunctive (or) facets the helper chan handle.
   * @method
   * @param {string[]} facets all the attributes of the algolia records used for disjunctive faceting
   * @return {SearchParameters} new instance
   */ setDisjunctiveFacets: function setDisjunctiveFacets(facets) {
        return this.setQueryParameters({
            disjunctiveFacets: facets
        });
    },
    /**
   * HitsPerPage setter
   * Hits per page represents the number of hits retrieved for this query
   * @method
   * @param {number} n number of hits retrieved per page of results
   * @return {SearchParameters} new instance
   */ setHitsPerPage: function setHitsPerPage(n) {
        if (this.hitsPerPage === n) return this;
        return this.setQueryParameters({
            hitsPerPage: n
        });
    },
    /**
   * typoTolerance setter
   * Set the value of typoTolerance
   * @method
   * @param {string} typoTolerance new value of typoTolerance ("true", "false", "min" or "strict")
   * @return {SearchParameters} new instance
   */ setTypoTolerance: function setTypoTolerance(typoTolerance) {
        if (this.typoTolerance === typoTolerance) return this;
        return this.setQueryParameters({
            typoTolerance: typoTolerance
        });
    },
    /**
   * Add a numeric filter for a given attribute
   * When value is an array, they are combined with OR
   * When value is a single value, it will combined with AND
   * @method
   * @param {string} attribute attribute to set the filter on
   * @param {string} operator operator of the filter (possible values: =, >, >=, <, <=, !=)
   * @param {number | number[]} value value of the filter
   * @return {SearchParameters} new instance
   * @example
   * // for price = 50 or 40
   * state.addNumericRefinement('price', '=', [50, 40]);
   * @example
   * // for size = 38 and 40
   * state.addNumericRefinement('size', '=', 38);
   * state.addNumericRefinement('size', '=', 40);
   */ addNumericRefinement: function(attribute, operator, value) {
        var val = $bx4yd(value);
        if (this.isNumericRefined(attribute, operator, val)) return this;
        var mod = $cNauE({}, this.numericRefinements);
        mod[attribute] = $cNauE({}, mod[attribute]);
        if (mod[attribute][operator]) {
            // Array copy
            mod[attribute][operator] = mod[attribute][operator].slice();
            // Add the element. Concat can't be used here because value can be an array.
            mod[attribute][operator].push(val);
        } else mod[attribute][operator] = [
            val
        ];
        return this.setQueryParameters({
            numericRefinements: mod
        });
    },
    /**
   * Get the list of conjunctive refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getConjunctiveRefinements: function(facetName) {
        if (!this.isConjunctiveFacet(facetName)) return [];
        return this.facetsRefinements[facetName] || [];
    },
    /**
   * Get the list of disjunctive refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getDisjunctiveRefinements: function(facetName) {
        if (!this.isDisjunctiveFacet(facetName)) return [];
        return this.disjunctiveFacetsRefinements[facetName] || [];
    },
    /**
   * Get the list of hierarchical refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getHierarchicalRefinement: function(facetName) {
        // we send an array but we currently do not support multiple
        // hierarchicalRefinements for a hierarchicalFacet
        return this.hierarchicalFacetsRefinements[facetName] || [];
    },
    /**
   * Get the list of exclude refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getExcludeRefinements: function(facetName) {
        if (!this.isConjunctiveFacet(facetName)) return [];
        return this.facetsExcludes[facetName] || [];
    },
    /**
   * Remove all the numeric filter for a given (attribute, operator)
   * @method
   * @param {string} attribute attribute to set the filter on
   * @param {string} [operator] operator of the filter (possible values: =, >, >=, <, <=, !=)
   * @param {number} [number] the value to be removed
   * @return {SearchParameters} new instance
   */ removeNumericRefinement: function(attribute, operator, number) {
        var paramValue = number;
        if (paramValue !== undefined) {
            if (!this.isNumericRefined(attribute, operator, paramValue)) return this;
            return this.setQueryParameters({
                numericRefinements: this._clearNumericRefinements(function(value, key) {
                    return key === attribute && value.op === operator && $c4bce0c9191240d9$var$isEqualNumericRefinement(value.val, $bx4yd(paramValue));
                })
            });
        } else if (operator !== undefined) {
            if (!this.isNumericRefined(attribute, operator)) return this;
            return this.setQueryParameters({
                numericRefinements: this._clearNumericRefinements(function(value, key) {
                    return key === attribute && value.op === operator;
                })
            });
        }
        if (!this.isNumericRefined(attribute)) return this;
        return this.setQueryParameters({
            numericRefinements: this._clearNumericRefinements(function(value, key) {
                return key === attribute;
            })
        });
    },
    /**
   * Get the list of numeric refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {SearchParameters.OperatorList} list of refinements
   */ getNumericRefinements: function(facetName) {
        return this.numericRefinements[facetName] || {};
    },
    /**
   * Return the current refinement for the (attribute, operator)
   * @param {string} attribute attribute in the record
   * @param {string} operator operator applied on the refined values
   * @return {Array.<number|number[]>} refined values
   */ getNumericRefinement: function(attribute, operator) {
        return this.numericRefinements[attribute] && this.numericRefinements[attribute][operator];
    },
    /**
   * Clear numeric filters.
   * @method
   * @private
   * @param {string|SearchParameters.clearCallback} [attribute] optional string or function
   * - If not given, means to clear all the filters.
   * - If `string`, means to clear all refinements for the `attribute` named filter.
   * - If `function`, means to clear all the refinements that return truthy values.
   * @return {Object.<string, OperatorList>} new numeric refinements
   */ _clearNumericRefinements: function _clearNumericRefinements(attribute) {
        if (attribute === undefined) {
            if (!$hPi9R(this.numericRefinements)) return this.numericRefinements;
            return {};
        } else if (typeof attribute === "string") return $2SavI(this.numericRefinements, [
            attribute
        ]);
        else if (typeof attribute === "function") {
            var hasChanged = false;
            var numericRefinements = this.numericRefinements;
            var newNumericRefinements = Object.keys(numericRefinements).reduce(function(memo, key) {
                var operators = numericRefinements[key];
                var operatorList = {};
                operators = operators || {};
                Object.keys(operators).forEach(function(operator) {
                    var values = operators[operator] || [];
                    var outValues = [];
                    values.forEach(function(value) {
                        var predicateResult = attribute({
                            val: value,
                            op: operator
                        }, key, "numeric");
                        if (!predicateResult) outValues.push(value);
                    });
                    if (outValues.length !== values.length) hasChanged = true;
                    operatorList[operator] = outValues;
                });
                memo[key] = operatorList;
                return memo;
            }, {});
            if (hasChanged) return newNumericRefinements;
            return this.numericRefinements;
        }
        // We return nothing if the attribute is not undefined, a string or a function,
        // as it is not a valid value for a refinement
        return undefined;
    },
    /**
   * Add a facet to the facets attribute of the helper configuration, if it
   * isn't already present.
   * @method
   * @param {string} facet facet name to add
   * @return {SearchParameters} new instance
   */ addFacet: function addFacet(facet) {
        if (this.isConjunctiveFacet(facet)) return this;
        return this.setQueryParameters({
            facets: this.facets.concat([
                facet
            ])
        });
    },
    /**
   * Add a disjunctive facet to the disjunctiveFacets attribute of the helper
   * configuration, if it isn't already present.
   * @method
   * @param {string} facet disjunctive facet name to add
   * @return {SearchParameters} new instance
   */ addDisjunctiveFacet: function addDisjunctiveFacet(facet) {
        if (this.isDisjunctiveFacet(facet)) return this;
        return this.setQueryParameters({
            disjunctiveFacets: this.disjunctiveFacets.concat([
                facet
            ])
        });
    },
    /**
   * Add a hierarchical facet to the hierarchicalFacets attribute of the helper
   * configuration.
   * @method
   * @param {object} hierarchicalFacet hierarchical facet to add
   * @return {SearchParameters} new instance
   * @throws will throw an error if a hierarchical facet with the same name was already declared
   */ addHierarchicalFacet: function addHierarchicalFacet(hierarchicalFacet) {
        if (this.isHierarchicalFacet(hierarchicalFacet.name)) throw new Error("Cannot declare two hierarchical facets with the same name: `" + hierarchicalFacet.name + "`");
        return this.setQueryParameters({
            hierarchicalFacets: this.hierarchicalFacets.concat([
                hierarchicalFacet
            ])
        });
    },
    /**
   * Add a refinement on a "normal" facet
   * @method
   * @param {string} facet attribute to apply the faceting on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addFacetRefinement: function addFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        if ($5s74r.isRefined(this.facetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            facetsRefinements: $5s74r.addRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Exclude a value from a "normal" facet
   * @method
   * @param {string} facet attribute to apply the exclusion on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addExcludeRefinement: function addExcludeRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        if ($5s74r.isRefined(this.facetsExcludes, facet, value)) return this;
        return this.setQueryParameters({
            facetsExcludes: $5s74r.addRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Adds a refinement on a disjunctive facet.
   * @method
   * @param {string} facet attribute to apply the faceting on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addDisjunctiveFacetRefinement: function addDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + " is not defined in the disjunctiveFacets attribute of the helper configuration");
        if ($5s74r.isRefined(this.disjunctiveFacetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $5s74r.addRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * addTagRefinement adds a tag to the list used to filter the results
   * @param {string} tag tag to be added
   * @return {SearchParameters} new instance
   */ addTagRefinement: function addTagRefinement(tag) {
        if (this.isTagRefined(tag)) return this;
        var modification = {
            tagRefinements: this.tagRefinements.concat(tag)
        };
        return this.setQueryParameters(modification);
    },
    /**
   * Remove a facet from the facets attribute of the helper configuration, if it
   * is present.
   * @method
   * @param {string} facet facet name to remove
   * @return {SearchParameters} new instance
   */ removeFacet: function removeFacet(facet) {
        if (!this.isConjunctiveFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            facets: this.facets.filter(function(f) {
                return f !== facet;
            })
        });
    },
    /**
   * Remove a disjunctive facet from the disjunctiveFacets attribute of the
   * helper configuration, if it is present.
   * @method
   * @param {string} facet disjunctive facet name to remove
   * @return {SearchParameters} new instance
   */ removeDisjunctiveFacet: function removeDisjunctiveFacet(facet) {
        if (!this.isDisjunctiveFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            disjunctiveFacets: this.disjunctiveFacets.filter(function(f) {
                return f !== facet;
            })
        });
    },
    /**
   * Remove a hierarchical facet from the hierarchicalFacets attribute of the
   * helper configuration, if it is present.
   * @method
   * @param {string} facet hierarchical facet name to remove
   * @return {SearchParameters} new instance
   */ removeHierarchicalFacet: function removeHierarchicalFacet(facet) {
        if (!this.isHierarchicalFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            hierarchicalFacets: this.hierarchicalFacets.filter(function(f) {
                return f.name !== facet;
            })
        });
    },
    /**
   * Remove a refinement set on facet. If a value is provided, it will clear the
   * refinement for the given value, otherwise it will clear all the refinement
   * values for the faceted attribute.
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} [value] value used to filter
   * @return {SearchParameters} new instance
   */ removeFacetRefinement: function removeFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        if (!$5s74r.isRefined(this.facetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            facetsRefinements: $5s74r.removeRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Remove a negative refinement on a facet
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} value value used to filter
   * @return {SearchParameters} new instance
   */ removeExcludeRefinement: function removeExcludeRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        if (!$5s74r.isRefined(this.facetsExcludes, facet, value)) return this;
        return this.setQueryParameters({
            facetsExcludes: $5s74r.removeRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Remove a refinement on a disjunctive facet
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} value value used to filter
   * @return {SearchParameters} new instance
   */ removeDisjunctiveFacetRefinement: function removeDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + " is not defined in the disjunctiveFacets attribute of the helper configuration");
        if (!$5s74r.isRefined(this.disjunctiveFacetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $5s74r.removeRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * Remove a tag from the list of tag refinements
   * @method
   * @param {string} tag the tag to remove
   * @return {SearchParameters} new instance
   */ removeTagRefinement: function removeTagRefinement(tag) {
        if (!this.isTagRefined(tag)) return this;
        var modification = {
            tagRefinements: this.tagRefinements.filter(function(t) {
                return t !== tag;
            })
        };
        return this.setQueryParameters(modification);
    },
    /**
   * Generic toggle refinement method to use with facet, disjunctive facets
   * and hierarchical facets
   * @param  {string} facet the facet to refine
   * @param  {string} value the associated value
   * @return {SearchParameters} new instance
   * @throws will throw an error if the facet is not declared in the settings of the helper
   * @deprecated since version 2.19.0, see {@link SearchParameters#toggleFacetRefinement}
   */ toggleRefinement: function toggleRefinement(facet, value) {
        return this.toggleFacetRefinement(facet, value);
    },
    /**
   * Generic toggle refinement method to use with facet, disjunctive facets
   * and hierarchical facets
   * @param  {string} facet the facet to refine
   * @param  {string} value the associated value
   * @return {SearchParameters} new instance
   * @throws will throw an error if the facet is not declared in the settings of the helper
   */ toggleFacetRefinement: function toggleFacetRefinement(facet, value) {
        if (this.isHierarchicalFacet(facet)) return this.toggleHierarchicalFacetRefinement(facet, value);
        else if (this.isConjunctiveFacet(facet)) return this.toggleConjunctiveFacetRefinement(facet, value);
        else if (this.isDisjunctiveFacet(facet)) return this.toggleDisjunctiveFacetRefinement(facet, value);
        throw new Error("Cannot refine the undeclared facet " + facet + "; it should be added to the helper options facets, disjunctiveFacets or hierarchicalFacets");
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleConjunctiveFacetRefinement: function toggleConjunctiveFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        return this.setQueryParameters({
            facetsRefinements: $5s74r.toggleRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleExcludeFacetRefinement: function toggleExcludeFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + " is not defined in the facets attribute of the helper configuration");
        return this.setQueryParameters({
            facetsExcludes: $5s74r.toggleRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleDisjunctiveFacetRefinement: function toggleDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + " is not defined in the disjunctiveFacets attribute of the helper configuration");
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $5s74r.toggleRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleHierarchicalFacetRefinement: function toggleHierarchicalFacetRefinement(facet, value) {
        if (!this.isHierarchicalFacet(facet)) throw new Error(facet + " is not defined in the hierarchicalFacets attribute of the helper configuration");
        var separator = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(facet));
        var mod = {};
        var upOneOrMultipleLevel = this.hierarchicalFacetsRefinements[facet] !== undefined && this.hierarchicalFacetsRefinements[facet].length > 0 && // remove current refinement:
        // refinement was 'beer > IPA', call is toggleRefine('beer > IPA'), refinement should be `beer`
        (this.hierarchicalFacetsRefinements[facet][0] === value || // remove a parent refinement of the current refinement:
        //  - refinement was 'beer > IPA > Flying dog'
        //  - call is toggleRefine('beer > IPA')
        //  - refinement should be `beer`
        this.hierarchicalFacetsRefinements[facet][0].indexOf(value + separator) === 0);
        if (upOneOrMultipleLevel) {
            if (value.indexOf(separator) === -1) // go back to root level
            mod[facet] = [];
            else mod[facet] = [
                value.slice(0, value.lastIndexOf(separator))
            ];
        } else mod[facet] = [
            value
        ];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $jGPgk({}, mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Adds a refinement on a hierarchical facet.
   * @param {string} facet the facet name
   * @param {string} path the hierarchical facet path
   * @return {SearchParameter} the new state
   * @throws Error if the facet is not defined or if the facet is refined
   */ addHierarchicalFacetRefinement: function(facet, path) {
        if (this.isHierarchicalFacetRefined(facet)) throw new Error(facet + " is already refined.");
        if (!this.isHierarchicalFacet(facet)) throw new Error(facet + " is not defined in the hierarchicalFacets attribute of the helper configuration.");
        var mod = {};
        mod[facet] = [
            path
        ];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $jGPgk({}, mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Removes the refinement set on a hierarchical facet.
   * @param {string} facet the facet name
   * @return {SearchParameter} the new state
   * @throws Error if the facet is not defined or if the facet is not refined
   */ removeHierarchicalFacetRefinement: function(facet) {
        if (!this.isHierarchicalFacetRefined(facet)) return this;
        var mod = {};
        mod[facet] = [];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $jGPgk({}, mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Switch the tag refinement
   * @method
   * @param {string} tag the tag to remove or add
   * @return {SearchParameters} new instance
   */ toggleTagRefinement: function toggleTagRefinement(tag) {
        if (this.isTagRefined(tag)) return this.removeTagRefinement(tag);
        return this.addTagRefinement(tag);
    },
    /**
   * Test if the facet name is from one of the disjunctive facets
   * @method
   * @param {string} facet facet name to test
   * @return {boolean} true if facet is a disjunctive facet
   */ isDisjunctiveFacet: function(facet) {
        return this.disjunctiveFacets.indexOf(facet) > -1;
    },
    /**
   * Test if the facet name is from one of the hierarchical facets
   * @method
   * @param {string} facetName facet name to test
   * @return {boolean} true if facetName is a hierarchical facet
   */ isHierarchicalFacet: function(facetName) {
        return this.getHierarchicalFacetByName(facetName) !== undefined;
    },
    /**
   * Test if the facet name is from one of the conjunctive/normal facets
   * @method
   * @param {string} facet facet name to test
   * @return {boolean} true if facet is a conjunctive facet
   */ isConjunctiveFacet: function(facet) {
        return this.facets.indexOf(facet) > -1;
    },
    /**
   * Returns true if the facet is refined, either for a specific value or in
   * general.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value, optional value. If passed will test that this value
   * is filtering the given facet.
   * @return {boolean} returns true if refined
   */ isFacetRefined: function isFacetRefined(facet, value) {
        if (!this.isConjunctiveFacet(facet)) return false;
        return $5s74r.isRefined(this.facetsRefinements, facet, value);
    },
    /**
   * Returns true if the facet contains exclusions or if a specific value is
   * excluded.
   *
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} [value] optional value. If passed will test that this value
   * is filtering the given facet.
   * @return {boolean} returns true if refined
   */ isExcludeRefined: function isExcludeRefined(facet, value) {
        if (!this.isConjunctiveFacet(facet)) return false;
        return $5s74r.isRefined(this.facetsExcludes, facet, value);
    },
    /**
   * Returns true if the facet contains a refinement, or if a value passed is a
   * refinement for the facet.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value optional, will test if the value is used for refinement
   * if there is one, otherwise will test if the facet contains any refinement
   * @return {boolean} true if the facet is refined
   */ isDisjunctiveFacetRefined: function isDisjunctiveFacetRefined(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) return false;
        return $5s74r.isRefined(this.disjunctiveFacetsRefinements, facet, value);
    },
    /**
   * Returns true if the facet contains a refinement, or if a value passed is a
   * refinement for the facet.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value optional, will test if the value is used for refinement
   * if there is one, otherwise will test if the facet contains any refinement
   * @return {boolean} true if the facet is refined
   */ isHierarchicalFacetRefined: function isHierarchicalFacetRefined(facet, value) {
        if (!this.isHierarchicalFacet(facet)) return false;
        var refinements = this.getHierarchicalRefinement(facet);
        if (!value) return refinements.length > 0;
        return refinements.indexOf(value) !== -1;
    },
    /**
   * Test if the triple (attribute, operator, value) is already refined.
   * If only the attribute and the operator are provided, it tests if the
   * contains any refinement value.
   * @method
   * @param {string} attribute attribute for which the refinement is applied
   * @param {string} [operator] operator of the refinement
   * @param {string} [value] value of the refinement
   * @return {boolean} true if it is refined
   */ isNumericRefined: function isNumericRefined(attribute, operator, value) {
        if (value === undefined && operator === undefined) return Boolean(this.numericRefinements[attribute]);
        var isOperatorDefined = this.numericRefinements[attribute] && this.numericRefinements[attribute][operator] !== undefined;
        if (value === undefined || !isOperatorDefined) return isOperatorDefined;
        var parsedValue = $bx4yd(value);
        var isAttributeValueDefined = $c4bce0c9191240d9$var$findArray(this.numericRefinements[attribute][operator], parsedValue) !== undefined;
        return isOperatorDefined && isAttributeValueDefined;
    },
    /**
   * Returns true if the tag refined, false otherwise
   * @method
   * @param {string} tag the tag to check
   * @return {boolean} true if tag is refined
   */ isTagRefined: function isTagRefined(tag) {
        return this.tagRefinements.indexOf(tag) !== -1;
    },
    /**
   * Returns the list of all disjunctive facets refined
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {string[]} returns the list of refinements
   */ getRefinedDisjunctiveFacets: function getRefinedDisjunctiveFacets() {
        // eslint-disable-next-line consistent-this
        var self = this;
        // attributes used for numeric filter can also be disjunctive
        var disjunctiveNumericRefinedFacets = $7OPVH(Object.keys(this.numericRefinements).filter(function(facet) {
            return Object.keys(self.numericRefinements[facet]).length > 0;
        }), this.disjunctiveFacets);
        return Object.keys(this.disjunctiveFacetsRefinements).filter(function(facet) {
            return self.disjunctiveFacetsRefinements[facet].length > 0;
        }).concat(disjunctiveNumericRefinedFacets).concat(this.getRefinedHierarchicalFacets()).sort();
    },
    /**
   * Returns the list of all disjunctive facets refined
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {string[]} returns the list of refinements
   */ getRefinedHierarchicalFacets: function getRefinedHierarchicalFacets() {
        // eslint-disable-next-line consistent-this
        var self = this;
        return $7OPVH(// enforce the order between the two arrays,
        // so that refinement name index === hierarchical facet index
        this.hierarchicalFacets.map(function(facet) {
            return facet.name;
        }), Object.keys(this.hierarchicalFacetsRefinements).filter(function(facet) {
            return self.hierarchicalFacetsRefinements[facet].length > 0;
        })).sort();
    },
    /**
   * Returned the list of all disjunctive facets not refined
   * @method
   * @return {string[]} returns the list of facets that are not refined
   */ getUnrefinedDisjunctiveFacets: function() {
        var refinedFacets = this.getRefinedDisjunctiveFacets();
        return this.disjunctiveFacets.filter(function(f) {
            return refinedFacets.indexOf(f) === -1;
        });
    },
    managedParameters: [
        "index",
        "facets",
        "disjunctiveFacets",
        "facetsRefinements",
        "hierarchicalFacets",
        "facetsExcludes",
        "disjunctiveFacetsRefinements",
        "numericRefinements",
        "tagRefinements",
        "hierarchicalFacetsRefinements"
    ],
    getQueryParams: function getQueryParams() {
        var managedParameters = this.managedParameters;
        var queryParams = {};
        // eslint-disable-next-line consistent-this
        var self = this;
        Object.keys(this).forEach(function(paramName) {
            var paramValue = self[paramName];
            if (managedParameters.indexOf(paramName) === -1 && paramValue !== undefined) queryParams[paramName] = paramValue;
        });
        return queryParams;
    },
    /**
   * Let the user set a specific value for a given parameter. Will return the
   * same instance if the parameter is invalid or if the value is the same as the
   * previous one.
   * @method
   * @param {string} parameter the parameter name
   * @param {any} value the value to be set, must be compliant with the definition
   * of the attribute on the object
   * @return {SearchParameters} the updated state
   */ setQueryParameter: function setParameter(parameter, value) {
        if (this[parameter] === value) return this;
        var modification = {};
        modification[parameter] = value;
        return this.setQueryParameters(modification);
    },
    /**
   * Let the user set any of the parameters with a plain object.
   * @method
   * @param {object} params all the keys and the values to be updated
   * @return {SearchParameters} a new updated instance
   */ setQueryParameters: function setQueryParameters(params) {
        if (!params) return this;
        var error = $c4bce0c9191240d9$var$SearchParameters.validate(this, params);
        if (error) throw error;
        // eslint-disable-next-line consistent-this
        var self = this;
        var nextWithNumbers = $c4bce0c9191240d9$var$SearchParameters._parseNumbers(params);
        var previousPlainObject = Object.keys(this).reduce(function(acc, key) {
            acc[key] = self[key];
            return acc;
        }, {});
        var nextPlainObject = Object.keys(nextWithNumbers).reduce(function(previous, key) {
            var isPreviousValueDefined = previous[key] !== undefined;
            var isNextValueDefined = nextWithNumbers[key] !== undefined;
            if (isPreviousValueDefined && !isNextValueDefined) return $2SavI(previous, [
                key
            ]);
            if (isNextValueDefined) previous[key] = nextWithNumbers[key];
            return previous;
        }, previousPlainObject);
        return new this.constructor(nextPlainObject);
    },
    /**
   * Returns a new instance with the page reset. Two scenarios possible:
   * the page is omitted -> return the given instance
   * the page is set -> return a new instance with a page of 0
   * @return {SearchParameters} a new updated instance
   */ resetPage: function() {
        if (this.page === undefined) return this;
        return this.setPage(0);
    },
    /**
   * Helper function to get the hierarchicalFacet separator or the default one (`>`)
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.separator or `>` as default
   */ _getHierarchicalFacetSortBy: function(hierarchicalFacet) {
        return hierarchicalFacet.sortBy || [
            "isRefined:desc",
            "name:asc"
        ];
    },
    /**
   * Helper function to get the hierarchicalFacet separator or the default one (`>`)
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.separator or `>` as default
   */ _getHierarchicalFacetSeparator: function(hierarchicalFacet) {
        return hierarchicalFacet.separator || " > ";
    },
    /**
   * Helper function to get the hierarchicalFacet prefix path or null
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.rootPath or null as default
   */ _getHierarchicalRootPath: function(hierarchicalFacet) {
        return hierarchicalFacet.rootPath || null;
    },
    /**
   * Helper function to check if we show the parent level of the hierarchicalFacet
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.showParentLevel or true as default
   */ _getHierarchicalShowParentLevel: function(hierarchicalFacet) {
        if (typeof hierarchicalFacet.showParentLevel === "boolean") return hierarchicalFacet.showParentLevel;
        return true;
    },
    /**
   * Helper function to get the hierarchicalFacet by it's name
   * @param  {string} hierarchicalFacetName the hierarchicalFacet name
   * @return {object} a hierarchicalFacet
   */ getHierarchicalFacetByName: function(hierarchicalFacetName) {
        return $hmac5(this.hierarchicalFacets, function(f) {
            return f.name === hierarchicalFacetName;
        });
    },
    /**
   * Get the current breadcrumb for a hierarchical facet, as an array
   * @param  {string} facetName Hierarchical facet name
   * @return {array.<string>} the path as an array of string
   */ getHierarchicalFacetBreadcrumb: function(facetName) {
        if (!this.isHierarchicalFacet(facetName)) return [];
        var refinement = this.getHierarchicalRefinement(facetName)[0];
        if (!refinement) return [];
        var separator = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(facetName));
        var path = refinement.split(separator);
        return path.map(function(part) {
            return part.trim();
        });
    },
    toString: function() {
        return JSON.stringify(this, null, 2);
    }
};
/**
 * Callback used for clearRefinement method
 * @callback SearchParameters.clearCallback
 * @param {OperatorList|FacetList} value the value of the filter
 * @param {string} key the current attribute name
 * @param {string} type `numeric`, `disjunctiveFacet`, `conjunctiveFacet`, `hierarchicalFacet` or `exclude`
 * depending on the type of facet
 * @return {boolean} `true` if the element should be removed. `false` otherwise.
 */ module.exports = $c4bce0c9191240d9$var$SearchParameters;

});
parcelRegister("jGPgk", function(module, exports) {
"use strict";
// NOTE: this behaves like lodash/defaults, but doesn't mutate the target
// it also preserve keys order
module.exports = function defaultsPure() {
    var sources = Array.prototype.slice.call(arguments);
    return sources.reduceRight(function(acc, source) {
        Object.keys(Object(source)).forEach(function(key) {
            if (source[key] === undefined) return;
            if (acc[key] !== undefined) // remove if already added, so that we can add it in correct order
            delete acc[key];
            acc[key] = source[key];
        });
        return acc;
    }, {});
};

});

parcelRegister("hmac5", function(module, exports) {
"use strict";
// @MAJOR can be replaced by native Array#find when we change support
module.exports = function find(array, comparator) {
    if (!Array.isArray(array)) return undefined;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return array[i];
    }
    return undefined;
};

});

parcelRegister("7OPVH", function(module, exports) {
"use strict";
function $5b157c0ff2ad7fc0$var$intersection(arr1, arr2) {
    return arr1.filter(function(value, index) {
        return arr2.indexOf(value) > -1 && arr1.indexOf(value) === index /* skips duplicates */ ;
    });
}
module.exports = $5b157c0ff2ad7fc0$var$intersection;

});

parcelRegister("bx4yd", function(module, exports) {
"use strict";
function $86564e7d3ef2e569$var$valToNumber(v) {
    if (typeof v === "number") return v;
    else if (typeof v === "string") return parseFloat(v);
    else if (Array.isArray(v)) return v.map($86564e7d3ef2e569$var$valToNumber);
    throw new Error("The value should be a number, a parsable string or an array of those.");
}
module.exports = $86564e7d3ef2e569$var$valToNumber;

});

parcelRegister("jIrs2", function(module, exports) {
"use strict";
module.exports = function isValidUserToken(userToken) {
    if (userToken === null) return false;
    return /^[a-zA-Z0-9_-]{1,64}$/.test(userToken);
};

});

parcelRegister("5s74r", function(module, exports) {
"use strict";

var $jGPgk = parcelRequire("jGPgk");

var $hPi9R = parcelRequire("hPi9R");

var $2SavI = parcelRequire("2SavI");
var $3f850d57f0daaad2$var$lib = {
    /**
   * Adds a refinement to a RefinementList
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} value the value of the refinement, if the value is not a string it will be converted
   * @return {RefinementList} a new and updated refinement list
   */ addRefinement: function addRefinement(refinementList, attribute, value) {
        if ($3f850d57f0daaad2$var$lib.isRefined(refinementList, attribute, value)) return refinementList;
        var valueAsString = "" + value;
        var facetRefinement = !refinementList[attribute] ? [
            valueAsString
        ] : refinementList[attribute].concat(valueAsString);
        var mod = {};
        mod[attribute] = facetRefinement;
        return $jGPgk({}, mod, refinementList);
    },
    /**
   * Removes refinement(s) for an attribute:
   *  - if the value is specified removes the refinement for the value on the attribute
   *  - if no value is specified removes all the refinements for this attribute
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} [value] the value of the refinement
   * @return {RefinementList} a new and updated refinement lst
   */ removeRefinement: function removeRefinement(refinementList, attribute, value) {
        if (value === undefined) // we use the "filter" form of clearRefinement, since it leaves empty values as-is
        // the form with a string will remove the attribute completely
        return $3f850d57f0daaad2$var$lib.clearRefinement(refinementList, function(v, f) {
            return attribute === f;
        });
        var valueAsString = "" + value;
        return $3f850d57f0daaad2$var$lib.clearRefinement(refinementList, function(v, f) {
            return attribute === f && valueAsString === v;
        });
    },
    /**
   * Toggles the refinement value for an attribute.
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} value the value of the refinement
   * @return {RefinementList} a new and updated list
   */ toggleRefinement: function toggleRefinement(refinementList, attribute, value) {
        if (value === undefined) throw new Error("toggleRefinement should be used with a value");
        if ($3f850d57f0daaad2$var$lib.isRefined(refinementList, attribute, value)) return $3f850d57f0daaad2$var$lib.removeRefinement(refinementList, attribute, value);
        return $3f850d57f0daaad2$var$lib.addRefinement(refinementList, attribute, value);
    },
    /**
   * Clear all or parts of a RefinementList. Depending on the arguments, three
   * kinds of behavior can happen:
   *  - if no attribute is provided: clears the whole list
   *  - if an attribute is provided as a string: clears the list for the specific attribute
   *  - if an attribute is provided as a function: discards the elements for which the function returns true
   * @param {RefinementList} refinementList the initial list
   * @param {string} [attribute] the attribute or function to discard
   * @param {string} [refinementType] optional parameter to give more context to the attribute function
   * @return {RefinementList} a new and updated refinement list
   */ clearRefinement: function clearRefinement(refinementList, attribute, refinementType) {
        if (attribute === undefined) {
            // return the same object if the list is already empty
            // this is mainly for tests, as it doesn't have much impact on performance
            if (!$hPi9R(refinementList)) return refinementList;
            return {};
        } else if (typeof attribute === "string") return $2SavI(refinementList, [
            attribute
        ]);
        else if (typeof attribute === "function") {
            var hasChanged = false;
            var newRefinementList = Object.keys(refinementList).reduce(function(memo, key) {
                var values = refinementList[key] || [];
                var facetList = values.filter(function(value) {
                    return !attribute(value, key, refinementType);
                });
                if (facetList.length !== values.length) hasChanged = true;
                memo[key] = facetList;
                return memo;
            }, {});
            if (hasChanged) return newRefinementList;
            return refinementList;
        }
        // We return nothing if the attribute is not undefined, a string or a function,
        // as it is not a valid value for a refinement
        return undefined;
    },
    /**
   * Test if the refinement value is used for the attribute. If no refinement value
   * is provided, test if the refinementList contains any refinement for the
   * given attribute.
   * @param {RefinementList} refinementList the list of refinement
   * @param {string} attribute name of the attribute
   * @param {string} [refinementValue] value of the filter/refinement
   * @return {boolean} true if the attribute is refined, false otherwise
   */ isRefined: function isRefined(refinementList, attribute, refinementValue) {
        var containsRefinements = Boolean(refinementList[attribute]) && refinementList[attribute].length > 0;
        if (refinementValue === undefined || !containsRefinements) return containsRefinements;
        var refinementValueAsString = "" + refinementValue;
        return refinementList[attribute].indexOf(refinementValueAsString) !== -1;
    }
};
module.exports = $3f850d57f0daaad2$var$lib;

});


parcelRegister("bUiU2", function(module, exports) {
"use strict";

var $jtI0v = parcelRequire("jtI0v");

var $jGPgk = parcelRequire("jGPgk");

var $9IuIV = parcelRequire("9IuIV");

var $hmac5 = parcelRequire("hmac5");

var $Do2a2 = parcelRequire("Do2a2");

var $16bmX = parcelRequire("16bmX");

var $cNauE = parcelRequire("cNauE");

var $2hata = parcelRequire("2hata");
var $8ab3966607d77b84$var$escapeFacetValue = $9IuIV.escapeFacetValue;
var $8ab3966607d77b84$var$unescapeFacetValue = $9IuIV.unescapeFacetValue;

var $9U5lC = parcelRequire("9U5lC");
/**
 * @typedef SearchResults.Facet
 * @type {object}
 * @property {string} name name of the attribute in the record
 * @property {object} data the faceting data: value, number of entries
 * @property {object} stats undefined unless facet_stats is retrieved from algolia
 */ /**
 * @typedef SearchResults.HierarchicalFacet
 * @type {object}
 * @property {string} name name of the current value given the hierarchical level, trimmed.
 * If root node, you get the facet name
 * @property {number} count number of objects matching this hierarchical value
 * @property {string} path the current hierarchical value full path
 * @property {boolean} isRefined `true` if the current value was refined, `false` otherwise
 * @property {HierarchicalFacet[]} data sub values for the current level
 */ /**
 * @typedef SearchResults.FacetValue
 * @type {object}
 * @property {string} name the facet value itself
 * @property {number} count times this facet appears in the results
 * @property {boolean} isRefined is the facet currently selected
 * @property {boolean} isExcluded is the facet currently excluded (only for conjunctive facets)
 */ /**
 * @typedef Refinement
 * @type {object}
 * @property {string} type the type of filter used:
 * `numeric`, `facet`, `exclude`, `disjunctive`, `hierarchical`
 * @property {string} attributeName name of the attribute used for filtering
 * @property {string} name the value of the filter
 * @property {number} numericValue the value as a number. Only for numeric filters.
 * @property {string} operator the operator used. Only for numeric filters.
 * @property {number} count the number of computed hits for this filter. Only on facets.
 * @property {boolean} exhaustive if the count is exhaustive
 */ /**
 * Turn an array of attributes in an object of attributes with their position in the array as value
 * @param {string[]} attributes the list of attributes in the record
 * @return {object} the list of attributes indexed by attribute name
 */ function $8ab3966607d77b84$var$getIndices(attributes) {
    var indices = {};
    attributes.forEach(function(val, idx) {
        indices[val] = idx;
    });
    return indices;
}
function $8ab3966607d77b84$var$assignFacetStats(dest, facetStats, key) {
    if (facetStats && facetStats[key]) dest.stats = facetStats[key];
}
/**
 * @typedef {Object} HierarchicalFacet
 * @property {string} name
 * @property {string[]} attributes
 */ /**
 * @param {HierarchicalFacet[]} hierarchicalFacets All hierarchical facets
 * @param {string} hierarchicalAttributeName The name of the hierarchical attribute
 * @return {HierarchicalFacet} The hierarchical facet matching the attribute name
 */ function $8ab3966607d77b84$var$findMatchingHierarchicalFacetFromAttributeName(hierarchicalFacets, hierarchicalAttributeName) {
    return $hmac5(hierarchicalFacets, function facetKeyMatchesAttribute(hierarchicalFacet) {
        var facetNames = hierarchicalFacet.attributes || [];
        return facetNames.indexOf(hierarchicalAttributeName) > -1;
    });
}
/**
 * Constructor for SearchResults
 * @class
 * @classdesc SearchResults contains the results of a query to Algolia using the
 * {@link AlgoliaSearchHelper}.
 * @param {SearchParameters} state state that led to the response
 * @param {array.<object>} results the results from algolia client
 * @param {object} options options to control results content
 * @example <caption>SearchResults of the first query in
 * <a href="http://demos.algolia.com/instant-search-demo">the instant search demo</a></caption>
{
   "hitsPerPage": 10,
   "processingTimeMS": 2,
   "facets": [
      {
         "name": "type",
         "data": {
            "HardGood": 6627,
            "BlackTie": 550,
            "Music": 665,
            "Software": 131,
            "Game": 456,
            "Movie": 1571
         },
         "exhaustive": false
      },
      {
         "exhaustive": false,
         "data": {
            "Free shipping": 5507
         },
         "name": "shipping"
      }
  ],
   "hits": [
      {
         "thumbnailImage": "http://img.bbystatic.com/BestBuy_US/images/products/1688/1688832_54x108_s.gif",
         "_highlightResult": {
            "shortDescription": {
               "matchLevel": "none",
               "value": "Safeguard your PC, Mac, Android and iOS devices with comprehensive Internet protection",
               "matchedWords": []
            },
            "category": {
               "matchLevel": "none",
               "value": "Computer Security Software",
               "matchedWords": []
            },
            "manufacturer": {
               "matchedWords": [],
               "value": "Webroot",
               "matchLevel": "none"
            },
            "name": {
               "value": "Webroot SecureAnywhere Internet Security (3-Device) (1-Year Subscription) - Mac/Windows",
               "matchedWords": [],
               "matchLevel": "none"
            }
         },
         "image": "http://img.bbystatic.com/BestBuy_US/images/products/1688/1688832_105x210_sc.jpg",
         "shipping": "Free shipping",
         "bestSellingRank": 4,
         "shortDescription": "Safeguard your PC, Mac, Android and iOS devices with comprehensive Internet protection",
         "url": "http://www.bestbuy.com/site/webroot-secureanywhere-internet-security-3-devi…d=1219060687969&skuId=1688832&cmp=RMX&ky=2d3GfEmNIzjA0vkzveHdZEBgpPCyMnLTJ",
         "name": "Webroot SecureAnywhere Internet Security (3-Device) (1-Year Subscription) - Mac/Windows",
         "category": "Computer Security Software",
         "salePrice_range": "1 - 50",
         "objectID": "1688832",
         "type": "Software",
         "customerReviewCount": 5980,
         "salePrice": 49.99,
         "manufacturer": "Webroot"
      },
      ....
  ],
   "nbHits": 10000,
   "disjunctiveFacets": [
      {
         "exhaustive": false,
         "data": {
            "5": 183,
            "12": 112,
            "7": 149,
            ...
         },
         "name": "customerReviewCount",
         "stats": {
            "max": 7461,
            "avg": 157.939,
            "min": 1
         }
      },
      {
         "data": {
            "Printer Ink": 142,
            "Wireless Speakers": 60,
            "Point & Shoot Cameras": 48,
            ...
         },
         "name": "category",
         "exhaustive": false
      },
      {
         "exhaustive": false,
         "data": {
            "> 5000": 2,
            "1 - 50": 6524,
            "501 - 2000": 566,
            "201 - 500": 1501,
            "101 - 200": 1360,
            "2001 - 5000": 47
         },
         "name": "salePrice_range"
      },
      {
         "data": {
            "Dynex™": 202,
            "Insignia™": 230,
            "PNY": 72,
            ...
         },
         "name": "manufacturer",
         "exhaustive": false
      }
  ],
   "query": "",
   "nbPages": 100,
   "page": 0,
   "index": "bestbuy"
}
 **/ function $8ab3966607d77b84$var$SearchResults(state, results, options) {
    var mainSubResponse = results[0] || {};
    this._rawResults = results;
    // eslint-disable-next-line consistent-this
    var self = this;
    // https://www.algolia.com/doc/api-reference/api-methods/search/#response
    Object.keys(mainSubResponse).forEach(function(key) {
        self[key] = mainSubResponse[key];
    });
    // Make every key of the result options reachable from the instance
    var opts = $cNauE({
        persistHierarchicalRootCount: false
    }, options);
    Object.keys(opts).forEach(function(key) {
        self[key] = opts[key];
    });
    /**
   * query used to generate the results
   * @name query
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * The query as parsed by the engine given all the rules.
   * @name parsedQuery
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * all the records that match the search parameters. Each record is
   * augmented with a new attribute `_highlightResult`
   * which is an object keyed by attribute and with the following properties:
   * - `value` : the value of the facet highlighted (html)
   * - `matchLevel`: `full`, `partial` or `none`, depending on how the query terms match
   * @name hits
   * @member {object[]}
   * @memberof SearchResults
   * @instance
   */ /**
   * index where the results come from
   * @name index
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * number of hits per page requested
   * @name hitsPerPage
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * total number of hits of this query on the index
   * @name nbHits
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * total number of pages with respect to the number of hits per page and the total number of hits
   * @name nbPages
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * current page
   * @name page
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * The position if the position was guessed by IP.
   * @name aroundLatLng
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "48.8637,2.3615",
   */ /**
   * The radius computed by Algolia.
   * @name automaticRadius
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "126792922",
   */ /**
   * String identifying the server used to serve this request.
   *
   * getRankingInfo needs to be set to `true` for this to be returned
   *
   * @name serverUsed
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "c7-use-2.algolia.net",
   */ /**
   * Boolean that indicates if the computation of the counts did time out.
   * @deprecated
   * @name timeoutCounts
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * Boolean that indicates if the computation of the hits did time out.
   * @deprecated
   * @name timeoutHits
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * True if the counts of the facets is exhaustive
   * @name exhaustiveFacetsCount
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * True if the number of hits is exhaustive
   * @name exhaustiveNbHits
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * Contains the userData if they are set by a [query rule](https://www.algolia.com/doc/guides/query-rules/query-rules-overview/).
   * @name userData
   * @member {object[]}
   * @memberof SearchResults
   * @instance
   */ /**
   * queryID is the unique identifier of the query used to generate the current search results.
   * This value is only available if the `clickAnalytics` search parameter is set to `true`.
   * @name queryID
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * sum of the processing time of all the queries
   * @name processingTimeMS
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ this.processingTimeMS = results.reduce(function(sum, result) {
        return result.processingTimeMS === undefined ? sum : sum + result.processingTimeMS;
    }, 0);
    /**
   * disjunctive facets results
   * @member {SearchResults.Facet[]}
   */ this.disjunctiveFacets = [];
    /**
   * disjunctive facets results
   * @member {SearchResults.HierarchicalFacet[]}
   */ this.hierarchicalFacets = state.hierarchicalFacets.map(function initFutureTree() {
        return [];
    });
    /**
   * other facets results
   * @member {SearchResults.Facet[]}
   */ this.facets = [];
    var disjunctiveFacets = state.getRefinedDisjunctiveFacets();
    var facetsIndices = $8ab3966607d77b84$var$getIndices(state.facets);
    var disjunctiveFacetsIndices = $8ab3966607d77b84$var$getIndices(state.disjunctiveFacets);
    var nextDisjunctiveResult = 1;
    // Since we send request only for disjunctive facets that have been refined,
    // we get the facets information from the first, general, response.
    var mainFacets = mainSubResponse.facets || {};
    Object.keys(mainFacets).forEach(function(facetKey) {
        var facetValueObject = mainFacets[facetKey];
        var hierarchicalFacet = $8ab3966607d77b84$var$findMatchingHierarchicalFacetFromAttributeName(state.hierarchicalFacets, facetKey);
        if (hierarchicalFacet) {
            // Place the hierarchicalFacet data at the correct index depending on
            // the attributes order that was defined at the helper initialization
            var facetIndex = hierarchicalFacet.attributes.indexOf(facetKey);
            var idxAttributeName = $Do2a2(state.hierarchicalFacets, function(f) {
                return f.name === hierarchicalFacet.name;
            });
            self.hierarchicalFacets[idxAttributeName][facetIndex] = {
                attribute: facetKey,
                data: facetValueObject,
                exhaustive: mainSubResponse.exhaustiveFacetsCount
            };
        } else {
            var isFacetDisjunctive = state.disjunctiveFacets.indexOf(facetKey) !== -1;
            var isFacetConjunctive = state.facets.indexOf(facetKey) !== -1;
            var position;
            if (isFacetDisjunctive) {
                position = disjunctiveFacetsIndices[facetKey];
                self.disjunctiveFacets[position] = {
                    name: facetKey,
                    data: facetValueObject,
                    exhaustive: mainSubResponse.exhaustiveFacetsCount
                };
                $8ab3966607d77b84$var$assignFacetStats(self.disjunctiveFacets[position], mainSubResponse.facets_stats, facetKey);
            }
            if (isFacetConjunctive) {
                position = facetsIndices[facetKey];
                self.facets[position] = {
                    name: facetKey,
                    data: facetValueObject,
                    exhaustive: mainSubResponse.exhaustiveFacetsCount
                };
                $8ab3966607d77b84$var$assignFacetStats(self.facets[position], mainSubResponse.facets_stats, facetKey);
            }
        }
    });
    // Make sure we do not keep holes within the hierarchical facets
    this.hierarchicalFacets = $jtI0v(this.hierarchicalFacets);
    // aggregate the refined disjunctive facets
    disjunctiveFacets.forEach(function(disjunctiveFacet) {
        var result = results[nextDisjunctiveResult];
        var facets = result && result.facets ? result.facets : {};
        var hierarchicalFacet = state.getHierarchicalFacetByName(disjunctiveFacet);
        // There should be only item in facets.
        Object.keys(facets).forEach(function(dfacet) {
            var facetResults = facets[dfacet];
            var position;
            if (hierarchicalFacet) {
                position = $Do2a2(state.hierarchicalFacets, function(f) {
                    return f.name === hierarchicalFacet.name;
                });
                var attributeIndex = $Do2a2(self.hierarchicalFacets[position], function(f) {
                    return f.attribute === dfacet;
                });
                // previous refinements and no results so not able to find it
                if (attributeIndex === -1) return;
                self.hierarchicalFacets[position][attributeIndex].data = $cNauE({}, self.hierarchicalFacets[position][attributeIndex].data, facetResults);
            } else {
                position = disjunctiveFacetsIndices[dfacet];
                var dataFromMainRequest = mainSubResponse.facets && mainSubResponse.facets[dfacet] || {};
                self.disjunctiveFacets[position] = {
                    name: dfacet,
                    data: $jGPgk({}, facetResults, dataFromMainRequest),
                    exhaustive: result.exhaustiveFacetsCount
                };
                $8ab3966607d77b84$var$assignFacetStats(self.disjunctiveFacets[position], result.facets_stats, dfacet);
                if (state.disjunctiveFacetsRefinements[dfacet]) state.disjunctiveFacetsRefinements[dfacet].forEach(function(refinementValue) {
                    // add the disjunctive refinements if it is no more retrieved
                    if (!self.disjunctiveFacets[position].data[refinementValue] && state.disjunctiveFacetsRefinements[dfacet].indexOf($8ab3966607d77b84$var$unescapeFacetValue(refinementValue)) > -1) self.disjunctiveFacets[position].data[refinementValue] = 0;
                });
            }
        });
        nextDisjunctiveResult++;
    });
    // if we have some parent level values for hierarchical facets, merge them
    state.getRefinedHierarchicalFacets().forEach(function(refinedFacet) {
        var hierarchicalFacet = state.getHierarchicalFacetByName(refinedFacet);
        var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var currentRefinement = state.getHierarchicalRefinement(refinedFacet);
        // if we are already at a root refinement (or no refinement at all), there is no
        // root level values request
        if (currentRefinement.length === 0 || currentRefinement[0].split(separator).length < 2) return;
        results.slice(nextDisjunctiveResult).forEach(function(result) {
            var facets = result && result.facets ? result.facets : {};
            Object.keys(facets).forEach(function(dfacet) {
                var facetResults = facets[dfacet];
                var position = $Do2a2(state.hierarchicalFacets, function(f) {
                    return f.name === hierarchicalFacet.name;
                });
                var attributeIndex = $Do2a2(self.hierarchicalFacets[position], function(f) {
                    return f.attribute === dfacet;
                });
                // previous refinements and no results so not able to find it
                if (attributeIndex === -1) return;
                // when we always get root levels, if the hits refinement is `beers > IPA` (count: 5),
                // then the disjunctive values will be `beers` (count: 100),
                // but we do not want to display
                //   | beers (100)
                //     > IPA (5)
                // We want
                //   | beers (5)
                //     > IPA (5)
                // @MAJOR: remove this legacy behaviour in next major version
                var defaultData = {};
                if (currentRefinement.length > 0 && !self.persistHierarchicalRootCount) {
                    var root = currentRefinement[0].split(separator)[0];
                    defaultData[root] = self.hierarchicalFacets[position][attributeIndex].data[root];
                }
                self.hierarchicalFacets[position][attributeIndex].data = $jGPgk(defaultData, facetResults, self.hierarchicalFacets[position][attributeIndex].data);
            });
            nextDisjunctiveResult++;
        });
    });
    // add the excludes
    Object.keys(state.facetsExcludes).forEach(function(facetName) {
        var excludes = state.facetsExcludes[facetName];
        var position = facetsIndices[facetName];
        self.facets[position] = {
            name: facetName,
            data: mainFacets[facetName],
            exhaustive: mainSubResponse.exhaustiveFacetsCount
        };
        excludes.forEach(function(facetValue) {
            self.facets[position] = self.facets[position] || {
                name: facetName
            };
            self.facets[position].data = self.facets[position].data || {};
            self.facets[position].data[facetValue] = 0;
        });
    });
    /**
   * @type {Array}
   */ this.hierarchicalFacets = this.hierarchicalFacets.map($9U5lC(state));
    /**
   * @type {Array}
   */ this.facets = $jtI0v(this.facets);
    /**
   * @type {Array}
   */ this.disjunctiveFacets = $jtI0v(this.disjunctiveFacets);
    this._state = state;
}
/**
 * Get a facet object with its name
 * @deprecated
 * @param {string} name name of the faceted attribute
 * @return {SearchResults.Facet} the facet object
 */ $8ab3966607d77b84$var$SearchResults.prototype.getFacetByName = function(name) {
    function predicate(facet) {
        return facet.name === name;
    }
    return $hmac5(this.facets, predicate) || $hmac5(this.disjunctiveFacets, predicate) || $hmac5(this.hierarchicalFacets, predicate);
};
/**
 * Get the facet values of a specified attribute from a SearchResults object.
 * @private
 * @param {SearchResults} results the search results to search in
 * @param {string} attribute name of the faceted attribute to search for
 * @return {array|object} facet values. For the hierarchical facets it is an object.
 */ function $8ab3966607d77b84$var$extractNormalizedFacetValues(results, attribute) {
    function predicate(facet) {
        return facet.name === attribute;
    }
    if (results._state.isConjunctiveFacet(attribute)) {
        var facet = $hmac5(results.facets, predicate);
        if (!facet) return [];
        return Object.keys(facet.data).map(function(name) {
            var value = $8ab3966607d77b84$var$escapeFacetValue(name);
            return {
                name: name,
                escapedValue: value,
                count: facet.data[name],
                isRefined: results._state.isFacetRefined(attribute, value),
                isExcluded: results._state.isExcludeRefined(attribute, name)
            };
        });
    } else if (results._state.isDisjunctiveFacet(attribute)) {
        var disjunctiveFacet = $hmac5(results.disjunctiveFacets, predicate);
        if (!disjunctiveFacet) return [];
        return Object.keys(disjunctiveFacet.data).map(function(name) {
            var value = $8ab3966607d77b84$var$escapeFacetValue(name);
            return {
                name: name,
                escapedValue: value,
                count: disjunctiveFacet.data[name],
                isRefined: results._state.isDisjunctiveFacetRefined(attribute, value)
            };
        });
    } else if (results._state.isHierarchicalFacet(attribute)) {
        var hierarchicalFacetValues = $hmac5(results.hierarchicalFacets, predicate);
        if (!hierarchicalFacetValues) return hierarchicalFacetValues;
        var hierarchicalFacet = results._state.getHierarchicalFacetByName(attribute);
        var separator = results._state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var currentRefinement = $8ab3966607d77b84$var$unescapeFacetValue(results._state.getHierarchicalRefinement(attribute)[0] || "");
        if (currentRefinement.indexOf(hierarchicalFacet.rootPath) === 0) currentRefinement = currentRefinement.replace(hierarchicalFacet.rootPath + separator, "");
        var currentRefinementSplit = currentRefinement.split(separator);
        currentRefinementSplit.unshift(attribute);
        $8ab3966607d77b84$var$setIsRefined(hierarchicalFacetValues, currentRefinementSplit, 0);
        return hierarchicalFacetValues;
    }
    return undefined;
}
/**
 * Set the isRefined of a hierarchical facet result based on the current state.
 * @param {SearchResults.HierarchicalFacet} item Hierarchical facet to fix
 * @param {string[]} currentRefinement array of parts of the current hierarchical refinement
 * @param {number} depth recursion depth in the currentRefinement
 * @return {undefined} function mutates the item
 */ function $8ab3966607d77b84$var$setIsRefined(item, currentRefinement, depth) {
    item.isRefined = item.name === (currentRefinement[depth] && currentRefinement[depth].trim());
    if (item.data) item.data.forEach(function(child) {
        $8ab3966607d77b84$var$setIsRefined(child, currentRefinement, depth + 1);
    });
}
/**
 * Sort nodes of a hierarchical or disjunctive facet results
 * @private
 * @param {function} sortFn sort function to apply
 * @param {HierarchicalFacet|Array} node node upon which we want to apply the sort
 * @param {string[]} names attribute names
 * @param {number} [level=0] current index in the names array
 * @return {HierarchicalFacet|Array} sorted node
 */ function $8ab3966607d77b84$var$recSort(sortFn, node, names, level) {
    level = level || 0;
    if (Array.isArray(node)) return sortFn(node, names[level]);
    if (!node.data || node.data.length === 0) return node;
    var children = node.data.map(function(childNode) {
        return $8ab3966607d77b84$var$recSort(sortFn, childNode, names, level + 1);
    });
    var sortedChildren = sortFn(children, names[level]);
    var newNode = $jGPgk({
        data: sortedChildren
    }, node);
    return newNode;
}
$8ab3966607d77b84$var$SearchResults.DEFAULT_SORT = [
    "isRefined:desc",
    "count:desc",
    "name:asc"
];
function $8ab3966607d77b84$var$vanillaSortFn(order, data) {
    return data.sort(order);
}
/**
 * @typedef FacetOrdering
 * @type {Object}
 * @property {string[]} [order]
 * @property {'count' | 'alpha' | 'hidden'} [sortRemainingBy]
 */ /**
 * Sorts facet arrays via their facet ordering
 * @param {Array} facetValues the values
 * @param {FacetOrdering} facetOrdering the ordering
 * @returns {Array} the sorted facet values
 */ function $8ab3966607d77b84$var$sortViaFacetOrdering(facetValues, facetOrdering) {
    var orderedFacets = [];
    var remainingFacets = [];
    var hide = facetOrdering.hide || [];
    var order = facetOrdering.order || [];
    /**
   * an object with the keys being the values in order, the values their index:
   * ['one', 'two'] -> { one: 0, two: 1 }
   */ var reverseOrder = order.reduce(function(acc, name, i) {
        acc[name] = i;
        return acc;
    }, {});
    facetValues.forEach(function(item) {
        // hierarchical facets get sorted using their raw name
        var name = item.path || item.name;
        var hidden = hide.indexOf(name) > -1;
        if (!hidden && reverseOrder[name] !== undefined) orderedFacets[reverseOrder[name]] = item;
        else if (!hidden) remainingFacets.push(item);
    });
    orderedFacets = orderedFacets.filter(function(facet) {
        return facet;
    });
    var sortRemainingBy = facetOrdering.sortRemainingBy;
    var ordering;
    if (sortRemainingBy === "hidden") return orderedFacets;
    else if (sortRemainingBy === "alpha") ordering = [
        [
            "path",
            "name"
        ],
        [
            "asc",
            "asc"
        ]
    ];
    else ordering = [
        [
            "count"
        ],
        [
            "desc"
        ]
    ];
    return orderedFacets.concat($2hata(remainingFacets, ordering[0], ordering[1]));
}
/**
 * @param {SearchResults} results the search results class
 * @param {string} attribute the attribute to retrieve ordering of
 * @returns {FacetOrdering | undefined} the facet ordering
 */ function $8ab3966607d77b84$var$getFacetOrdering(results, attribute) {
    return results.renderingContent && results.renderingContent.facetOrdering && results.renderingContent.facetOrdering.values && results.renderingContent.facetOrdering.values[attribute];
}
/**
 * Get a the list of values for a given facet attribute. Those values are sorted
 * refinement first, descending count (bigger value on top), and name ascending
 * (alphabetical order). The sort formula can overridden using either string based
 * predicates or a function.
 *
 * This method will return all the values returned by the Algolia engine plus all
 * the values already refined. This means that it can happen that the
 * `maxValuesPerFacet` [configuration](https://www.algolia.com/doc/rest-api/search#param-maxValuesPerFacet)
 * might not be respected if you have facet values that are already refined.
 * @param {string} attribute attribute name
 * @param {object} opts configuration options.
 * @param {boolean} [opts.facetOrdering]
 * Force the use of facetOrdering from the result if a sortBy is present. If
 * sortBy isn't present, facetOrdering will be used automatically.
 * @param {Array.<string> | function} opts.sortBy
 * When using strings, it consists of
 * the name of the [FacetValue](#SearchResults.FacetValue) or the
 * [HierarchicalFacet](#SearchResults.HierarchicalFacet) attributes with the
 * order (`asc` or `desc`). For example to order the value by count, the
 * argument would be `['count:asc']`.
 *
 * If only the attribute name is specified, the ordering defaults to the one
 * specified in the default value for this attribute.
 *
 * When not specified, the order is
 * ascending.  This parameter can also be a function which takes two facet
 * values and should return a number, 0 if equal, 1 if the first argument is
 * bigger or -1 otherwise.
 *
 * The default value for this attribute `['isRefined:desc', 'count:desc', 'name:asc']`
 * @return {FacetValue[]|HierarchicalFacet|undefined} depending on the type of facet of
 * the attribute requested (hierarchical, disjunctive or conjunctive)
 * @example
 * helper.on('result', function(event){
 *   //get values ordered only by name ascending using the string predicate
 *   event.results.getFacetValues('city', {sortBy: ['name:asc']});
 *   //get values  ordered only by count ascending using a function
 *   event.results.getFacetValues('city', {
 *     // this is equivalent to ['count:asc']
 *     sortBy: function(a, b) {
 *       if (a.count === b.count) return 0;
 *       if (a.count > b.count)   return 1;
 *       if (b.count > a.count)   return -1;
 *     }
 *   });
 * });
 */ $8ab3966607d77b84$var$SearchResults.prototype.getFacetValues = function(attribute, opts) {
    var facetValues = $8ab3966607d77b84$var$extractNormalizedFacetValues(this, attribute);
    if (!facetValues) return undefined;
    var options = $jGPgk({}, opts, {
        sortBy: $8ab3966607d77b84$var$SearchResults.DEFAULT_SORT,
        // if no sortBy is given, attempt to sort based on facetOrdering
        // if it is given, we still allow to sort via facet ordering first
        facetOrdering: !(opts && opts.sortBy)
    });
    // eslint-disable-next-line consistent-this
    var results = this;
    var attributes;
    if (Array.isArray(facetValues)) attributes = [
        attribute
    ];
    else {
        var config = results._state.getHierarchicalFacetByName(facetValues.name);
        attributes = config.attributes;
    }
    return $8ab3966607d77b84$var$recSort(function(data, facetName) {
        if (options.facetOrdering) {
            var facetOrdering = $8ab3966607d77b84$var$getFacetOrdering(results, facetName);
            if (facetOrdering) return $8ab3966607d77b84$var$sortViaFacetOrdering(data, facetOrdering);
        }
        if (Array.isArray(options.sortBy)) {
            var order = $16bmX(options.sortBy, $8ab3966607d77b84$var$SearchResults.DEFAULT_SORT);
            return $2hata(data, order[0], order[1]);
        } else if (typeof options.sortBy === "function") return $8ab3966607d77b84$var$vanillaSortFn(options.sortBy, data);
        throw new Error("options.sortBy is optional but if defined it must be either an array of string (predicates) or a sorting function");
    }, facetValues, attributes);
};
/**
 * Returns the facet stats if attribute is defined and the facet contains some.
 * Otherwise returns undefined.
 * @param {string} attribute name of the faceted attribute
 * @return {object} The stats of the facet
 */ $8ab3966607d77b84$var$SearchResults.prototype.getFacetStats = function(attribute) {
    if (this._state.isConjunctiveFacet(attribute)) return $8ab3966607d77b84$var$getFacetStatsIfAvailable(this.facets, attribute);
    else if (this._state.isDisjunctiveFacet(attribute)) return $8ab3966607d77b84$var$getFacetStatsIfAvailable(this.disjunctiveFacets, attribute);
    return undefined;
};
/**
 * @typedef {Object} FacetListItem
 * @property {string} name
 */ /**
 * @param {FacetListItem[]} facetList (has more items, but enough for here)
 * @param {string} facetName The attribute to look for
 * @return {object|undefined} The stats of the facet
 */ function $8ab3966607d77b84$var$getFacetStatsIfAvailable(facetList, facetName) {
    var data = $hmac5(facetList, function(facet) {
        return facet.name === facetName;
    });
    return data && data.stats;
}
/**
 * Returns all refinements for all filters + tags. It also provides
 * additional information: count and exhaustiveness for each filter.
 *
 * See the [refinement type](#Refinement) for an exhaustive view of the available
 * data.
 *
 * Note that for a numeric refinement, results are grouped per operator, this
 * means that it will return responses for operators which are empty.
 *
 * @return {Array.<Refinement>} all the refinements
 */ $8ab3966607d77b84$var$SearchResults.prototype.getRefinements = function() {
    var state = this._state;
    // eslint-disable-next-line consistent-this
    var results = this;
    var res = [];
    Object.keys(state.facetsRefinements).forEach(function(attributeName) {
        state.facetsRefinements[attributeName].forEach(function(name) {
            res.push($8ab3966607d77b84$var$getRefinement(state, "facet", attributeName, name, results.facets));
        });
    });
    Object.keys(state.facetsExcludes).forEach(function(attributeName) {
        state.facetsExcludes[attributeName].forEach(function(name) {
            res.push($8ab3966607d77b84$var$getRefinement(state, "exclude", attributeName, name, results.facets));
        });
    });
    Object.keys(state.disjunctiveFacetsRefinements).forEach(function(attributeName) {
        state.disjunctiveFacetsRefinements[attributeName].forEach(function(name) {
            res.push($8ab3966607d77b84$var$getRefinement(state, "disjunctive", attributeName, name, results.disjunctiveFacets));
        });
    });
    Object.keys(state.hierarchicalFacetsRefinements).forEach(function(attributeName) {
        state.hierarchicalFacetsRefinements[attributeName].forEach(function(name) {
            res.push($8ab3966607d77b84$var$getHierarchicalRefinement(state, attributeName, name, results.hierarchicalFacets));
        });
    });
    Object.keys(state.numericRefinements).forEach(function(attributeName) {
        var operators = state.numericRefinements[attributeName];
        Object.keys(operators).forEach(function(operator) {
            operators[operator].forEach(function(value) {
                res.push({
                    type: "numeric",
                    attributeName: attributeName,
                    name: value,
                    numericValue: value,
                    operator: operator
                });
            });
        });
    });
    state.tagRefinements.forEach(function(name) {
        res.push({
            type: "tag",
            attributeName: "_tags",
            name: name
        });
    });
    return res;
};
/**
 * @typedef {Object} Facet
 * @property {string} name
 * @property {Object} data
 * @property {boolean} exhaustive
 */ /**
 * @param {SearchParameters} state the current state
 * @param {string} type the type of the refinement
 * @param {string} attributeName The attribute of the facet
 * @param {*} name The name of the facet
 * @param {Facet[]} resultsFacets facets from the results
 * @return {Refinement} the refinement
 */ function $8ab3966607d77b84$var$getRefinement(state, type, attributeName, name, resultsFacets) {
    var facet = $hmac5(resultsFacets, function(f) {
        return f.name === attributeName;
    });
    var count = facet && facet.data && facet.data[name] ? facet.data[name] : 0;
    var exhaustive = facet && facet.exhaustive || false;
    return {
        type: type,
        attributeName: attributeName,
        name: name,
        count: count,
        exhaustive: exhaustive
    };
}
/**
 * @param {SearchParameters} state the current state
 * @param {string} attributeName the attribute of the hierarchical facet
 * @param {string} name the name of the facet
 * @param {Facet[]} resultsFacets facets from the results
 * @return {HierarchicalFacet} the hierarchical facet
 */ function $8ab3966607d77b84$var$getHierarchicalRefinement(state, attributeName, name, resultsFacets) {
    var facetDeclaration = state.getHierarchicalFacetByName(attributeName);
    var separator = state._getHierarchicalFacetSeparator(facetDeclaration);
    var split = name.split(separator);
    var rootFacet = $hmac5(resultsFacets, function(facet) {
        return facet.name === attributeName;
    });
    var facet = split.reduce(function(intermediateFacet, part) {
        var newFacet = intermediateFacet && $hmac5(intermediateFacet.data, function(f) {
            return f.name === part;
        });
        return newFacet !== undefined ? newFacet : intermediateFacet;
    }, rootFacet);
    var count = facet && facet.count || 0;
    var exhaustive = facet && facet.exhaustive || false;
    var path = facet && facet.path || "";
    return {
        type: "hierarchical",
        attributeName: attributeName,
        name: path,
        count: count,
        exhaustive: exhaustive
    };
}
module.exports = $8ab3966607d77b84$var$SearchResults;

});
parcelRegister("jtI0v", function(module, exports) {
"use strict";
module.exports = function compact(array) {
    if (!Array.isArray(array)) return [];
    return array.filter(Boolean);
};

});

parcelRegister("Do2a2", function(module, exports) {
"use strict";
// @MAJOR can be replaced by native Array#findIndex when we change support
module.exports = function find(array, comparator) {
    if (!Array.isArray(array)) return -1;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return i;
    }
    return -1;
};

});

parcelRegister("16bmX", function(module, exports) {
"use strict";

var $hmac5 = parcelRequire("hmac5");
/**
 * Transform sort format from user friendly notation to lodash format
 * @param {string[]} sortBy array of predicate of the form "attribute:order"
 * @param {string[]} [defaults] array of predicate of the form "attribute:order"
 * @return {array.<string[]>} array containing 2 elements : attributes, orders
 */ module.exports = function formatSort(sortBy, defaults) {
    var defaultInstructions = (defaults || []).map(function(sort) {
        return sort.split(":");
    });
    return sortBy.reduce(function preparePredicate(out, sort) {
        var sortInstruction = sort.split(":");
        var matchingDefault = $hmac5(defaultInstructions, function(defaultInstruction) {
            return defaultInstruction[0] === sortInstruction[0];
        });
        if (sortInstruction.length > 1 || !matchingDefault) {
            out[0].push(sortInstruction[0]);
            out[1].push(sortInstruction[1]);
            return out;
        }
        out[0].push(matchingDefault[0]);
        out[1].push(matchingDefault[1]);
        return out;
    }, [
        [],
        []
    ]);
};

});

parcelRegister("2hata", function(module, exports) {
"use strict";
function $1a854a4d6e961755$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined;
        var valIsNull = value === null;
        var othIsDefined = other !== undefined;
        var othIsNull = other === null;
        if (!othIsNull && value > other || valIsNull && othIsDefined || !valIsDefined) return 1;
        if (!valIsNull && value < other || othIsNull && valIsDefined || !othIsDefined) return -1;
    }
    return 0;
}
/**
 * @param {Array<object>} collection object with keys in attributes
 * @param {Array<string>} iteratees attributes
 * @param {Array<string>} orders asc | desc
 * @return {Array<object>} sorted collection
 */ function $1a854a4d6e961755$var$orderBy(collection, iteratees, orders) {
    if (!Array.isArray(collection)) return [];
    if (!Array.isArray(orders)) orders = [];
    var result = collection.map(function(value, index) {
        return {
            criteria: iteratees.map(function(iteratee) {
                return value[iteratee];
            }),
            index: index,
            value: value
        };
    });
    result.sort(function comparer(object, other) {
        var index = -1;
        while(++index < object.criteria.length){
            var res = $1a854a4d6e961755$var$compareAscending(object.criteria[index], other.criteria[index]);
            if (res) {
                if (index >= orders.length) return res;
                if (orders[index] === "desc") return -res;
                return res;
            }
        }
        // This ensures a stable sort in V8 and other engines.
        // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
        return object.index - other.index;
    });
    return result.map(function(res) {
        return res.value;
    });
}
module.exports = $1a854a4d6e961755$var$orderBy;

});

parcelRegister("9U5lC", function(module, exports) {
"use strict";
module.exports = $735d7df0be1ead43$var$generateTrees;

var $9IuIV = parcelRequire("9IuIV");

var $hmac5 = parcelRequire("hmac5");

var $16bmX = parcelRequire("16bmX");

var $2hata = parcelRequire("2hata");
var $735d7df0be1ead43$var$escapeFacetValue = $9IuIV.escapeFacetValue;
var $735d7df0be1ead43$var$unescapeFacetValue = $9IuIV.unescapeFacetValue;
function $735d7df0be1ead43$var$generateTrees(state) {
    return function generate(hierarchicalFacetResult, hierarchicalFacetIndex) {
        var hierarchicalFacet = state.hierarchicalFacets[hierarchicalFacetIndex];
        var hierarchicalFacetRefinement = state.hierarchicalFacetsRefinements[hierarchicalFacet.name] && state.hierarchicalFacetsRefinements[hierarchicalFacet.name][0] || "";
        var hierarchicalSeparator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var hierarchicalRootPath = state._getHierarchicalRootPath(hierarchicalFacet);
        var hierarchicalShowParentLevel = state._getHierarchicalShowParentLevel(hierarchicalFacet);
        var sortBy = $16bmX(state._getHierarchicalFacetSortBy(hierarchicalFacet));
        var rootExhaustive = hierarchicalFacetResult.every(function(facetResult) {
            return facetResult.exhaustive;
        });
        var generateTreeFn = $735d7df0be1ead43$var$generateHierarchicalTree(sortBy, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel, hierarchicalFacetRefinement);
        var results = hierarchicalFacetResult;
        if (hierarchicalRootPath) results = hierarchicalFacetResult.slice(hierarchicalRootPath.split(hierarchicalSeparator).length);
        return results.reduce(generateTreeFn, {
            name: state.hierarchicalFacets[hierarchicalFacetIndex].name,
            count: null,
            isRefined: true,
            path: null,
            escapedValue: null,
            exhaustive: rootExhaustive,
            data: null
        });
    };
}
function $735d7df0be1ead43$var$generateHierarchicalTree(sortBy, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel, currentRefinement) {
    return function generateTree(hierarchicalTree, hierarchicalFacetResult, currentHierarchicalLevel) {
        var parent = hierarchicalTree;
        if (currentHierarchicalLevel > 0) {
            var level = 0;
            parent = hierarchicalTree;
            while(level < currentHierarchicalLevel){
                /**
         * @type {object[]]} hierarchical data
         */ var data = parent && Array.isArray(parent.data) ? parent.data : [];
                parent = $hmac5(data, function(subtree) {
                    return subtree.isRefined;
                });
                level++;
            }
        }
        // we found a refined parent, let's add current level data under it
        if (parent) {
            // filter values in case an object has multiple categories:
            //   {
            //     categories: {
            //       level0: ['beers', 'bières'],
            //       level1: ['beers > IPA', 'bières > Belges']
            //     }
            //   }
            //
            // If parent refinement is `beers`, then we do not want to have `bières > Belges`
            // showing up
            var picked = Object.keys(hierarchicalFacetResult.data).map(function(facetValue) {
                return [
                    facetValue,
                    hierarchicalFacetResult.data[facetValue]
                ];
            }).filter(function(tuple) {
                var facetValue = tuple[0];
                return $735d7df0be1ead43$var$onlyMatchingTree(facetValue, parent.path || hierarchicalRootPath, currentRefinement, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel);
            });
            parent.data = $2hata(picked.map(function(tuple) {
                var facetValue = tuple[0];
                var facetCount = tuple[1];
                return $735d7df0be1ead43$var$format(facetCount, facetValue, hierarchicalSeparator, $735d7df0be1ead43$var$unescapeFacetValue(currentRefinement), hierarchicalFacetResult.exhaustive);
            }), sortBy[0], sortBy[1]);
        }
        return hierarchicalTree;
    };
}
// eslint-disable-next-line max-params
function $735d7df0be1ead43$var$onlyMatchingTree(facetValue, parentPath, currentRefinement, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel) {
    // we want the facetValue is a child of hierarchicalRootPath
    if (hierarchicalRootPath && (facetValue.indexOf(hierarchicalRootPath) !== 0 || hierarchicalRootPath === facetValue)) return false;
    // we always want root levels (only when there is no prefix path)
    return !hierarchicalRootPath && facetValue.indexOf(hierarchicalSeparator) === -1 || // if there is a rootPath, being root level mean 1 level under rootPath
    hierarchicalRootPath && facetValue.split(hierarchicalSeparator).length - hierarchicalRootPath.split(hierarchicalSeparator).length === 1 || // if current refinement is a root level and current facetValue is a root level,
    // keep the facetValue
    facetValue.indexOf(hierarchicalSeparator) === -1 && currentRefinement.indexOf(hierarchicalSeparator) === -1 || // currentRefinement is a child of the facet value
    currentRefinement.indexOf(facetValue) === 0 || // facetValue is a child of the current parent, add it
    facetValue.indexOf(parentPath + hierarchicalSeparator) === 0 && (hierarchicalShowParentLevel || facetValue.indexOf(currentRefinement) === 0);
}
function $735d7df0be1ead43$var$format(facetCount, facetValue, hierarchicalSeparator, currentRefinement, exhaustive) {
    var parts = facetValue.split(hierarchicalSeparator);
    return {
        name: parts[parts.length - 1].trim(),
        path: facetValue,
        escapedValue: $735d7df0be1ead43$var$escapeFacetValue(facetValue),
        count: facetCount,
        isRefined: currentRefinement === facetValue || currentRefinement.indexOf(facetValue + hierarchicalSeparator) === 0,
        exhaustive: exhaustive,
        data: null
    };
}

});


parcelRegister("gll5V", function(module, exports) {
"use strict";

var $hmac5 = parcelRequire("hmac5");

var $b6VTg = parcelRequire("b6VTg");
function $be5ef86dfc3a1a80$var$getAverageIndices(indexTracker, nrOfObjs) {
    var avgIndices = [];
    Object.keys(indexTracker).forEach(function(key) {
        if (indexTracker[key].count < 2) indexTracker[key].indexSum += 100;
        avgIndices.push({
            objectID: key,
            avgOfIndices: indexTracker[key].indexSum / nrOfObjs
        });
    });
    return avgIndices.sort(function(a, b) {
        return a.avgOfIndices > b.avgOfIndices ? 1 : -1;
    });
}
function $be5ef86dfc3a1a80$var$sortAndMergeRecommendations(results) {
    var indexTracker = {};
    results.forEach(function(hits) {
        hits.forEach(function(hit, index) {
            if (!indexTracker[hit.objectID]) indexTracker[hit.objectID] = {
                indexSum: index,
                count: 1
            };
            else indexTracker[hit.objectID] = {
                indexSum: indexTracker[hit.objectID].indexSum + index,
                count: indexTracker[hit.objectID].count + 1
            };
        });
    });
    var sortedAverageIndices = $be5ef86dfc3a1a80$var$getAverageIndices(indexTracker, results.length);
    var finalOrder = sortedAverageIndices.reduce(function(orderedHits, avgIndexRef) {
        var result = $hmac5($b6VTg(results), function(hit) {
            return hit.objectID === avgIndexRef.objectID;
        });
        return result ? orderedHits.concat(result) : orderedHits;
    }, []);
    return finalOrder;
}
module.exports = $be5ef86dfc3a1a80$var$sortAndMergeRecommendations;

});
parcelRegister("b6VTg", function(module, exports) {
// @MAJOR: remove this function and use Array.prototype.flat
module.exports = function flat(arr) {
    return arr.reduce(function(acc, val) {
        return acc.concat(val);
    }, []);
};

});


parcelRegister("4kbyH", function(module, exports) {
"use strict";
module.exports = "3.22.5";

});



parcelRegister("5gdGA", function(module, exports) {

$parcel$export(module.exports, "createInsightsMiddleware", () => $3d49101849564d6d$export$91e0bf09562e2c44);

var $aLrwr = parcelRequire("aLrwr");

var $dZQeP = parcelRequire("dZQeP");
var $42mgF = parcelRequire("42mgF");
var $iNPz2 = parcelRequire("iNPz2");
var $93kMs = parcelRequire("93kMs");
function $3d49101849564d6d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $3d49101849564d6d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $3d49101849564d6d$var$_typeof(obj);
}
function $3d49101849564d6d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3d49101849564d6d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $3d49101849564d6d$var$ownKeys(Object(source), !0).forEach(function(key) {
            $3d49101849564d6d$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $3d49101849564d6d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3d49101849564d6d$var$_defineProperty(obj, key, value) {
    key = $3d49101849564d6d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3d49101849564d6d$var$_toPropertyKey(arg) {
    var key = $3d49101849564d6d$var$_toPrimitive(arg, "string");
    return $3d49101849564d6d$var$_typeof(key) === "symbol" ? key : String(key);
}
function $3d49101849564d6d$var$_toPrimitive(input, hint) {
    if ($3d49101849564d6d$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($3d49101849564d6d$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $3d49101849564d6d$var$_slicedToArray(arr, i) {
    return $3d49101849564d6d$var$_arrayWithHoles(arr) || $3d49101849564d6d$var$_iterableToArrayLimit(arr, i) || $3d49101849564d6d$var$_unsupportedIterableToArray(arr, i) || $3d49101849564d6d$var$_nonIterableRest();
}
function $3d49101849564d6d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3d49101849564d6d$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $3d49101849564d6d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $3d49101849564d6d$var$_toConsumableArray(arr) {
    return $3d49101849564d6d$var$_arrayWithoutHoles(arr) || $3d49101849564d6d$var$_iterableToArray(arr) || $3d49101849564d6d$var$_unsupportedIterableToArray(arr) || $3d49101849564d6d$var$_nonIterableSpread();
}
function $3d49101849564d6d$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3d49101849564d6d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3d49101849564d6d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3d49101849564d6d$var$_arrayLikeToArray(o, minLen);
}
function $3d49101849564d6d$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $3d49101849564d6d$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $3d49101849564d6d$var$_arrayLikeToArray(arr);
}
function $3d49101849564d6d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $3d49101849564d6d$var$ALGOLIA_INSIGHTS_VERSION = "2.15.0";
var $3d49101849564d6d$var$ALGOLIA_INSIGHTS_SRC = "https://cdn.jsdelivr.net/npm/search-insights@".concat($3d49101849564d6d$var$ALGOLIA_INSIGHTS_VERSION, "/dist/search-insights.min.js");
function $3d49101849564d6d$export$91e0bf09562e2c44() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _insightsClient = props.insightsClient, insightsInitParams = props.insightsInitParams, onEvent = props.onEvent, _props$$$internal = props.$$internal, $$internal = _props$$$internal === void 0 ? false : _props$$$internal, _props$$$automatic = props.$$automatic, $$automatic = _props$$$automatic === void 0 ? false : _props$$$automatic;
    var potentialInsightsClient = _insightsClient;
    if (!_insightsClient && _insightsClient !== null) (0, $93kMs.safelyRunOnBrowser)(function(_ref) {
        var window = _ref.window;
        var pointer = window.AlgoliaAnalyticsObject || "aa";
        if (typeof pointer === "string") potentialInsightsClient = window[pointer];
        if (!potentialInsightsClient) {
            window.AlgoliaAnalyticsObject = pointer;
            if (!window[pointer]) {
                window[pointer] = function() {
                    if (!window[pointer].queue) window[pointer].queue = [];
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    window[pointer].queue.push(args);
                };
                window[pointer].version = $3d49101849564d6d$var$ALGOLIA_INSIGHTS_VERSION;
                window[pointer].shouldAddScript = true;
            }
            potentialInsightsClient = window[pointer];
        }
    });
    // if still no insightsClient was found, we use a noop
    var insightsClient = potentialInsightsClient || (0, $iNPz2.noop);
    return function(_ref2) {
        var instantSearchInstance = _ref2.instantSearchInstance;
        // remove existing default insights middleware
        // user-provided insights middleware takes precedence
        var existingInsightsMiddlewares = instantSearchInstance.middleware.filter(function(m) {
            return m.instance.$$type === "ais.insights" && m.instance.$$internal;
        }).map(function(m) {
            return m.creator;
        });
        instantSearchInstance.unuse.apply(instantSearchInstance, $3d49101849564d6d$var$_toConsumableArray(existingInsightsMiddlewares));
        var _getAppIdAndApiKey = (0, $42mgF.getAppIdAndApiKey)(instantSearchInstance.client), _getAppIdAndApiKey2 = $3d49101849564d6d$var$_slicedToArray(_getAppIdAndApiKey, 2), appId = _getAppIdAndApiKey2[0], apiKey = _getAppIdAndApiKey2[1];
        var queuedUserToken = undefined;
        var queuedAuthenticatedUserToken = undefined;
        var userTokenBeforeInit = undefined;
        var authenticatedUserTokenBeforeInit = undefined;
        var queue = insightsClient.queue;
        if (Array.isArray(queue)) {
            // Context: The umd build of search-insights is asynchronously loaded by the snippet.
            //
            // When user calls `aa('setUserToken', 'my-user-token')` before `search-insights` is loaded,
            // ['setUserToken', 'my-user-token'] gets stored in `aa.queue`.
            // Whenever `search-insights` is finally loaded, it will process the queue.
            //
            // But here's the reason why we handle it here:
            // At this point, even though `search-insights` is not loaded yet,
            // we still want to read the token from the queue.
            // Otherwise, the first search call will be fired without the token.
            var _map = [
                "setUserToken",
                "setAuthenticatedUserToken"
            ].map(function(key) {
                var _ref3 = (0, $dZQeP.find)(queue.slice().reverse(), function(_ref5) {
                    var _ref6 = $3d49101849564d6d$var$_slicedToArray(_ref5, 1), method = _ref6[0];
                    return method === key;
                }) || [], _ref4 = $3d49101849564d6d$var$_slicedToArray(_ref3, 2), value = _ref4[1];
                return value;
            });
            var _map2 = $3d49101849564d6d$var$_slicedToArray(_map, 2);
            queuedUserToken = _map2[0];
            queuedAuthenticatedUserToken = _map2[1];
        }
        // If user called `aa('setUserToken')` or `aa('setAuthenticatedUserToken')`
        // before creating the Insights middleware, we temporarily store the token
        // and set it later on.
        //
        // Otherwise, the `init` call might override them with anonymous user token.
        insightsClient("getUserToken", null, function(_error, userToken) {
            userTokenBeforeInit = $3d49101849564d6d$var$normalizeUserToken(userToken);
        });
        insightsClient("getAuthenticatedUserToken", null, function(_error, userToken) {
            authenticatedUserTokenBeforeInit = $3d49101849564d6d$var$normalizeUserToken(userToken);
        });
        // Only `init` if the `insightsInitParams` option is passed or
        // if the `insightsClient` version doesn't supports optional `init` calling.
        if (insightsInitParams || !$3d49101849564d6d$var$isModernInsightsClient(insightsClient)) insightsClient("init", $3d49101849564d6d$var$_objectSpread({
            appId: appId,
            apiKey: apiKey,
            partial: true
        }, insightsInitParams));
        var initialParameters;
        var helper;
        return {
            $$type: "ais.insights",
            $$internal: $$internal,
            $$automatic: $$automatic,
            onStateChange: function onStateChange() {},
            subscribe: function subscribe() {
                if (!insightsClient.shouldAddScript) return;
                var errorMessage = "[insights middleware]: could not load search-insights.js. Please load it manually following https://alg.li/insights-init";
                try {
                    var script = document.createElement("script");
                    script.async = true;
                    script.src = $3d49101849564d6d$var$ALGOLIA_INSIGHTS_SRC;
                    script.onerror = function() {
                        instantSearchInstance.emit("error", new Error(errorMessage));
                    };
                    document.body.appendChild(script);
                    insightsClient.shouldAddScript = false;
                } catch (cause) {
                    insightsClient.shouldAddScript = false;
                    instantSearchInstance.emit("error", new Error(errorMessage));
                }
            },
            started: function started() {
                insightsClient("addAlgoliaAgent", "insights-middleware");
                helper = instantSearchInstance.mainHelper;
                initialParameters = {
                    userToken: helper.state.userToken,
                    clickAnalytics: helper.state.clickAnalytics
                };
                // We don't want to force clickAnalytics when the insights is enabled from the search response.
                // This means we don't enable insights for indices that don't opt in
                if (!$$automatic) helper.overrideStateWithoutTriggeringChangeEvent($3d49101849564d6d$var$_objectSpread($3d49101849564d6d$var$_objectSpread({}, helper.state), {}, {
                    clickAnalytics: true
                }));
                if (!$$internal) instantSearchInstance.scheduleSearch();
                var setUserTokenToSearch = function setUserTokenToSearch(userToken) {
                    var immediate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                    var normalizedUserToken = $3d49101849564d6d$var$normalizeUserToken(userToken);
                    if (!normalizedUserToken) return;
                    var existingToken = helper.state.userToken;
                    function applyToken() {
                        helper.overrideStateWithoutTriggeringChangeEvent($3d49101849564d6d$var$_objectSpread($3d49101849564d6d$var$_objectSpread({}, helper.state), {}, {
                            userToken: normalizedUserToken
                        }));
                        if (existingToken && existingToken !== userToken) instantSearchInstance.scheduleSearch();
                    }
                    // Delay the token application to the next render cycle
                    if (!immediate) setTimeout(applyToken, 0);
                    else applyToken();
                };
                var anonymousUserToken = (0, $aLrwr.getInsightsAnonymousUserTokenInternal)();
                if (anonymousUserToken) // When `aa('init', { ... })` is called, it creates an anonymous user token in cookie.
                // We can set it as userToken.
                setUserTokenToSearch(anonymousUserToken, true);
                function setUserToken(token, userToken, authenticatedUserToken) {
                    setUserTokenToSearch(token, true);
                    if (userToken) insightsClient("setUserToken", userToken);
                    if (authenticatedUserToken) insightsClient("setAuthenticatedUserToken", authenticatedUserToken);
                }
                // We consider the `userToken` or `authenticatedUserToken` before an
                // `init` call of higher importance than one from the queue.
                var tokenBeforeInit = authenticatedUserTokenBeforeInit || userTokenBeforeInit;
                var queuedToken = queuedAuthenticatedUserToken || queuedUserToken;
                if (tokenBeforeInit) setUserToken(tokenBeforeInit, userTokenBeforeInit, authenticatedUserTokenBeforeInit);
                else if (queuedToken) setUserToken(queuedToken, queuedUserToken, queuedAuthenticatedUserToken);
                // This updates userToken which is set explicitly by `aa('setUserToken', userToken)`
                insightsClient("onUserTokenChange", setUserTokenToSearch, {
                    immediate: true
                });
                // This updates userToken which is set explicitly by `aa('setAuthenticatedtUserToken', authenticatedUserToken)`
                insightsClient("onAuthenticatedUserTokenChange", function(authenticatedUserToken) {
                    // If we're unsetting the `authenticatedUserToken`, we revert to the `userToken`
                    if (!authenticatedUserToken) insightsClient("getUserToken", null, function(_, userToken) {
                        setUserTokenToSearch(userToken);
                    });
                    setUserTokenToSearch(authenticatedUserToken);
                }, {
                    immediate: true
                });
                var insightsClientWithLocalCredentials = insightsClient;
                if ($3d49101849564d6d$var$isModernInsightsClient(insightsClient)) insightsClientWithLocalCredentials = function insightsClientWithLocalCredentials(method, payload) {
                    var extraParams = {
                        headers: {
                            "X-Algolia-Application-Id": appId,
                            "X-Algolia-API-Key": apiKey
                        }
                    };
                    // @ts-ignore we are calling this only when we know that the client actually is correct
                    return insightsClient(method, payload, extraParams);
                };
                instantSearchInstance.sendEventToInsights = function(event) {
                    if (onEvent) onEvent(event, insightsClientWithLocalCredentials);
                    else if (event.insightsMethod) {
                        // Source is used to differentiate events sent by instantsearch from those sent manually.
                        event.payload.algoliaSource = [
                            "instantsearch"
                        ];
                        if ($$automatic) event.payload.algoliaSource.push("instantsearch-automatic");
                        if (event.eventModifier === "internal") event.payload.algoliaSource.push("instantsearch-internal");
                        insightsClientWithLocalCredentials(event.insightsMethod, event.payload);
                    }
                };
            },
            unsubscribe: function unsubscribe() {
                insightsClient("onUserTokenChange", undefined);
                insightsClient("onAuthenticatedUserTokenChange", undefined);
                instantSearchInstance.sendEventToInsights = (0, $iNPz2.noop);
                if (helper && initialParameters) {
                    helper.overrideStateWithoutTriggeringChangeEvent($3d49101849564d6d$var$_objectSpread($3d49101849564d6d$var$_objectSpread({}, helper.state), initialParameters));
                    instantSearchInstance.scheduleSearch();
                }
            }
        };
    };
}
/**
 * Determines if a given insights `client` supports the optional call to `init`
 * and the ability to set credentials via extra parameters when sending events.
 */ function $3d49101849564d6d$var$isModernInsightsClient(client) {
    var _split$map = (client.version || "").split(".").map(Number), _split$map2 = $3d49101849564d6d$var$_slicedToArray(_split$map, 2), major = _split$map2[0], minor = _split$map2[1];
    /* eslint-disable @typescript-eslint/naming-convention */ var v3 = major >= 3;
    var v2_6 = major === 2 && minor >= 6;
    var v1_10 = major === 1 && minor >= 10;
    /* eslint-enable @typescript-eslint/naming-convention */ return v3 || v2_6 || v1_10;
}
/**
 * While `search-insights` supports both string and number user tokens,
 * the Search API only accepts strings. This function normalizes the user token.
 */ function $3d49101849564d6d$var$normalizeUserToken(userToken) {
    if (!userToken) return undefined;
    return typeof userToken === "number" ? userToken.toString() : userToken;
}

});
parcelRegister("dZQeP", function(module, exports) {

$parcel$export(module.exports, "find", () => $a3097e451722c435$export$71aa6c912b956294);
// We aren't using the native `Array.prototype.find` because the refactor away from Lodash is not
// published as a major version.
// Relying on the `find` polyfill on user-land, which before was only required for niche use-cases,
// was decided as too risky.
// @MAJOR Replace with the native `Array.prototype.find` method
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
function $a3097e451722c435$export$71aa6c912b956294(items, predicate) {
    var value;
    for(var i = 0; i < items.length; i++){
        value = items[i];
        // inlined for performance: if (Call(predicate, thisArg, [value, i, list])) {
        if (predicate(value, i, items)) return value;
    }
    return undefined;
}

});

parcelRegister("42mgF", function(module, exports) {

$parcel$export(module.exports, "getAppIdAndApiKey", () => $2f089f4420a57003$export$58f35ab8a1251bc0);
// typed as any, since it accepts the _real_ js clients, not the interface we otherwise expect
function $2f089f4420a57003$export$58f35ab8a1251bc0(searchClient) {
    if (searchClient.transporter) {
        // searchClient v4 or v5
        var transporter = searchClient.transporter;
        var headers = transporter.headers || transporter.baseHeaders;
        var queryParameters = transporter.queryParameters || transporter.baseQueryParameters;
        var APP_ID = "x-algolia-application-id";
        var API_KEY = "x-algolia-api-key";
        var appId = headers[APP_ID] || queryParameters[APP_ID];
        var apiKey = headers[API_KEY] || queryParameters[API_KEY];
        return [
            appId,
            apiKey
        ];
    } else // searchClient v3
    return [
        searchClient.applicationID,
        searchClient.apiKey
    ];
}

});

parcelRegister("iNPz2", function(module, exports) {

$parcel$export(module.exports, "noop", () => $db04cd27b0c7d378$export$8793edee2d425525);
function $db04cd27b0c7d378$export$8793edee2d425525() {}

});


parcelRegister("hcwya", function(module, exports) {

$parcel$export(module.exports, "isMetadataEnabled", () => $c85cce681d003c95$export$4b4254890acf93e7);
$parcel$export(module.exports, "createMetadataMiddleware", () => $c85cce681d003c95$export$8ee9d2447935ed96);

var $keGxy = parcelRequire("keGxy");
var $93kMs = parcelRequire("93kMs");
function $c85cce681d003c95$var$extractWidgetPayload(widgets, instantSearchInstance, payload) {
    var initOptions = (0, $keGxy.createInitArgs)(instantSearchInstance, instantSearchInstance.mainIndex, instantSearchInstance._initialUiState);
    widgets.forEach(function(widget) {
        var widgetParams = {};
        if (widget.getWidgetRenderState) {
            var renderState = widget.getWidgetRenderState(initOptions);
            if (renderState && renderState.widgetParams) // casting, as we just earlier checked widgetParams exists, and thus an object
            widgetParams = renderState.widgetParams;
        }
        // since we destructure in all widgets, the parameters with defaults are set to "undefined"
        var params = Object.keys(widgetParams).filter(function(key) {
            return widgetParams[key] !== undefined;
        });
        payload.widgets.push({
            type: widget.$$type,
            widgetType: widget.$$widgetType,
            params: params
        });
        if (widget.$$type === "ais.index") $c85cce681d003c95$var$extractWidgetPayload(widget.getWidgets(), instantSearchInstance, payload);
    });
}
function $c85cce681d003c95$export$4b4254890acf93e7() {
    return (0, $93kMs.safelyRunOnBrowser)(function(_ref) {
        var _window$navigator, _window$navigator$use;
        var window = _ref.window;
        return ((_window$navigator = window.navigator) === null || _window$navigator === void 0 ? void 0 : (_window$navigator$use = _window$navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.indexOf("Algolia Crawler")) > -1;
    }, {
        fallback: function fallback() {
            return false;
        }
    });
}
function $c85cce681d003c95$export$8ee9d2447935ed96() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$$$internal = _ref2.$$internal, $$internal = _ref2$$$internal === void 0 ? false : _ref2$$$internal;
    return function(_ref3) {
        var instantSearchInstance = _ref3.instantSearchInstance;
        var payload = {
            widgets: []
        };
        var payloadContainer = document.createElement("meta");
        var refNode = document.querySelector("head");
        payloadContainer.name = "instantsearch:widgets";
        return {
            $$type: "ais.metadata",
            $$internal: $$internal,
            onStateChange: function onStateChange() {},
            subscribe: function subscribe() {
                // using setTimeout here to delay extraction until widgets have been added in a tick (e.g. Vue)
                setTimeout(function() {
                    var client = instantSearchInstance.client;
                    payload.ua = client.transporter && client.transporter.userAgent ? client.transporter.userAgent.value : client._ua;
                    $c85cce681d003c95$var$extractWidgetPayload(instantSearchInstance.mainIndex.getWidgets(), instantSearchInstance, payload);
                    instantSearchInstance.middleware.forEach(function(middleware) {
                        return payload.widgets.push({
                            middleware: true,
                            type: middleware.instance.$$type,
                            internal: middleware.instance.$$internal
                        });
                    });
                    payloadContainer.content = JSON.stringify(payload);
                    refNode.appendChild(payloadContainer);
                }, 0);
            },
            started: function started() {},
            unsubscribe: function unsubscribe() {
                payloadContainer.remove();
            }
        };
    };
}

});
parcelRegister("keGxy", function(module, exports) {

$parcel$export(module.exports, "createInitArgs", () => $ebb61d06e2725df1$export$dbf1227de6c1fbc6);
$parcel$export(module.exports, "createRenderArgs", () => $ebb61d06e2725df1$export$c3ba97e79c76dd38);
function $ebb61d06e2725df1$export$dbf1227de6c1fbc6(instantSearchInstance, parent, uiState) {
    var helper = parent.getHelper();
    return {
        uiState: uiState,
        helper: helper,
        parent: parent,
        instantSearchInstance: instantSearchInstance,
        state: helper.state,
        renderState: instantSearchInstance.renderState,
        templatesConfig: instantSearchInstance.templatesConfig,
        createURL: parent.createURL,
        scopedResults: [],
        searchMetadata: {
            isSearchStalled: instantSearchInstance.status === "stalled"
        },
        status: instantSearchInstance.status,
        error: instantSearchInstance.error
    };
}
function $ebb61d06e2725df1$export$c3ba97e79c76dd38(instantSearchInstance, parent, widget) {
    var results = parent.getResultsForWidget(widget);
    var helper = parent.getHelper();
    return {
        helper: helper,
        parent: parent,
        instantSearchInstance: instantSearchInstance,
        results: results,
        scopedResults: parent.getScopedResults(),
        state: results && "_state" in results ? results._state : helper.state,
        renderState: instantSearchInstance.renderState,
        templatesConfig: instantSearchInstance.templatesConfig,
        createURL: parent.createURL,
        searchMetadata: {
            isSearchStalled: instantSearchInstance.status === "stalled"
        },
        status: instantSearchInstance.status,
        error: instantSearchInstance.error
    };
}

});


parcelRegister("3rHjr", function(module, exports) {

$parcel$export(module.exports, "createRouterMiddleware", () => $28257db10a71f294$export$1fe5128387816284);

var $3WIcP = parcelRequire("3WIcP");

var $ab3TT = parcelRequire("ab3TT");

var $hHEcB = parcelRequire("hHEcB");
function $28257db10a71f294$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $28257db10a71f294$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $28257db10a71f294$var$_typeof(obj);
}
function $28257db10a71f294$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $28257db10a71f294$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $28257db10a71f294$var$ownKeys(Object(source), !0).forEach(function(key) {
            $28257db10a71f294$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $28257db10a71f294$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $28257db10a71f294$var$_defineProperty(obj, key, value) {
    key = $28257db10a71f294$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $28257db10a71f294$var$_toPropertyKey(arg) {
    var key = $28257db10a71f294$var$_toPrimitive(arg, "string");
    return $28257db10a71f294$var$_typeof(key) === "symbol" ? key : String(key);
}
function $28257db10a71f294$var$_toPrimitive(input, hint) {
    if ($28257db10a71f294$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($28257db10a71f294$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $28257db10a71f294$export$1fe5128387816284 = function createRouterMiddleware() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _props$router = props.router, router = _props$router === void 0 ? (0, $3WIcP.default)() : _props$router, _props$stateMapping = props.stateMapping, stateMapping = _props$stateMapping === void 0 ? (0, $ab3TT.default)() : _props$stateMapping, _props$$$internal = props.$$internal, $$internal = _props$$$internal === void 0 ? false : _props$$$internal;
    return function(_ref) {
        var instantSearchInstance = _ref.instantSearchInstance;
        function topLevelCreateURL(nextState) {
            var previousUiState = // If only the mainIndex is initialized, we don't yet know what other
            // index widgets are used. Therefore we fall back to the initialUiState.
            // We can't indiscriminately use the initialUiState because then we
            // reintroduce state that was changed by the user.
            // When there are no widgets, we are sure the user can't yet have made
            // any changes.
            instantSearchInstance.mainIndex.getWidgets().length === 0 ? instantSearchInstance._initialUiState : instantSearchInstance.mainIndex.getWidgetUiState({});
            var uiState = Object.keys(nextState).reduce(function(acc, indexId) {
                return $28257db10a71f294$var$_objectSpread($28257db10a71f294$var$_objectSpread({}, acc), {}, $28257db10a71f294$var$_defineProperty({}, indexId, nextState[indexId]));
            }, previousUiState);
            var route = stateMapping.stateToRoute(uiState);
            return router.createURL(route);
        }
        // casting to UiState here to keep createURL unaware of custom UiState
        // (as long as it's an object, it's ok)
        instantSearchInstance._createURL = topLevelCreateURL;
        var lastRouteState = undefined;
        var initialUiState = instantSearchInstance._initialUiState;
        return {
            $$type: "ais.router({router:".concat(router.$$type || "__unknown__", ", stateMapping:").concat(stateMapping.$$type || "__unknown__", "})"),
            $$internal: $$internal,
            onStateChange: function onStateChange(_ref2) {
                var uiState = _ref2.uiState;
                var routeState = stateMapping.stateToRoute(uiState);
                if (lastRouteState === undefined || !(0, $hHEcB.isEqual)(lastRouteState, routeState)) {
                    router.write(routeState);
                    lastRouteState = routeState;
                }
            },
            subscribe: function subscribe() {
                instantSearchInstance._initialUiState = $28257db10a71f294$var$_objectSpread($28257db10a71f294$var$_objectSpread({}, initialUiState), stateMapping.routeToState(router.read()));
                router.onUpdate(function(route) {
                    if (instantSearchInstance.mainIndex.getWidgets().length > 0) instantSearchInstance.setUiState(stateMapping.routeToState(route));
                });
            },
            started: function started() {
                var _router$start;
                (_router$start = router.start) === null || _router$start === void 0 || _router$start.call(router);
            },
            unsubscribe: function unsubscribe() {
                router.dispose();
            }
        };
    };
};

});
parcelRegister("3WIcP", function(module, exports) {

$parcel$export(module.exports, "default", () => $2df91446519e0275$export$2e2bcd8739ae039);

var $2rasJ = parcelRequire("2rasJ");

var $93kMs = parcelRequire("93kMs");
function $2df91446519e0275$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $2df91446519e0275$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $2df91446519e0275$var$_typeof(obj);
}
function $2df91446519e0275$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2df91446519e0275$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $2df91446519e0275$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $2df91446519e0275$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2df91446519e0275$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2df91446519e0275$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $2df91446519e0275$var$_defineProperty(obj, key, value) {
    key = $2df91446519e0275$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2df91446519e0275$var$_toPropertyKey(arg) {
    var key = $2df91446519e0275$var$_toPrimitive(arg, "string");
    return $2df91446519e0275$var$_typeof(key) === "symbol" ? key : String(key);
}
function $2df91446519e0275$var$_toPrimitive(input, hint) {
    if ($2df91446519e0275$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($2df91446519e0275$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $2df91446519e0275$var$setWindowTitle = function setWindowTitle(title) {
    if (title) // This function is only executed on browsers so we can disable this check.
    // eslint-disable-next-line no-restricted-globals
    window.document.title = title;
};
var $2df91446519e0275$var$BrowserHistory = /*#__PURE__*/ function() {
    /**
   * Initializes a new storage provider that syncs the search state to the URL
   * using web APIs (`window.location.pushState` and `onpopstate` event).
   */ function BrowserHistory(_ref) {
        var _this = this;
        var windowTitle = _ref.windowTitle, _ref$writeDelay = _ref.writeDelay, writeDelay = _ref$writeDelay === void 0 ? 400 : _ref$writeDelay, createURL = _ref.createURL, parseURL = _ref.parseURL, getLocation = _ref.getLocation, start = _ref.start, dispose = _ref.dispose, push = _ref.push, cleanUrlOnDispose = _ref.cleanUrlOnDispose;
        $2df91446519e0275$var$_classCallCheck(this, BrowserHistory);
        $2df91446519e0275$var$_defineProperty(this, "$$type", "ais.browser");
        /**
     * Transforms a UI state into a title for the page.
     */ $2df91446519e0275$var$_defineProperty(this, "windowTitle", void 0);
        /**
     * Time in milliseconds before performing a write in the history.
     * It prevents from adding too many entries in the history and
     * makes the back button more usable.
     *
     * @default 400
     */ $2df91446519e0275$var$_defineProperty(this, "writeDelay", void 0);
        /**
     * Creates a full URL based on the route state.
     * The storage adaptor maps all syncable keys to the query string of the URL.
     */ $2df91446519e0275$var$_defineProperty(this, "_createURL", void 0);
        /**
     * Parses the URL into a route state.
     * It should be symmetrical to `createURL`.
     */ $2df91446519e0275$var$_defineProperty(this, "parseURL", void 0);
        /**
     * Returns the location to store in the history.
     * @default () => window.location
     */ $2df91446519e0275$var$_defineProperty(this, "getLocation", void 0);
        $2df91446519e0275$var$_defineProperty(this, "writeTimer", void 0);
        $2df91446519e0275$var$_defineProperty(this, "_onPopState", void 0);
        /**
     * Indicates if last action was back/forward in the browser.
     */ $2df91446519e0275$var$_defineProperty(this, "inPopState", false);
        /**
     * Indicates whether the history router is disposed or not.
     */ $2df91446519e0275$var$_defineProperty(this, "isDisposed", false);
        /**
     * Indicates the window.history.length before the last call to
     * window.history.pushState (called in `write`).
     * It allows to determine if a `pushState` has been triggered elsewhere,
     * and thus to prevent the `write` method from calling `pushState`.
     */ $2df91446519e0275$var$_defineProperty(this, "latestAcknowledgedHistory", 0);
        $2df91446519e0275$var$_defineProperty(this, "_start", void 0);
        $2df91446519e0275$var$_defineProperty(this, "_dispose", void 0);
        $2df91446519e0275$var$_defineProperty(this, "_push", void 0);
        $2df91446519e0275$var$_defineProperty(this, "_cleanUrlOnDispose", void 0);
        this.windowTitle = windowTitle;
        this.writeTimer = undefined;
        this.writeDelay = writeDelay;
        this._createURL = createURL;
        this.parseURL = parseURL;
        this.getLocation = getLocation;
        this._start = start;
        this._dispose = dispose;
        this._push = push;
        this._cleanUrlOnDispose = typeof cleanUrlOnDispose === "undefined" ? true : cleanUrlOnDispose;
        (0, $93kMs.safelyRunOnBrowser)(function(_ref2) {
            var window1 = _ref2.window;
            var title = _this.windowTitle && _this.windowTitle(_this.read());
            $2df91446519e0275$var$setWindowTitle(title);
            _this.latestAcknowledgedHistory = window1.history.length;
        });
    }
    /**
   * Reads the URL and returns a syncable UI search state.
   */ $2df91446519e0275$var$_createClass(BrowserHistory, [
        {
            key: "read",
            value: function read() {
                return this.parseURL({
                    qsModule: (0, (/*@__PURE__*/$parcel$interopDefault($2rasJ))),
                    location: this.getLocation()
                });
            }
        },
        {
            key: "write",
            value: function write(routeState) {
                var _this2 = this;
                (0, $93kMs.safelyRunOnBrowser)(function(_ref3) {
                    var window1 = _ref3.window;
                    var url = _this2.createURL(routeState);
                    var title = _this2.windowTitle && _this2.windowTitle(routeState);
                    if (_this2.writeTimer) clearTimeout(_this2.writeTimer);
                    _this2.writeTimer = setTimeout(function() {
                        $2df91446519e0275$var$setWindowTitle(title);
                        if (_this2.shouldWrite(url)) {
                            if (_this2._push) _this2._push(url);
                            else window1.history.pushState(routeState, title || "", url);
                            _this2.latestAcknowledgedHistory = window1.history.length;
                        }
                        _this2.inPopState = false;
                        _this2.writeTimer = undefined;
                    }, _this2.writeDelay);
                });
            }
        },
        {
            key: "onUpdate",
            value: function onUpdate(callback) {
                var _this3 = this;
                if (this._start) this._start(function() {
                    callback(_this3.read());
                });
                this._onPopState = function() {
                    if (_this3.writeTimer) {
                        clearTimeout(_this3.writeTimer);
                        _this3.writeTimer = undefined;
                    }
                    _this3.inPopState = true;
                    // We always read the state from the URL because the state of the history
                    // can be incorect in some cases (e.g. using React Router).
                    callback(_this3.read());
                };
                (0, $93kMs.safelyRunOnBrowser)(function(_ref4) {
                    var window1 = _ref4.window;
                    window1.addEventListener("popstate", _this3._onPopState);
                });
            }
        },
        {
            key: "createURL",
            value: function createURL(routeState) {
                var url = this._createURL({
                    qsModule: (0, (/*@__PURE__*/$parcel$interopDefault($2rasJ))),
                    routeState: routeState,
                    location: this.getLocation()
                });
                var e;
                return url;
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                var _this4 = this;
                if (this._dispose) this._dispose();
                this.isDisposed = true;
                (0, $93kMs.safelyRunOnBrowser)(function(_ref5) {
                    var window1 = _ref5.window;
                    if (_this4._onPopState) window1.removeEventListener("popstate", _this4._onPopState);
                });
                if (this.writeTimer) clearTimeout(this.writeTimer);
                if (this._cleanUrlOnDispose) this.write({});
            }
        },
        {
            key: "start",
            value: function start() {
                this.isDisposed = false;
            }
        },
        {
            key: "shouldWrite",
            value: function shouldWrite(url) {
                var _this5 = this;
                return (0, $93kMs.safelyRunOnBrowser)(function(_ref6) {
                    var window1 = _ref6.window;
                    // When disposed and the cleanUrlOnDispose is set to false, we do not want to write the URL.
                    if (_this5.isDisposed && !_this5._cleanUrlOnDispose) return false;
                    // We do want to `pushState` if:
                    // - the router is not disposed, IS.js needs to update the URL
                    // OR
                    // - the last write was from InstantSearch.js
                    // (unlike a SPA, where it would have last written)
                    var lastPushWasByISAfterDispose = !(_this5.isDisposed && _this5.latestAcknowledgedHistory !== window1.history.length);
                    return(// When the last state change was through popstate, the IS.js state changes,
                    // but that should not write the URL.
                    !_this5.inPopState && // When the previous pushState after dispose was by IS.js, we want to write the URL.
                    lastPushWasByISAfterDispose && // When the URL is the same as the current one, we do not want to write it.
                    url !== window1.location.href);
                });
            }
        }
    ]);
    return BrowserHistory;
}();
function $2df91446519e0275$export$2e2bcd8739ae039() {
    var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref7$createURL = _ref7.createURL, createURL = _ref7$createURL === void 0 ? function(_ref8) {
        var qsModule = _ref8.qsModule, routeState = _ref8.routeState, location = _ref8.location;
        var protocol = location.protocol, hostname = location.hostname, _location$port = location.port, port = _location$port === void 0 ? "" : _location$port, pathname = location.pathname, hash = location.hash;
        var queryString = qsModule.stringify(routeState);
        var portWithPrefix = port === "" ? "" : ":".concat(port);
        // IE <= 11 has no proper `location.origin` so we cannot rely on it.
        if (!queryString) return "".concat(protocol, "//").concat(hostname).concat(portWithPrefix).concat(pathname).concat(hash);
        return "".concat(protocol, "//").concat(hostname).concat(portWithPrefix).concat(pathname, "?").concat(queryString).concat(hash);
    } : _ref7$createURL, _ref7$parseURL = _ref7.parseURL, parseURL = _ref7$parseURL === void 0 ? function(_ref9) {
        var qsModule = _ref9.qsModule, location = _ref9.location;
        // `qs` by default converts arrays with more than 20 items to an object.
        // We want to avoid this because the data structure manipulated can therefore vary.
        // Setting the limit to `100` seems a good number because the engine's default is 100
        // (it can go up to 1000 but it is very unlikely to select more than 100 items in the UI).
        //
        // Using an `arrayLimit` of `n` allows `n + 1` items.
        //
        // See:
        //   - https://github.com/ljharb/qs#parsing-arrays
        //   - https://www.algolia.com/doc/api-reference/api-parameters/maxValuesPerFacet/
        return qsModule.parse(location.search.slice(1), {
            arrayLimit: 99
        });
    } : _ref7$parseURL, _ref7$writeDelay = _ref7.writeDelay, writeDelay = _ref7$writeDelay === void 0 ? 400 : _ref7$writeDelay, windowTitle = _ref7.windowTitle, _ref7$getLocation = _ref7.getLocation, getLocation = _ref7$getLocation === void 0 ? function() {
        return (0, $93kMs.safelyRunOnBrowser)(function(_ref10) {
            var window1 = _ref10.window;
            return window1.location;
        }, {
            fallback: function fallback() {
                throw new Error("You need to provide `getLocation` to the `history` router in environments where `window` does not exist.");
            }
        });
    } : _ref7$getLocation, start = _ref7.start, dispose = _ref7.dispose, push = _ref7.push, cleanUrlOnDispose = _ref7.cleanUrlOnDispose;
    return new $2df91446519e0275$var$BrowserHistory({
        createURL: createURL,
        parseURL: parseURL,
        writeDelay: writeDelay,
        windowTitle: windowTitle,
        getLocation: getLocation,
        start: start,
        dispose: dispose,
        push: push,
        cleanUrlOnDispose: cleanUrlOnDispose
    });
}

});
parcelRegister("2rasJ", function(module, exports) {
"use strict";

var $jJyEy = parcelRequire("jJyEy");

var $cfYIz = parcelRequire("cfYIz");

var $i1Gbt = parcelRequire("i1Gbt");
module.exports = {
    formats: $i1Gbt,
    parse: $cfYIz,
    stringify: $jJyEy
};

});
parcelRegister("jJyEy", function(module, exports) {
"use strict";

var $iBfJ5 = parcelRequire("iBfJ5");

var $i1Gbt = parcelRequire("i1Gbt");
var $e5dd19a945a45bbb$var$has = Object.prototype.hasOwnProperty;
var $e5dd19a945a45bbb$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $e5dd19a945a45bbb$var$isArray = Array.isArray;
var $e5dd19a945a45bbb$var$split = String.prototype.split;
var $e5dd19a945a45bbb$var$push = Array.prototype.push;
var $e5dd19a945a45bbb$var$pushToArray = function(arr, valueOrArray) {
    $e5dd19a945a45bbb$var$push.apply(arr, $e5dd19a945a45bbb$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $e5dd19a945a45bbb$var$toISO = Date.prototype.toISOString;
var $e5dd19a945a45bbb$var$defaultFormat = $i1Gbt.default;
var $e5dd19a945a45bbb$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encoder: $iBfJ5.encode,
    encodeValuesOnly: false,
    format: $e5dd19a945a45bbb$var$defaultFormat,
    formatter: $i1Gbt.formatters[$e5dd19a945a45bbb$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $e5dd19a945a45bbb$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $e5dd19a945a45bbb$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var $e5dd19a945a45bbb$var$stringify = function stringify(object, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset) {
    var obj = object;
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && $e5dd19a945a45bbb$var$isArray(obj)) obj = $iBfJ5.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $e5dd19a945a45bbb$var$defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if ($e5dd19a945a45bbb$var$isNonNullishPrimitive(obj) || $iBfJ5.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $e5dd19a945a45bbb$var$defaults.encoder, charset, "key", format);
            if (generateArrayPrefix === "comma" && encodeValuesOnly) {
                var valuesArray = $e5dd19a945a45bbb$var$split.call(String(obj), ",");
                var valuesJoined = "";
                for(var i = 0; i < valuesArray.length; ++i)valuesJoined += (i === 0 ? "" : ",") + formatter(encoder(valuesArray[i], $e5dd19a945a45bbb$var$defaults.encoder, charset, "value", format));
                return [
                    formatter(keyValue) + "=" + valuesJoined
                ];
            }
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, $e5dd19a945a45bbb$var$defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && $e5dd19a945a45bbb$var$isArray(obj)) // we need to join elements in
    objKeys = [
        {
            value: obj.length > 0 ? obj.join(",") || null : void 0
        }
    ];
    else if ($e5dd19a945a45bbb$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var keyPrefix = $e5dd19a945a45bbb$var$isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(prefix, key) : prefix : prefix + (allowDots ? "." + key : "[" + key + "]");
        $e5dd19a945a45bbb$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset));
    }
    return values;
};
var $e5dd19a945a45bbb$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $e5dd19a945a45bbb$var$defaults;
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || $e5dd19a945a45bbb$var$defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = $i1Gbt.default;
    if (typeof opts.format !== "undefined") {
        if (!$e5dd19a945a45bbb$var$has.call($i1Gbt.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = $i1Gbt.formatters[format];
    var filter = $e5dd19a945a45bbb$var$defaults.filter;
    if (typeof opts.filter === "function" || $e5dd19a945a45bbb$var$isArray(opts.filter)) filter = opts.filter;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : $e5dd19a945a45bbb$var$defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === "undefined" ? $e5dd19a945a45bbb$var$defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $e5dd19a945a45bbb$var$defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === "undefined" ? $e5dd19a945a45bbb$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : $e5dd19a945a45bbb$var$defaults.encode,
        encoder: typeof opts.encoder === "function" ? opts.encoder : $e5dd19a945a45bbb$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : $e5dd19a945a45bbb$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : $e5dd19a945a45bbb$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : $e5dd19a945a45bbb$var$defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $e5dd19a945a45bbb$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $e5dd19a945a45bbb$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if ($e5dd19a945a45bbb$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var arrayFormat;
    if (opts && opts.arrayFormat in $e5dd19a945a45bbb$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if (opts && "indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = "indices";
    var generateArrayPrefix = $e5dd19a945a45bbb$var$arrayPrefixGenerators[arrayFormat];
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $e5dd19a945a45bbb$var$pushToArray(keys, $e5dd19a945a45bbb$var$stringify(obj[key], key, generateArrayPrefix, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};

});
parcelRegister("iBfJ5", function(module, exports) {
"use strict";

var $i1Gbt = parcelRequire("i1Gbt");
var $d8a7e190fdc9c6e7$var$has = Object.prototype.hasOwnProperty;
var $d8a7e190fdc9c6e7$var$isArray = Array.isArray;
var $d8a7e190fdc9c6e7$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var $d8a7e190fdc9c6e7$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($d8a7e190fdc9c6e7$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $d8a7e190fdc9c6e7$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var $d8a7e190fdc9c6e7$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if ($d8a7e190fdc9c6e7$var$isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !$d8a7e190fdc9c6e7$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($d8a7e190fdc9c6e7$var$isArray(target) && !$d8a7e190fdc9c6e7$var$isArray(source)) mergeTarget = $d8a7e190fdc9c6e7$var$arrayToObject(target, options);
    if ($d8a7e190fdc9c6e7$var$isArray(target) && $d8a7e190fdc9c6e7$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($d8a7e190fdc9c6e7$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($d8a7e190fdc9c6e7$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $d8a7e190fdc9c6e7$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $d8a7e190fdc9c6e7$var$decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $d8a7e190fdc9c6e7$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var i = 0; i < string.length; ++i){
        var c = string.charCodeAt(i);
        if (c === 0x2D // -
         || c === 0x2E // .
         || c === 0x5F // _
         || c === 0x7E // ~
         || c >= 0x30 && c <= 0x39 // 0-9
         || c >= 0x41 && c <= 0x5A // a-z
         || c >= 0x61 && c <= 0x7A // A-Z
         || format === $i1Gbt.RFC1738 && (c === 0x28 || c === 0x29) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }
        if (c < 0x80) {
            out = out + $d8a7e190fdc9c6e7$var$hexTable[c];
            continue;
        }
        if (c < 0x800) {
            out = out + ($d8a7e190fdc9c6e7$var$hexTable[0xC0 | c >> 6] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        if (c < 0xD800 || c >= 0xE000) {
            out = out + ($d8a7e190fdc9c6e7$var$hexTable[0xE0 | c >> 12] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 6 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        i += 1;
        c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
        /* eslint operator-linebreak: [2, "before"] */ out += $d8a7e190fdc9c6e7$var$hexTable[0xF0 | c >> 18] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 12 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c >> 6 & 0x3F] + $d8a7e190fdc9c6e7$var$hexTable[0x80 | c & 0x3F];
    }
    return out;
};
var $d8a7e190fdc9c6e7$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $d8a7e190fdc9c6e7$var$compactQueue(queue);
    return value;
};
var $d8a7e190fdc9c6e7$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var $d8a7e190fdc9c6e7$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $d8a7e190fdc9c6e7$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $d8a7e190fdc9c6e7$var$maybeMap = function maybeMap(val, fn) {
    if ($d8a7e190fdc9c6e7$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $d8a7e190fdc9c6e7$var$arrayToObject,
    assign: $d8a7e190fdc9c6e7$var$assign,
    combine: $d8a7e190fdc9c6e7$var$combine,
    compact: $d8a7e190fdc9c6e7$var$compact,
    decode: $d8a7e190fdc9c6e7$var$decode,
    encode: $d8a7e190fdc9c6e7$var$encode,
    isBuffer: $d8a7e190fdc9c6e7$var$isBuffer,
    isRegExp: $d8a7e190fdc9c6e7$var$isRegExp,
    maybeMap: $d8a7e190fdc9c6e7$var$maybeMap,
    merge: $d8a7e190fdc9c6e7$var$merge
};

});
parcelRegister("i1Gbt", function(module, exports) {
"use strict";
var $d1f90adf4e1eece6$var$replace = String.prototype.replace;
var $d1f90adf4e1eece6$var$percentTwenties = /%20/g;
var $d1f90adf4e1eece6$var$Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
module.exports = {
    "default": $d1f90adf4e1eece6$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $d1f90adf4e1eece6$var$replace.call(value, $d1f90adf4e1eece6$var$percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $d1f90adf4e1eece6$var$Format.RFC1738,
    RFC3986: $d1f90adf4e1eece6$var$Format.RFC3986
};

});



parcelRegister("cfYIz", function(module, exports) {
"use strict";

var $iBfJ5 = parcelRequire("iBfJ5");
var $8ec5fc0fdc198ba4$var$has = Object.prototype.hasOwnProperty;
var $8ec5fc0fdc198ba4$var$isArray = Array.isArray;
var $8ec5fc0fdc198ba4$var$defaults = {
    allowDots: false,
    allowPrototypes: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decoder: $iBfJ5.decode,
    delimiter: "&",
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};
var $8ec5fc0fdc198ba4$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $8ec5fc0fdc198ba4$var$parseArrayValue = function(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $8ec5fc0fdc198ba4$var$isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $8ec5fc0fdc198ba4$var$charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var $8ec5fc0fdc198ba4$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === $8ec5fc0fdc198ba4$var$charsetSentinel) charset = "utf-8";
            else if (parts[i] === $8ec5fc0fdc198ba4$var$isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $8ec5fc0fdc198ba4$var$defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), $8ec5fc0fdc198ba4$var$defaults.decoder, charset, "key");
            val = $iBfJ5.maybeMap($8ec5fc0fdc198ba4$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $8ec5fc0fdc198ba4$var$defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = $8ec5fc0fdc198ba4$var$interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = $8ec5fc0fdc198ba4$var$isArray(val) ? [
            val
        ] : val;
        if ($8ec5fc0fdc198ba4$var$has.call(obj, key)) obj[key] = $iBfJ5.combine(obj[key], val);
        else obj[key] = val;
    }
    return obj;
};
var $8ec5fc0fdc198ba4$var$parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $8ec5fc0fdc198ba4$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== "__proto__") obj[cleanRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $8ec5fc0fdc198ba4$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $8ec5fc0fdc198ba4$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $8ec5fc0fdc198ba4$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, just add whatever is left
    if (segment) keys.push("[" + key.slice(segment.index) + "]");
    return $8ec5fc0fdc198ba4$var$parseObject(keys, val, options, valuesParsed);
};
var $8ec5fc0fdc198ba4$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $8ec5fc0fdc198ba4$var$defaults;
    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? $8ec5fc0fdc198ba4$var$defaults.charset : opts.charset;
    return {
        allowDots: typeof opts.allowDots === "undefined" ? $8ec5fc0fdc198ba4$var$defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : $8ec5fc0fdc198ba4$var$defaults.allowPrototypes,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : $8ec5fc0fdc198ba4$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $8ec5fc0fdc198ba4$var$defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : $8ec5fc0fdc198ba4$var$defaults.comma,
        decoder: typeof opts.decoder === "function" ? opts.decoder : $8ec5fc0fdc198ba4$var$defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || $iBfJ5.isRegExp(opts.delimiter) ? opts.delimiter : $8ec5fc0fdc198ba4$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : $8ec5fc0fdc198ba4$var$defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : $8ec5fc0fdc198ba4$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : $8ec5fc0fdc198ba4$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : $8ec5fc0fdc198ba4$var$defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $8ec5fc0fdc198ba4$var$defaults.strictNullHandling
    };
};
module.exports = function(str, opts) {
    var options = $8ec5fc0fdc198ba4$var$normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? $8ec5fc0fdc198ba4$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $8ec5fc0fdc198ba4$var$parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = $iBfJ5.merge(obj, newObj, options);
    }
    return $iBfJ5.compact(obj);
};

});



parcelRegister("ab3TT", function(module, exports) {

$parcel$export(module.exports, "default", () => $768df5004f58dc5e$export$2e2bcd8739ae039);
function $768df5004f58dc5e$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $768df5004f58dc5e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $768df5004f58dc5e$var$_typeof(obj);
}
var $768df5004f58dc5e$var$_excluded = [
    "configure"
];
function $768df5004f58dc5e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $768df5004f58dc5e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $768df5004f58dc5e$var$ownKeys(Object(source), !0).forEach(function(key) {
            $768df5004f58dc5e$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $768df5004f58dc5e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $768df5004f58dc5e$var$_defineProperty(obj, key, value) {
    key = $768df5004f58dc5e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $768df5004f58dc5e$var$_toPropertyKey(arg) {
    var key = $768df5004f58dc5e$var$_toPrimitive(arg, "string");
    return $768df5004f58dc5e$var$_typeof(key) === "symbol" ? key : String(key);
}
function $768df5004f58dc5e$var$_toPrimitive(input, hint) {
    if ($768df5004f58dc5e$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($768df5004f58dc5e$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $768df5004f58dc5e$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $768df5004f58dc5e$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $768df5004f58dc5e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $768df5004f58dc5e$var$getIndexStateWithoutConfigure(uiState) {
    var configure = uiState.configure, trackedUiState = $768df5004f58dc5e$var$_objectWithoutProperties(uiState, $768df5004f58dc5e$var$_excluded);
    return trackedUiState;
}
function $768df5004f58dc5e$export$2e2bcd8739ae039() {
    return {
        $$type: "ais.simple",
        stateToRoute: function stateToRoute(uiState) {
            return Object.keys(uiState).reduce(function(state, indexId) {
                return $768df5004f58dc5e$var$_objectSpread($768df5004f58dc5e$var$_objectSpread({}, state), {}, $768df5004f58dc5e$var$_defineProperty({}, indexId, $768df5004f58dc5e$var$getIndexStateWithoutConfigure(uiState[indexId])));
            }, {});
        },
        routeToState: function routeToState() {
            var routeState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            return Object.keys(routeState).reduce(function(state, indexId) {
                return $768df5004f58dc5e$var$_objectSpread($768df5004f58dc5e$var$_objectSpread({}, state), {}, $768df5004f58dc5e$var$_defineProperty({}, indexId, $768df5004f58dc5e$var$getIndexStateWithoutConfigure(routeState[indexId])));
            }, {});
        }
    };
}

});


parcelRegister("fYhEq", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba0a26bb74d967c8$export$2e2bcd8739ae039);

var $3gYKj = parcelRequire("3gYKj");

var $del55 = parcelRequire("del55");
var $keGxy = parcelRequire("keGxy");
var $h47Cl = parcelRequire("h47Cl");
var $dohXG = parcelRequire("dohXG");
var $1rijK = parcelRequire("1rijK");

var $9Fp4u = parcelRequire("9Fp4u");
function $ba0a26bb74d967c8$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $ba0a26bb74d967c8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $ba0a26bb74d967c8$var$_typeof(obj);
}
var $ba0a26bb74d967c8$var$_excluded = [
    "initialSearchParameters"
], $ba0a26bb74d967c8$var$_excluded2 = [
    "initialRecommendParameters"
];
function $ba0a26bb74d967c8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ba0a26bb74d967c8$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ba0a26bb74d967c8$var$ownKeys(Object(source), !0).forEach(function(key) {
            $ba0a26bb74d967c8$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ba0a26bb74d967c8$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ba0a26bb74d967c8$var$_defineProperty(obj, key, value) {
    key = $ba0a26bb74d967c8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ba0a26bb74d967c8$var$_toPropertyKey(arg) {
    var key = $ba0a26bb74d967c8$var$_toPrimitive(arg, "string");
    return $ba0a26bb74d967c8$var$_typeof(key) === "symbol" ? key : String(key);
}
function $ba0a26bb74d967c8$var$_toPrimitive(input, hint) {
    if ($ba0a26bb74d967c8$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($ba0a26bb74d967c8$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $ba0a26bb74d967c8$var$_toConsumableArray(arr) {
    return $ba0a26bb74d967c8$var$_arrayWithoutHoles(arr) || $ba0a26bb74d967c8$var$_iterableToArray(arr) || $ba0a26bb74d967c8$var$_unsupportedIterableToArray(arr) || $ba0a26bb74d967c8$var$_nonIterableSpread();
}
function $ba0a26bb74d967c8$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ba0a26bb74d967c8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ba0a26bb74d967c8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ba0a26bb74d967c8$var$_arrayLikeToArray(o, minLen);
}
function $ba0a26bb74d967c8$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $ba0a26bb74d967c8$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $ba0a26bb74d967c8$var$_arrayLikeToArray(arr);
}
function $ba0a26bb74d967c8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ba0a26bb74d967c8$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ba0a26bb74d967c8$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ba0a26bb74d967c8$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $ba0a26bb74d967c8$var$withUsage = (0, $del55.createDocumentationMessageGenerator)({
    name: "index-widget"
});
/**
 * This is the same content as helper._change / setState, but allowing for extra
 * UiState to be synchronized.
 * see: https://github.com/algolia/algoliasearch-helper-js/blob/6b835ffd07742f2d6b314022cce6848f5cfecd4a/src/algoliasearch.helper.js#L1311-L1324
 */ function $ba0a26bb74d967c8$var$privateHelperSetState(helper, _ref) {
    var state = _ref.state, recommendState = _ref.recommendState, isPageReset = _ref.isPageReset, _uiState = _ref._uiState;
    if (state !== helper.state) {
        helper.state = state;
        helper.emit("change", {
            state: helper.state,
            results: helper.lastResults,
            isPageReset: isPageReset,
            _uiState: _uiState
        });
    }
    if (recommendState !== helper.recommendState) helper.recommendState = recommendState;
}
function $ba0a26bb74d967c8$var$getLocalWidgetsUiState(widgets, widgetStateOptions) {
    var initialUiState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return widgets.reduce(function(uiState, widget) {
        if ((0, $h47Cl.isIndexWidget)(widget)) return uiState;
        if (!widget.getWidgetUiState && !widget.getWidgetState) return uiState;
        if (widget.getWidgetUiState) return widget.getWidgetUiState(uiState, widgetStateOptions);
        return widget.getWidgetState(uiState, widgetStateOptions);
    }, initialUiState);
}
function $ba0a26bb74d967c8$var$getLocalWidgetsSearchParameters(widgets, widgetSearchParametersOptions) {
    var initialSearchParameters = widgetSearchParametersOptions.initialSearchParameters, rest = $ba0a26bb74d967c8$var$_objectWithoutProperties(widgetSearchParametersOptions, $ba0a26bb74d967c8$var$_excluded);
    return widgets.reduce(function(state, widget) {
        if (!widget.getWidgetSearchParameters || (0, $h47Cl.isIndexWidget)(widget)) return state;
        if (widget.dependsOn === "search" && widget.getWidgetParameters) return widget.getWidgetParameters(state, rest);
        return widget.getWidgetSearchParameters(state, rest);
    }, initialSearchParameters);
}
function $ba0a26bb74d967c8$var$getLocalWidgetsRecommendParameters(widgets, widgetRecommendParametersOptions) {
    var initialRecommendParameters = widgetRecommendParametersOptions.initialRecommendParameters, rest = $ba0a26bb74d967c8$var$_objectWithoutProperties(widgetRecommendParametersOptions, $ba0a26bb74d967c8$var$_excluded2);
    return widgets.reduce(function(state, widget) {
        if (!(0, $h47Cl.isIndexWidget)(widget) && widget.dependsOn === "recommend" && widget.getWidgetParameters) return widget.getWidgetParameters(state, rest);
        return state;
    }, initialRecommendParameters);
}
function $ba0a26bb74d967c8$var$resetPageFromWidgets(widgets) {
    var indexWidgets = widgets.filter((0, $h47Cl.isIndexWidget));
    if (indexWidgets.length === 0) return;
    indexWidgets.forEach(function(widget) {
        var widgetHelper = widget.getHelper();
        $ba0a26bb74d967c8$var$privateHelperSetState(widgetHelper, {
            state: widgetHelper.state.resetPage(),
            recommendState: widgetHelper.recommendState,
            isPageReset: true
        });
        $ba0a26bb74d967c8$var$resetPageFromWidgets(widget.getWidgets());
    });
}
function $ba0a26bb74d967c8$var$resolveScopedResultsFromWidgets(widgets) {
    var indexWidgets = widgets.filter((0, $h47Cl.isIndexWidget));
    return indexWidgets.reduce(function(scopedResults, current) {
        return scopedResults.concat.apply(scopedResults, [
            {
                indexId: current.getIndexId(),
                results: current.getResults(),
                helper: current.getHelper()
            }
        ].concat($ba0a26bb74d967c8$var$_toConsumableArray($ba0a26bb74d967c8$var$resolveScopedResultsFromWidgets(current.getWidgets()))));
    }, []);
}
var $ba0a26bb74d967c8$var$index = function index(widgetParams) {
    if (widgetParams === undefined || widgetParams.indexName === undefined) throw new Error($ba0a26bb74d967c8$var$withUsage("The `indexName` option is required."));
    var indexName = widgetParams.indexName, _widgetParams$indexId = widgetParams.indexId, indexId = _widgetParams$indexId === void 0 ? indexName : _widgetParams$indexId;
    var localWidgets = [];
    var localUiState = {};
    var localInstantSearchInstance = null;
    var localParent = null;
    var helper = null;
    var derivedHelper = null;
    var lastValidSearchParameters = null;
    var hasRecommendWidget = false;
    var hasSearchWidget = false;
    return {
        $$type: "ais.index",
        $$widgetType: "ais.index",
        getIndexName: function getIndexName() {
            return indexName;
        },
        getIndexId: function getIndexId() {
            return indexId;
        },
        getHelper: function getHelper() {
            return helper;
        },
        getResults: function getResults() {
            var _derivedHelper;
            if (!((_derivedHelper = derivedHelper) !== null && _derivedHelper !== void 0 && _derivedHelper.lastResults)) return null;
            // To make the UI optimistic, we patch the state to display to the current
            // one instead of the one associated with the latest results.
            // This means user-driven UI changes (e.g., checked checkbox) are reflected
            // immediately instead of waiting for Algolia to respond, regardless of
            // the status of the network request.
            derivedHelper.lastResults._state = helper.state;
            return derivedHelper.lastResults;
        },
        getResultsForWidget: function getResultsForWidget(widget) {
            var _helper;
            if (widget.dependsOn !== "recommend" || (0, $h47Cl.isIndexWidget)(widget) || widget.$$id === undefined) return this.getResults();
            if (!((_helper = helper) !== null && _helper !== void 0 && _helper.lastRecommendResults)) return null;
            return helper.lastRecommendResults[widget.$$id];
        },
        getPreviousState: function getPreviousState() {
            return lastValidSearchParameters;
        },
        getScopedResults: function getScopedResults() {
            var widgetParent = this.getParent();
            var widgetSiblings;
            if (widgetParent) widgetSiblings = widgetParent.getWidgets();
            else if (indexName.length === 0) // The widget is the root but has no index name:
            // we resolve results from its children index widgets
            widgetSiblings = this.getWidgets();
            else // The widget is the root and has an index name:
            // we consider itself as the only sibling
            widgetSiblings = [
                this
            ];
            return $ba0a26bb74d967c8$var$resolveScopedResultsFromWidgets(widgetSiblings);
        },
        getParent: function getParent() {
            return localParent;
        },
        createURL: function createURL(nextState) {
            if (typeof nextState === "function") return localInstantSearchInstance._createURL($ba0a26bb74d967c8$var$_defineProperty({}, indexId, nextState(localUiState)));
            return localInstantSearchInstance._createURL($ba0a26bb74d967c8$var$_defineProperty({}, indexId, $ba0a26bb74d967c8$var$getLocalWidgetsUiState(localWidgets, {
                searchParameters: nextState,
                helper: helper
            })));
        },
        getWidgets: function getWidgets() {
            return localWidgets;
        },
        addWidgets: function addWidgets(widgets) {
            var _this = this;
            if (!Array.isArray(widgets)) throw new Error($ba0a26bb74d967c8$var$withUsage("The `addWidgets` method expects an array of widgets."));
            if (widgets.some(function(widget) {
                return typeof widget.init !== "function" && typeof widget.render !== "function";
            })) throw new Error($ba0a26bb74d967c8$var$withUsage("The widget definition expects a `render` and/or an `init` method."));
            widgets.forEach(function(widget) {
                if ((0, $h47Cl.isIndexWidget)(widget)) return;
                if (localInstantSearchInstance && widget.dependsOn === "recommend") localInstantSearchInstance._hasRecommendWidget = true;
                else if (localInstantSearchInstance) localInstantSearchInstance._hasSearchWidget = true;
                else if (widget.dependsOn === "recommend") hasRecommendWidget = true;
                else hasSearchWidget = true;
                (0, $9Fp4u.addWidgetId)(widget);
            });
            localWidgets = localWidgets.concat(widgets);
            if (localInstantSearchInstance && Boolean(widgets.length)) {
                $ba0a26bb74d967c8$var$privateHelperSetState(helper, {
                    state: $ba0a26bb74d967c8$var$getLocalWidgetsSearchParameters(localWidgets, {
                        uiState: localUiState,
                        initialSearchParameters: helper.state
                    }),
                    recommendState: $ba0a26bb74d967c8$var$getLocalWidgetsRecommendParameters(localWidgets, {
                        uiState: localUiState,
                        initialRecommendParameters: helper.recommendState
                    }),
                    _uiState: localUiState
                });
                // We compute the render state before calling `init` in a separate loop
                // to construct the whole render state object that is then passed to
                // `init`.
                widgets.forEach(function(widget) {
                    if (widget.getRenderState) {
                        var renderState = widget.getRenderState(localInstantSearchInstance.renderState[_this.getIndexId()] || {}, (0, $keGxy.createInitArgs)(localInstantSearchInstance, _this, localInstantSearchInstance._initialUiState));
                        $ba0a26bb74d967c8$var$storeRenderState({
                            renderState: renderState,
                            instantSearchInstance: localInstantSearchInstance,
                            parent: _this
                        });
                    }
                });
                widgets.forEach(function(widget) {
                    if (widget.init) widget.init((0, $keGxy.createInitArgs)(localInstantSearchInstance, _this, localInstantSearchInstance._initialUiState));
                });
                localInstantSearchInstance.scheduleSearch();
            }
            return this;
        },
        removeWidgets: function removeWidgets(widgets) {
            var _this2 = this;
            if (!Array.isArray(widgets)) throw new Error($ba0a26bb74d967c8$var$withUsage("The `removeWidgets` method expects an array of widgets."));
            if (widgets.some(function(widget) {
                return typeof widget.dispose !== "function";
            })) throw new Error($ba0a26bb74d967c8$var$withUsage("The widget definition expects a `dispose` method."));
            localWidgets = localWidgets.filter(function(widget) {
                return widgets.indexOf(widget) === -1;
            });
            localWidgets.forEach(function(widget) {
                if ((0, $h47Cl.isIndexWidget)(widget)) return;
                if (localInstantSearchInstance && widget.dependsOn === "recommend") localInstantSearchInstance._hasRecommendWidget = true;
                else if (localInstantSearchInstance) localInstantSearchInstance._hasSearchWidget = true;
                else if (widget.dependsOn === "recommend") hasRecommendWidget = true;
                else hasSearchWidget = true;
            });
            if (localInstantSearchInstance && Boolean(widgets.length)) {
                var _widgets$reduce = widgets.reduce(function(states, widget) {
                    // the `dispose` method exists at this point we already assert it
                    var next = widget.dispose({
                        helper: helper,
                        state: states.cleanedSearchState,
                        recommendState: states.cleanedRecommendState,
                        parent: _this2
                    });
                    if (next instanceof (0, (/*@__PURE__*/$parcel$interopDefault($3gYKj))).RecommendParameters) states.cleanedRecommendState = next;
                    else if (next) states.cleanedSearchState = next;
                    return states;
                }, {
                    cleanedSearchState: helper.state,
                    cleanedRecommendState: helper.recommendState
                }), cleanedSearchState = _widgets$reduce.cleanedSearchState, cleanedRecommendState = _widgets$reduce.cleanedRecommendState;
                var newState = localInstantSearchInstance.future.preserveSharedStateOnUnmount ? $ba0a26bb74d967c8$var$getLocalWidgetsSearchParameters(localWidgets, {
                    uiState: localUiState,
                    initialSearchParameters: new (0, (/*@__PURE__*/$parcel$interopDefault($3gYKj))).SearchParameters({
                        index: this.getIndexName()
                    })
                }) : $ba0a26bb74d967c8$var$getLocalWidgetsSearchParameters(localWidgets, {
                    uiState: $ba0a26bb74d967c8$var$getLocalWidgetsUiState(localWidgets, {
                        searchParameters: cleanedSearchState,
                        helper: helper
                    }),
                    initialSearchParameters: cleanedSearchState
                });
                localUiState = $ba0a26bb74d967c8$var$getLocalWidgetsUiState(localWidgets, {
                    searchParameters: newState,
                    helper: helper
                });
                helper.setState(newState);
                helper.recommendState = cleanedRecommendState;
                if (localWidgets.length) localInstantSearchInstance.scheduleSearch();
            }
            return this;
        },
        init: function init(_ref2) {
            var _this3 = this, _instantSearchInstanc;
            var instantSearchInstance = _ref2.instantSearchInstance, parent = _ref2.parent, uiState = _ref2.uiState;
            if (helper !== null) // helper is already initialized, therefore we do not need to set up
            // any listeners
            return;
            localInstantSearchInstance = instantSearchInstance;
            localParent = parent;
            localUiState = uiState[indexId] || {};
            // The `mainHelper` is already defined at this point. The instance is created
            // inside InstantSearch at the `start` method, which occurs before the `init`
            // step.
            var mainHelper = instantSearchInstance.mainHelper;
            var parameters = $ba0a26bb74d967c8$var$getLocalWidgetsSearchParameters(localWidgets, {
                uiState: localUiState,
                initialSearchParameters: new (0, (/*@__PURE__*/$parcel$interopDefault($3gYKj))).SearchParameters({
                    index: indexName
                })
            });
            var recommendParameters = $ba0a26bb74d967c8$var$getLocalWidgetsRecommendParameters(localWidgets, {
                uiState: localUiState,
                initialRecommendParameters: new (0, (/*@__PURE__*/$parcel$interopDefault($3gYKj))).RecommendParameters()
            });
            // This Helper is only used for state management we do not care about the
            // `searchClient`. Only the "main" Helper created at the `InstantSearch`
            // level is aware of the client.
            helper = (0, (/*@__PURE__*/$parcel$interopDefault($3gYKj)))({}, parameters.index, parameters);
            helper.recommendState = recommendParameters;
            // We forward the call to `search` to the "main" instance of the Helper
            // which is responsible for managing the queries (it's the only one that is
            // aware of the `searchClient`).
            helper.search = function() {
                if (instantSearchInstance.onStateChange) {
                    instantSearchInstance.onStateChange({
                        uiState: instantSearchInstance.mainIndex.getWidgetUiState({}),
                        setUiState: function setUiState(nextState) {
                            return instantSearchInstance.setUiState(nextState, false);
                        }
                    });
                    // We don't trigger a search when controlled because it becomes the
                    // responsibility of `setUiState`.
                    return mainHelper;
                }
                return mainHelper.search();
            };
            helper.searchWithoutTriggeringOnStateChange = function() {
                return mainHelper.search();
            };
            // We use the same pattern for the `searchForFacetValues`.
            helper.searchForFacetValues = function(facetName, facetValue, maxFacetHits, userState) {
                var state = helper.state.setQueryParameters(userState);
                return mainHelper.searchForFacetValues(facetName, facetValue, maxFacetHits, state);
            };
            derivedHelper = mainHelper.derive(function() {
                return (0, $dohXG.mergeSearchParameters).apply(void 0, [
                    mainHelper.state
                ].concat($ba0a26bb74d967c8$var$_toConsumableArray((0, $1rijK.resolveSearchParameters)(_this3))));
            }, function() {
                return _this3.getHelper().recommendState;
            });
            var indexInitialResults = (_instantSearchInstanc = instantSearchInstance._initialResults) === null || _instantSearchInstanc === void 0 ? void 0 : _instantSearchInstanc[this.getIndexId()];
            if (indexInitialResults !== null && indexInitialResults !== void 0 && indexInitialResults.results) {
                // We restore the shape of the results provided to the instance to respect
                // the helper's structure.
                var results = new (0, (/*@__PURE__*/$parcel$interopDefault($3gYKj))).SearchResults(new (0, (/*@__PURE__*/$parcel$interopDefault($3gYKj))).SearchParameters(indexInitialResults.state), indexInitialResults.results);
                derivedHelper.lastResults = results;
                helper.lastResults = results;
            }
            if (indexInitialResults !== null && indexInitialResults !== void 0 && indexInitialResults.recommendResults) {
                var recommendResults = new (0, (/*@__PURE__*/$parcel$interopDefault($3gYKj))).RecommendResults(new (0, (/*@__PURE__*/$parcel$interopDefault($3gYKj))).RecommendParameters({
                    params: indexInitialResults.recommendResults.params
                }), indexInitialResults.recommendResults.results);
                derivedHelper.lastRecommendResults = recommendResults;
                helper.lastRecommendResults = recommendResults;
            }
            // Subscribe to the Helper state changes for the page before widgets
            // are initialized. This behavior mimics the original one of the Helper.
            // It makes sense to replicate it at the `init` step. We have another
            // listener on `change` below, once `init` is done.
            helper.on("change", function(_ref3) {
                var isPageReset = _ref3.isPageReset;
                if (isPageReset) $ba0a26bb74d967c8$var$resetPageFromWidgets(localWidgets);
            });
            derivedHelper.on("search", function() {
                // The index does not manage the "staleness" of the search. This is the
                // responsibility of the main instance. It does not make sense to manage
                // it at the index level because it's either: all of them or none of them
                // that are stalled. The queries are performed into a single network request.
                instantSearchInstance.scheduleStalledRender();
            });
            derivedHelper.on("result", function(_ref4) {
                var results = _ref4.results;
                // The index does not render the results it schedules a new render
                // to let all the other indices emit their own results. It allows us to
                // run the render process in one pass.
                instantSearchInstance.scheduleRender();
                // the derived helper is the one which actually searches, but the helper
                // which is exposed e.g. via instance.helper, doesn't search, and thus
                // does not have access to lastResults, which it used to in pre-federated
                // search behavior.
                helper.lastResults = results;
                lastValidSearchParameters = results === null || results === void 0 ? void 0 : results._state;
            });
            // eslint-disable-next-line no-warning-comments
            // TODO: listen to "result" event when events for Recommend are implemented
            derivedHelper.on("recommend:result", function(_ref5) {
                var recommend = _ref5.recommend;
                // The index does not render the results it schedules a new render
                // to let all the other indices emit their own results. It allows us to
                // run the render process in one pass.
                instantSearchInstance.scheduleRender();
                // the derived helper is the one which actually searches, but the helper
                // which is exposed e.g. via instance.helper, doesn't search, and thus
                // does not have access to lastRecommendResults.
                helper.lastRecommendResults = recommend.results;
            });
            // We compute the render state before calling `init` in a separate loop
            // to construct the whole render state object that is then passed to
            // `init`.
            localWidgets.forEach(function(widget) {
                if (widget.getRenderState) {
                    var renderState = widget.getRenderState(instantSearchInstance.renderState[_this3.getIndexId()] || {}, (0, $keGxy.createInitArgs)(instantSearchInstance, _this3, uiState));
                    $ba0a26bb74d967c8$var$storeRenderState({
                        renderState: renderState,
                        instantSearchInstance: instantSearchInstance,
                        parent: _this3
                    });
                }
            });
            localWidgets.forEach(function(widget) {
                if (widget.init) widget.init((0, $keGxy.createInitArgs)(instantSearchInstance, _this3, uiState));
            });
            // Subscribe to the Helper state changes for the `uiState` once widgets
            // are initialized. Until the first render, state changes are part of the
            // configuration step. This is mainly for backward compatibility with custom
            // widgets. When the subscription happens before the `init` step, the (static)
            // configuration of the widget is pushed in the URL. That's what we want to avoid.
            // https://github.com/algolia/instantsearch/pull/994/commits/4a672ae3fd78809e213de0368549ef12e9dc9454
            helper.on("change", function(event) {
                var state = event.state;
                var _uiState = event._uiState;
                localUiState = $ba0a26bb74d967c8$var$getLocalWidgetsUiState(localWidgets, {
                    searchParameters: state,
                    helper: helper
                }, _uiState || {});
                // We don't trigger an internal change when controlled because it
                // becomes the responsibility of `setUiState`.
                if (!instantSearchInstance.onStateChange) instantSearchInstance.onInternalStateChange();
            });
            if (indexInitialResults) // If there are initial results, we're not notified of the next results
            // because we don't trigger an initial search. We therefore need to directly
            // schedule a render that will render the results injected on the helper.
            instantSearchInstance.scheduleRender();
            if (hasRecommendWidget) instantSearchInstance._hasRecommendWidget = true;
            if (hasSearchWidget) instantSearchInstance._hasSearchWidget = true;
        },
        render: function render(_ref6) {
            var _derivedHelper2, _this4 = this;
            var instantSearchInstance = _ref6.instantSearchInstance;
            // we can't attach a listener to the error event of search, as the error
            // then would no longer be thrown for global handlers.
            if (instantSearchInstance.status === "error" && !instantSearchInstance.mainHelper.hasPendingRequests() && lastValidSearchParameters) helper.setState(lastValidSearchParameters);
            // We only render index widgets if there are no results.
            // This makes sure `render` is never called with `results` being `null`.
            var widgetsToRender = this.getResults() || (_derivedHelper2 = derivedHelper) !== null && _derivedHelper2 !== void 0 && _derivedHelper2.lastRecommendResults ? localWidgets : localWidgets.filter((0, $h47Cl.isIndexWidget));
            widgetsToRender = widgetsToRender.filter(function(widget) {
                if (!widget.shouldRender) return true;
                return widget.shouldRender({
                    instantSearchInstance: instantSearchInstance
                });
            });
            widgetsToRender.forEach(function(widget) {
                if (widget.getRenderState) {
                    var renderState = widget.getRenderState(instantSearchInstance.renderState[_this4.getIndexId()] || {}, (0, $keGxy.createRenderArgs)(instantSearchInstance, _this4, widget));
                    $ba0a26bb74d967c8$var$storeRenderState({
                        renderState: renderState,
                        instantSearchInstance: instantSearchInstance,
                        parent: _this4
                    });
                }
            });
            widgetsToRender.forEach(function(widget) {
                // At this point, all the variables used below are set. Both `helper`
                // and `derivedHelper` have been created at the `init` step. The attribute
                // `lastResults` might be `null` though. It's possible that a stalled render
                // happens before the result e.g with a dynamically added index the request might
                // be delayed. The render is triggered for the complete tree but some parts do
                // not have results yet.
                if (widget.render) widget.render((0, $keGxy.createRenderArgs)(instantSearchInstance, _this4, widget));
            });
        },
        dispose: function dispose() {
            var _this5 = this, _helper2, _derivedHelper3;
            localWidgets.forEach(function(widget) {
                if (widget.dispose && helper) // The dispose function is always called once the instance is started
                // (it's an effect of `removeWidgets`). The index is initialized and
                // the Helper is available. We don't care about the return value of
                // `dispose` because the index is removed. We can't call `removeWidgets`
                // because we want to keep the widgets on the instance, to allow idempotent
                // operations on `add` & `remove`.
                widget.dispose({
                    helper: helper,
                    state: helper.state,
                    recommendState: helper.recommendState,
                    parent: _this5
                });
            });
            localInstantSearchInstance = null;
            localParent = null;
            (_helper2 = helper) === null || _helper2 === void 0 || _helper2.removeAllListeners();
            helper = null;
            (_derivedHelper3 = derivedHelper) === null || _derivedHelper3 === void 0 || _derivedHelper3.detach();
            derivedHelper = null;
        },
        getWidgetUiState: function getWidgetUiState(uiState) {
            return localWidgets.filter((0, $h47Cl.isIndexWidget)).reduce(function(previousUiState, innerIndex) {
                return innerIndex.getWidgetUiState(previousUiState);
            }, $ba0a26bb74d967c8$var$_objectSpread($ba0a26bb74d967c8$var$_objectSpread({}, uiState), {}, $ba0a26bb74d967c8$var$_defineProperty({}, indexId, $ba0a26bb74d967c8$var$_objectSpread($ba0a26bb74d967c8$var$_objectSpread({}, uiState[indexId]), localUiState))));
        },
        getWidgetState: function getWidgetState(uiState) {
            return this.getWidgetUiState(uiState);
        },
        getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref7) {
            var uiState = _ref7.uiState;
            return $ba0a26bb74d967c8$var$getLocalWidgetsSearchParameters(localWidgets, {
                uiState: uiState,
                initialSearchParameters: searchParameters
            });
        },
        refreshUiState: function refreshUiState() {
            localUiState = $ba0a26bb74d967c8$var$getLocalWidgetsUiState(localWidgets, {
                searchParameters: this.getHelper().state,
                helper: this.getHelper()
            }, localUiState);
        },
        setIndexUiState: function setIndexUiState(indexUiState) {
            var nextIndexUiState = typeof indexUiState === "function" ? indexUiState(localUiState) : indexUiState;
            localInstantSearchInstance.setUiState(function(state) {
                return $ba0a26bb74d967c8$var$_objectSpread($ba0a26bb74d967c8$var$_objectSpread({}, state), {}, $ba0a26bb74d967c8$var$_defineProperty({}, indexId, nextIndexUiState));
            });
        }
    };
};
var $ba0a26bb74d967c8$export$2e2bcd8739ae039 = $ba0a26bb74d967c8$var$index;
function $ba0a26bb74d967c8$var$storeRenderState(_ref8) {
    var renderState = _ref8.renderState, instantSearchInstance = _ref8.instantSearchInstance, parent = _ref8.parent;
    var parentIndexName = parent ? parent.getIndexId() : instantSearchInstance.mainIndex.getIndexId();
    instantSearchInstance.renderState = $ba0a26bb74d967c8$var$_objectSpread($ba0a26bb74d967c8$var$_objectSpread({}, instantSearchInstance.renderState), {}, $ba0a26bb74d967c8$var$_defineProperty({}, parentIndexName, $ba0a26bb74d967c8$var$_objectSpread($ba0a26bb74d967c8$var$_objectSpread({}, instantSearchInstance.renderState[parentIndexName]), renderState)));
}

});
parcelRegister("del55", function(module, exports) {

$parcel$export(module.exports, "createDocumentationMessageGenerator", () => $9a1cef70250cb400$export$2fde5bffc340821e);
function $9a1cef70250cb400$export$110679b26359d23d(_ref) {
    var name = _ref.name, _ref$connector = _ref.connector, connector = _ref$connector === void 0 ? false : _ref$connector;
    return [
        "https://www.algolia.com/doc/api-reference/widgets/",
        name,
        "/js/",
        connector ? "#connector" : ""
    ].join("");
}
function $9a1cef70250cb400$export$2fde5bffc340821e() {
    for(var _len = arguments.length, widgets = new Array(_len), _key = 0; _key < _len; _key++)widgets[_key] = arguments[_key];
    var links = widgets.map(function(widget) {
        return $9a1cef70250cb400$export$110679b26359d23d(widget);
    }).join(", ");
    return function(message) {
        return [
            message,
            "See documentation: ".concat(links)
        ].filter(Boolean).join("\n\n");
    };
}

});

parcelRegister("h47Cl", function(module, exports) {

$parcel$export(module.exports, "isIndexWidget", () => $c6c8b80cbd5e3ac9$export$a9c9a0d43506297d);
function $c6c8b80cbd5e3ac9$export$a9c9a0d43506297d(widget) {
    return widget.$$type === "ais.index";
}

});

parcelRegister("dohXG", function(module, exports) {

$parcel$export(module.exports, "mergeSearchParameters", () => $9bfb730df128d58d$export$8049d91f25899769);

var $5P7n0 = parcelRequire("5P7n0");

var $7oPxv = parcelRequire("7oPxv");
function $9bfb730df128d58d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $9bfb730df128d58d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $9bfb730df128d58d$var$_typeof(obj);
}
var $9bfb730df128d58d$var$_excluded = [
    "facets",
    "disjunctiveFacets",
    "facetsRefinements",
    "facetsExcludes",
    "disjunctiveFacetsRefinements",
    "numericRefinements",
    "tagRefinements",
    "hierarchicalFacets",
    "hierarchicalFacetsRefinements",
    "ruleContexts"
];
function $9bfb730df128d58d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9bfb730df128d58d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $9bfb730df128d58d$var$ownKeys(Object(source), !0).forEach(function(key) {
            $9bfb730df128d58d$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $9bfb730df128d58d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $9bfb730df128d58d$var$_defineProperty(obj, key, value) {
    key = $9bfb730df128d58d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9bfb730df128d58d$var$_toPropertyKey(arg) {
    var key = $9bfb730df128d58d$var$_toPrimitive(arg, "string");
    return $9bfb730df128d58d$var$_typeof(key) === "symbol" ? key : String(key);
}
function $9bfb730df128d58d$var$_toPrimitive(input, hint) {
    if ($9bfb730df128d58d$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($9bfb730df128d58d$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $9bfb730df128d58d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $9bfb730df128d58d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $9bfb730df128d58d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $9bfb730df128d58d$var$mergeWithRest = function mergeWithRest(left, right) {
    var facets = right.facets, disjunctiveFacets = right.disjunctiveFacets, facetsRefinements = right.facetsRefinements, facetsExcludes = right.facetsExcludes, disjunctiveFacetsRefinements = right.disjunctiveFacetsRefinements, numericRefinements = right.numericRefinements, tagRefinements = right.tagRefinements, hierarchicalFacets = right.hierarchicalFacets, hierarchicalFacetsRefinements = right.hierarchicalFacetsRefinements, ruleContexts = right.ruleContexts, rest = $9bfb730df128d58d$var$_objectWithoutProperties(right, $9bfb730df128d58d$var$_excluded);
    return left.setQueryParameters(rest);
};
// Merge facets
var $9bfb730df128d58d$var$mergeFacets = function mergeFacets(left, right) {
    return right.facets.reduce(function(_, name) {
        return _.addFacet(name);
    }, left);
};
var $9bfb730df128d58d$var$mergeDisjunctiveFacets = function mergeDisjunctiveFacets(left, right) {
    return right.disjunctiveFacets.reduce(function(_, name) {
        return _.addDisjunctiveFacet(name);
    }, left);
};
var $9bfb730df128d58d$var$mergeHierarchicalFacets = function mergeHierarchicalFacets(left, right) {
    return left.setQueryParameters({
        hierarchicalFacets: right.hierarchicalFacets.reduce(function(facets, facet) {
            var index = (0, $5P7n0.findIndex)(facets, function(_) {
                return _.name === facet.name;
            });
            if (index === -1) return facets.concat(facet);
            var nextFacets = facets.slice();
            nextFacets.splice(index, 1, facet);
            return nextFacets;
        }, left.hierarchicalFacets)
    });
};
// Merge facet refinements
var $9bfb730df128d58d$var$mergeTagRefinements = function mergeTagRefinements(left, right) {
    return right.tagRefinements.reduce(function(_, value) {
        return _.addTagRefinement(value);
    }, left);
};
var $9bfb730df128d58d$var$mergeFacetRefinements = function mergeFacetRefinements(left, right) {
    return left.setQueryParameters({
        facetsRefinements: $9bfb730df128d58d$var$_objectSpread($9bfb730df128d58d$var$_objectSpread({}, left.facetsRefinements), right.facetsRefinements)
    });
};
var $9bfb730df128d58d$var$mergeFacetsExcludes = function mergeFacetsExcludes(left, right) {
    return left.setQueryParameters({
        facetsExcludes: $9bfb730df128d58d$var$_objectSpread($9bfb730df128d58d$var$_objectSpread({}, left.facetsExcludes), right.facetsExcludes)
    });
};
var $9bfb730df128d58d$var$mergeDisjunctiveFacetsRefinements = function mergeDisjunctiveFacetsRefinements(left, right) {
    return left.setQueryParameters({
        disjunctiveFacetsRefinements: $9bfb730df128d58d$var$_objectSpread($9bfb730df128d58d$var$_objectSpread({}, left.disjunctiveFacetsRefinements), right.disjunctiveFacetsRefinements)
    });
};
var $9bfb730df128d58d$var$mergeNumericRefinements = function mergeNumericRefinements(left, right) {
    return left.setQueryParameters({
        numericRefinements: $9bfb730df128d58d$var$_objectSpread($9bfb730df128d58d$var$_objectSpread({}, left.numericRefinements), right.numericRefinements)
    });
};
var $9bfb730df128d58d$var$mergeHierarchicalFacetsRefinements = function mergeHierarchicalFacetsRefinements(left, right) {
    return left.setQueryParameters({
        hierarchicalFacetsRefinements: $9bfb730df128d58d$var$_objectSpread($9bfb730df128d58d$var$_objectSpread({}, left.hierarchicalFacetsRefinements), right.hierarchicalFacetsRefinements)
    });
};
var $9bfb730df128d58d$var$mergeRuleContexts = function mergeRuleContexts(left, right) {
    var ruleContexts = (0, $7oPxv.uniq)([].concat(left.ruleContexts).concat(right.ruleContexts).filter(Boolean));
    if (ruleContexts.length > 0) return left.setQueryParameters({
        ruleContexts: ruleContexts
    });
    return left;
};
var $9bfb730df128d58d$export$8049d91f25899769 = function mergeSearchParameters() {
    for(var _len = arguments.length, parameters = new Array(_len), _key = 0; _key < _len; _key++)parameters[_key] = arguments[_key];
    return parameters.reduce(function(left, right) {
        var hierarchicalFacetsRefinementsMerged = $9bfb730df128d58d$var$mergeHierarchicalFacetsRefinements(left, right);
        var hierarchicalFacetsMerged = $9bfb730df128d58d$var$mergeHierarchicalFacets(hierarchicalFacetsRefinementsMerged, right);
        var tagRefinementsMerged = $9bfb730df128d58d$var$mergeTagRefinements(hierarchicalFacetsMerged, right);
        var numericRefinementsMerged = $9bfb730df128d58d$var$mergeNumericRefinements(tagRefinementsMerged, right);
        var disjunctiveFacetsRefinementsMerged = $9bfb730df128d58d$var$mergeDisjunctiveFacetsRefinements(numericRefinementsMerged, right);
        var facetsExcludesMerged = $9bfb730df128d58d$var$mergeFacetsExcludes(disjunctiveFacetsRefinementsMerged, right);
        var facetRefinementsMerged = $9bfb730df128d58d$var$mergeFacetRefinements(facetsExcludesMerged, right);
        var disjunctiveFacetsMerged = $9bfb730df128d58d$var$mergeDisjunctiveFacets(facetRefinementsMerged, right);
        var ruleContextsMerged = $9bfb730df128d58d$var$mergeRuleContexts(disjunctiveFacetsMerged, right);
        var facetsMerged = $9bfb730df128d58d$var$mergeFacets(ruleContextsMerged, right);
        return $9bfb730df128d58d$var$mergeWithRest(facetsMerged, right);
    });
};

});
parcelRegister("5P7n0", function(module, exports) {

$parcel$export(module.exports, "findIndex", () => $43d76eb9a03ab4b8$export$de3a4d4a0d731119);
// We aren't using the native `Array.prototype.findIndex` because the refactor away from Lodash is not
// published as a major version.
// Relying on the `findIndex` polyfill on user-land, which before was only required for niche use-cases,
// was decided as too risky.
// @MAJOR Replace with the native `Array.prototype.findIndex` method
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
function $43d76eb9a03ab4b8$export$de3a4d4a0d731119(array, comparator) {
    if (!Array.isArray(array)) return -1;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return i;
    }
    return -1;
}

});

parcelRegister("7oPxv", function(module, exports) {

$parcel$export(module.exports, "uniq", () => $5632c0f0a9c6e576$export$f70730c3d1fc524e);
function $5632c0f0a9c6e576$export$f70730c3d1fc524e(array) {
    return array.filter(function(value, index, self) {
        return self.indexOf(value) === index;
    });
}

});


parcelRegister("1rijK", function(module, exports) {

$parcel$export(module.exports, "resolveSearchParameters", () => $10c685838ecf7a68$export$1c33c9881dac6797);
function $10c685838ecf7a68$export$1c33c9881dac6797(current) {
    var parent = current.getParent();
    var states = [
        current.getHelper().state
    ];
    while(parent !== null){
        states = [
            parent.getHelper().state
        ].concat(states);
        parent = parent.getParent();
    }
    return states;
}

});

parcelRegister("9Fp4u", function(module, exports) {

$parcel$export(module.exports, "addWidgetId", () => $709b641293d8c0c7$export$50b3ac0e47148c0b);
var $709b641293d8c0c7$var$id = 0;
function $709b641293d8c0c7$export$50b3ac0e47148c0b(widget) {
    if (widget.dependsOn !== "recommend") return;
    widget.$$id = $709b641293d8c0c7$var$id++;
}
function $709b641293d8c0c7$export$13e2e3d76152aecf() {
    $709b641293d8c0c7$var$id = 0;
}

});


parcelRegister("1WQQ9", function(module, exports) {

$parcel$export(module.exports, "default", () => $16b432293965da04$export$2e2bcd8739ae039);

var $gFjXN = parcelRequire("gFjXN");
var $eFtWV = parcelRequire("eFtWV");
var $hLLYk = parcelRequire("hLLYk");
var $5Rcc1 = parcelRequire("5Rcc1");
var $fGOQ9 = parcelRequire("fGOQ9");

var $aiWu2 = parcelRequire("aiWu2");
function $16b432293965da04$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $16b432293965da04$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $16b432293965da04$var$_typeof(obj);
}
function $16b432293965da04$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $16b432293965da04$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $16b432293965da04$var$ownKeys(Object(source), !0).forEach(function(key) {
            $16b432293965da04$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $16b432293965da04$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $16b432293965da04$var$_defineProperty(obj, key, value) {
    key = $16b432293965da04$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $16b432293965da04$var$_toPropertyKey(arg) {
    var key = $16b432293965da04$var$_toPrimitive(arg, "string");
    return $16b432293965da04$var$_typeof(key) === "symbol" ? key : String(key);
}
function $16b432293965da04$var$_toPrimitive(input, hint) {
    if ($16b432293965da04$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($16b432293965da04$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $16b432293965da04$export$2e2bcd8739ae039(_ref) {
    var numberLocale = _ref.numberLocale;
    return {
        formatNumber: function formatNumber(value, render) {
            return (0, $aiWu2.formatNumber)(Number(render(value)), numberLocale);
        },
        highlight: function highlight(options, render) {
            try {
                var highlightOptions = JSON.parse(options);
                return render((0, $gFjXN.default)($16b432293965da04$var$_objectSpread($16b432293965da04$var$_objectSpread({}, highlightOptions), {}, {
                    hit: this
                })));
            } catch (error) {
                throw new Error('\nThe highlight helper expects a JSON object of the format:\n{ "attribute": "name", "highlightedTagName": "mark" }');
            }
        },
        reverseHighlight: function reverseHighlight(options, render) {
            try {
                var reverseHighlightOptions = JSON.parse(options);
                return render((0, $hLLYk.default)($16b432293965da04$var$_objectSpread($16b432293965da04$var$_objectSpread({}, reverseHighlightOptions), {}, {
                    hit: this
                })));
            } catch (error) {
                throw new Error('\n  The reverseHighlight helper expects a JSON object of the format:\n  { "attribute": "name", "highlightedTagName": "mark" }');
            }
        },
        snippet: function snippet(options, render) {
            try {
                var snippetOptions = JSON.parse(options);
                return render((0, $fGOQ9.default)($16b432293965da04$var$_objectSpread($16b432293965da04$var$_objectSpread({}, snippetOptions), {}, {
                    hit: this
                })));
            } catch (error) {
                throw new Error('\nThe snippet helper expects a JSON object of the format:\n{ "attribute": "name", "highlightedTagName": "mark" }');
            }
        },
        reverseSnippet: function reverseSnippet(options, render) {
            try {
                var reverseSnippetOptions = JSON.parse(options);
                return render((0, $5Rcc1.default)($16b432293965da04$var$_objectSpread($16b432293965da04$var$_objectSpread({}, reverseSnippetOptions), {}, {
                    hit: this
                })));
            } catch (error) {
                throw new Error('\n  The reverseSnippet helper expects a JSON object of the format:\n  { "attribute": "name", "highlightedTagName": "mark" }');
            }
        },
        insights: function insights(options, render) {
            try {
                var _JSON$parse = JSON.parse(options), method = _JSON$parse.method, payload = _JSON$parse.payload;
                return render((0, $eFtWV.default)(method, $16b432293965da04$var$_objectSpread({
                    objectIDs: [
                        this.objectID
                    ]
                }, payload)));
            } catch (error) {
                throw new Error('\nThe insights helper expects a JSON object of the format:\n{ "method": "method-name", "payload": { "eventName": "name of the event" } }');
            }
        }
    };
}

});
parcelRegister("aiWu2", function(module, exports) {

$parcel$export(module.exports, "formatNumber", () => $7808f3729e904a8d$export$f5dd818bff069720);
function $7808f3729e904a8d$export$f5dd818bff069720(value, numberLocale) {
    return value.toLocaleString(numberLocale);
}

});


parcelRegister("9cl1f", function(module, exports) {

$parcel$export(module.exports, "defer", () => $6b2589fc765a0f47$export$260e5c0943f31606);
var $6b2589fc765a0f47$var$nextMicroTask = Promise.resolve();
function $6b2589fc765a0f47$export$260e5c0943f31606(callback) {
    var progress = null;
    var cancelled = false;
    var fn = function fn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (progress !== null) return;
        progress = $6b2589fc765a0f47$var$nextMicroTask.then(function() {
            progress = null;
            if (cancelled) {
                cancelled = false;
                return;
            }
            callback.apply(void 0, args);
        });
    };
    fn.wait = function() {
        if (progress === null) throw new Error("The deferred function should be called before calling `wait()`");
        return progress;
    };
    fn.cancel = function() {
        if (progress === null) return;
        cancelled = true;
    };
    return fn;
}

});

parcelRegister("a3Abi", function(module, exports) {

$parcel$export(module.exports, "hydrateRecommendCache", () => $75264001439889a7$export$53ef00b131a96aa6);
function $75264001439889a7$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $75264001439889a7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $75264001439889a7$var$_typeof(obj);
}
function $75264001439889a7$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $75264001439889a7$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $75264001439889a7$var$ownKeys(Object(source), !0).forEach(function(key) {
            $75264001439889a7$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $75264001439889a7$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $75264001439889a7$var$_defineProperty(obj, key, value) {
    key = $75264001439889a7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $75264001439889a7$var$_toPropertyKey(arg) {
    var key = $75264001439889a7$var$_toPrimitive(arg, "string");
    return $75264001439889a7$var$_typeof(key) === "symbol" ? key : String(key);
}
function $75264001439889a7$var$_toPrimitive(input, hint) {
    if ($75264001439889a7$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($75264001439889a7$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $75264001439889a7$export$53ef00b131a96aa6(helper, initialResults) {
    var recommendCache = Object.keys(initialResults).reduce(function(acc, indexName) {
        var initialResult = initialResults[indexName];
        if (initialResult.recommendResults) // @MAJOR: Use `Object.assign` instead of spread operator
        return $75264001439889a7$var$_objectSpread($75264001439889a7$var$_objectSpread({}, acc), initialResult.recommendResults.results);
        return acc;
    }, {});
    helper._recommendCache = recommendCache;
}

});

parcelRegister("6bAnG", function(module, exports) {

$parcel$export(module.exports, "hydrateSearchClient", () => $480ffdacd1d8dee9$export$7edf4eca27ca3a19);
function $480ffdacd1d8dee9$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $480ffdacd1d8dee9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $480ffdacd1d8dee9$var$_typeof(obj);
}
function $480ffdacd1d8dee9$var$_slicedToArray(arr, i) {
    return $480ffdacd1d8dee9$var$_arrayWithHoles(arr) || $480ffdacd1d8dee9$var$_iterableToArrayLimit(arr, i) || $480ffdacd1d8dee9$var$_unsupportedIterableToArray(arr, i) || $480ffdacd1d8dee9$var$_nonIterableRest();
}
function $480ffdacd1d8dee9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $480ffdacd1d8dee9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $480ffdacd1d8dee9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $480ffdacd1d8dee9$var$_arrayLikeToArray(o, minLen);
}
function $480ffdacd1d8dee9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $480ffdacd1d8dee9$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $480ffdacd1d8dee9$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $480ffdacd1d8dee9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $480ffdacd1d8dee9$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $480ffdacd1d8dee9$var$ownKeys(Object(source), !0).forEach(function(key) {
            $480ffdacd1d8dee9$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $480ffdacd1d8dee9$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $480ffdacd1d8dee9$var$_defineProperty(obj, key, value) {
    key = $480ffdacd1d8dee9$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $480ffdacd1d8dee9$var$_toPropertyKey(arg) {
    var key = $480ffdacd1d8dee9$var$_toPrimitive(arg, "string");
    return $480ffdacd1d8dee9$var$_typeof(key) === "symbol" ? key : String(key);
}
function $480ffdacd1d8dee9$var$_toPrimitive(input, hint) {
    if ($480ffdacd1d8dee9$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($480ffdacd1d8dee9$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $480ffdacd1d8dee9$export$7edf4eca27ca3a19(client, results) {
    if (!results) return;
    // Disable cache hydration on:
    // - Algoliasearch API Client < v4 with cache disabled
    // - Third party clients (detected by the `addAlgoliaAgent` function missing)
    if ((!("transporter" in client) || client._cacheHydrated) && (!client._useCache || typeof client.addAlgoliaAgent !== "function")) return;
    var cachedRequest = [
        Object.keys(results).reduce(function(acc, key) {
            var _results$key = results[key], state = _results$key.state, requestParams = _results$key.requestParams, serverResults = _results$key.results;
            var mappedResults = serverResults && state ? serverResults.map(function(result, idx) {
                return $480ffdacd1d8dee9$var$_objectSpread({
                    indexName: state.index || result.index
                }, requestParams !== null && requestParams !== void 0 && requestParams[idx] || result.params ? {
                    params: $480ffdacd1d8dee9$var$serializeQueryParameters((requestParams === null || requestParams === void 0 ? void 0 : requestParams[idx]) || $480ffdacd1d8dee9$var$deserializeQueryParameters(result.params))
                } : {});
            }) : [];
            return acc.concat(mappedResults);
        }, [])
    ];
    var cachedResults = Object.keys(results).reduce(function(acc, key) {
        var res = results[key].results;
        if (!res) return acc;
        return acc.concat(res);
    }, []);
    // Algoliasearch API Client >= v4
    // To hydrate the client we need to populate the cache with the data from
    // the server (done in `hydrateSearchClientWithMultiIndexRequest` or
    // `hydrateSearchClientWithSingleIndexRequest`). But since there is no way
    // for us to compute the key the same way as `algoliasearch-client` we need
    // to populate it on a custom key and override the `search` method to
    // search on it first.
    if ("transporter" in client && !client._cacheHydrated) {
        client._cacheHydrated = true;
        var baseMethod = client.search.bind(client);
        // @ts-ignore wanting type checks for v3 on this would make this too complex
        client.search = function(requests) {
            for(var _len = arguments.length, methodArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)methodArgs[_key - 1] = arguments[_key];
            var requestsWithSerializedParams = requests.map(function(request) {
                return $480ffdacd1d8dee9$var$_objectSpread($480ffdacd1d8dee9$var$_objectSpread({}, request), {}, {
                    params: $480ffdacd1d8dee9$var$serializeQueryParameters(request.params)
                });
            });
            return client.transporter.responsesCache.get({
                method: "search",
                args: [
                    requestsWithSerializedParams
                ].concat(methodArgs)
            }, function() {
                return baseMethod.apply(void 0, [
                    requests
                ].concat(methodArgs));
            });
        };
        client.transporter.responsesCache.set({
            method: "search",
            args: cachedRequest
        }, {
            results: cachedResults
        });
    }
    // Algoliasearch API Client < v4
    // Prior to client v4 we didn't have a proper API to hydrate the client
    // cache from the outside. The following code populates the cache with
    // a single-index result. You can find more information about the
    // computation of the key inside the client (see link below).
    // https://github.com/algolia/algoliasearch-client-javascript/blob/c27e89ff92b2a854ae6f40dc524bffe0f0cbc169/src/AlgoliaSearchCore.js#L232-L240
    if (!("transporter" in client)) {
        var cacheKey = "/1/indexes/*/queries_body_".concat(JSON.stringify({
            requests: cachedRequest
        }));
        client.cache = $480ffdacd1d8dee9$var$_objectSpread($480ffdacd1d8dee9$var$_objectSpread({}, client.cache), {}, $480ffdacd1d8dee9$var$_defineProperty({}, cacheKey, JSON.stringify({
            results: Object.keys(results).map(function(key) {
                return results[key].results;
            })
        })));
    }
}
function $480ffdacd1d8dee9$var$deserializeQueryParameters(parameters) {
    return parameters.split("&").reduce(function(acc, parameter) {
        var _parameter$split = parameter.split("="), _parameter$split2 = $480ffdacd1d8dee9$var$_slicedToArray(_parameter$split, 2), key = _parameter$split2[0], value = _parameter$split2[1];
        acc[key] = value ? decodeURIComponent(value) : "";
        return acc;
    }, {});
}
// This function is copied from the algoliasearch v4 API Client. If modified,
// consider updating it also in `serializeQueryParameters` from `@algolia/transporter`.
function $480ffdacd1d8dee9$var$serializeQueryParameters(parameters) {
    var isObjectOrArray = function isObjectOrArray(value) {
        return Object.prototype.toString.call(value) === "[object Object]" || Object.prototype.toString.call(value) === "[object Array]";
    };
    var encode = function encode(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        var i = 0;
        return format.replace(/%s/g, function() {
            return encodeURIComponent(args[i++]);
        });
    };
    return Object.keys(parameters).map(function(key) {
        return encode("%s=%s", key, isObjectOrArray(parameters[key]) ? JSON.stringify(parameters[key]) : parameters[key]);
    }).join("&");
}

});

parcelRegister("aD5BU", function(module, exports) {

$parcel$export(module.exports, "setIndexHelperState", () => $7bd1e60596b942f4$export$fd5e8f1329b3d5e0);


var $h47Cl = parcelRequire("h47Cl");
function $7bd1e60596b942f4$export$fd5e8f1329b3d5e0(finalUiState, indexWidget) {
    var nextIndexUiState = finalUiState[indexWidget.getIndexId()] || {};
    indexWidget.getHelper().setState(indexWidget.getWidgetSearchParameters(indexWidget.getHelper().state, {
        uiState: nextIndexUiState
    }));
    indexWidget.getWidgets().filter((0, $h47Cl.isIndexWidget)).forEach(function(widget) {
        return $7bd1e60596b942f4$export$fd5e8f1329b3d5e0(finalUiState, widget);
    });
}

});

parcelRegister("5vcx9", function(module, exports) {

$parcel$export(module.exports, "default", () => $401991f4915caca9$export$2e2bcd8739ae039);
var $401991f4915caca9$export$2e2bcd8739ae039 = "4.74.2";

});


parcelRegister("9KSsO", function(module, exports) {

$parcel$export(module.exports, "deprecate", () => $01d5344343bfadb9$export$b680e6b2c82f8c2f);

var $iNPz2 = parcelRequire("iNPz2");
/**
 * Logs a warning when this function is called, in development environment only.
 */ var $01d5344343bfadb9$export$b680e6b2c82f8c2f = function deprecate(fn, message) {
    return fn;
};
/**
 * Logs a warning
 * This is used to log issues in development environment only.
 */ var $01d5344343bfadb9$export$c106dd0671a0fc2d = (0, $iNPz2.noop);
/**
 * Logs a warning if the condition is not met.
 * This is used to log issues in development environment only.
 */ var $01d5344343bfadb9$export$491112666e282270 = (0, $iNPz2.noop);

});


parcelRegister("2TWNj", function(module, exports) {

$parcel$export(module.exports, "checkRendering", () => $21ce532af88f27d3$export$adc2a8e09aa583ee);

var $j3DNf = parcelRequire("j3DNf");
function $21ce532af88f27d3$export$adc2a8e09aa583ee(rendering, usage) {
    if (rendering === undefined || typeof rendering !== "function") throw new Error("The render function is not valid (received type ".concat((0, $j3DNf.getObjectType)(rendering), ").\n\n").concat(usage));
}

});
parcelRegister("j3DNf", function(module, exports) {

$parcel$export(module.exports, "getObjectType", () => $ddfd2a3c5d851d32$export$11cc42aebef2ef3a);
function $ddfd2a3c5d851d32$export$11cc42aebef2ef3a(object) {
    return Object.prototype.toString.call(object).slice(8, -1);
}

});


parcelRegister("6N6DO", function(module, exports) {

$parcel$export(module.exports, "createSendEventForFacet", () => $4f1c7875ce9af800$export$75bfa3473d01f29f);

var $f7bia = parcelRequire("f7bia");
function $4f1c7875ce9af800$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4f1c7875ce9af800$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $4f1c7875ce9af800$var$ownKeys(Object(source), !0).forEach(function(key) {
            $4f1c7875ce9af800$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $4f1c7875ce9af800$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4f1c7875ce9af800$var$_defineProperty(obj, key, value) {
    key = $4f1c7875ce9af800$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4f1c7875ce9af800$var$_toPropertyKey(arg) {
    var key = $4f1c7875ce9af800$var$_toPrimitive(arg, "string");
    return $4f1c7875ce9af800$var$_typeof(key) === "symbol" ? key : String(key);
}
function $4f1c7875ce9af800$var$_toPrimitive(input, hint) {
    if ($4f1c7875ce9af800$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($4f1c7875ce9af800$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $4f1c7875ce9af800$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $4f1c7875ce9af800$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $4f1c7875ce9af800$var$_typeof(obj);
}
function $4f1c7875ce9af800$var$_slicedToArray(arr, i) {
    return $4f1c7875ce9af800$var$_arrayWithHoles(arr) || $4f1c7875ce9af800$var$_iterableToArrayLimit(arr, i) || $4f1c7875ce9af800$var$_unsupportedIterableToArray(arr, i) || $4f1c7875ce9af800$var$_nonIterableRest();
}
function $4f1c7875ce9af800$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4f1c7875ce9af800$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4f1c7875ce9af800$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4f1c7875ce9af800$var$_arrayLikeToArray(o, minLen);
}
function $4f1c7875ce9af800$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $4f1c7875ce9af800$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $4f1c7875ce9af800$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $4f1c7875ce9af800$export$75bfa3473d01f29f(_ref) {
    var instantSearchInstance = _ref.instantSearchInstance, helper = _ref.helper, attr = _ref.attribute, widgetType = _ref.widgetType;
    var sendEventForFacet = function sendEventForFacet() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var facetValue = args[1], _args$ = args[2], eventName = _args$ === void 0 ? "Filter Applied" : _args$, _args$2 = args[3], additionalData = _args$2 === void 0 ? {} : _args$2;
        var _args$0$split = args[0].split(":"), _args$0$split2 = $4f1c7875ce9af800$var$_slicedToArray(_args$0$split, 2), eventType = _args$0$split2[0], eventModifier = _args$0$split2[1];
        var attribute = typeof attr === "string" ? attr : attr(facetValue);
        if (args.length === 1 && $4f1c7875ce9af800$var$_typeof(args[0]) === "object") instantSearchInstance.sendEventToInsights(args[0]);
        else if (eventType === "click" && args.length >= 2 && args.length <= 4) {
            if (!(0, $f7bia.isFacetRefined)(helper, attribute, facetValue)) // send event only when the facet is being checked "ON"
            instantSearchInstance.sendEventToInsights({
                insightsMethod: "clickedFilters",
                widgetType: widgetType,
                eventType: eventType,
                eventModifier: eventModifier,
                payload: $4f1c7875ce9af800$var$_objectSpread({
                    eventName: eventName,
                    index: helper.getIndex(),
                    filters: [
                        "".concat(attribute, ":").concat(facetValue)
                    ]
                }, additionalData),
                attribute: attribute
            });
        }
    };
    return sendEventForFacet;
}

});
parcelRegister("f7bia", function(module, exports) {

$parcel$export(module.exports, "isFacetRefined", () => $b01044cc5321f418$export$12368a7050a31bdd);
function $b01044cc5321f418$export$12368a7050a31bdd(helper, facet, value) {
    if (helper.state.isHierarchicalFacet(facet)) return helper.state.isHierarchicalFacetRefined(facet, value);
    else if (helper.state.isConjunctiveFacet(facet)) return helper.state.isFacetRefined(facet, value);
    else return helper.state.isDisjunctiveFacetRefined(facet, value);
}

});


parcelRegister("aqOVV", function(module, exports) {

$parcel$export(module.exports, "default", () => $7983d75c6bdf897f$export$2e2bcd8739ae039);

var $iQB5y = parcelRequire("iQB5y");

var $1Hdcz = parcelRequire("1Hdcz");

var $5XIV4 = parcelRequire("5XIV4");

var $BvxtV = parcelRequire("BvxtV");

var $ipedu = parcelRequire("ipedu");

var $7OG5t = parcelRequire("7OG5t");

var $del55 = parcelRequire("del55");
var $6lpSe = parcelRequire("6lpSe");

var $3L2Wj = parcelRequire("3L2Wj");
function $7983d75c6bdf897f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $7983d75c6bdf897f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $7983d75c6bdf897f$var$_typeof(obj);
}
function $7983d75c6bdf897f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7983d75c6bdf897f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $7983d75c6bdf897f$var$ownKeys(Object(source), !0).forEach(function(key) {
            $7983d75c6bdf897f$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $7983d75c6bdf897f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7983d75c6bdf897f$var$_defineProperty(obj, key, value) {
    key = $7983d75c6bdf897f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7983d75c6bdf897f$var$_toPropertyKey(arg) {
    var key = $7983d75c6bdf897f$var$_toPrimitive(arg, "string");
    return $7983d75c6bdf897f$var$_typeof(key) === "symbol" ? key : String(key);
}
function $7983d75c6bdf897f$var$_toPrimitive(input, hint) {
    if ($7983d75c6bdf897f$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($7983d75c6bdf897f$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $7983d75c6bdf897f$var$withUsage = (0, $del55.createDocumentationMessageGenerator)({
    name: "clear-refinements"
});
var $7983d75c6bdf897f$var$suit = (0, $ipedu.component)("ClearRefinements");
var $7983d75c6bdf897f$var$renderer = function renderer(_ref) {
    var containerNode = _ref.containerNode, cssClasses = _ref.cssClasses, renderState = _ref.renderState, templates = _ref.templates;
    return function(_ref2, isFirstRendering) {
        var refine = _ref2.refine, canRefine = _ref2.canRefine, instantSearchInstance = _ref2.instantSearchInstance;
        if (isFirstRendering) {
            renderState.templateProps = (0, $7OG5t.prepareTemplateProps)({
                defaultTemplates: (0, $3L2Wj.default),
                templatesConfig: instantSearchInstance.templatesConfig,
                templates: templates
            });
            return;
        }
        (0, $1Hdcz.render)((0, $1Hdcz.h)((0, $5XIV4.default), {
            refine: refine,
            cssClasses: cssClasses,
            hasRefinements: canRefine,
            templateProps: renderState.templateProps
        }), containerNode);
    };
};
var $7983d75c6bdf897f$var$clearRefinements = function clearRefinements(widgetParams) {
    var _ref3 = widgetParams || {}, container = _ref3.container, _ref3$templates = _ref3.templates, templates = _ref3$templates === void 0 ? {} : _ref3$templates, includedAttributes = _ref3.includedAttributes, excludedAttributes = _ref3.excludedAttributes, transformItems = _ref3.transformItems, _ref3$cssClasses = _ref3.cssClasses, userCssClasses = _ref3$cssClasses === void 0 ? {} : _ref3$cssClasses;
    if (!container) throw new Error($7983d75c6bdf897f$var$withUsage("The `container` option is required."));
    var containerNode = (0, $6lpSe.getContainerNode)(container);
    var cssClasses = {
        root: (0, $iQB5y.cx)($7983d75c6bdf897f$var$suit(), userCssClasses.root),
        button: (0, $iQB5y.cx)($7983d75c6bdf897f$var$suit({
            descendantName: "button"
        }), userCssClasses.button),
        disabledButton: (0, $iQB5y.cx)($7983d75c6bdf897f$var$suit({
            descendantName: "button",
            modifierName: "disabled"
        }), userCssClasses.disabledButton)
    };
    var specializedRenderer = $7983d75c6bdf897f$var$renderer({
        containerNode: containerNode,
        cssClasses: cssClasses,
        renderState: {},
        templates: templates
    });
    var makeWidget = (0, $BvxtV.default)(specializedRenderer, function() {
        return (0, $1Hdcz.render)(null, containerNode);
    });
    return $7983d75c6bdf897f$var$_objectSpread($7983d75c6bdf897f$var$_objectSpread({}, makeWidget({
        includedAttributes: includedAttributes,
        excludedAttributes: excludedAttributes,
        transformItems: transformItems
    })), {}, {
        $$widgetType: "ais.clearRefinements"
    });
};
var $7983d75c6bdf897f$export$2e2bcd8739ae039 = $7983d75c6bdf897f$var$clearRefinements;

});
parcelRegister("iQB5y", function(module, exports) {

$parcel$export(module.exports, "cx", () => $db89da5e675c74f8$export$a274e22fb40f762e);
function $db89da5e675c74f8$export$a274e22fb40f762e() {
    for(var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++)classNames[_key] = arguments[_key];
    return classNames.reduce(function(acc, className) {
        if (Array.isArray(className)) return acc.concat(className);
        return acc.concat([
            className
        ]);
    }, []).filter(Boolean).join(" ");
}

});

parcelRegister("1Hdcz", function(module, exports) {

$parcel$export(module.exports, "createElement", () => $13c40c34b78c8ee2$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "createRef", () => $13c40c34b78c8ee2$export$7d1e3a5e95ceca43);
$parcel$export(module.exports, "Fragment", () => $13c40c34b78c8ee2$export$ffb0004e005737fa);
$parcel$export(module.exports, "Component", () => $13c40c34b78c8ee2$export$16fa2f45be04daa8);
$parcel$export(module.exports, "render", () => $13c40c34b78c8ee2$export$b3890eb0ae9dca99);
$parcel$export(module.exports, "h", () => $13c40c34b78c8ee2$export$c8a8987d4410bf2d);
var $13c40c34b78c8ee2$var$n, $13c40c34b78c8ee2$export$41c562ebe57d11e2, $13c40c34b78c8ee2$var$u, $13c40c34b78c8ee2$export$a8257692ac88316c, $13c40c34b78c8ee2$var$i, $13c40c34b78c8ee2$var$o, $13c40c34b78c8ee2$var$r, $13c40c34b78c8ee2$var$f, $13c40c34b78c8ee2$var$e, $13c40c34b78c8ee2$var$c, $13c40c34b78c8ee2$var$s, $13c40c34b78c8ee2$var$a, $13c40c34b78c8ee2$var$h = {}, $13c40c34b78c8ee2$var$v = [], $13c40c34b78c8ee2$var$p = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $13c40c34b78c8ee2$var$y = Array.isArray;
function $13c40c34b78c8ee2$var$d(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $13c40c34b78c8ee2$var$w(n) {
    n && n.parentNode && n.parentNode.removeChild(n);
}
function $13c40c34b78c8ee2$export$c8a8987d4410bf2d(l, u, t) {
    var i, o, r, f = {};
    for(r in u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $13c40c34b78c8ee2$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(r in l.defaultProps)void 0 === f[r] && (f[r] = l.defaultProps[r]);
    return $13c40c34b78c8ee2$var$g(l, f, i, o, null);
}
function $13c40c34b78c8ee2$var$g(n, t, i, o, r) {
    var f = {
        type: n,
        props: t,
        key: i,
        ref: o,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        constructor: void 0,
        __v: null == r ? ++$13c40c34b78c8ee2$var$u : r,
        __i: -1,
        __u: 0
    };
    return null == r && null != $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode && $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode(f), f;
}
function $13c40c34b78c8ee2$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $13c40c34b78c8ee2$export$ffb0004e005737fa(n) {
    return n.children;
}
function $13c40c34b78c8ee2$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $13c40c34b78c8ee2$var$x(n, l) {
    if (null == l) return n.__ ? $13c40c34b78c8ee2$var$x(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $13c40c34b78c8ee2$var$x(n) : null;
}
function $13c40c34b78c8ee2$var$C(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $13c40c34b78c8ee2$var$C(n);
    }
}
function $13c40c34b78c8ee2$var$M(n) {
    (!n.__d && (n.__d = !0) && $13c40c34b78c8ee2$var$i.push(n) && !$13c40c34b78c8ee2$var$P.__r++ || $13c40c34b78c8ee2$var$o !== $13c40c34b78c8ee2$export$41c562ebe57d11e2.debounceRendering) && (($13c40c34b78c8ee2$var$o = $13c40c34b78c8ee2$export$41c562ebe57d11e2.debounceRendering) || $13c40c34b78c8ee2$var$r)($13c40c34b78c8ee2$var$P);
}
function $13c40c34b78c8ee2$var$P() {
    var n, u, t, o, r, e, c, s;
    for($13c40c34b78c8ee2$var$i.sort($13c40c34b78c8ee2$var$f); n = $13c40c34b78c8ee2$var$i.shift();)n.__d && (u = $13c40c34b78c8ee2$var$i.length, o = void 0, e = (r = (t = n).__v).__e, c = [], s = [], t.__P && ((o = $13c40c34b78c8ee2$var$d({}, r)).__v = r.__v + 1, $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode && $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode(o), $13c40c34b78c8ee2$var$O(t.__P, o, r, t.__n, t.__P.namespaceURI, 32 & r.__u ? [
        e
    ] : null, c, null == e ? $13c40c34b78c8ee2$var$x(r) : e, !!(32 & r.__u), s), o.__v = r.__v, o.__.__k[o.__i] = o, $13c40c34b78c8ee2$var$j(c, o, s), o.__e != e && $13c40c34b78c8ee2$var$C(o)), $13c40c34b78c8ee2$var$i.length > u && $13c40c34b78c8ee2$var$i.sort($13c40c34b78c8ee2$var$f));
    $13c40c34b78c8ee2$var$P.__r = 0;
}
function $13c40c34b78c8ee2$var$S(n, l, u, t, i, o, r, f, e, c, s) {
    var a, p, y, d, w, _ = t && t.__k || $13c40c34b78c8ee2$var$v, g = l.length;
    for(u.__d = e, $13c40c34b78c8ee2$var$$(u, l, _), e = u.__d, a = 0; a < g; a++)null != (y = u.__k[a]) && (p = -1 === y.__i ? $13c40c34b78c8ee2$var$h : _[y.__i] || $13c40c34b78c8ee2$var$h, y.__i = a, $13c40c34b78c8ee2$var$O(n, y, p, i, o, r, f, e, c, s), d = y.__e, y.ref && p.ref != y.ref && (p.ref && $13c40c34b78c8ee2$var$N(p.ref, null, y), s.push(y.ref, y.__c || d, y)), null == w && null != d && (w = d), 65536 & y.__u || p.__k === y.__k ? e = $13c40c34b78c8ee2$var$I(y, e, n) : "function" == typeof y.type && void 0 !== y.__d ? e = y.__d : d && (e = d.nextSibling), y.__d = void 0, y.__u &= -196609);
    u.__d = e, u.__e = w;
}
function $13c40c34b78c8ee2$var$$(n, l, u) {
    var t, i, o, r, f, e = l.length, c = u.length, s = c, a = 0;
    for(n.__k = [], t = 0; t < e; t++)null != (i = l[t]) && "boolean" != typeof i && "function" != typeof i ? (r = t + a, (i = n.__k[t] = "string" == typeof i || "number" == typeof i || "bigint" == typeof i || i.constructor == String ? $13c40c34b78c8ee2$var$g(null, i, null, null, null) : $13c40c34b78c8ee2$var$y(i) ? $13c40c34b78c8ee2$var$g($13c40c34b78c8ee2$export$ffb0004e005737fa, {
        children: i
    }, null, null, null) : void 0 === i.constructor && i.__b > 0 ? $13c40c34b78c8ee2$var$g(i.type, i.props, i.key, i.ref ? i.ref : null, i.__v) : i).__ = n, i.__b = n.__b + 1, o = null, -1 !== (f = i.__i = $13c40c34b78c8ee2$var$L(i, u, r, s)) && (s--, (o = u[f]) && (o.__u |= 131072)), null == o || null === o.__v ? (-1 == f && a--, "function" != typeof i.type && (i.__u |= 65536)) : f !== r && (f == r - 1 ? a-- : f == r + 1 ? a++ : (f > r ? a-- : a++, i.__u |= 65536))) : i = n.__k[t] = null;
    if (s) for(t = 0; t < c; t++)null != (o = u[t]) && 0 == (131072 & o.__u) && (o.__e == n.__d && (n.__d = $13c40c34b78c8ee2$var$x(o)), $13c40c34b78c8ee2$var$V(o, o));
}
function $13c40c34b78c8ee2$var$I(n, l, u) {
    var t, i;
    if ("function" == typeof n.type) {
        for(t = n.__k, i = 0; t && i < t.length; i++)t[i] && (t[i].__ = n, l = $13c40c34b78c8ee2$var$I(t[i], l, u));
        return l;
    }
    n.__e != l && (l && n.type && !u.contains(l) && (l = $13c40c34b78c8ee2$var$x(n)), u.insertBefore(n.__e, l || null), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 === l.nodeType);
    return l;
}
function $13c40c34b78c8ee2$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($13c40c34b78c8ee2$var$y(n) ? n.some(function(n) {
        $13c40c34b78c8ee2$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $13c40c34b78c8ee2$var$L(n, l, u, t) {
    var i = n.key, o = n.type, r = u - 1, f = u + 1, e = l[u];
    if (null === e || e && i == e.key && o === e.type && 0 == (131072 & e.__u)) return u;
    if (t > (null != e && 0 == (131072 & e.__u) ? 1 : 0)) for(; r >= 0 || f < l.length;){
        if (r >= 0) {
            if ((e = l[r]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return r;
            r--;
        }
        if (f < l.length) {
            if ((e = l[f]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return f;
            f++;
        }
    }
    return -1;
}
function $13c40c34b78c8ee2$var$T(n, l, u) {
    "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $13c40c34b78c8ee2$var$p.test(l) ? u : u + "px";
}
function $13c40c34b78c8ee2$var$A(n, l, u, t, i) {
    var o;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $13c40c34b78c8ee2$var$T(n.style, l, "");
            if (u) for(l in u)t && u[l] === t[l] || $13c40c34b78c8ee2$var$T(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/(PointerCapture)$|Capture$/i, "$1")), l = l.toLowerCase() in n || "onFocusOut" === l || "onFocusIn" === l ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? t ? u.u = t.u : (u.u = $13c40c34b78c8ee2$var$e, n.addEventListener(l, o ? $13c40c34b78c8ee2$var$s : $13c40c34b78c8ee2$var$c, o)) : n.removeEventListener(l, o ? $13c40c34b78c8ee2$var$s : $13c40c34b78c8ee2$var$c, o);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" !== l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == u ? "" : u));
    }
}
function $13c40c34b78c8ee2$var$F(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u.t) u.t = $13c40c34b78c8ee2$var$e++;
            else if (u.t < t.u) return;
            return t($13c40c34b78c8ee2$export$41c562ebe57d11e2.event ? $13c40c34b78c8ee2$export$41c562ebe57d11e2.event(u) : u);
        }
    };
}
function $13c40c34b78c8ee2$var$O(n, u, t, i, o, r, f, e, c, s) {
    var a, h, v, p, w, _, g, m, x, C, M, P, $, I, H, L, T = u.type;
    if (void 0 !== u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), r = [
        e = u.__e = t.__e
    ]), (a = $13c40c34b78c8ee2$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof T) try {
        if (m = u.props, x = "prototype" in T && T.prototype.render, C = (a = T.contextType) && i[a.__c], M = a ? C ? C.props.value : a.__ : i, t.__c ? g = (h = u.__c = t.__c).__ = h.__E : (x ? u.__c = h = new T(m, M) : (u.__c = h = new $13c40c34b78c8ee2$export$16fa2f45be04daa8(m, M), h.constructor = T, h.render = $13c40c34b78c8ee2$var$q), C && C.sub(h), h.props = m, h.state || (h.state = {}), h.context = M, h.__n = i, v = h.__d = !0, h.__h = [], h._sb = []), x && null == h.__s && (h.__s = h.state), x && null != T.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $13c40c34b78c8ee2$var$d({}, h.__s)), $13c40c34b78c8ee2$var$d(h.__s, T.getDerivedStateFromProps(m, h.__s))), p = h.props, w = h.state, h.__v = u, v) x && null == T.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), x && null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (x && null == T.getDerivedStateFromProps && m !== p && null != h.componentWillReceiveProps && h.componentWillReceiveProps(m, M), !h.__e && (null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(m, h.__s, M) || u.__v === t.__v)) {
                for(u.__v !== t.__v && (h.props = m, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.some(function(n) {
                    n && (n.__ = u);
                }), P = 0; P < h._sb.length; P++)h.__h.push(h._sb[P]);
                h._sb = [], h.__h.length && f.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(m, h.__s, M), x && null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(p, w, _);
            });
        }
        if (h.context = M, h.props = m, h.__P = n, h.__e = !1, $ = $13c40c34b78c8ee2$export$41c562ebe57d11e2.__r, I = 0, x) {
            for(h.state = h.__s, h.__d = !1, $ && $(u), a = h.render(h.props, h.state, h.context), H = 0; H < h._sb.length; H++)h.__h.push(h._sb[H]);
            h._sb = [];
        } else do h.__d = !1, $ && $(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++I < 25);
        h.state = h.__s, null != h.getChildContext && (i = $13c40c34b78c8ee2$var$d($13c40c34b78c8ee2$var$d({}, i), h.getChildContext())), x && !v && null != h.getSnapshotBeforeUpdate && (_ = h.getSnapshotBeforeUpdate(p, w)), $13c40c34b78c8ee2$var$S(n, $13c40c34b78c8ee2$var$y(L = null != a && a.type === $13c40c34b78c8ee2$export$ffb0004e005737fa && null == a.key ? a.props.children : a) ? L : [
            L
        ], u, t, i, o, r, f, e, c, s), h.base = u.__e, u.__u &= -161, h.__h.length && f.push(h), g && (h.__E = h.__ = null);
    } catch (n) {
        if (u.__v = null, c || null != r) {
            for(u.__u |= c ? 160 : 32; e && 8 === e.nodeType && e.nextSibling;)e = e.nextSibling;
            r[r.indexOf(e)] = null, u.__e = e;
        } else u.__e = t.__e, u.__k = t.__k;
        $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == r && u.__v === t.__v ? (u.__k = t.__k, u.__e = t.__e) : u.__e = $13c40c34b78c8ee2$var$z(t.__e, u, t, i, o, r, f, c, s);
    (a = $13c40c34b78c8ee2$export$41c562ebe57d11e2.diffed) && a(u);
}
function $13c40c34b78c8ee2$var$j(n, u, t) {
    u.__d = void 0;
    for(var i = 0; i < t.length; i++)$13c40c34b78c8ee2$var$N(t[i], t[++i], t[++i]);
    $13c40c34b78c8ee2$export$41c562ebe57d11e2.__c && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $13c40c34b78c8ee2$var$z(u, t, i, o, r, f, e, c, s) {
    var a, v, p, d, _, g, m, b = i.props, k = t.props, C = t.type;
    if ("svg" === C ? r = "http://www.w3.org/2000/svg" : "math" === C ? r = "http://www.w3.org/1998/Math/MathML" : r || (r = "http://www.w3.org/1999/xhtml"), null != f) {
        for(a = 0; a < f.length; a++)if ((_ = f[a]) && "setAttribute" in _ == !!C && (C ? _.localName === C : 3 === _.nodeType)) {
            u = _, f[a] = null;
            break;
        }
    }
    if (null == u) {
        if (null === C) return document.createTextNode(k);
        u = document.createElementNS(r, C, k.is && k), c && ($13c40c34b78c8ee2$export$41c562ebe57d11e2.__m && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__m(t, f), c = !1), f = null;
    }
    if (null === C) b === k || c && u.data === k || (u.data = k);
    else {
        if (f = f && $13c40c34b78c8ee2$var$n.call(u.childNodes), b = i.props || $13c40c34b78c8ee2$var$h, !c && null != f) for(b = {}, a = 0; a < u.attributes.length; a++)b[(_ = u.attributes[a]).name] = _.value;
        for(a in b)if (_ = b[a], "children" == a) ;
        else if ("dangerouslySetInnerHTML" == a) p = _;
        else if (!(a in k)) {
            if ("value" == a && "defaultValue" in k || "checked" == a && "defaultChecked" in k) continue;
            $13c40c34b78c8ee2$var$A(u, a, null, _, r);
        }
        for(a in k)_ = k[a], "children" == a ? d = _ : "dangerouslySetInnerHTML" == a ? v = _ : "value" == a ? g = _ : "checked" == a ? m = _ : c && "function" != typeof _ || b[a] === _ || $13c40c34b78c8ee2$var$A(u, a, _, b[a], r);
        if (v) c || p && (v.__html === p.__html || v.__html === u.innerHTML) || (u.innerHTML = v.__html), t.__k = [];
        else if (p && (u.innerHTML = ""), $13c40c34b78c8ee2$var$S(u, $13c40c34b78c8ee2$var$y(d) ? d : [
            d
        ], t, i, o, "foreignObject" === C ? "http://www.w3.org/1999/xhtml" : r, f, e, f ? f[0] : i.__k && $13c40c34b78c8ee2$var$x(i, 0), c, s), null != f) for(a = f.length; a--;)$13c40c34b78c8ee2$var$w(f[a]);
        c || (a = "value", "progress" === C && null == g ? u.removeAttribute("value") : void 0 !== g && (g !== u[a] || "progress" === C && !g || "option" === C && g !== b[a]) && $13c40c34b78c8ee2$var$A(u, a, g, b[a], r), a = "checked", void 0 !== m && m !== u[a] && $13c40c34b78c8ee2$var$A(u, a, m, b[a], r));
    }
    return u;
}
function $13c40c34b78c8ee2$var$N(n, u, t) {
    try {
        if ("function" == typeof n) {
            var i = "function" == typeof n.__u;
            i && n.__u(), i && null == u || (n.__u = n(u));
        } else n.current = u;
    } catch (n) {
        $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $13c40c34b78c8ee2$var$V(n, u, t) {
    var i, o;
    if ($13c40c34b78c8ee2$export$41c562ebe57d11e2.unmount && $13c40c34b78c8ee2$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current !== n.__e || $13c40c34b78c8ee2$var$N(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(o = 0; o < i.length; o++)i[o] && $13c40c34b78c8ee2$var$V(i[o], u, t || "function" != typeof n.type);
    t || $13c40c34b78c8ee2$var$w(n.__e), n.__c = n.__ = n.__e = n.__d = void 0;
}
function $13c40c34b78c8ee2$var$q(n, l, u) {
    return this.constructor(n, u);
}
function $13c40c34b78c8ee2$export$b3890eb0ae9dca99(u, t, i) {
    var o, r, f, e;
    $13c40c34b78c8ee2$export$41c562ebe57d11e2.__ && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__(u, t), r = (o = "function" == typeof i) ? null : i && i.__k || t.__k, f = [], e = [], $13c40c34b78c8ee2$var$O(t, u = (!o && i || t).__k = $13c40c34b78c8ee2$export$c8a8987d4410bf2d($13c40c34b78c8ee2$export$ffb0004e005737fa, null, [
        u
    ]), r || $13c40c34b78c8ee2$var$h, $13c40c34b78c8ee2$var$h, t.namespaceURI, !o && i ? [
        i
    ] : r ? null : t.firstChild ? $13c40c34b78c8ee2$var$n.call(t.childNodes) : null, f, !o && i ? i : r ? r.__e : t.firstChild, o, e), $13c40c34b78c8ee2$var$j(f, u, e);
}
function $13c40c34b78c8ee2$export$fa8d919ba61d84db(n, l) {
    $13c40c34b78c8ee2$export$b3890eb0ae9dca99(n, l, $13c40c34b78c8ee2$export$fa8d919ba61d84db);
}
function $13c40c34b78c8ee2$export$e530037191fcd5d7(l, u, t) {
    var i, o, r, f, e = $13c40c34b78c8ee2$var$d({}, l.props);
    for(r in l.type && l.type.defaultProps && (f = l.type.defaultProps), u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : e[r] = void 0 === u[r] && void 0 !== f ? f[r] : u[r];
    return arguments.length > 2 && (e.children = arguments.length > 3 ? $13c40c34b78c8ee2$var$n.call(arguments, 2) : t), $13c40c34b78c8ee2$var$g(l.type, e, i || l.key, o || l.ref, null);
}
function $13c40c34b78c8ee2$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $13c40c34b78c8ee2$var$a++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, t;
            return this.getChildContext || (u = [], (t = {})[l] = this, this.getChildContext = function() {
                return t;
            }, this.componentWillUnmount = function() {
                u = null;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some(function(n) {
                    n.__e = !0, $13c40c34b78c8ee2$var$M(n);
                });
            }, this.sub = function(n) {
                u.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u && u.splice(u.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$13c40c34b78c8ee2$var$n = $13c40c34b78c8ee2$var$v.slice, $13c40c34b78c8ee2$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, o, r; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((o = i.constructor) && null != o.getDerivedStateFromError && (i.setState(o.getDerivedStateFromError(n)), r = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), r = i.__d), r) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $13c40c34b78c8ee2$var$u = 0, $13c40c34b78c8ee2$export$a8257692ac88316c = function(n) {
    return null != n && null == n.constructor;
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $13c40c34b78c8ee2$var$d({}, this.state), "function" == typeof n && (n = n($13c40c34b78c8ee2$var$d({}, u), this.props)), n && $13c40c34b78c8ee2$var$d(u, n), null != n && this.__v && (l && this._sb.push(l), $13c40c34b78c8ee2$var$M(this));
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $13c40c34b78c8ee2$var$M(this));
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.render = $13c40c34b78c8ee2$export$ffb0004e005737fa, $13c40c34b78c8ee2$var$i = [], $13c40c34b78c8ee2$var$r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $13c40c34b78c8ee2$var$f = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $13c40c34b78c8ee2$var$P.__r = 0, $13c40c34b78c8ee2$var$e = 0, $13c40c34b78c8ee2$var$c = $13c40c34b78c8ee2$var$F(!1), $13c40c34b78c8ee2$var$s = $13c40c34b78c8ee2$var$F(!0), $13c40c34b78c8ee2$var$a = 0;

});

parcelRegister("5XIV4", function(module, exports) {

$parcel$export(module.exports, "default", () => $45754e89f8b2dcf3$export$2e2bcd8739ae039);

var $iQB5y = parcelRequire("iQB5y");

var $1Hdcz = parcelRequire("1Hdcz");

var $b7YL7 = parcelRequire("b7YL7");
function $45754e89f8b2dcf3$var$_extends() {
    $45754e89f8b2dcf3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $45754e89f8b2dcf3$var$_extends.apply(this, arguments);
}
var $45754e89f8b2dcf3$var$ClearRefinements = function ClearRefinements(_ref) {
    var hasRefinements = _ref.hasRefinements, refine = _ref.refine, cssClasses = _ref.cssClasses, templateProps = _ref.templateProps;
    return (0, $1Hdcz.h)("div", {
        className: cssClasses.root
    }, (0, $1Hdcz.h)((0, $b7YL7.default), $45754e89f8b2dcf3$var$_extends({}, templateProps, {
        templateKey: "resetLabel",
        rootTagName: "button",
        rootProps: {
            className: (0, $iQB5y.cx)(cssClasses.button, !hasRefinements && cssClasses.disabledButton),
            onClick: refine,
            disabled: !hasRefinements
        },
        data: {
            hasRefinements: hasRefinements
        }
    })));
};
var $45754e89f8b2dcf3$export$2e2bcd8739ae039 = $45754e89f8b2dcf3$var$ClearRefinements;

});
parcelRegister("b7YL7", function(module, exports) {

$parcel$export(module.exports, "default", () => $819f7aa05bbfba7e$export$2e2bcd8739ae039);

var $1Hdcz = parcelRequire("1Hdcz");

var $20TSt = parcelRequire("20TSt");

var $hHEcB = parcelRequire("hHEcB");
function $819f7aa05bbfba7e$var$_extends() {
    $819f7aa05bbfba7e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $819f7aa05bbfba7e$var$_extends.apply(this, arguments);
}
function $819f7aa05bbfba7e$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $819f7aa05bbfba7e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $819f7aa05bbfba7e$var$_typeof(obj);
}
function $819f7aa05bbfba7e$var$_toConsumableArray(arr) {
    return $819f7aa05bbfba7e$var$_arrayWithoutHoles(arr) || $819f7aa05bbfba7e$var$_iterableToArray(arr) || $819f7aa05bbfba7e$var$_unsupportedIterableToArray(arr) || $819f7aa05bbfba7e$var$_nonIterableSpread();
}
function $819f7aa05bbfba7e$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $819f7aa05bbfba7e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $819f7aa05bbfba7e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $819f7aa05bbfba7e$var$_arrayLikeToArray(o, minLen);
}
function $819f7aa05bbfba7e$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $819f7aa05bbfba7e$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $819f7aa05bbfba7e$var$_arrayLikeToArray(arr);
}
function $819f7aa05bbfba7e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $819f7aa05bbfba7e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $819f7aa05bbfba7e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $819f7aa05bbfba7e$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $819f7aa05bbfba7e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $819f7aa05bbfba7e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $819f7aa05bbfba7e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $819f7aa05bbfba7e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $819f7aa05bbfba7e$var$_setPrototypeOf(subClass, superClass);
}
function $819f7aa05bbfba7e$var$_setPrototypeOf(o, p) {
    $819f7aa05bbfba7e$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $819f7aa05bbfba7e$var$_setPrototypeOf(o, p);
}
function $819f7aa05bbfba7e$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $819f7aa05bbfba7e$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $819f7aa05bbfba7e$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $819f7aa05bbfba7e$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $819f7aa05bbfba7e$var$_possibleConstructorReturn(this, result);
    };
}
function $819f7aa05bbfba7e$var$_possibleConstructorReturn(self, call) {
    if (call && ($819f7aa05bbfba7e$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $819f7aa05bbfba7e$var$_assertThisInitialized(self);
}
function $819f7aa05bbfba7e$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $819f7aa05bbfba7e$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $819f7aa05bbfba7e$var$_getPrototypeOf(o) {
    $819f7aa05bbfba7e$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $819f7aa05bbfba7e$var$_getPrototypeOf(o);
}
function $819f7aa05bbfba7e$var$_defineProperty(obj, key, value) {
    key = $819f7aa05bbfba7e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $819f7aa05bbfba7e$var$_toPropertyKey(arg) {
    var key = $819f7aa05bbfba7e$var$_toPrimitive(arg, "string");
    return $819f7aa05bbfba7e$var$_typeof(key) === "symbol" ? key : String(key);
}
function $819f7aa05bbfba7e$var$_toPrimitive(input, hint) {
    if ($819f7aa05bbfba7e$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($819f7aa05bbfba7e$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $819f7aa05bbfba7e$var$RawHtml = /*#__PURE__*/ function(_Component) {
    $819f7aa05bbfba7e$var$_inherits(RawHtml, _Component);
    var _super = $819f7aa05bbfba7e$var$_createSuper(RawHtml);
    function RawHtml() {
        var _this;
        $819f7aa05bbfba7e$var$_classCallCheck(this, RawHtml);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $819f7aa05bbfba7e$var$_defineProperty($819f7aa05bbfba7e$var$_assertThisInitialized(_this), "ref", (0, $1Hdcz.createRef)());
        $819f7aa05bbfba7e$var$_defineProperty($819f7aa05bbfba7e$var$_assertThisInitialized(_this), "nodes", []);
        return _this;
    }
    $819f7aa05bbfba7e$var$_createClass(RawHtml, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var fragment = new DocumentFragment();
                var root = document.createElement("div");
                root.innerHTML = this.props.content;
                this.nodes = $819f7aa05bbfba7e$var$_toConsumableArray(root.childNodes);
                this.nodes.forEach(function(node) {
                    return fragment.appendChild(node);
                });
                this.ref.current.replaceWith(fragment);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.nodes.forEach(function(node) {
                    if (node instanceof Element) {
                        node.outerHTML = "";
                        return;
                    }
                    node.nodeValue = "";
                });
                // if there is one TextNode first and one TextNode last, the
                // last one's nodeValue will be assigned to the first.
                if (this.nodes[0].nodeValue) this.nodes[0].nodeValue = "";
            }
        },
        {
            key: "render",
            value: function render() {
                return (0, $1Hdcz.h)("div", {
                    ref: this.ref
                });
            }
        }
    ]);
    return RawHtml;
}((0, $1Hdcz.Component));
var $819f7aa05bbfba7e$var$defaultProps = {
    data: {},
    rootTagName: "div",
    useCustomCompileOptions: {},
    templates: {},
    templatesConfig: {}
};
// @TODO: Template should be a generic and receive TData to pass to Templates (to avoid TTemplateData to be set as `any`)
var $819f7aa05bbfba7e$var$Template = /*#__PURE__*/ function(_Component2) {
    $819f7aa05bbfba7e$var$_inherits(Template, _Component2);
    var _super2 = $819f7aa05bbfba7e$var$_createSuper(Template);
    function Template() {
        $819f7aa05bbfba7e$var$_classCallCheck(this, Template);
        return _super2.apply(this, arguments);
    }
    $819f7aa05bbfba7e$var$_createClass(Template, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                return !(0, $hHEcB.isEqual)(this.props.data, nextProps.data) || this.props.templateKey !== nextProps.templateKey || !(0, $hHEcB.isEqual)(this.props.rootProps, nextProps.rootProps);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var nonFunctionTemplates;
                var RootTagName = this.props.rootTagName === "fragment" ? (0, $1Hdcz.Fragment) : this.props.rootTagName;
                var useCustomCompileOptions = this.props.useCustomCompileOptions[this.props.templateKey];
                var compileOptions = useCustomCompileOptions ? this.props.templatesConfig.compileOptions : {};
                var content = (0, $20TSt.renderTemplate)({
                    templates: this.props.templates,
                    templateKey: this.props.templateKey,
                    compileOptions: compileOptions,
                    helpers: this.props.templatesConfig.helpers,
                    data: this.props.data,
                    bindEvent: this.props.bindEvent,
                    sendEvent: this.props.sendEvent
                });
                if (content === null) // Adds a noscript to the DOM but virtual DOM is null
                // See http://facebook.github.io/react/docs/component-specs.html#render
                return null;
                if ($819f7aa05bbfba7e$var$_typeof(content) === "object") return (0, $1Hdcz.h)(RootTagName, this.props.rootProps, content);
                // This is to handle Hogan templates with Fragment as rootTagName
                if (RootTagName === (0, $1Hdcz.Fragment)) return (0, $1Hdcz.h)($819f7aa05bbfba7e$var$RawHtml, {
                    content: content,
                    key: Math.random()
                });
                return (0, $1Hdcz.h)(RootTagName, $819f7aa05bbfba7e$var$_extends({}, this.props.rootProps, {
                    dangerouslySetInnerHTML: {
                        __html: content
                    }
                }));
            }
        }
    ]);
    return Template;
}((0, $1Hdcz.Component));
$819f7aa05bbfba7e$var$_defineProperty($819f7aa05bbfba7e$var$Template, "defaultProps", $819f7aa05bbfba7e$var$defaultProps);
var $819f7aa05bbfba7e$export$2e2bcd8739ae039 = $819f7aa05bbfba7e$var$Template;

});
parcelRegister("20TSt", function(module, exports) {

$parcel$export(module.exports, "renderTemplate", () => $1776ecf81ec92751$export$b5c363744c17aeab);

var $b6SEl = parcelRequire("b6SEl");

var $81LIe = parcelRequire("81LIe");

var $c6ZJp = parcelRequire("c6ZJp");
var $28CUM = parcelRequire("28CUM");
var $2207q = parcelRequire("2207q");
var $VTgUm = parcelRequire("VTgUm");
function $1776ecf81ec92751$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $1776ecf81ec92751$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $1776ecf81ec92751$var$_typeof(obj);
}
function $1776ecf81ec92751$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1776ecf81ec92751$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $1776ecf81ec92751$var$ownKeys(Object(source), !0).forEach(function(key) {
            $1776ecf81ec92751$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $1776ecf81ec92751$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1776ecf81ec92751$var$_defineProperty(obj, key, value) {
    key = $1776ecf81ec92751$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1776ecf81ec92751$var$_toPropertyKey(arg) {
    var key = $1776ecf81ec92751$var$_toPrimitive(arg, "string");
    return $1776ecf81ec92751$var$_typeof(key) === "symbol" ? key : String(key);
}
function $1776ecf81ec92751$var$_toPrimitive(input, hint) {
    if ($1776ecf81ec92751$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($1776ecf81ec92751$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
// We add all our template helper methods to the template as lambdas. Note
// that lambdas in Mustache are supposed to accept a second argument of
// `render` to get the rendered value, not the literal `{{value}}`. But
// this is currently broken (see https://github.com/twitter/hogan.js/issues/222).
function $1776ecf81ec92751$var$transformHelpersToHogan() {
    var helpers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var compileOptions = arguments.length > 1 ? arguments[1] : undefined;
    var data = arguments.length > 2 ? arguments[2] : undefined;
    return Object.keys(helpers).reduce(function(acc, helperKey) {
        return $1776ecf81ec92751$var$_objectSpread($1776ecf81ec92751$var$_objectSpread({}, acc), {}, $1776ecf81ec92751$var$_defineProperty({}, helperKey, function() {
            var _this = this;
            return function(text) {
                var render = function render(value) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($b6SEl))).compile(value, compileOptions).render(_this);
                };
                return helpers[helperKey].call(data, text, render);
            };
        }));
    }, {});
}
function $1776ecf81ec92751$export$b5c363744c17aeab(_ref) {
    var templates = _ref.templates, templateKey = _ref.templateKey, compileOptions = _ref.compileOptions, helpers = _ref.helpers, data = _ref.data, bindEvent = _ref.bindEvent, sendEvent = _ref.sendEvent;
    var template = templates[templateKey];
    if (typeof template !== "string" && typeof template !== "function") throw new Error("Template must be 'string' or 'function', was '".concat($1776ecf81ec92751$var$_typeof(template), "' (key: ").concat(templateKey, ")"));
    if (typeof template === "function") {
        // @MAJOR no longer pass bindEvent when string templates are removed
        var params = bindEvent || {};
        params.html = (0, $81LIe.html);
        params.sendEvent = sendEvent;
        params.components = {
            Highlight: (0, $c6ZJp.Highlight),
            ReverseHighlight: (0, $28CUM.ReverseHighlight),
            Snippet: (0, $VTgUm.Snippet),
            ReverseSnippet: (0, $2207q.ReverseSnippet)
        };
        // @MAJOR remove the `as any` when string templates are removed
        // needed because not every template receives sendEvent
        return template(data, params);
    }
    var transformedHelpers = $1776ecf81ec92751$var$transformHelpersToHogan(helpers, compileOptions, data);
    return (0, (/*@__PURE__*/$parcel$interopDefault($b6SEl))).compile(template, compileOptions).render($1776ecf81ec92751$var$_objectSpread($1776ecf81ec92751$var$_objectSpread({}, data), {}, {
        helpers: transformedHelpers
    })).replace(/[ \n\r\t\f\xA0]+/g, function(spaces) {
        return spaces.replace(/(^|\xA0+)[^\xA0]+/g, "$1 ");
    }).trim();
}

});
parcelRegister("b6SEl", function(module, exports) {
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */ // This file is for use with Node.js. See dist/ for browser files.

var $g2q0E = parcelRequire("g2q0E");

$g2q0E.Template = (parcelRequire("kBwwM")).Template;
$g2q0E.template = $g2q0E.Template;
module.exports = $g2q0E;

});
parcelRegister("g2q0E", function(module, exports) {
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */ (function(Hogan) {
    // Setup regex  assignments
    // remove whitespace according to Mustache spec
    var rIsWhitespace = /\S/, rQuot = /\"/g, rNewline = /\n/g, rCr = /\r/g, rSlash = /\\/g, rLineSep = /\u2028/, rParagraphSep = /\u2029/;
    Hogan.tags = {
        "#": 1,
        "^": 2,
        "<": 3,
        "$": 4,
        "/": 5,
        "!": 6,
        ">": 7,
        "=": 8,
        "_v": 9,
        "{": 10,
        "&": 11,
        "_t": 12
    };
    Hogan.scan = function scan(text, delimiters) {
        var len = text.length, IN_TEXT = 0, IN_TAG_TYPE = 1, IN_TAG = 2, state = IN_TEXT, tagType = null, tag = null, buf = "", tokens = [], seenTag = false, i = 0, lineStart = 0, otag = "{{", ctag = "}}";
        function addBuf() {
            if (buf.length > 0) {
                tokens.push({
                    tag: "_t",
                    text: new String(buf)
                });
                buf = "";
            }
        }
        function lineIsWhitespace() {
            var isAllWhitespace = true;
            for(var j = lineStart; j < tokens.length; j++){
                isAllWhitespace = Hogan.tags[tokens[j].tag] < Hogan.tags["_v"] || tokens[j].tag == "_t" && tokens[j].text.match(rIsWhitespace) === null;
                if (!isAllWhitespace) return false;
            }
            return isAllWhitespace;
        }
        function filterLine(haveSeenTag, noNewLine) {
            addBuf();
            if (haveSeenTag && lineIsWhitespace()) {
                for(var j = lineStart, next; j < tokens.length; j++)if (tokens[j].text) {
                    if ((next = tokens[j + 1]) && next.tag == ">") // set indent to token value
                    next.indent = tokens[j].text.toString();
                    tokens.splice(j, 1);
                }
            } else if (!noNewLine) tokens.push({
                tag: "\n"
            });
            seenTag = false;
            lineStart = tokens.length;
        }
        function changeDelimiters(text, index) {
            var close = "=" + ctag, closeIndex = text.indexOf(close, index), delimiters = trim(text.substring(text.indexOf("=", index) + 1, closeIndex)).split(" ");
            otag = delimiters[0];
            ctag = delimiters[delimiters.length - 1];
            return closeIndex + close.length - 1;
        }
        if (delimiters) {
            delimiters = delimiters.split(" ");
            otag = delimiters[0];
            ctag = delimiters[1];
        }
        for(i = 0; i < len; i++){
            if (state == IN_TEXT) {
                if (tagChange(otag, text, i)) {
                    --i;
                    addBuf();
                    state = IN_TAG_TYPE;
                } else if (text.charAt(i) == "\n") filterLine(seenTag);
                else buf += text.charAt(i);
            } else if (state == IN_TAG_TYPE) {
                i += otag.length - 1;
                tag = Hogan.tags[text.charAt(i + 1)];
                tagType = tag ? text.charAt(i + 1) : "_v";
                if (tagType == "=") {
                    i = changeDelimiters(text, i);
                    state = IN_TEXT;
                } else {
                    if (tag) i++;
                    state = IN_TAG;
                }
                seenTag = i;
            } else if (tagChange(ctag, text, i)) {
                tokens.push({
                    tag: tagType,
                    n: trim(buf),
                    otag: otag,
                    ctag: ctag,
                    i: tagType == "/" ? seenTag - otag.length : i + ctag.length
                });
                buf = "";
                i += ctag.length - 1;
                state = IN_TEXT;
                if (tagType == "{") {
                    if (ctag == "}}") i++;
                    else cleanTripleStache(tokens[tokens.length - 1]);
                }
            } else buf += text.charAt(i);
        }
        filterLine(seenTag, true);
        return tokens;
    };
    function cleanTripleStache(token) {
        if (token.n.substr(token.n.length - 1) === "}") token.n = token.n.substring(0, token.n.length - 1);
    }
    function trim(s) {
        if (s.trim) return s.trim();
        return s.replace(/^\s*|\s*$/g, "");
    }
    function tagChange(tag, text, index) {
        if (text.charAt(index) != tag.charAt(0)) return false;
        for(var i = 1, l = tag.length; i < l; i++){
            if (text.charAt(index + i) != tag.charAt(i)) return false;
        }
        return true;
    }
    // the tags allowed inside super templates
    var allowedInSuper = {
        "_t": true,
        "\n": true,
        "$": true,
        "/": true
    };
    function buildTree(tokens, kind, stack, customTags) {
        var instructions = [], opener = null, tail = null, token = null;
        tail = stack[stack.length - 1];
        while(tokens.length > 0){
            token = tokens.shift();
            if (tail && tail.tag == "<" && !(token.tag in allowedInSuper)) throw new Error("Illegal content in < super tag.");
            if (Hogan.tags[token.tag] <= Hogan.tags["$"] || isOpener(token, customTags)) {
                stack.push(token);
                token.nodes = buildTree(tokens, token.tag, stack, customTags);
            } else if (token.tag == "/") {
                if (stack.length === 0) throw new Error("Closing tag without opener: /" + token.n);
                opener = stack.pop();
                if (token.n != opener.n && !isCloser(token.n, opener.n, customTags)) throw new Error("Nesting error: " + opener.n + " vs. " + token.n);
                opener.end = token.i;
                return instructions;
            } else if (token.tag == "\n") token.last = tokens.length == 0 || tokens[0].tag == "\n";
            instructions.push(token);
        }
        if (stack.length > 0) throw new Error("missing closing tag: " + stack.pop().n);
        return instructions;
    }
    function isOpener(token, tags) {
        for(var i = 0, l = tags.length; i < l; i++)if (tags[i].o == token.n) {
            token.tag = "#";
            return true;
        }
    }
    function isCloser(close, open, tags) {
        for(var i = 0, l = tags.length; i < l; i++){
            if (tags[i].c == close && tags[i].o == open) return true;
        }
    }
    function stringifySubstitutions(obj) {
        var items = [];
        for(var key in obj)items.push('"' + esc(key) + '": function(c,p,t,i) {' + obj[key] + "}");
        return "{ " + items.join(",") + " }";
    }
    function stringifyPartials(codeObj) {
        var partials = [];
        for(var key in codeObj.partials)partials.push('"' + esc(key) + '":{name:"' + esc(codeObj.partials[key].name) + '", ' + stringifyPartials(codeObj.partials[key]) + "}");
        return "partials: {" + partials.join(",") + "}, subs: " + stringifySubstitutions(codeObj.subs);
    }
    Hogan.stringify = function(codeObj, text, options) {
        return "{code: function (c,p,i) { " + Hogan.wrapMain(codeObj.code) + " }," + stringifyPartials(codeObj) + "}";
    };
    var serialNo = 0;
    Hogan.generate = function(tree, text, options) {
        serialNo = 0;
        var context = {
            code: "",
            subs: {},
            partials: {}
        };
        Hogan.walk(tree, context);
        if (options.asString) return this.stringify(context, text, options);
        return this.makeTemplate(context, text, options);
    };
    Hogan.wrapMain = function(code) {
        return 'var t=this;t.b(i=i||"");' + code + "return t.fl();";
    };
    Hogan.template = Hogan.Template;
    Hogan.makeTemplate = function(codeObj, text, options) {
        var template = this.makePartials(codeObj);
        template.code = new Function("c", "p", "i", this.wrapMain(codeObj.code));
        return new this.template(template, text, this, options);
    };
    Hogan.makePartials = function(codeObj) {
        var key, template = {
            subs: {},
            partials: codeObj.partials,
            name: codeObj.name
        };
        for(key in template.partials)template.partials[key] = this.makePartials(template.partials[key]);
        for(key in codeObj.subs)template.subs[key] = new Function("c", "p", "t", "i", codeObj.subs[key]);
        return template;
    };
    function esc(s) {
        return s.replace(rSlash, "\\\\").replace(rQuot, '\\"').replace(rNewline, "\\n").replace(rCr, "\\r").replace(rLineSep, "\\u2028").replace(rParagraphSep, "\\u2029");
    }
    function chooseMethod(s) {
        return ~s.indexOf(".") ? "d" : "f";
    }
    function createPartial(node, context) {
        var prefix = "<" + (context.prefix || "");
        var sym = prefix + node.n + serialNo++;
        context.partials[sym] = {
            name: node.n,
            partials: {}
        };
        context.code += 't.b(t.rp("' + esc(sym) + '",c,p,"' + (node.indent || "") + '"));';
        return sym;
    }
    Hogan.codegen = {
        "#": function(node, context) {
            context.code += "if(t.s(t." + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),' + "c,p,0," + node.i + "," + node.end + ',"' + node.otag + " " + node.ctag + '")){' + "t.rs(c,p," + "function(c,p,t){";
            Hogan.walk(node.nodes, context);
            context.code += "});c.pop();}";
        },
        "^": function(node, context) {
            context.code += "if(!t.s(t." + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,1),c,p,1,0,0,"")){';
            Hogan.walk(node.nodes, context);
            context.code += "};";
        },
        ">": createPartial,
        "<": function(node, context) {
            var ctx = {
                partials: {},
                code: "",
                subs: {},
                inPartial: true
            };
            Hogan.walk(node.nodes, ctx);
            var template = context.partials[createPartial(node, context)];
            template.subs = ctx.subs;
            template.partials = ctx.partials;
        },
        "$": function(node, context) {
            var ctx = {
                subs: {},
                code: "",
                partials: context.partials,
                prefix: node.n
            };
            Hogan.walk(node.nodes, ctx);
            context.subs[node.n] = ctx.code;
            if (!context.inPartial) context.code += 't.sub("' + esc(node.n) + '",c,p,i);';
        },
        "\n": function(node, context) {
            context.code += write('"\\n"' + (node.last ? "" : " + i"));
        },
        "_v": function(node, context) {
            context.code += "t.b(t.v(t." + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
        },
        "_t": function(node, context) {
            context.code += write('"' + esc(node.text) + '"');
        },
        "{": tripleStache,
        "&": tripleStache
    };
    function tripleStache(node, context) {
        context.code += "t.b(t.t(t." + chooseMethod(node.n) + '("' + esc(node.n) + '",c,p,0)));';
    }
    function write(s) {
        return "t.b(" + s + ");";
    }
    Hogan.walk = function(nodelist, context) {
        var func;
        for(var i = 0, l = nodelist.length; i < l; i++){
            func = Hogan.codegen[nodelist[i].tag];
            func && func(nodelist[i], context);
        }
        return context;
    };
    Hogan.parse = function(tokens, text, options) {
        options = options || {};
        return buildTree(tokens, "", [], options.sectionTags || []);
    };
    Hogan.cache = {};
    Hogan.cacheKey = function(text, options) {
        return [
            text,
            !!options.asString,
            !!options.disableLambda,
            options.delimiters,
            !!options.modelGet
        ].join("||");
    };
    Hogan.compile = function(text, options) {
        options = options || {};
        var key = Hogan.cacheKey(text, options);
        var template = this.cache[key];
        if (template) {
            var partials = template.partials;
            for(var name in partials)delete partials[name].instance;
            return template;
        }
        template = this.generate(this.parse(this.scan(text, options.delimiters), text, options), text, options);
        return this.cache[key] = template;
    };
})(module.exports);

});

parcelRegister("kBwwM", function(module, exports) {
/*
 *  Copyright 2011 Twitter, Inc.
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *  http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 */ var $f0007eb20c8c2e20$var$Hogan = {};
(function(Hogan) {
    Hogan.Template = function(codeObj, text, compiler, options) {
        codeObj = codeObj || {};
        this.r = codeObj.code || this.r;
        this.c = compiler;
        this.options = options || {};
        this.text = text || "";
        this.partials = codeObj.partials || {};
        this.subs = codeObj.subs || {};
        this.buf = "";
    };
    Hogan.Template.prototype = {
        // render: replaced by generated code.
        r: function(context, partials, indent) {
            return "";
        },
        // variable escaping
        v: hoganEscape,
        // triple stache
        t: coerceToString,
        render: function render(context, partials, indent) {
            return this.ri([
                context
            ], partials || {}, indent);
        },
        // render internal -- a hook for overrides that catches partials too
        ri: function(context, partials, indent) {
            return this.r(context, partials, indent);
        },
        // ensurePartial
        ep: function(symbol, partials) {
            var partial = this.partials[symbol];
            // check to see that if we've instantiated this partial before
            var template = partials[partial.name];
            if (partial.instance && partial.base == template) return partial.instance;
            if (typeof template == "string") {
                if (!this.c) throw new Error("No compiler available.");
                template = this.c.compile(template, this.options);
            }
            if (!template) return null;
            // We use this to check whether the partials dictionary has changed
            this.partials[symbol].base = template;
            if (partial.subs) {
                // Make sure we consider parent template now
                if (!partials.stackText) partials.stackText = {};
                for(key in partial.subs)if (!partials.stackText[key]) partials.stackText[key] = this.activeSub !== undefined && partials.stackText[this.activeSub] ? partials.stackText[this.activeSub] : this.text;
                template = createSpecializedPartial(template, partial.subs, partial.partials, this.stackSubs, this.stackPartials, partials.stackText);
            }
            this.partials[symbol].instance = template;
            return template;
        },
        // tries to find a partial in the current scope and render it
        rp: function(symbol, context, partials, indent) {
            var partial = this.ep(symbol, partials);
            if (!partial) return "";
            return partial.ri(context, partials, indent);
        },
        // render a section
        rs: function(context, partials, section) {
            var tail = context[context.length - 1];
            if (!isArray(tail)) {
                section(context, partials, this);
                return;
            }
            for(var i = 0; i < tail.length; i++){
                context.push(tail[i]);
                section(context, partials, this);
                context.pop();
            }
        },
        // maybe start a section
        s: function(val, ctx, partials, inverted, start, end, tags) {
            var pass;
            if (isArray(val) && val.length === 0) return false;
            if (typeof val == "function") val = this.ms(val, ctx, partials, inverted, start, end, tags);
            pass = !!val;
            if (!inverted && pass && ctx) ctx.push(typeof val == "object" ? val : ctx[ctx.length - 1]);
            return pass;
        },
        // find values with dotted names
        d: function(key1, ctx, partials, returnFound) {
            var found, names = key1.split("."), val = this.f(names[0], ctx, partials, returnFound), doModelGet = this.options.modelGet, cx = null;
            if (key1 === "." && isArray(ctx[ctx.length - 2])) val = ctx[ctx.length - 1];
            else for(var i = 1; i < names.length; i++){
                found = findInScope(names[i], val, doModelGet);
                if (found !== undefined) {
                    cx = val;
                    val = found;
                } else val = "";
            }
            if (returnFound && !val) return false;
            if (!returnFound && typeof val == "function") {
                ctx.push(cx);
                val = this.mv(val, ctx, partials);
                ctx.pop();
            }
            return val;
        },
        // find values with normal names
        f: function(key1, ctx, partials, returnFound) {
            var val = false, v = null, found = false, doModelGet = this.options.modelGet;
            for(var i = ctx.length - 1; i >= 0; i--){
                v = ctx[i];
                val = findInScope(key1, v, doModelGet);
                if (val !== undefined) {
                    found = true;
                    break;
                }
            }
            if (!found) return returnFound ? false : "";
            if (!returnFound && typeof val == "function") val = this.mv(val, ctx, partials);
            return val;
        },
        // higher order templates
        ls: function(func, cx, partials, text, tags) {
            var oldTags = this.options.delimiters;
            this.options.delimiters = tags;
            this.b(this.ct(coerceToString(func.call(cx, text)), cx, partials));
            this.options.delimiters = oldTags;
            return false;
        },
        // compile text
        ct: function(text, cx, partials) {
            if (this.options.disableLambda) throw new Error("Lambda features disabled.");
            return this.c.compile(text, this.options).render(cx, partials);
        },
        // template result buffering
        b: function(s) {
            this.buf += s;
        },
        fl: function() {
            var r = this.buf;
            this.buf = "";
            return r;
        },
        // method replace section
        ms: function(func, ctx, partials, inverted, start, end, tags) {
            var textSource, cx = ctx[ctx.length - 1], result = func.call(cx);
            if (typeof result == "function") {
                if (inverted) return true;
                else {
                    textSource = this.activeSub && this.subsText && this.subsText[this.activeSub] ? this.subsText[this.activeSub] : this.text;
                    return this.ls(result, cx, partials, textSource.substring(start, end), tags);
                }
            }
            return result;
        },
        // method replace variable
        mv: function(func, ctx, partials) {
            var cx = ctx[ctx.length - 1];
            var result = func.call(cx);
            if (typeof result == "function") return this.ct(coerceToString(result.call(cx)), cx, partials);
            return result;
        },
        sub: function(name, context, partials, indent) {
            var f = this.subs[name];
            if (f) {
                this.activeSub = name;
                f(context, partials, this, indent);
                this.activeSub = false;
            }
        }
    };
    //Find a key in an object
    function findInScope(key1, scope, doModelGet) {
        var val;
        if (scope && typeof scope == "object") {
            if (scope[key1] !== undefined) val = scope[key1];
            else if (doModelGet && scope.get && typeof scope.get == "function") val = scope.get(key1);
        }
        return val;
    }
    function createSpecializedPartial(instance, subs, partials, stackSubs, stackPartials, stackText) {
        function PartialTemplate() {}
        PartialTemplate.prototype = instance;
        function Substitutions() {}
        Substitutions.prototype = instance.subs;
        var key1;
        var partial = new PartialTemplate();
        partial.subs = new Substitutions();
        partial.subsText = {}; //hehe. substext.
        partial.buf = "";
        stackSubs = stackSubs || {};
        partial.stackSubs = stackSubs;
        partial.subsText = stackText;
        for(key1 in subs)if (!stackSubs[key1]) stackSubs[key1] = subs[key1];
        for(key1 in stackSubs)partial.subs[key1] = stackSubs[key1];
        stackPartials = stackPartials || {};
        partial.stackPartials = stackPartials;
        for(key1 in partials)if (!stackPartials[key1]) stackPartials[key1] = partials[key1];
        for(key1 in stackPartials)partial.partials[key1] = stackPartials[key1];
        return partial;
    }
    var rAmp = /&/g, rLt = /</g, rGt = />/g, rApos = /\'/g, rQuot = /\"/g, hChars = /[&<>\"\']/;
    function coerceToString(val) {
        return String(val === null || val === undefined ? "" : val);
    }
    function hoganEscape(str) {
        str = coerceToString(str);
        return hChars.test(str) ? str.replace(rAmp, "&amp;").replace(rLt, "&lt;").replace(rGt, "&gt;").replace(rApos, "&#39;").replace(rQuot, "&quot;") : str;
    }
    var isArray = Array.isArray || function(a) {
        return Object.prototype.toString.call(a) === "[object Array]";
    };
})(module.exports);

});


parcelRegister("81LIe", function(module, exports) {

$parcel$export(module.exports, "html", () => $5d836d6e65da64f6$export$c0bb0b647f701bb5);

var $1Hdcz = parcelRequire("1Hdcz");

var $65v1b = parcelRequire("65v1b");
var $5d836d6e65da64f6$export$c0bb0b647f701bb5 = (0, $65v1b.default).bind((0, $1Hdcz.h));

});
parcelRegister("65v1b", function(module, exports) {

$parcel$export(module.exports, "default", () => $46eb45435212d36d$export$2e2bcd8739ae039);
var $46eb45435212d36d$var$n = function(t, s, r, e) {
    var u;
    s[0] = 0;
    for(var h = 1; h < s.length; h++){
        var p = s[h++], a = s[h] ? (s[0] |= p ? 1 : 2, r[s[h++]]) : s[++h];
        3 === p ? e[0] = a : 4 === p ? e[1] = Object.assign(e[1] || {}, a) : 5 === p ? (e[1] = e[1] || {})[s[++h]] = a : 6 === p ? e[1][s[++h]] += a + "" : p ? (u = t.apply(a, $46eb45435212d36d$var$n(t, a, r, [
            "",
            null
        ])), e.push(u), a[0] ? s[0] |= 2 : (s[h - 2] = 0, s[h] = u)) : e.push(a);
    }
    return e;
}, $46eb45435212d36d$var$t = new Map;
function $46eb45435212d36d$export$2e2bcd8739ae039(s) {
    var r = $46eb45435212d36d$var$t.get(this);
    return r || (r = new Map, $46eb45435212d36d$var$t.set(this, r)), (r = $46eb45435212d36d$var$n(this, r.get(s) || (r.set(s, r = function(n) {
        for(var t, s, r = 1, e = "", u = "", h = [
            0
        ], p = function(n) {
            1 === r && (n || (e = e.replace(/^\s*\n\s*|\s*\n\s*$/g, ""))) ? h.push(0, n, e) : 3 === r && (n || e) ? (h.push(3, n, e), r = 2) : 2 === r && "..." === e && n ? h.push(4, n, 0) : 2 === r && e && !n ? h.push(5, 0, !0, e) : r >= 5 && ((e || !n && 5 === r) && (h.push(r, 0, e, s), r = 6), n && (h.push(r, n, 0, s), r = 6)), e = "";
        }, a = 0; a < n.length; a++){
            a && (1 === r && p(), p(a));
            for(var l = 0; l < n[a].length; l++)t = n[a][l], 1 === r ? "<" === t ? (p(), h = [
                h
            ], r = 3) : e += t : 4 === r ? "--" === e && ">" === t ? (r = 1, e = "") : e = t + e[0] : u ? t === u ? u = "" : e += t : '"' === t || "'" === t ? u = t : ">" === t ? (p(), r = 1) : r && ("=" === t ? (r = 5, s = e, e = "") : "/" === t && (r < 5 || ">" === n[a][l + 1]) ? (p(), 3 === r && (h = h[0]), r = h, (h = h[0]).push(2, 0, r), r = 0) : " " === t || "	" === t || "\n" === t || "\r" === t ? (p(), r = 2) : e += t), 3 === r && "!--" === e && (r = 4, h = h[0]);
        }
        return p(), h;
    }(s)), r), arguments, [])).length > 1 ? r : r[0];
}

});


parcelRegister("c6ZJp", function(module, exports) {

$parcel$export(module.exports, "Highlight", () => $8d15ee28eaadcbc3$export$39dbc3f558091353);

var $1Hdcz = parcelRequire("1Hdcz");

var $gV0Xn = parcelRequire("gV0Xn");

var $lm4H5 = parcelRequire("lm4H5");
var $bbXj3 = parcelRequire("bbXj3");
var $eBjUU = parcelRequire("eBjUU");
var $5VBDn = parcelRequire("5VBDn");
var $8d15ee28eaadcbc3$var$_excluded = [
    "hit",
    "attribute",
    "cssClasses"
];
function $8d15ee28eaadcbc3$var$_extends() {
    $8d15ee28eaadcbc3$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8d15ee28eaadcbc3$var$_extends.apply(this, arguments);
}
function $8d15ee28eaadcbc3$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $8d15ee28eaadcbc3$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $8d15ee28eaadcbc3$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $8d15ee28eaadcbc3$export$39dbc3f558091353(_ref) {
    var hit = _ref.hit, attribute = _ref.attribute, cssClasses = _ref.cssClasses, props = $8d15ee28eaadcbc3$var$_objectWithoutProperties(_ref, $8d15ee28eaadcbc3$var$_excluded);
    var property = (0, $bbXj3.getPropertyByPath)(hit._highlightResult, attribute) || [];
    var properties = (0, $eBjUU.toArray)(property);
    var parts = properties.map(function(_ref2) {
        var value = _ref2.value;
        return (0, $lm4H5.getHighlightedParts)((0, $5VBDn.unescape)(value || ""));
    });
    return (0, $1Hdcz.h)((0, $gV0Xn.Highlight), $8d15ee28eaadcbc3$var$_extends({}, props, {
        parts: parts,
        classNames: cssClasses
    }));
}

});
parcelRegister("gV0Xn", function(module, exports) {

$parcel$export(module.exports, "Highlight", () => $c512b62b9cc8fd2e$export$39dbc3f558091353);

var $iQB5y = parcelRequire("iQB5y");

var $1Hdcz = parcelRequire("1Hdcz");

var $8z4Ft = parcelRequire("8z4Ft");
var $c512b62b9cc8fd2e$var$_excluded = [
    "classNames"
];
function $c512b62b9cc8fd2e$var$_extends() {
    $c512b62b9cc8fd2e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c512b62b9cc8fd2e$var$_extends.apply(this, arguments);
}
function $c512b62b9cc8fd2e$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $c512b62b9cc8fd2e$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $c512b62b9cc8fd2e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $c512b62b9cc8fd2e$export$39dbc3f558091353(_ref) {
    var _ref$classNames = _ref.classNames, classNames = _ref$classNames === void 0 ? {} : _ref$classNames, props = $c512b62b9cc8fd2e$var$_objectWithoutProperties(_ref, $c512b62b9cc8fd2e$var$_excluded);
    return (0, $1Hdcz.h)((0, $8z4Ft.InternalHighlight), $c512b62b9cc8fd2e$var$_extends({
        classNames: {
            root: (0, $iQB5y.cx)("ais-Highlight", classNames.root),
            highlighted: (0, $iQB5y.cx)("ais-Highlight-highlighted", classNames.highlighted),
            nonHighlighted: (0, $iQB5y.cx)("ais-Highlight-nonHighlighted", classNames.nonHighlighted),
            separator: (0, $iQB5y.cx)("ais-Highlight-separator", classNames.separator)
        }
    }, props));
}

});
parcelRegister("8z4Ft", function(module, exports) {

$parcel$export(module.exports, "InternalHighlight", () => $63c5368f46370bc7$export$57a0c6fc80bec05c);

var $1SZBi = parcelRequire("1SZBi");

var $1Hdcz = parcelRequire("1Hdcz");
var $63c5368f46370bc7$export$57a0c6fc80bec05c = (0, $1SZBi.createHighlightComponent)({
    createElement: (0, $1Hdcz.createElement),
    Fragment: (0, $1Hdcz.Fragment)
});

});
parcelRegister("1SZBi", function(module, exports) {

$parcel$export(module.exports, "createHighlightComponent", () => $15fa9e32529e1644$export$c8682df1c852a966);

var $8nd05 = parcelRequire("8nd05");

var $9X7IJ = parcelRequire("9X7IJ");

var $iQB5y = parcelRequire("iQB5y");
var $15fa9e32529e1644$var$_excluded = [
    "parts",
    "highlightedTagName",
    "nonHighlightedTagName",
    "separator",
    "className",
    "classNames"
];
function $15fa9e32529e1644$var$createHighlightPartComponent(_ref) {
    var createElement = _ref.createElement;
    return function HighlightPart(_ref2) {
        var classNames = _ref2.classNames, children = _ref2.children, highlightedTagName = _ref2.highlightedTagName, isHighlighted = _ref2.isHighlighted, nonHighlightedTagName = _ref2.nonHighlightedTagName;
        var TagName = isHighlighted ? highlightedTagName : nonHighlightedTagName;
        return createElement(TagName, {
            className: isHighlighted ? classNames.highlighted : classNames.nonHighlighted
        }, children);
    };
}
function $15fa9e32529e1644$export$c8682df1c852a966(_ref3) {
    var createElement = _ref3.createElement, Fragment = _ref3.Fragment;
    var HighlightPart = $15fa9e32529e1644$var$createHighlightPartComponent({
        createElement: createElement,
        Fragment: Fragment
    });
    return function Highlight(userProps) {
        var parts = userProps.parts, _userProps$highlighte = userProps.highlightedTagName, highlightedTagName = _userProps$highlighte === void 0 ? "mark" : _userProps$highlighte, _userProps$nonHighlig = userProps.nonHighlightedTagName, nonHighlightedTagName = _userProps$nonHighlig === void 0 ? "span" : _userProps$nonHighlig, _userProps$separator = userProps.separator, separator = _userProps$separator === void 0 ? ", " : _userProps$separator, className = userProps.className, _userProps$classNames = userProps.classNames, classNames = _userProps$classNames === void 0 ? {} : _userProps$classNames, props = (0, $9X7IJ.default)(userProps, $15fa9e32529e1644$var$_excluded);
        return createElement("span", (0, $8nd05.default)({}, props, {
            className: (0, $iQB5y.cx)(classNames.root, className)
        }), parts.map(function(part, partIndex) {
            var isLastPart = partIndex === parts.length - 1;
            return createElement(Fragment, {
                key: partIndex
            }, part.map(function(subPart, subPartIndex) {
                return createElement(HighlightPart, {
                    key: subPartIndex,
                    classNames: classNames,
                    highlightedTagName: highlightedTagName,
                    nonHighlightedTagName: nonHighlightedTagName,
                    isHighlighted: subPart.isHighlighted
                }, subPart.value);
            }), !isLastPart && createElement("span", {
                className: classNames.separator
            }, separator));
        }));
    };
}

});
parcelRegister("8nd05", function(module, exports) {

$parcel$export(module.exports, "default", () => $618a8e53233cd9fa$export$2e2bcd8739ae039);
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("9X7IJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $73ef9ce1c41fc0c0$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");
function $73ef9ce1c41fc0c0$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $1En50.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("1En50", function(module, exports) {

$parcel$export(module.exports, "default", () => $133b6e059b2f6d5e$export$2e2bcd8739ae039);
function $133b6e059b2f6d5e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});





parcelRegister("eBjUU", function(module, exports) {

$parcel$export(module.exports, "toArray", () => $aa13f8766aec4fdc$export$45b10814cc054894);
function $aa13f8766aec4fdc$export$45b10814cc054894(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}

});


parcelRegister("28CUM", function(module, exports) {

$parcel$export(module.exports, "ReverseHighlight", () => $18ea83ce696eccc4$export$f346643e8570b662);

var $1Hdcz = parcelRequire("1Hdcz");

var $3OVIF = parcelRequire("3OVIF");

var $lm4H5 = parcelRequire("lm4H5");
var $bbXj3 = parcelRequire("bbXj3");
var $eBjUU = parcelRequire("eBjUU");
var $5VBDn = parcelRequire("5VBDn");
function $18ea83ce696eccc4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $18ea83ce696eccc4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $18ea83ce696eccc4$var$_typeof(obj);
}
var $18ea83ce696eccc4$var$_excluded = [
    "hit",
    "attribute",
    "cssClasses"
], $18ea83ce696eccc4$var$_excluded2 = [
    "isHighlighted"
];
function $18ea83ce696eccc4$var$_extends() {
    $18ea83ce696eccc4$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $18ea83ce696eccc4$var$_extends.apply(this, arguments);
}
function $18ea83ce696eccc4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $18ea83ce696eccc4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $18ea83ce696eccc4$var$ownKeys(Object(source), !0).forEach(function(key) {
            $18ea83ce696eccc4$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $18ea83ce696eccc4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $18ea83ce696eccc4$var$_defineProperty(obj, key, value) {
    key = $18ea83ce696eccc4$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $18ea83ce696eccc4$var$_toPropertyKey(arg) {
    var key = $18ea83ce696eccc4$var$_toPrimitive(arg, "string");
    return $18ea83ce696eccc4$var$_typeof(key) === "symbol" ? key : String(key);
}
function $18ea83ce696eccc4$var$_toPrimitive(input, hint) {
    if ($18ea83ce696eccc4$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($18ea83ce696eccc4$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $18ea83ce696eccc4$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $18ea83ce696eccc4$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $18ea83ce696eccc4$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $18ea83ce696eccc4$export$f346643e8570b662(_ref) {
    var hit = _ref.hit, attribute = _ref.attribute, cssClasses = _ref.cssClasses, props = $18ea83ce696eccc4$var$_objectWithoutProperties(_ref, $18ea83ce696eccc4$var$_excluded);
    var property = (0, $bbXj3.getPropertyByPath)(hit._highlightResult, attribute) || [];
    var properties = (0, $eBjUU.toArray)(property);
    var parts = properties.map(function(_ref2) {
        var value = _ref2.value;
        return (0, $lm4H5.getHighlightedParts)((0, $5VBDn.unescape)(value || "")).map(function(_ref3) {
            var isHighlighted = _ref3.isHighlighted, rest = $18ea83ce696eccc4$var$_objectWithoutProperties(_ref3, $18ea83ce696eccc4$var$_excluded2);
            return $18ea83ce696eccc4$var$_objectSpread($18ea83ce696eccc4$var$_objectSpread({}, rest), {}, {
                isHighlighted: !isHighlighted
            });
        });
    });
    return (0, $1Hdcz.h)((0, $3OVIF.ReverseHighlight), $18ea83ce696eccc4$var$_extends({}, props, {
        parts: parts,
        classNames: cssClasses
    }));
}

});
parcelRegister("3OVIF", function(module, exports) {

$parcel$export(module.exports, "ReverseHighlight", () => $2c82d07de407efd1$export$f346643e8570b662);

var $iQB5y = parcelRequire("iQB5y");

var $1Hdcz = parcelRequire("1Hdcz");

var $8z4Ft = parcelRequire("8z4Ft");
var $2c82d07de407efd1$var$_excluded = [
    "classNames"
];
function $2c82d07de407efd1$var$_extends() {
    $2c82d07de407efd1$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2c82d07de407efd1$var$_extends.apply(this, arguments);
}
function $2c82d07de407efd1$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $2c82d07de407efd1$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $2c82d07de407efd1$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $2c82d07de407efd1$export$f346643e8570b662(_ref) {
    var _ref$classNames = _ref.classNames, classNames = _ref$classNames === void 0 ? {} : _ref$classNames, props = $2c82d07de407efd1$var$_objectWithoutProperties(_ref, $2c82d07de407efd1$var$_excluded);
    return (0, $1Hdcz.h)((0, $8z4Ft.InternalHighlight), $2c82d07de407efd1$var$_extends({
        classNames: {
            root: (0, $iQB5y.cx)("ais-ReverseHighlight", classNames.root),
            highlighted: (0, $iQB5y.cx)("ais-ReverseHighlight-highlighted", classNames.highlighted),
            nonHighlighted: (0, $iQB5y.cx)("ais-ReverseHighlight-nonHighlighted", classNames.nonHighlighted),
            separator: (0, $iQB5y.cx)("ais-ReverseHighlight-separator", classNames.separator)
        }
    }, props));
}

});


parcelRegister("2207q", function(module, exports) {

$parcel$export(module.exports, "ReverseSnippet", () => $17abdc462fa8fcea$export$235f9e0721ad46fa);

var $1Hdcz = parcelRequire("1Hdcz");

var $1BLli = parcelRequire("1BLli");

var $lm4H5 = parcelRequire("lm4H5");
var $bbXj3 = parcelRequire("bbXj3");
var $eBjUU = parcelRequire("eBjUU");
var $5VBDn = parcelRequire("5VBDn");
function $17abdc462fa8fcea$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $17abdc462fa8fcea$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $17abdc462fa8fcea$var$_typeof(obj);
}
var $17abdc462fa8fcea$var$_excluded = [
    "hit",
    "attribute",
    "cssClasses"
], $17abdc462fa8fcea$var$_excluded2 = [
    "isHighlighted"
];
function $17abdc462fa8fcea$var$_extends() {
    $17abdc462fa8fcea$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $17abdc462fa8fcea$var$_extends.apply(this, arguments);
}
function $17abdc462fa8fcea$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $17abdc462fa8fcea$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $17abdc462fa8fcea$var$ownKeys(Object(source), !0).forEach(function(key) {
            $17abdc462fa8fcea$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $17abdc462fa8fcea$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $17abdc462fa8fcea$var$_defineProperty(obj, key, value) {
    key = $17abdc462fa8fcea$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $17abdc462fa8fcea$var$_toPropertyKey(arg) {
    var key = $17abdc462fa8fcea$var$_toPrimitive(arg, "string");
    return $17abdc462fa8fcea$var$_typeof(key) === "symbol" ? key : String(key);
}
function $17abdc462fa8fcea$var$_toPrimitive(input, hint) {
    if ($17abdc462fa8fcea$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($17abdc462fa8fcea$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $17abdc462fa8fcea$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $17abdc462fa8fcea$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $17abdc462fa8fcea$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $17abdc462fa8fcea$export$235f9e0721ad46fa(_ref) {
    var hit = _ref.hit, attribute = _ref.attribute, cssClasses = _ref.cssClasses, props = $17abdc462fa8fcea$var$_objectWithoutProperties(_ref, $17abdc462fa8fcea$var$_excluded);
    var property = (0, $bbXj3.getPropertyByPath)(hit._snippetResult, attribute) || [];
    var properties = (0, $eBjUU.toArray)(property);
    var parts = properties.map(function(_ref2) {
        var value = _ref2.value;
        return (0, $lm4H5.getHighlightedParts)((0, $5VBDn.unescape)(value || "")).map(function(_ref3) {
            var isHighlighted = _ref3.isHighlighted, rest = $17abdc462fa8fcea$var$_objectWithoutProperties(_ref3, $17abdc462fa8fcea$var$_excluded2);
            return $17abdc462fa8fcea$var$_objectSpread($17abdc462fa8fcea$var$_objectSpread({}, rest), {}, {
                isHighlighted: !isHighlighted
            });
        });
    });
    return (0, $1Hdcz.h)((0, $1BLli.ReverseSnippet), $17abdc462fa8fcea$var$_extends({}, props, {
        parts: parts,
        classNames: cssClasses
    }));
}

});
parcelRegister("1BLli", function(module, exports) {

$parcel$export(module.exports, "ReverseSnippet", () => $12bdf8672f0fd6c0$export$235f9e0721ad46fa);

var $iQB5y = parcelRequire("iQB5y");

var $1Hdcz = parcelRequire("1Hdcz");

var $8z4Ft = parcelRequire("8z4Ft");
var $12bdf8672f0fd6c0$var$_excluded = [
    "classNames"
];
function $12bdf8672f0fd6c0$var$_extends() {
    $12bdf8672f0fd6c0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $12bdf8672f0fd6c0$var$_extends.apply(this, arguments);
}
function $12bdf8672f0fd6c0$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $12bdf8672f0fd6c0$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $12bdf8672f0fd6c0$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $12bdf8672f0fd6c0$export$235f9e0721ad46fa(_ref) {
    var _ref$classNames = _ref.classNames, classNames = _ref$classNames === void 0 ? {} : _ref$classNames, props = $12bdf8672f0fd6c0$var$_objectWithoutProperties(_ref, $12bdf8672f0fd6c0$var$_excluded);
    return (0, $1Hdcz.h)((0, $8z4Ft.InternalHighlight), $12bdf8672f0fd6c0$var$_extends({
        classNames: {
            root: (0, $iQB5y.cx)("ais-ReverseSnippet", classNames.root),
            highlighted: (0, $iQB5y.cx)("ais-ReverseSnippet-highlighted", classNames.highlighted),
            nonHighlighted: (0, $iQB5y.cx)("ais-ReverseSnippet-nonHighlighted", classNames.nonHighlighted),
            separator: (0, $iQB5y.cx)("ais-ReverseSnippet-separator", classNames.separator)
        }
    }, props));
}

});


parcelRegister("VTgUm", function(module, exports) {

$parcel$export(module.exports, "Snippet", () => $0ae032cbefcac09e$export$10c56fa12fda26f9);

var $1Hdcz = parcelRequire("1Hdcz");

var $aERzb = parcelRequire("aERzb");

var $lm4H5 = parcelRequire("lm4H5");
var $bbXj3 = parcelRequire("bbXj3");
var $eBjUU = parcelRequire("eBjUU");
var $5VBDn = parcelRequire("5VBDn");
var $0ae032cbefcac09e$var$_excluded = [
    "hit",
    "attribute",
    "cssClasses"
];
function $0ae032cbefcac09e$var$_extends() {
    $0ae032cbefcac09e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0ae032cbefcac09e$var$_extends.apply(this, arguments);
}
function $0ae032cbefcac09e$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $0ae032cbefcac09e$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $0ae032cbefcac09e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $0ae032cbefcac09e$export$10c56fa12fda26f9(_ref) {
    var hit = _ref.hit, attribute = _ref.attribute, cssClasses = _ref.cssClasses, props = $0ae032cbefcac09e$var$_objectWithoutProperties(_ref, $0ae032cbefcac09e$var$_excluded);
    var property = (0, $bbXj3.getPropertyByPath)(hit._snippetResult, attribute) || [];
    var properties = (0, $eBjUU.toArray)(property);
    var parts = properties.map(function(_ref2) {
        var value = _ref2.value;
        return (0, $lm4H5.getHighlightedParts)((0, $5VBDn.unescape)(value || ""));
    });
    return (0, $1Hdcz.h)((0, $aERzb.Snippet), $0ae032cbefcac09e$var$_extends({}, props, {
        parts: parts,
        classNames: cssClasses
    }));
}

});
parcelRegister("aERzb", function(module, exports) {

$parcel$export(module.exports, "Snippet", () => $7c2731038c01b48d$export$10c56fa12fda26f9);

var $iQB5y = parcelRequire("iQB5y");

var $1Hdcz = parcelRequire("1Hdcz");

var $8z4Ft = parcelRequire("8z4Ft");
var $7c2731038c01b48d$var$_excluded = [
    "classNames"
];
function $7c2731038c01b48d$var$_extends() {
    $7c2731038c01b48d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7c2731038c01b48d$var$_extends.apply(this, arguments);
}
function $7c2731038c01b48d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $7c2731038c01b48d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $7c2731038c01b48d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $7c2731038c01b48d$export$10c56fa12fda26f9(_ref) {
    var _ref$classNames = _ref.classNames, classNames = _ref$classNames === void 0 ? {} : _ref$classNames, props = $7c2731038c01b48d$var$_objectWithoutProperties(_ref, $7c2731038c01b48d$var$_excluded);
    return (0, $1Hdcz.h)((0, $8z4Ft.InternalHighlight), $7c2731038c01b48d$var$_extends({
        classNames: {
            root: (0, $iQB5y.cx)("ais-Snippet", classNames.root),
            highlighted: (0, $iQB5y.cx)("ais-Snippet-highlighted", classNames.highlighted),
            nonHighlighted: (0, $iQB5y.cx)("ais-Snippet-nonHighlighted", classNames.nonHighlighted),
            separator: (0, $iQB5y.cx)("ais-Snippet-separator", classNames.separator)
        }
    }, props));
}

});





parcelRegister("BvxtV", function(module, exports) {

$parcel$export(module.exports, "default", () => $070bebcf5f96cab1$export$2e2bcd8739ae039);

var $2TWNj = parcelRequire("2TWNj");
var $dLWdP = parcelRequire("dLWdP");
var $del55 = parcelRequire("del55");
var $6KqqP = parcelRequire("6KqqP");
var $dohXG = parcelRequire("dohXG");
var $iNPz2 = parcelRequire("iNPz2");
var $7oPxv = parcelRequire("7oPxv");
function $070bebcf5f96cab1$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $070bebcf5f96cab1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $070bebcf5f96cab1$var$_typeof(obj);
}
function $070bebcf5f96cab1$var$_toConsumableArray(arr) {
    return $070bebcf5f96cab1$var$_arrayWithoutHoles(arr) || $070bebcf5f96cab1$var$_iterableToArray(arr) || $070bebcf5f96cab1$var$_unsupportedIterableToArray(arr) || $070bebcf5f96cab1$var$_nonIterableSpread();
}
function $070bebcf5f96cab1$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $070bebcf5f96cab1$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $070bebcf5f96cab1$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $070bebcf5f96cab1$var$_arrayLikeToArray(o, minLen);
}
function $070bebcf5f96cab1$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $070bebcf5f96cab1$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $070bebcf5f96cab1$var$_arrayLikeToArray(arr);
}
function $070bebcf5f96cab1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $070bebcf5f96cab1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $070bebcf5f96cab1$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $070bebcf5f96cab1$var$ownKeys(Object(source), !0).forEach(function(key) {
            $070bebcf5f96cab1$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $070bebcf5f96cab1$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $070bebcf5f96cab1$var$_defineProperty(obj, key, value) {
    key = $070bebcf5f96cab1$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $070bebcf5f96cab1$var$_toPropertyKey(arg) {
    var key = $070bebcf5f96cab1$var$_toPrimitive(arg, "string");
    return $070bebcf5f96cab1$var$_typeof(key) === "symbol" ? key : String(key);
}
function $070bebcf5f96cab1$var$_toPrimitive(input, hint) {
    if ($070bebcf5f96cab1$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($070bebcf5f96cab1$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $070bebcf5f96cab1$var$withUsage = (0, $del55.createDocumentationMessageGenerator)({
    name: "clear-refinements",
    connector: true
});
var $070bebcf5f96cab1$var$connectClearRefinements = function connectClearRefinements(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $iNPz2.noop);
    (0, $2TWNj.checkRendering)(renderFn, $070bebcf5f96cab1$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, _ref$includedAttribut = _ref.includedAttributes, includedAttributes = _ref$includedAttribut === void 0 ? [] : _ref$includedAttribut, _ref$excludedAttribut = _ref.excludedAttributes, excludedAttributes = _ref$excludedAttribut === void 0 ? [
            "query"
        ] : _ref$excludedAttribut, _ref$transformItems = _ref.transformItems, transformItems = _ref$transformItems === void 0 ? function(items) {
            return items;
        } : _ref$transformItems;
        if (widgetParams && widgetParams.includedAttributes && widgetParams.excludedAttributes) throw new Error($070bebcf5f96cab1$var$withUsage("The options `includedAttributes` and `excludedAttributes` cannot be used together."));
        var connectorState = {
            refine: (0, $iNPz2.noop),
            createURL: function createURL() {
                return "";
            },
            attributesToClear: []
        };
        var cachedRefine = function cachedRefine() {
            return connectorState.refine();
        };
        var cachedCreateURL = function cachedCreateURL() {
            return connectorState.createURL();
        };
        return {
            $$type: "ais.clearRefinements",
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($070bebcf5f96cab1$var$_objectSpread($070bebcf5f96cab1$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($070bebcf5f96cab1$var$_objectSpread($070bebcf5f96cab1$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose() {
                unmountFn();
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $070bebcf5f96cab1$var$_objectSpread($070bebcf5f96cab1$var$_objectSpread({}, renderState), {}, {
                    clearRefinements: this.getWidgetRenderState(renderOptions)
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref2) {
                var createURL = _ref2.createURL, scopedResults = _ref2.scopedResults, results = _ref2.results;
                connectorState.attributesToClear = scopedResults.reduce(function(attributesToClear, scopedResult) {
                    return attributesToClear.concat($070bebcf5f96cab1$var$getAttributesToClear({
                        scopedResult: scopedResult,
                        includedAttributes: includedAttributes,
                        excludedAttributes: excludedAttributes,
                        transformItems: transformItems,
                        results: results
                    }));
                }, []);
                connectorState.refine = function() {
                    connectorState.attributesToClear.forEach(function(_ref3) {
                        var indexHelper = _ref3.helper, items = _ref3.items;
                        indexHelper.setState((0, $dLWdP.clearRefinements)({
                            helper: indexHelper,
                            attributesToClear: items
                        })).search();
                    });
                };
                connectorState.createURL = function() {
                    return createURL((0, $dohXG.mergeSearchParameters).apply(void 0, $070bebcf5f96cab1$var$_toConsumableArray(connectorState.attributesToClear.map(function(_ref4) {
                        var indexHelper = _ref4.helper, items = _ref4.items;
                        return (0, $dLWdP.clearRefinements)({
                            helper: indexHelper,
                            attributesToClear: items
                        });
                    }))));
                };
                var canRefine = connectorState.attributesToClear.some(function(attributeToClear) {
                    return attributeToClear.items.length > 0;
                });
                return {
                    canRefine: canRefine,
                    hasRefinements: canRefine,
                    refine: cachedRefine,
                    createURL: cachedCreateURL,
                    widgetParams: widgetParams
                };
            }
        };
    };
};
function $070bebcf5f96cab1$var$getAttributesToClear(_ref5) {
    var scopedResult = _ref5.scopedResult, includedAttributes = _ref5.includedAttributes, excludedAttributes = _ref5.excludedAttributes, transformItems = _ref5.transformItems, results = _ref5.results;
    var includesQuery = includedAttributes.indexOf("query") !== -1 || excludedAttributes.indexOf("query") === -1;
    return {
        helper: scopedResult.helper,
        items: transformItems((0, $7oPxv.uniq)((0, $6KqqP.getRefinements)(scopedResult.results, scopedResult.helper.state, includesQuery).map(function(refinement) {
            return refinement.attribute;
        }).filter(function(attribute) {
            return(// If the array is empty (default case), we keep all the attributes
            includedAttributes.length === 0 || // Otherwise, only add the specified attributes
            includedAttributes.indexOf(attribute) !== -1);
        }).filter(function(attribute) {
            return(// If the query is included, we ignore the default `excludedAttributes = ['query']`
            attribute === "query" && includesQuery || // Otherwise, ignore the excluded attributes
            excludedAttributes.indexOf(attribute) === -1);
        })), {
            results: results
        })
    };
}
var $070bebcf5f96cab1$export$2e2bcd8739ae039 = $070bebcf5f96cab1$var$connectClearRefinements;

});
parcelRegister("dLWdP", function(module, exports) {

$parcel$export(module.exports, "clearRefinements", () => $a06cd3d62413ddd1$export$c8b9db57471d846b);
/**
 * Clears the refinements of a SearchParameters object based on rules provided.
 * The included attributes list is applied before the excluded attributes list. If the list
 * is not provided, this list of all the currently refined attributes is used as included attributes.
 * @returns search parameters with refinements cleared
 */ function $a06cd3d62413ddd1$export$c8b9db57471d846b(_ref) {
    var helper = _ref.helper, _ref$attributesToClea = _ref.attributesToClear, attributesToClear = _ref$attributesToClea === void 0 ? [] : _ref$attributesToClea;
    var finalState = helper.state.setPage(0);
    finalState = attributesToClear.reduce(function(state, attribute) {
        if (finalState.isNumericRefined(attribute)) return state.removeNumericRefinement(attribute);
        if (finalState.isHierarchicalFacet(attribute)) return state.removeHierarchicalFacetRefinement(attribute);
        if (finalState.isDisjunctiveFacet(attribute)) return state.removeDisjunctiveFacetRefinement(attribute);
        if (finalState.isConjunctiveFacet(attribute)) return state.removeFacetRefinement(attribute);
        return state;
    }, finalState);
    if (attributesToClear.indexOf("query") !== -1) finalState = finalState.setQuery("");
    return finalState;
}

});

parcelRegister("6KqqP", function(module, exports) {

$parcel$export(module.exports, "getRefinements", () => $4e9b8ab7f4182a38$export$d9f33760e70a0a);

var $hb3Wq = parcelRequire("hb3Wq");

var $dZQeP = parcelRequire("dZQeP");
function $4e9b8ab7f4182a38$var$getRefinement(state, type, attribute, name) {
    var resultsFacets = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    var res = {
        type: type,
        attribute: attribute,
        name: name,
        escapedValue: (0, $hb3Wq.escapeFacetValue)(name)
    };
    var facet = (0, $dZQeP.find)(resultsFacets, function(resultsFacet) {
        return resultsFacet.name === attribute;
    });
    var count;
    if (type === "hierarchical") {
        var facetDeclaration = state.getHierarchicalFacetByName(attribute);
        var nameParts = name.split(facetDeclaration.separator);
        var getFacetRefinement = function getFacetRefinement(facetData) {
            return function(refinementKey) {
                return facetData[refinementKey];
            };
        };
        var _loop = function _loop(i) {
            facet = facet && facet.data && (0, $dZQeP.find)(Object.keys(facet.data).map(getFacetRefinement(facet.data)), function(refinement) {
                return refinement.name === nameParts[i];
            });
        };
        for(var i = 0; facet !== undefined && i < nameParts.length; ++i)_loop(i);
        count = facet && facet.count;
    } else count = facet && facet.data && facet.data[res.name];
    if (count !== undefined) res.count = count;
    if (facet && facet.exhaustive !== undefined) res.exhaustive = facet.exhaustive;
    return res;
}
function $4e9b8ab7f4182a38$export$d9f33760e70a0a(results, state) {
    var includesQuery = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var refinements = [];
    var _state$facetsRefineme = state.facetsRefinements, facetsRefinements = _state$facetsRefineme === void 0 ? {} : _state$facetsRefineme, _state$facetsExcludes = state.facetsExcludes, facetsExcludes = _state$facetsExcludes === void 0 ? {} : _state$facetsExcludes, _state$disjunctiveFac = state.disjunctiveFacetsRefinements, disjunctiveFacetsRefinements = _state$disjunctiveFac === void 0 ? {} : _state$disjunctiveFac, _state$hierarchicalFa = state.hierarchicalFacetsRefinements, hierarchicalFacetsRefinements = _state$hierarchicalFa === void 0 ? {} : _state$hierarchicalFa, _state$numericRefinem = state.numericRefinements, numericRefinements = _state$numericRefinem === void 0 ? {} : _state$numericRefinem, _state$tagRefinements = state.tagRefinements, tagRefinements = _state$tagRefinements === void 0 ? [] : _state$tagRefinements;
    Object.keys(facetsRefinements).forEach(function(attribute) {
        var refinementNames = facetsRefinements[attribute];
        refinementNames.forEach(function(refinementName) {
            refinements.push($4e9b8ab7f4182a38$var$getRefinement(state, "facet", attribute, refinementName, results.facets));
        });
    });
    Object.keys(facetsExcludes).forEach(function(attribute) {
        var refinementNames = facetsExcludes[attribute];
        refinementNames.forEach(function(refinementName) {
            refinements.push({
                type: "exclude",
                attribute: attribute,
                name: refinementName,
                exclude: true
            });
        });
    });
    Object.keys(disjunctiveFacetsRefinements).forEach(function(attribute) {
        var refinementNames = disjunctiveFacetsRefinements[attribute];
        refinementNames.forEach(function(refinementName) {
            refinements.push($4e9b8ab7f4182a38$var$getRefinement(state, "disjunctive", attribute, // We unescape any disjunctive refined values with `unescapeFacetValue` because
            // they can be escaped on negative numeric values with `escapeFacetValue`.
            (0, $hb3Wq.unescapeFacetValue)(refinementName), results.disjunctiveFacets));
        });
    });
    Object.keys(hierarchicalFacetsRefinements).forEach(function(attribute) {
        var refinementNames = hierarchicalFacetsRefinements[attribute];
        refinementNames.forEach(function(refinement) {
            refinements.push($4e9b8ab7f4182a38$var$getRefinement(state, "hierarchical", attribute, refinement, results.hierarchicalFacets));
        });
    });
    Object.keys(numericRefinements).forEach(function(attribute) {
        var operators = numericRefinements[attribute];
        Object.keys(operators).forEach(function(operatorOriginal) {
            var operator = operatorOriginal;
            var valueOrValues = operators[operator];
            var refinementNames = Array.isArray(valueOrValues) ? valueOrValues : [
                valueOrValues
            ];
            refinementNames.forEach(function(refinementName) {
                refinements.push({
                    type: "numeric",
                    attribute: attribute,
                    name: "".concat(refinementName),
                    numericValue: refinementName,
                    operator: operator
                });
            });
        });
    });
    tagRefinements.forEach(function(refinementName) {
        refinements.push({
            type: "tag",
            attribute: "_tags",
            name: refinementName
        });
    });
    if (includesQuery && state.query && state.query.trim()) refinements.push({
        attribute: "query",
        type: "query",
        name: state.query,
        query: state.query
    });
    return refinements;
}

});
parcelRegister("hb3Wq", function(module, exports) {

$parcel$export(module.exports, "unescapeFacetValue", () => $c8168569e48abcac$export$ad628980c7383a99);
$parcel$export(module.exports, "escapeFacetValue", () => $c8168569e48abcac$export$40415fcf01f0c9e8);
function $c8168569e48abcac$export$ad628980c7383a99(value) {
    if (typeof value === "string") return value.replace(/^\\-/, "-");
    return value;
}
function $c8168569e48abcac$export$40415fcf01f0c9e8(value) {
    if (typeof value === "number" && value < 0 || typeof value === "string") return String(value).replace(/^-/, "\\-");
    return value;
}

});



parcelRegister("7OG5t", function(module, exports) {

$parcel$export(module.exports, "prepareTemplateProps", () => $5b0dd994114ed26b$export$2938ff6a58d41f25);

var $7oPxv = parcelRequire("7oPxv");
function $5b0dd994114ed26b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $5b0dd994114ed26b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $5b0dd994114ed26b$var$_typeof(obj);
}
function $5b0dd994114ed26b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5b0dd994114ed26b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $5b0dd994114ed26b$var$ownKeys(Object(source), !0).forEach(function(key) {
            $5b0dd994114ed26b$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $5b0dd994114ed26b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5b0dd994114ed26b$var$_defineProperty(obj, key, value) {
    key = $5b0dd994114ed26b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5b0dd994114ed26b$var$_toPropertyKey(arg) {
    var key = $5b0dd994114ed26b$var$_toPrimitive(arg, "string");
    return $5b0dd994114ed26b$var$_typeof(key) === "symbol" ? key : String(key);
}
function $5b0dd994114ed26b$var$_toPrimitive(input, hint) {
    if ($5b0dd994114ed26b$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($5b0dd994114ed26b$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $5b0dd994114ed26b$var$_toConsumableArray(arr) {
    return $5b0dd994114ed26b$var$_arrayWithoutHoles(arr) || $5b0dd994114ed26b$var$_iterableToArray(arr) || $5b0dd994114ed26b$var$_unsupportedIterableToArray(arr) || $5b0dd994114ed26b$var$_nonIterableSpread();
}
function $5b0dd994114ed26b$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5b0dd994114ed26b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5b0dd994114ed26b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5b0dd994114ed26b$var$_arrayLikeToArray(o, minLen);
}
function $5b0dd994114ed26b$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $5b0dd994114ed26b$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $5b0dd994114ed26b$var$_arrayLikeToArray(arr);
}
function $5b0dd994114ed26b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $5b0dd994114ed26b$var$prepareTemplates(// can not use = {} here, since the template could have different constraints
defaultTemplates) {
    var templates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var allKeys = (0, $7oPxv.uniq)([].concat($5b0dd994114ed26b$var$_toConsumableArray(Object.keys(defaultTemplates || {})), $5b0dd994114ed26b$var$_toConsumableArray(Object.keys(templates))));
    return allKeys.reduce(function(config, key) {
        var defaultTemplate = defaultTemplates ? defaultTemplates[key] : undefined;
        var customTemplate = templates[key];
        var isCustomTemplate = customTemplate !== undefined && customTemplate !== defaultTemplate;
        config.templates[key] = isCustomTemplate ? customTemplate : defaultTemplate;
        config.useCustomCompileOptions[key] = isCustomTemplate;
        return config;
    }, {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        templates: {},
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        useCustomCompileOptions: {}
    });
}
function $5b0dd994114ed26b$export$2938ff6a58d41f25(_ref) {
    var defaultTemplates = _ref.defaultTemplates, templates = _ref.templates, templatesConfig = _ref.templatesConfig;
    var preparedTemplates = $5b0dd994114ed26b$var$prepareTemplates(defaultTemplates, templates);
    return $5b0dd994114ed26b$var$_objectSpread({
        templatesConfig: templatesConfig
    }, preparedTemplates);
}

});

parcelRegister("6lpSe", function(module, exports) {

$parcel$export(module.exports, "getContainerNode", () => $49e8c633bf16687c$export$ffb2c7b8d67c359a);

var $agIkE = parcelRequire("agIkE");
function $49e8c633bf16687c$export$ffb2c7b8d67c359a(selectorOrHTMLElement) {
    var isSelectorString = typeof selectorOrHTMLElement === "string";
    var domElement = isSelectorString ? document.querySelector(selectorOrHTMLElement) : selectorOrHTMLElement;
    if (!(0, $agIkE.isDomElement)(domElement)) {
        var errorMessage = "Container must be `string` or `HTMLElement`.";
        if (isSelectorString) errorMessage += " Unable to find ".concat(selectorOrHTMLElement);
        throw new Error(errorMessage);
    }
    return domElement;
}

});
parcelRegister("agIkE", function(module, exports) {

$parcel$export(module.exports, "isDomElement", () => $779dc96dc599a638$export$124b2c3e0d3efb2d);
function $779dc96dc599a638$export$124b2c3e0d3efb2d(object) {
    return object instanceof HTMLElement || Boolean(object) && object.nodeType > 0;
}

});


parcelRegister("3L2Wj", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bc80a9d5855ca2a$export$2e2bcd8739ae039);
var $2bc80a9d5855ca2a$var$defaultTemplates = {
    resetLabel: function resetLabel() {
        return "Clear refinements";
    }
};
var $2bc80a9d5855ca2a$export$2e2bcd8739ae039 = $2bc80a9d5855ca2a$var$defaultTemplates;

});


parcelRegister("kMjUy", function(module, exports) {

$parcel$export(module.exports, "default", () => $f207bc4d2063b2fc$export$2e2bcd8739ae039);

var $lNb7j = parcelRequire("lNb7j");

var $iNPz2 = parcelRequire("iNPz2");
function $f207bc4d2063b2fc$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $f207bc4d2063b2fc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $f207bc4d2063b2fc$var$_typeof(obj);
}
function $f207bc4d2063b2fc$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f207bc4d2063b2fc$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $f207bc4d2063b2fc$var$ownKeys(Object(source), !0).forEach(function(key) {
            $f207bc4d2063b2fc$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $f207bc4d2063b2fc$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f207bc4d2063b2fc$var$_defineProperty(obj, key, value) {
    key = $f207bc4d2063b2fc$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f207bc4d2063b2fc$var$_toPropertyKey(arg) {
    var key = $f207bc4d2063b2fc$var$_toPrimitive(arg, "string");
    return $f207bc4d2063b2fc$var$_typeof(key) === "symbol" ? key : String(key);
}
function $f207bc4d2063b2fc$var$_toPrimitive(input, hint) {
    if ($f207bc4d2063b2fc$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($f207bc4d2063b2fc$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/**
 * A list of [search parameters](https://www.algolia.com/doc/api-reference/search-api-parameters/)
 * to enable when the widget mounts.
 */ var $f207bc4d2063b2fc$var$configure = function configure(widgetParams) {
    // This is a renderless widget that falls back to the connector's
    // noop render and unmount functions.
    var makeWidget = (0, $lNb7j.default)((0, $iNPz2.noop));
    return $f207bc4d2063b2fc$var$_objectSpread($f207bc4d2063b2fc$var$_objectSpread({}, makeWidget({
        searchParameters: widgetParams
    })), {}, {
        $$widgetType: "ais.configure"
    });
};
var $f207bc4d2063b2fc$export$2e2bcd8739ae039 = $f207bc4d2063b2fc$var$configure;

});
parcelRegister("lNb7j", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdd6cc2d948c1c01$export$2e2bcd8739ae039);

var $3gYKj = parcelRequire("3gYKj");

var $del55 = parcelRequire("del55");
var $9KXQK = parcelRequire("9KXQK");
var $dohXG = parcelRequire("dohXG");
var $iNPz2 = parcelRequire("iNPz2");
function $fdd6cc2d948c1c01$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $fdd6cc2d948c1c01$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $fdd6cc2d948c1c01$var$_typeof(obj);
}
function $fdd6cc2d948c1c01$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $fdd6cc2d948c1c01$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $fdd6cc2d948c1c01$var$ownKeys(Object(source), !0).forEach(function(key) {
            $fdd6cc2d948c1c01$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $fdd6cc2d948c1c01$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $fdd6cc2d948c1c01$var$_defineProperty(obj, key, value) {
    key = $fdd6cc2d948c1c01$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $fdd6cc2d948c1c01$var$_toPropertyKey(arg) {
    var key = $fdd6cc2d948c1c01$var$_toPrimitive(arg, "string");
    return $fdd6cc2d948c1c01$var$_typeof(key) === "symbol" ? key : String(key);
}
function $fdd6cc2d948c1c01$var$_toPrimitive(input, hint) {
    if ($fdd6cc2d948c1c01$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($fdd6cc2d948c1c01$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
/**
 * Refine the given search parameters.
 */ var $fdd6cc2d948c1c01$var$withUsage = (0, $del55.createDocumentationMessageGenerator)({
    name: "configure",
    connector: true
});
function $fdd6cc2d948c1c01$var$getInitialSearchParameters(state, widgetParams) {
    // We leverage the helper internals to remove the `widgetParams` from
    // the state. The function `setQueryParameters` omits the values that
    // are `undefined` on the next state.
    return state.setQueryParameters(Object.keys(widgetParams.searchParameters).reduce(function(acc, key) {
        return $fdd6cc2d948c1c01$var$_objectSpread($fdd6cc2d948c1c01$var$_objectSpread({}, acc), {}, $fdd6cc2d948c1c01$var$_defineProperty({}, key, undefined));
    }, {}));
}
var $fdd6cc2d948c1c01$var$connectConfigure = function connectConfigure() {
    var renderFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $iNPz2.noop);
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $iNPz2.noop);
    return function(widgetParams) {
        if (!widgetParams || !(0, $9KXQK.isPlainObject)(widgetParams.searchParameters)) throw new Error($fdd6cc2d948c1c01$var$withUsage("The `searchParameters` option expects an object."));
        var connectorState = {};
        function refine(helper) {
            return function(searchParameters) {
                // Merge new `searchParameters` with the ones set from other widgets
                var actualState = $fdd6cc2d948c1c01$var$getInitialSearchParameters(helper.state, widgetParams);
                var nextSearchParameters = (0, $dohXG.mergeSearchParameters)(actualState, new (0, (/*@__PURE__*/$parcel$interopDefault($3gYKj))).SearchParameters(searchParameters));
                // Update original `widgetParams.searchParameters` to the new refined one
                widgetParams.searchParameters = searchParameters;
                // Trigger a search with the resolved search parameters
                helper.setState(nextSearchParameters).search();
            };
        }
        return {
            $$type: "ais.configure",
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($fdd6cc2d948c1c01$var$_objectSpread($fdd6cc2d948c1c01$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($fdd6cc2d948c1c01$var$_objectSpread($fdd6cc2d948c1c01$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose(_ref) {
                var state = _ref.state;
                unmountFn();
                return $fdd6cc2d948c1c01$var$getInitialSearchParameters(state, widgetParams);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                var _renderState$configur;
                var widgetRenderState = this.getWidgetRenderState(renderOptions);
                return $fdd6cc2d948c1c01$var$_objectSpread($fdd6cc2d948c1c01$var$_objectSpread({}, renderState), {}, {
                    configure: $fdd6cc2d948c1c01$var$_objectSpread($fdd6cc2d948c1c01$var$_objectSpread({}, widgetRenderState), {}, {
                        widgetParams: $fdd6cc2d948c1c01$var$_objectSpread($fdd6cc2d948c1c01$var$_objectSpread({}, widgetRenderState.widgetParams), {}, {
                            searchParameters: (0, $dohXG.mergeSearchParameters)(new (0, (/*@__PURE__*/$parcel$interopDefault($3gYKj))).SearchParameters((_renderState$configur = renderState.configure) === null || _renderState$configur === void 0 ? void 0 : _renderState$configur.widgetParams.searchParameters), new (0, (/*@__PURE__*/$parcel$interopDefault($3gYKj))).SearchParameters(widgetRenderState.widgetParams.searchParameters)).getQueryParams()
                        })
                    })
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref2) {
                var helper = _ref2.helper;
                if (!connectorState.refine) connectorState.refine = refine(helper);
                return {
                    refine: connectorState.refine,
                    widgetParams: widgetParams
                };
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(state, _ref3) {
                var uiState = _ref3.uiState;
                return (0, $dohXG.mergeSearchParameters)(state, new (0, (/*@__PURE__*/$parcel$interopDefault($3gYKj))).SearchParameters($fdd6cc2d948c1c01$var$_objectSpread($fdd6cc2d948c1c01$var$_objectSpread({}, uiState.configure), widgetParams.searchParameters)));
            },
            getWidgetUiState: function getWidgetUiState(uiState) {
                return $fdd6cc2d948c1c01$var$_objectSpread($fdd6cc2d948c1c01$var$_objectSpread({}, uiState), {}, {
                    configure: $fdd6cc2d948c1c01$var$_objectSpread($fdd6cc2d948c1c01$var$_objectSpread({}, uiState.configure), widgetParams.searchParameters)
                });
            }
        };
    };
};
var $fdd6cc2d948c1c01$export$2e2bcd8739ae039 = $fdd6cc2d948c1c01$var$connectConfigure;

});


parcelRegister("cNXNW", function(module, exports) {

$parcel$export(module.exports, "default", () => $9528738f56fe4d28$export$2e2bcd8739ae039);

var $iQB5y = parcelRequire("iQB5y");

var $1Hdcz = parcelRequire("1Hdcz");

var $jV0k9 = parcelRequire("jV0k9");

var $bLDkB = parcelRequire("bLDkB");

var $ipedu = parcelRequire("ipedu");

var $del55 = parcelRequire("del55");
var $6lpSe = parcelRequire("6lpSe");
function $9528738f56fe4d28$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $9528738f56fe4d28$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $9528738f56fe4d28$var$_typeof(obj);
}
function $9528738f56fe4d28$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9528738f56fe4d28$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $9528738f56fe4d28$var$ownKeys(Object(source), !0).forEach(function(key) {
            $9528738f56fe4d28$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $9528738f56fe4d28$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $9528738f56fe4d28$var$_defineProperty(obj, key, value) {
    key = $9528738f56fe4d28$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9528738f56fe4d28$var$_toPropertyKey(arg) {
    var key = $9528738f56fe4d28$var$_toPrimitive(arg, "string");
    return $9528738f56fe4d28$var$_typeof(key) === "symbol" ? key : String(key);
}
function $9528738f56fe4d28$var$_toPrimitive(input, hint) {
    if ($9528738f56fe4d28$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($9528738f56fe4d28$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $9528738f56fe4d28$var$suit = (0, $ipedu.component)("Pagination");
var $9528738f56fe4d28$var$withUsage = (0, $del55.createDocumentationMessageGenerator)({
    name: "pagination"
});
var $9528738f56fe4d28$var$defaultTemplates = {
    previous: function previous() {
        return "\u2039";
    },
    next: function next() {
        return "\u203A";
    },
    page: function page(_ref) {
        var _page = _ref.page;
        return "".concat(_page);
    },
    first: function first() {
        return "\xab";
    },
    last: function last() {
        return "\xbb";
    }
};
var $9528738f56fe4d28$var$renderer = function renderer(_ref2) {
    var containerNode = _ref2.containerNode, cssClasses = _ref2.cssClasses, templates = _ref2.templates, showFirst = _ref2.showFirst, showLast = _ref2.showLast, showPrevious = _ref2.showPrevious, showNext = _ref2.showNext, scrollToNode = _ref2.scrollToNode;
    return function(_ref3, isFirstRendering) {
        var createURL = _ref3.createURL, currentRefinement = _ref3.currentRefinement, nbPages = _ref3.nbPages, pages = _ref3.pages, isFirstPage = _ref3.isFirstPage, isLastPage = _ref3.isLastPage, refine = _ref3.refine;
        if (isFirstRendering) return;
        var setCurrentPage = function setCurrentPage(pageNumber) {
            refine(pageNumber);
            if (scrollToNode !== false) scrollToNode.scrollIntoView();
        };
        (0, $1Hdcz.render)((0, $1Hdcz.h)((0, $jV0k9.default), {
            createURL: createURL,
            cssClasses: cssClasses,
            currentPage: currentRefinement,
            templates: templates,
            nbPages: nbPages,
            pages: pages,
            isFirstPage: isFirstPage,
            isLastPage: isLastPage,
            setCurrentPage: setCurrentPage,
            showFirst: showFirst,
            showLast: showLast,
            showPrevious: showPrevious,
            showNext: showNext
        }), containerNode);
    };
};
var $9528738f56fe4d28$var$pagination = function pagination(widgetParams) {
    var _ref4 = widgetParams || {}, container = _ref4.container, _ref4$templates = _ref4.templates, userTemplates = _ref4$templates === void 0 ? {} : _ref4$templates, _ref4$cssClasses = _ref4.cssClasses, userCssClasses = _ref4$cssClasses === void 0 ? {} : _ref4$cssClasses, totalPages = _ref4.totalPages, padding = _ref4.padding, _ref4$showFirst = _ref4.showFirst, showFirst = _ref4$showFirst === void 0 ? true : _ref4$showFirst, _ref4$showLast = _ref4.showLast, showLast = _ref4$showLast === void 0 ? true : _ref4$showLast, _ref4$showPrevious = _ref4.showPrevious, showPrevious = _ref4$showPrevious === void 0 ? true : _ref4$showPrevious, _ref4$showNext = _ref4.showNext, showNext = _ref4$showNext === void 0 ? true : _ref4$showNext, _ref4$scrollTo = _ref4.scrollTo, userScrollTo = _ref4$scrollTo === void 0 ? "body" : _ref4$scrollTo;
    if (!container) throw new Error($9528738f56fe4d28$var$withUsage("The `container` option is required."));
    var containerNode = (0, $6lpSe.getContainerNode)(container);
    var scrollTo = userScrollTo === true ? "body" : userScrollTo;
    var scrollToNode = scrollTo !== false ? (0, $6lpSe.getContainerNode)(scrollTo) : false;
    var cssClasses = {
        root: (0, $iQB5y.cx)($9528738f56fe4d28$var$suit(), userCssClasses.root),
        noRefinementRoot: (0, $iQB5y.cx)($9528738f56fe4d28$var$suit({
            modifierName: "noRefinement"
        }), userCssClasses.noRefinementRoot),
        list: (0, $iQB5y.cx)($9528738f56fe4d28$var$suit({
            descendantName: "list"
        }), userCssClasses.list),
        item: (0, $iQB5y.cx)($9528738f56fe4d28$var$suit({
            descendantName: "item"
        }), userCssClasses.item),
        firstPageItem: (0, $iQB5y.cx)($9528738f56fe4d28$var$suit({
            descendantName: "item",
            modifierName: "firstPage"
        }), userCssClasses.firstPageItem),
        lastPageItem: (0, $iQB5y.cx)($9528738f56fe4d28$var$suit({
            descendantName: "item",
            modifierName: "lastPage"
        }), userCssClasses.lastPageItem),
        previousPageItem: (0, $iQB5y.cx)($9528738f56fe4d28$var$suit({
            descendantName: "item",
            modifierName: "previousPage"
        }), userCssClasses.previousPageItem),
        nextPageItem: (0, $iQB5y.cx)($9528738f56fe4d28$var$suit({
            descendantName: "item",
            modifierName: "nextPage"
        }), userCssClasses.nextPageItem),
        pageItem: (0, $iQB5y.cx)($9528738f56fe4d28$var$suit({
            descendantName: "item",
            modifierName: "page"
        }), userCssClasses.pageItem),
        selectedItem: (0, $iQB5y.cx)($9528738f56fe4d28$var$suit({
            descendantName: "item",
            modifierName: "selected"
        }), userCssClasses.selectedItem),
        disabledItem: (0, $iQB5y.cx)($9528738f56fe4d28$var$suit({
            descendantName: "item",
            modifierName: "disabled"
        }), userCssClasses.disabledItem),
        link: (0, $iQB5y.cx)($9528738f56fe4d28$var$suit({
            descendantName: "link"
        }), userCssClasses.link)
    };
    var templates = $9528738f56fe4d28$var$_objectSpread($9528738f56fe4d28$var$_objectSpread({}, $9528738f56fe4d28$var$defaultTemplates), userTemplates);
    var specializedRenderer = $9528738f56fe4d28$var$renderer({
        containerNode: containerNode,
        cssClasses: cssClasses,
        templates: templates,
        showFirst: showFirst,
        showLast: showLast,
        showPrevious: showPrevious,
        showNext: showNext,
        scrollToNode: scrollToNode
    });
    var makeWidget = (0, $bLDkB.default)(specializedRenderer, function() {
        return (0, $1Hdcz.render)(null, containerNode);
    });
    return $9528738f56fe4d28$var$_objectSpread($9528738f56fe4d28$var$_objectSpread({}, makeWidget({
        totalPages: totalPages,
        padding: padding
    })), {}, {
        $$widgetType: "ais.pagination"
    });
};
var $9528738f56fe4d28$export$2e2bcd8739ae039 = $9528738f56fe4d28$var$pagination;

});
parcelRegister("jV0k9", function(module, exports) {

$parcel$export(module.exports, "default", () => $e803978a470ee444$export$2e2bcd8739ae039);

var $iQB5y = parcelRequire("iQB5y");

var $1Hdcz = parcelRequire("1Hdcz");

var $hJhqV = parcelRequire("hJhqV");

var $b7YL7 = parcelRequire("b7YL7");
function $e803978a470ee444$var$Pagination(props) {
    function createClickHandler(pageNumber) {
        return function(event) {
            if ((0, $hJhqV.isSpecialClick)(event)) // do not alter the default browser behavior
            // if one special key is down
            return;
            event.preventDefault();
            props.setCurrentPage(pageNumber);
        };
    }
    return (0, $1Hdcz.h)("div", {
        className: (0, $iQB5y.cx)(props.cssClasses.root, props.nbPages <= 1 && props.cssClasses.noRefinementRoot)
    }, (0, $1Hdcz.h)("ul", {
        className: props.cssClasses.list
    }, props.showFirst && (0, $1Hdcz.h)($e803978a470ee444$var$PaginationLink, {
        ariaLabel: "First Page",
        className: props.cssClasses.firstPageItem,
        isDisabled: props.isFirstPage,
        templates: props.templates,
        templateKey: "first",
        pageNumber: 0,
        createURL: props.createURL,
        cssClasses: props.cssClasses,
        createClickHandler: createClickHandler
    }), props.showPrevious && (0, $1Hdcz.h)($e803978a470ee444$var$PaginationLink, {
        ariaLabel: "Previous Page",
        className: props.cssClasses.previousPageItem,
        isDisabled: props.isFirstPage,
        templates: props.templates,
        templateKey: "previous",
        pageNumber: props.currentPage - 1,
        createURL: props.createURL,
        cssClasses: props.cssClasses,
        createClickHandler: createClickHandler
    }), props.pages.map(function(pageNumber) {
        return (0, $1Hdcz.h)($e803978a470ee444$var$PaginationLink, {
            key: pageNumber,
            ariaLabel: "Page ".concat(pageNumber + 1),
            className: props.cssClasses.pageItem,
            isSelected: pageNumber === props.currentPage,
            templates: props.templates,
            templateKey: "page",
            pageNumber: pageNumber,
            createURL: props.createURL,
            cssClasses: props.cssClasses,
            createClickHandler: createClickHandler
        });
    }), props.showNext && (0, $1Hdcz.h)($e803978a470ee444$var$PaginationLink, {
        ariaLabel: "Next Page",
        className: props.cssClasses.nextPageItem,
        isDisabled: props.isLastPage,
        templates: props.templates,
        templateKey: "next",
        pageNumber: props.currentPage + 1,
        createURL: props.createURL,
        cssClasses: props.cssClasses,
        createClickHandler: createClickHandler
    }), props.showLast && (0, $1Hdcz.h)($e803978a470ee444$var$PaginationLink, {
        ariaLabel: "Last Page, Page ".concat(props.nbPages),
        className: props.cssClasses.lastPageItem,
        isDisabled: props.isLastPage,
        templates: props.templates,
        templateKey: "last",
        pageNumber: props.nbPages - 1,
        createURL: props.createURL,
        cssClasses: props.cssClasses,
        createClickHandler: createClickHandler
    })));
}
function $e803978a470ee444$var$PaginationLink(_ref) {
    var templates = _ref.templates, templateKey = _ref.templateKey, ariaLabel = _ref.ariaLabel, pageNumber = _ref.pageNumber, className = _ref.className, _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, cssClasses = _ref.cssClasses, createURL = _ref.createURL, createClickHandler = _ref.createClickHandler;
    return (0, $1Hdcz.h)("li", {
        className: (0, $iQB5y.cx)(cssClasses.item, isDisabled && cssClasses.disabledItem, className, isSelected && cssClasses.selectedItem)
    }, isDisabled ? (0, $1Hdcz.h)((0, $b7YL7.default), {
        rootTagName: "span",
        rootProps: {
            className: cssClasses.link,
            "aria-label": ariaLabel
        },
        templateKey: templateKey,
        templates: templates,
        data: {
            page: pageNumber + 1
        }
    }) : (0, $1Hdcz.h)((0, $b7YL7.default), {
        rootTagName: "a",
        rootProps: {
            className: cssClasses.link,
            "aria-label": ariaLabel,
            href: createURL(pageNumber),
            onClick: createClickHandler(pageNumber)
        },
        templateKey: templateKey,
        templates: templates,
        data: {
            page: pageNumber + 1
        }
    }));
}
var $e803978a470ee444$export$2e2bcd8739ae039 = $e803978a470ee444$var$Pagination;

});
parcelRegister("hJhqV", function(module, exports) {

$parcel$export(module.exports, "isSpecialClick", () => $ce842980b1dc8270$export$5b1771037ab7c451);
function $ce842980b1dc8270$export$5b1771037ab7c451(event) {
    var isMiddleClick = event.button === 1;
    return isMiddleClick || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;
}

});


parcelRegister("bLDkB", function(module, exports) {

$parcel$export(module.exports, "default", () => $891297d9ae5dfb83$export$2e2bcd8739ae039);

var $2TWNj = parcelRequire("2TWNj");
var $del55 = parcelRequire("del55");
var $iNPz2 = parcelRequire("iNPz2");

var $iJy2O = parcelRequire("iJy2O");
function $891297d9ae5dfb83$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $891297d9ae5dfb83$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $891297d9ae5dfb83$var$_typeof(obj);
}
function $891297d9ae5dfb83$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $891297d9ae5dfb83$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $891297d9ae5dfb83$var$ownKeys(Object(source), !0).forEach(function(key) {
            $891297d9ae5dfb83$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $891297d9ae5dfb83$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $891297d9ae5dfb83$var$_defineProperty(obj, key, value) {
    key = $891297d9ae5dfb83$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $891297d9ae5dfb83$var$_toPropertyKey(arg) {
    var key = $891297d9ae5dfb83$var$_toPrimitive(arg, "string");
    return $891297d9ae5dfb83$var$_typeof(key) === "symbol" ? key : String(key);
}
function $891297d9ae5dfb83$var$_toPrimitive(input, hint) {
    if ($891297d9ae5dfb83$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($891297d9ae5dfb83$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $891297d9ae5dfb83$var$withUsage = (0, $del55.createDocumentationMessageGenerator)({
    name: "pagination",
    connector: true
});
/**
 * **Pagination** connector provides the logic to build a widget that will let the user
 * choose the current page of the results.
 *
 * When using the pagination with Algolia, you should be aware that the engine won't provide you pages
 * beyond the 1000th hits by default. You can find more information on the [Algolia documentation](https://www.algolia.com/doc/guides/searching/pagination/#pagination-limitations).
 */ var $891297d9ae5dfb83$var$connectPagination = function connectPagination(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $iNPz2.noop);
    (0, $2TWNj.checkRendering)(renderFn, $891297d9ae5dfb83$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, totalPages = _ref.totalPages, _ref$padding = _ref.padding, padding = _ref$padding === void 0 ? 3 : _ref$padding;
        var pager = new (0, $iJy2O.default)({
            currentPage: 0,
            total: 0,
            padding: padding
        });
        var connectorState = {};
        function getMaxPage(_ref2) {
            var nbPages = _ref2.nbPages;
            return totalPages !== undefined ? Math.min(totalPages, nbPages) : nbPages;
        }
        return {
            $$type: "ais.pagination",
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($891297d9ae5dfb83$var$_objectSpread($891297d9ae5dfb83$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($891297d9ae5dfb83$var$_objectSpread($891297d9ae5dfb83$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose(_ref3) {
                var state = _ref3.state;
                unmountFn();
                return state.setQueryParameter("page", undefined);
            },
            getWidgetUiState: function getWidgetUiState(uiState, _ref4) {
                var searchParameters = _ref4.searchParameters;
                var page = searchParameters.page || 0;
                if (!page) return uiState;
                return $891297d9ae5dfb83$var$_objectSpread($891297d9ae5dfb83$var$_objectSpread({}, uiState), {}, {
                    page: page + 1
                });
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(searchParameters, _ref5) {
                var uiState = _ref5.uiState;
                var page = uiState.page ? uiState.page - 1 : 0;
                return searchParameters.setQueryParameter("page", page);
            },
            getWidgetRenderState: function getWidgetRenderState(_ref6) {
                var results = _ref6.results, helper = _ref6.helper, state = _ref6.state, createURL = _ref6.createURL;
                if (!connectorState.refine) connectorState.refine = function(page) {
                    helper.setPage(page);
                    helper.search();
                };
                if (!connectorState.createURL) connectorState.createURL = function(page) {
                    return createURL(function(uiState) {
                        return $891297d9ae5dfb83$var$_objectSpread($891297d9ae5dfb83$var$_objectSpread({}, uiState), {}, {
                            page: page + 1
                        });
                    });
                };
                var page = state.page || 0;
                var nbPages = getMaxPage(results || {
                    nbPages: 0
                });
                pager.currentPage = page;
                pager.total = nbPages;
                return {
                    createURL: connectorState.createURL,
                    refine: connectorState.refine,
                    canRefine: nbPages > 1,
                    currentRefinement: page,
                    nbHits: (results === null || results === void 0 ? void 0 : results.nbHits) || 0,
                    nbPages: nbPages,
                    pages: results ? pager.pages() : [],
                    isFirstPage: pager.isFirstPage(),
                    isLastPage: pager.isLastPage(),
                    widgetParams: widgetParams
                };
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $891297d9ae5dfb83$var$_objectSpread($891297d9ae5dfb83$var$_objectSpread({}, renderState), {}, {
                    pagination: this.getWidgetRenderState(renderOptions)
                });
            }
        };
    };
};
var $891297d9ae5dfb83$export$2e2bcd8739ae039 = $891297d9ae5dfb83$var$connectPagination;

});
parcelRegister("iJy2O", function(module, exports) {

$parcel$export(module.exports, "default", () => $da36d675dc25800d$export$2e2bcd8739ae039);

var $kWpoE = parcelRequire("kWpoE");
function $da36d675dc25800d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $da36d675dc25800d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $da36d675dc25800d$var$_typeof(obj);
}
function $da36d675dc25800d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $da36d675dc25800d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $da36d675dc25800d$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $da36d675dc25800d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $da36d675dc25800d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $da36d675dc25800d$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $da36d675dc25800d$var$_defineProperty(obj, key, value) {
    key = $da36d675dc25800d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $da36d675dc25800d$var$_toPropertyKey(arg) {
    var key = $da36d675dc25800d$var$_toPrimitive(arg, "string");
    return $da36d675dc25800d$var$_typeof(key) === "symbol" ? key : String(key);
}
function $da36d675dc25800d$var$_toPrimitive(input, hint) {
    if ($da36d675dc25800d$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($da36d675dc25800d$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $da36d675dc25800d$var$Paginator = /*#__PURE__*/ function() {
    function Paginator(params) {
        $da36d675dc25800d$var$_classCallCheck(this, Paginator);
        $da36d675dc25800d$var$_defineProperty(this, "currentPage", void 0);
        $da36d675dc25800d$var$_defineProperty(this, "total", void 0);
        $da36d675dc25800d$var$_defineProperty(this, "padding", void 0);
        this.currentPage = params.currentPage;
        this.total = params.total;
        this.padding = params.padding;
    }
    $da36d675dc25800d$var$_createClass(Paginator, [
        {
            key: "pages",
            value: function pages() {
                var total = this.total, currentPage = this.currentPage, padding = this.padding;
                if (total === 0) return [
                    0
                ];
                var totalDisplayedPages = this.nbPagesDisplayed(padding, total);
                if (totalDisplayedPages === total) return (0, $kWpoE.range)({
                    end: total
                });
                var paddingLeft = this.calculatePaddingLeft(currentPage, padding, total, totalDisplayedPages);
                var paddingRight = totalDisplayedPages - paddingLeft;
                var first = currentPage - paddingLeft;
                var last = currentPage + paddingRight;
                return (0, $kWpoE.range)({
                    start: first,
                    end: last
                });
            }
        },
        {
            key: "nbPagesDisplayed",
            value: function nbPagesDisplayed(padding, total) {
                return Math.min(2 * padding + 1, total);
            }
        },
        {
            key: "calculatePaddingLeft",
            value: function calculatePaddingLeft(current, padding, total, totalDisplayedPages) {
                if (current <= padding) return current;
                if (current >= total - padding) return totalDisplayedPages - (total - current);
                return padding;
            }
        },
        {
            key: "isLastPage",
            value: function isLastPage() {
                return this.currentPage >= this.total - 1;
            }
        },
        {
            key: "isFirstPage",
            value: function isFirstPage() {
                return this.currentPage <= 0;
            }
        }
    ]);
    return Paginator;
}();
var $da36d675dc25800d$export$2e2bcd8739ae039 = $da36d675dc25800d$var$Paginator;

});
parcelRegister("kWpoE", function(module, exports) {

$parcel$export(module.exports, "range", () => $f3ececa64fea1dba$export$d02631cccf789723);
function $f3ececa64fea1dba$var$_toConsumableArray(arr) {
    return $f3ececa64fea1dba$var$_arrayWithoutHoles(arr) || $f3ececa64fea1dba$var$_iterableToArray(arr) || $f3ececa64fea1dba$var$_unsupportedIterableToArray(arr) || $f3ececa64fea1dba$var$_nonIterableSpread();
}
function $f3ececa64fea1dba$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f3ececa64fea1dba$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f3ececa64fea1dba$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f3ececa64fea1dba$var$_arrayLikeToArray(o, minLen);
}
function $f3ececa64fea1dba$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $f3ececa64fea1dba$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $f3ececa64fea1dba$var$_arrayLikeToArray(arr);
}
function $f3ececa64fea1dba$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f3ececa64fea1dba$export$d02631cccf789723(_ref) {
    var _ref$start = _ref.start, start = _ref$start === void 0 ? 0 : _ref$start, end = _ref.end, _ref$step = _ref.step, step = _ref$step === void 0 ? 1 : _ref$step;
    // We can't divide by 0 so we re-assign the step to 1 if it happens.
    var limitStep = step === 0 ? 1 : step;
    // In some cases the array to create has a decimal length.
    // We therefore need to round the value.
    // Example:
    //   { start: 1, end: 5000, step: 500 }
    //   => Array length = (5000 - 1) / 500 = 9.998
    var arrayLength = Math.round((end - start) / limitStep);
    return $f3ececa64fea1dba$var$_toConsumableArray(Array(arrayLength)).map(function(_, current) {
        return start + current * limitStep;
    });
}

});




parcelRegister("lHFYh", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcce2bc0c905ff4e$export$2e2bcd8739ae039);

var $iQB5y = parcelRequire("iQB5y");

var $1Hdcz = parcelRequire("1Hdcz");

var $cRGW5 = parcelRequire("cRGW5");

var $kh9u2 = parcelRequire("kh9u2");

var $aiWu2 = parcelRequire("aiWu2");

var $ipedu = parcelRequire("ipedu");

var $7OG5t = parcelRequire("7OG5t");

var $del55 = parcelRequire("del55");
var $6lpSe = parcelRequire("6lpSe");
function $fcce2bc0c905ff4e$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $fcce2bc0c905ff4e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $fcce2bc0c905ff4e$var$_typeof(obj);
}
function $fcce2bc0c905ff4e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $fcce2bc0c905ff4e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $fcce2bc0c905ff4e$var$ownKeys(Object(source), !0).forEach(function(key) {
            $fcce2bc0c905ff4e$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $fcce2bc0c905ff4e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $fcce2bc0c905ff4e$var$_defineProperty(obj, key, value) {
    key = $fcce2bc0c905ff4e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $fcce2bc0c905ff4e$var$_toPropertyKey(arg) {
    var key = $fcce2bc0c905ff4e$var$_toPrimitive(arg, "string");
    return $fcce2bc0c905ff4e$var$_typeof(key) === "symbol" ? key : String(key);
}
function $fcce2bc0c905ff4e$var$_toPrimitive(input, hint) {
    if ($fcce2bc0c905ff4e$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($fcce2bc0c905ff4e$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $fcce2bc0c905ff4e$var$withUsage = (0, $del55.createDocumentationMessageGenerator)({
    name: "stats"
});
var $fcce2bc0c905ff4e$var$suit = (0, $ipedu.component)("Stats");
var $fcce2bc0c905ff4e$export$952bbd6b1defadc7 = {
    text: function text(props) {
        return "".concat(props.areHitsSorted ? $fcce2bc0c905ff4e$var$getSortedResultsSentence(props) : $fcce2bc0c905ff4e$var$getResultsSentence(props), " found in ").concat(props.processingTimeMS, "ms");
    }
};
function $fcce2bc0c905ff4e$var$getSortedResultsSentence(_ref) {
    var nbHits = _ref.nbHits, hasNoSortedResults = _ref.hasNoSortedResults, hasOneSortedResults = _ref.hasOneSortedResults, hasManySortedResults = _ref.hasManySortedResults, nbSortedHits = _ref.nbSortedHits;
    var suffix = "sorted out of ".concat((0, $aiWu2.formatNumber)(nbHits));
    if (hasNoSortedResults) return "No relevant results ".concat(suffix);
    if (hasOneSortedResults) return "1 relevant result ".concat(suffix);
    if (hasManySortedResults) return "".concat((0, $aiWu2.formatNumber)(nbSortedHits || 0), " relevant results ").concat(suffix);
    return "";
}
function $fcce2bc0c905ff4e$var$getResultsSentence(_ref2) {
    var nbHits = _ref2.nbHits, hasNoResults = _ref2.hasNoResults, hasOneResult = _ref2.hasOneResult, hasManyResults = _ref2.hasManyResults;
    if (hasNoResults) return "No results";
    if (hasOneResult) return "1 result";
    if (hasManyResults) return "".concat((0, $aiWu2.formatNumber)(nbHits), " results");
    return "";
}
var $fcce2bc0c905ff4e$var$renderer = function renderer(_ref3) {
    var renderState = _ref3.renderState, cssClasses = _ref3.cssClasses, containerNode = _ref3.containerNode, templates = _ref3.templates;
    return function(_ref4, isFirstRendering) {
        var hitsPerPage = _ref4.hitsPerPage, nbHits = _ref4.nbHits, nbSortedHits = _ref4.nbSortedHits, areHitsSorted = _ref4.areHitsSorted, nbPages = _ref4.nbPages, page = _ref4.page, processingTimeMS = _ref4.processingTimeMS, query = _ref4.query, instantSearchInstance = _ref4.instantSearchInstance;
        if (isFirstRendering) {
            renderState.templateProps = (0, $7OG5t.prepareTemplateProps)({
                defaultTemplates: $fcce2bc0c905ff4e$export$952bbd6b1defadc7,
                templatesConfig: instantSearchInstance.templatesConfig,
                templates: templates
            });
            return;
        }
        (0, $1Hdcz.render)((0, $1Hdcz.h)((0, $cRGW5.default), {
            cssClasses: cssClasses,
            hitsPerPage: hitsPerPage,
            nbHits: nbHits,
            nbSortedHits: nbSortedHits,
            areHitsSorted: areHitsSorted,
            nbPages: nbPages,
            page: page,
            processingTimeMS: processingTimeMS,
            query: query,
            templateProps: renderState.templateProps
        }), containerNode);
    };
};
/**
 * The `stats` widget is used to display useful insights about the current results.
 *
 * By default, it will display the **number of hits** and the time taken to compute the
 * results inside the engine.
 */ var $fcce2bc0c905ff4e$var$stats = function stats(widgetParams) {
    var _ref5 = widgetParams || {}, container = _ref5.container, _ref5$cssClasses = _ref5.cssClasses, userCssClasses = _ref5$cssClasses === void 0 ? {} : _ref5$cssClasses, _ref5$templates = _ref5.templates, templates = _ref5$templates === void 0 ? {} : _ref5$templates;
    if (!container) throw new Error($fcce2bc0c905ff4e$var$withUsage("The `container` option is required."));
    var containerNode = (0, $6lpSe.getContainerNode)(container);
    var cssClasses = {
        root: (0, $iQB5y.cx)($fcce2bc0c905ff4e$var$suit(), userCssClasses.root),
        text: (0, $iQB5y.cx)($fcce2bc0c905ff4e$var$suit({
            descendantName: "text"
        }), userCssClasses.text)
    };
    var specializedRenderer = $fcce2bc0c905ff4e$var$renderer({
        containerNode: containerNode,
        cssClasses: cssClasses,
        templates: templates,
        renderState: {}
    });
    var makeWidget = (0, $kh9u2.default)(specializedRenderer, function() {
        return (0, $1Hdcz.render)(null, containerNode);
    });
    return $fcce2bc0c905ff4e$var$_objectSpread($fcce2bc0c905ff4e$var$_objectSpread({}, makeWidget({})), {}, {
        $$widgetType: "ais.stats"
    });
};
var $fcce2bc0c905ff4e$export$2e2bcd8739ae039 = $fcce2bc0c905ff4e$var$stats;

});
parcelRegister("cRGW5", function(module, exports) {

$parcel$export(module.exports, "default", () => $95dbbd6f40a29eff$export$2e2bcd8739ae039);

var $iQB5y = parcelRequire("iQB5y");

var $1Hdcz = parcelRequire("1Hdcz");

var $b7YL7 = parcelRequire("b7YL7");
function $95dbbd6f40a29eff$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $95dbbd6f40a29eff$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $95dbbd6f40a29eff$var$_typeof(obj);
}
var $95dbbd6f40a29eff$var$_excluded = [
    "nbHits",
    "nbSortedHits",
    "cssClasses",
    "templateProps"
];
function $95dbbd6f40a29eff$var$_extends() {
    $95dbbd6f40a29eff$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $95dbbd6f40a29eff$var$_extends.apply(this, arguments);
}
function $95dbbd6f40a29eff$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $95dbbd6f40a29eff$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $95dbbd6f40a29eff$var$ownKeys(Object(source), !0).forEach(function(key) {
            $95dbbd6f40a29eff$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $95dbbd6f40a29eff$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $95dbbd6f40a29eff$var$_defineProperty(obj, key, value) {
    key = $95dbbd6f40a29eff$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $95dbbd6f40a29eff$var$_toPropertyKey(arg) {
    var key = $95dbbd6f40a29eff$var$_toPrimitive(arg, "string");
    return $95dbbd6f40a29eff$var$_typeof(key) === "symbol" ? key : String(key);
}
function $95dbbd6f40a29eff$var$_toPrimitive(input, hint) {
    if ($95dbbd6f40a29eff$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($95dbbd6f40a29eff$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $95dbbd6f40a29eff$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $95dbbd6f40a29eff$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $95dbbd6f40a29eff$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $95dbbd6f40a29eff$var$Stats = function Stats(_ref) {
    var nbHits = _ref.nbHits, nbSortedHits = _ref.nbSortedHits, cssClasses = _ref.cssClasses, templateProps = _ref.templateProps, rest = $95dbbd6f40a29eff$var$_objectWithoutProperties(_ref, $95dbbd6f40a29eff$var$_excluded);
    return (0, $1Hdcz.h)("div", {
        className: (0, $iQB5y.cx)(cssClasses.root)
    }, (0, $1Hdcz.h)((0, $b7YL7.default), $95dbbd6f40a29eff$var$_extends({}, templateProps, {
        templateKey: "text",
        rootTagName: "span",
        rootProps: {
            className: cssClasses.text
        },
        data: $95dbbd6f40a29eff$var$_objectSpread({
            hasManySortedResults: nbSortedHits && nbSortedHits > 1,
            hasNoSortedResults: nbSortedHits === 0,
            hasOneSortedResults: nbSortedHits === 1,
            hasManyResults: nbHits > 1,
            hasNoResults: nbHits === 0,
            hasOneResult: nbHits === 1,
            nbHits: nbHits,
            nbSortedHits: nbSortedHits,
            cssClasses: cssClasses
        }, rest)
    })));
};
var $95dbbd6f40a29eff$export$2e2bcd8739ae039 = $95dbbd6f40a29eff$var$Stats;

});

parcelRegister("kh9u2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec2cc0651e86cc30$export$2e2bcd8739ae039);

var $2TWNj = parcelRequire("2TWNj");
var $del55 = parcelRequire("del55");
var $iNPz2 = parcelRequire("iNPz2");
function $ec2cc0651e86cc30$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $ec2cc0651e86cc30$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $ec2cc0651e86cc30$var$_typeof(obj);
}
function $ec2cc0651e86cc30$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ec2cc0651e86cc30$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ec2cc0651e86cc30$var$ownKeys(Object(source), !0).forEach(function(key) {
            $ec2cc0651e86cc30$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ec2cc0651e86cc30$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ec2cc0651e86cc30$var$_defineProperty(obj, key, value) {
    key = $ec2cc0651e86cc30$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ec2cc0651e86cc30$var$_toPropertyKey(arg) {
    var key = $ec2cc0651e86cc30$var$_toPrimitive(arg, "string");
    return $ec2cc0651e86cc30$var$_typeof(key) === "symbol" ? key : String(key);
}
function $ec2cc0651e86cc30$var$_toPrimitive(input, hint) {
    if ($ec2cc0651e86cc30$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($ec2cc0651e86cc30$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $ec2cc0651e86cc30$var$withUsage = (0, $del55.createDocumentationMessageGenerator)({
    name: "stats",
    connector: true
});
/**
 * **Stats** connector provides the logic to build a custom widget that will displays
 * search statistics (hits number and processing time).
 */ var $ec2cc0651e86cc30$var$connectStats = function connectStats(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $iNPz2.noop);
    (0, $2TWNj.checkRendering)(renderFn, $ec2cc0651e86cc30$var$withUsage());
    return function(widgetParams) {
        return {
            $$type: "ais.stats",
            init: function init(initOptions) {
                var instantSearchInstance = initOptions.instantSearchInstance;
                renderFn($ec2cc0651e86cc30$var$_objectSpread($ec2cc0651e86cc30$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var instantSearchInstance = renderOptions.instantSearchInstance;
                renderFn($ec2cc0651e86cc30$var$_objectSpread($ec2cc0651e86cc30$var$_objectSpread({}, this.getWidgetRenderState(renderOptions)), {}, {
                    instantSearchInstance: instantSearchInstance
                }), false);
            },
            dispose: function dispose() {
                unmountFn();
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $ec2cc0651e86cc30$var$_objectSpread($ec2cc0651e86cc30$var$_objectSpread({}, renderState), {}, {
                    stats: this.getWidgetRenderState(renderOptions)
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref) {
                var results = _ref.results, state = _ref.state;
                if (!results) return {
                    hitsPerPage: state.hitsPerPage,
                    nbHits: 0,
                    nbSortedHits: undefined,
                    areHitsSorted: false,
                    nbPages: 0,
                    page: state.page || 0,
                    processingTimeMS: -1,
                    query: state.query || "",
                    widgetParams: widgetParams
                };
                return {
                    hitsPerPage: results.hitsPerPage,
                    nbHits: results.nbHits,
                    nbSortedHits: results.nbSortedHits,
                    areHitsSorted: typeof results.appliedRelevancyStrictness !== "undefined" && results.appliedRelevancyStrictness > 0 && results.nbSortedHits !== results.nbHits,
                    nbPages: results.nbPages,
                    page: results.page,
                    processingTimeMS: results.processingTimeMS,
                    query: results.query,
                    widgetParams: widgetParams
                };
            }
        };
    };
};
var $ec2cc0651e86cc30$export$2e2bcd8739ae039 = $ec2cc0651e86cc30$var$connectStats;

});


parcelRegister("1qliK", function(module, exports) {

$parcel$export(module.exports, "customHits", () => $1098be2514d3cd7a$export$b36b28d3a848da36);

var $krmKp = parcelRequire("krmKp");
// Create the render function that customizes the hits.
// See: https://www.algolia.com/doc/api-reference/widgets/hits/js/
const $1098be2514d3cd7a$var$renderHits = (renderOptions, isFirstRender)=>{
    const { items: items, widgetParams: widgetParams } = renderOptions;
    const defaultClass = "grid grid-cols-1 gap-x-6 gap-y-8 lg:grid-cols-3 xl:gap-x-8";
    const ulClass = widgetParams.container.getAttribute("data-ul-class");
    // <dd class="text-gray-700"><time datetime="2022-12-13">December 13, 2022</time></dd>
    widgetParams.container.innerHTML = `
    <ul role="list" class="${ulClass || defaultClass}">
    ${items.map((hit)=>`
        <!-- 
          objectID: ${hit.objectID} 
          uri: ${hit.uri} 
        -->
      <li class="overflow-hidden rounded-xl border border-gray-200">
        <div class="flex items-center gap-x-4 border-b border-gray-900/5 bg-gray-50 p-4">
          <svg class="h-12 w-12 flex-none rounded-lg bg-white object-cover ring-1 ring-gray-900/10" id="template" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><title/><path d="M30.316,20.846a.336.336,0,0,0-.338-.194l-13.7.867v-1.4h6.6a4.49,4.49,0,0,0,4.785-3.935c.6-4.158-3.193-9.876-11.385-12.387V2.573a.355.355,0,0,0-.709,0V5.354a.339.339,0,0,0-.1.146C11.57,17.3,4.221,19.4,4.147,19.418a.355.355,0,0,0,.092.7h11.33v1.449l-8.215.519a.355.355,0,0,0-.332.354v3.487a.355.355,0,0,0,.709,0V22.77L29.2,21.411,25.615,25.7a.355.355,0,0,0,.544.455l4.113-4.918A.353.353,0,0,0,30.316,20.846ZM16.278,5.729c1.065,2.677,2.745,8.3,0,11.932Zm0,13.034c4.2-4.335,1.385-11.754.315-14.134C24.052,7.1,27.507,12.3,26.961,16.079a3.777,3.777,0,0,1-4.083,3.327h-6.6Zm-.709.643H6C8.34,18.179,12.637,15,15.569,7.328Z"/><path d="M29.819,29.072A3.643,3.643,0,0,1,26.682,26.9a.369.369,0,0,0-.029-.04.3.3,0,0,0-.048-.069.306.306,0,0,0-.047-.033.314.314,0,0,0-.059-.042l-.009,0a.22.22,0,0,0-.043-.009.326.326,0,0,0-.092-.018.185.185,0,0,0-.023,0,.343.343,0,0,0-.11.023h-.006c-.014.006-.024.018-.037.025a.357.357,0,0,0-.072.05.366.366,0,0,0-.04.057.274.274,0,0,0-.035.049,3.7,3.7,0,0,1-3.167,2.175A3.643,3.643,0,0,1,19.727,26.9c-.008-.016-.021-.027-.03-.042a.379.379,0,0,0-.046-.067.44.44,0,0,0-.052-.036.344.344,0,0,0-.055-.039l-.008,0a.431.431,0,0,0-.049-.011.38.38,0,0,0-.087-.016l-.016,0a.345.345,0,0,0-.118.024h0a.307.307,0,0,0-.035.024.375.375,0,0,0-.074.051.324.324,0,0,0-.04.057.274.274,0,0,0-.035.049,3.7,3.7,0,0,1-3.167,2.175A3.643,3.643,0,0,1,12.772,26.9c-.007-.015-.02-.026-.028-.04a.37.37,0,0,0-.048-.069.33.33,0,0,0-.049-.034.3.3,0,0,0-.058-.041l-.009,0a.348.348,0,0,0-.044-.01.357.357,0,0,0-.09-.017.155.155,0,0,0-.021,0,.335.335,0,0,0-.113.023h0a.33.33,0,0,0-.039.026.228.228,0,0,0-.111.107.348.348,0,0,0-.035.048,3.7,3.7,0,0,1-3.167,2.175A3.643,3.643,0,0,1,5.817,26.9c-.007-.015-.02-.026-.028-.04a.333.333,0,0,0-.049-.069.4.4,0,0,0-.047-.034.31.31,0,0,0-.059-.041l-.009,0a.348.348,0,0,0-.044-.01.365.365,0,0,0-.091-.017c-.006,0-.012,0-.019,0a.368.368,0,0,0-.114.024h0c-.014.006-.023.017-.036.024a.375.375,0,0,0-.074.051.388.388,0,0,0-.04.057.434.434,0,0,0-.035.049A3.7,3.7,0,0,1,2,29.072a.355.355,0,0,0,0,.709,4.182,4.182,0,0,0,3.488-2.018,4.128,4.128,0,0,0,3.467,2.018,4.18,4.18,0,0,0,3.488-2.018,4.125,4.125,0,0,0,3.467,2.018A4.183,4.183,0,0,0,19.4,27.763a4.127,4.127,0,0,0,3.467,2.018,4.183,4.183,0,0,0,3.488-2.018,4.124,4.124,0,0,0,3.466,2.018.355.355,0,1,0,0-.709Z"/></svg>
          <div class="text-sm font-medium leading-6 text-gray-900">${hit.name}</div>
          <div class="ml-auto flex flex-col flex-nowrap gap-2">
            <div class="text-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/10 truncate">${hit.yachtType}</div>
            <div class="ml-auto flex flex-row flex-nowrap gap-x-2">
              <div class="text-center rounded-md bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-700 ring-1 ring-inset ring-yellow-600/10 ${hit.cruisingCapacity ?? "hidden"}">DAY</div>
              <div class="text-center rounded-md bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-600/10 ${hit.sleeps ?? "hidden"}">WEEK</div>
            </div>
          </div>
        </div>
        <dl class="-my-3 divide-y divide-gray-100 px-6 py-4 text-sm leading-6">
          <div class="flex justify-between gap-x-4 py-3">
            <dt class="text-gray-500">Length</dt>
            <dd class="text-gray-700">${hit.length_m} m</dd>
          </div>
          <div class="flex justify-between gap-x-4 py-3 ${hit.sleeps ?? "hidden"}">
            <dt class="text-gray-500">Sleeps</dt>
            <dd class="text-gray-700">${hit.sleeps}</dd>
          </div>
          <div class="flex justify-between gap-x-4 py-3 ${hit.cruisingCapacity ?? "hidden"}">
            <dt class="text-gray-500">Guest Capacity</dt>
            <dd class="text-gray-700">${hit.cruisingCapacity}</dd>
          </div>
          <div class="flex justify-between gap-x-4 py-3">
            <dt class="text-gray-500">From</dt>
            <!-- this price is already div 100 prior to sending to the search provider -->
            <dd class="text-gray-700">${Intl.NumberFormat("en-US", {
            style: "currency",
            currency: hit.priceCurrency
        }).format(hit.priceTotal)}</dd>
          </div>
        </dl>
      </li>
      `).join("")}
    </ul>
  `;
};
const $1098be2514d3cd7a$export$b36b28d3a848da36 = (0, $krmKp.default)($1098be2514d3cd7a$var$renderHits);

});
parcelRegister("krmKp", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee17f9739c3013b3$export$2e2bcd8739ae039);

var $gIg1f = parcelRequire("gIg1f");
var $luHzu = parcelRequire("luHzu");
var $2TWNj = parcelRequire("2TWNj");
var $7TXRe = parcelRequire("7TXRe");
var $del55 = parcelRequire("del55");
var $6ZYbr = parcelRequire("6ZYbr");
var $iNPz2 = parcelRequire("iNPz2");
function $ee17f9739c3013b3$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $ee17f9739c3013b3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $ee17f9739c3013b3$var$_typeof(obj);
}
function $ee17f9739c3013b3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ee17f9739c3013b3$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ee17f9739c3013b3$var$ownKeys(Object(source), !0).forEach(function(key) {
            $ee17f9739c3013b3$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ee17f9739c3013b3$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ee17f9739c3013b3$var$_defineProperty(obj, key, value) {
    key = $ee17f9739c3013b3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ee17f9739c3013b3$var$_toPropertyKey(arg) {
    var key = $ee17f9739c3013b3$var$_toPrimitive(arg, "string");
    return $ee17f9739c3013b3$var$_typeof(key) === "symbol" ? key : String(key);
}
function $ee17f9739c3013b3$var$_toPrimitive(input, hint) {
    if ($ee17f9739c3013b3$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($ee17f9739c3013b3$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $ee17f9739c3013b3$var$withUsage = (0, $del55.createDocumentationMessageGenerator)({
    name: "hits",
    connector: true
});
var $ee17f9739c3013b3$export$2e2bcd8739ae039 = function connectHits(renderFn) {
    var unmountFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $iNPz2.noop);
    (0, $2TWNj.checkRendering)(renderFn, $ee17f9739c3013b3$var$withUsage());
    return function(widgetParams) {
        var _ref = widgetParams || {}, _ref$escapeHTML = _ref.escapeHTML, escapeHTML = _ref$escapeHTML === void 0 ? true : _ref$escapeHTML, _ref$transformItems = _ref.transformItems, transformItems = _ref$transformItems === void 0 ? function(items) {
            return items;
        } : _ref$transformItems;
        var sendEvent;
        var bindEvent;
        return {
            $$type: "ais.hits",
            init: function init(initOptions) {
                renderFn($ee17f9739c3013b3$var$_objectSpread($ee17f9739c3013b3$var$_objectSpread({}, this.getWidgetRenderState(initOptions)), {}, {
                    instantSearchInstance: initOptions.instantSearchInstance
                }), true);
            },
            render: function render(renderOptions) {
                var renderState = this.getWidgetRenderState(renderOptions);
                renderFn($ee17f9739c3013b3$var$_objectSpread($ee17f9739c3013b3$var$_objectSpread({}, renderState), {}, {
                    instantSearchInstance: renderOptions.instantSearchInstance
                }), false);
                renderState.sendEvent("view:internal", renderState.items);
            },
            getRenderState: function getRenderState(renderState, renderOptions) {
                return $ee17f9739c3013b3$var$_objectSpread($ee17f9739c3013b3$var$_objectSpread({}, renderState), {}, {
                    hits: this.getWidgetRenderState(renderOptions)
                });
            },
            getWidgetRenderState: function getWidgetRenderState(_ref2) {
                var _results$renderingCon, _results$renderingCon2, _results$renderingCon3;
                var results = _ref2.results, helper = _ref2.helper, instantSearchInstance = _ref2.instantSearchInstance;
                if (!sendEvent) sendEvent = (0, $7TXRe.createSendEventForHits)({
                    instantSearchInstance: instantSearchInstance,
                    getIndex: function getIndex() {
                        return helper.getIndex();
                    },
                    widgetType: this.$$type
                });
                if (!bindEvent) bindEvent = (0, $7TXRe.createBindEventForHits)({
                    getIndex: function getIndex() {
                        return helper.getIndex();
                    },
                    widgetType: this.$$type,
                    instantSearchInstance: instantSearchInstance
                });
                if (!results) return {
                    hits: [],
                    items: [],
                    results: undefined,
                    banner: undefined,
                    sendEvent: sendEvent,
                    bindEvent: bindEvent,
                    widgetParams: widgetParams
                };
                if (escapeHTML && results.hits.length > 0) results.hits = (0, $6ZYbr.escapeHits)(results.hits);
                var hitsWithAbsolutePosition = (0, $gIg1f.addAbsolutePosition)(results.hits, results.page, results.hitsPerPage);
                var hitsWithAbsolutePositionAndQueryID = (0, $luHzu.addQueryID)(hitsWithAbsolutePosition, results.queryID);
                var items = transformItems(hitsWithAbsolutePositionAndQueryID, {
                    results: results
                });
                var banner = (_results$renderingCon = results.renderingContent) === null || _results$renderingCon === void 0 ? void 0 : (_results$renderingCon2 = _results$renderingCon.widgets) === null || _results$renderingCon2 === void 0 ? void 0 : (_results$renderingCon3 = _results$renderingCon2.banners) === null || _results$renderingCon3 === void 0 ? void 0 : _results$renderingCon3[0];
                return {
                    hits: items,
                    items: items,
                    results: results,
                    banner: banner,
                    sendEvent: sendEvent,
                    bindEvent: bindEvent,
                    widgetParams: widgetParams
                };
            },
            dispose: function dispose(_ref3) {
                var state = _ref3.state;
                unmountFn();
                if (!escapeHTML) return state;
                return state.setQueryParameters(Object.keys((0, $6ZYbr.TAG_PLACEHOLDER)).reduce(function(acc, key) {
                    return $ee17f9739c3013b3$var$_objectSpread($ee17f9739c3013b3$var$_objectSpread({}, acc), {}, $ee17f9739c3013b3$var$_defineProperty({}, key, undefined));
                }, {}));
            },
            getWidgetSearchParameters: function getWidgetSearchParameters(state, _uiState) {
                if (!escapeHTML) return state;
                // @MAJOR: set this globally, not in the Hits widget to allow Hits to be conditionally used
                return state.setQueryParameters((0, $6ZYbr.TAG_PLACEHOLDER));
            }
        };
    };
};

});
parcelRegister("gIg1f", function(module, exports) {

$parcel$export(module.exports, "addAbsolutePosition", () => $c2ad2e756459ed3f$export$33d742d8ee5a4609);
function $c2ad2e756459ed3f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $c2ad2e756459ed3f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $c2ad2e756459ed3f$var$_typeof(obj);
}
function $c2ad2e756459ed3f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c2ad2e756459ed3f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $c2ad2e756459ed3f$var$ownKeys(Object(source), !0).forEach(function(key) {
            $c2ad2e756459ed3f$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $c2ad2e756459ed3f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c2ad2e756459ed3f$var$_defineProperty(obj, key, value) {
    key = $c2ad2e756459ed3f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c2ad2e756459ed3f$var$_toPropertyKey(arg) {
    var key = $c2ad2e756459ed3f$var$_toPrimitive(arg, "string");
    return $c2ad2e756459ed3f$var$_typeof(key) === "symbol" ? key : String(key);
}
function $c2ad2e756459ed3f$var$_toPrimitive(input, hint) {
    if ($c2ad2e756459ed3f$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($c2ad2e756459ed3f$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $c2ad2e756459ed3f$export$33d742d8ee5a4609(hits, page, hitsPerPage) {
    return hits.map(function(hit, idx) {
        return $c2ad2e756459ed3f$var$_objectSpread($c2ad2e756459ed3f$var$_objectSpread({}, hit), {}, {
            __position: hitsPerPage * page + idx + 1
        });
    });
}

});

parcelRegister("luHzu", function(module, exports) {

$parcel$export(module.exports, "addQueryID", () => $fa5e32afbc529f54$export$b8f834386ea30952);
function $fa5e32afbc529f54$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $fa5e32afbc529f54$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $fa5e32afbc529f54$var$_typeof(obj);
}
function $fa5e32afbc529f54$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $fa5e32afbc529f54$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $fa5e32afbc529f54$var$ownKeys(Object(source), !0).forEach(function(key) {
            $fa5e32afbc529f54$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $fa5e32afbc529f54$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $fa5e32afbc529f54$var$_defineProperty(obj, key, value) {
    key = $fa5e32afbc529f54$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $fa5e32afbc529f54$var$_toPropertyKey(arg) {
    var key = $fa5e32afbc529f54$var$_toPrimitive(arg, "string");
    return $fa5e32afbc529f54$var$_typeof(key) === "symbol" ? key : String(key);
}
function $fa5e32afbc529f54$var$_toPrimitive(input, hint) {
    if ($fa5e32afbc529f54$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($fa5e32afbc529f54$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $fa5e32afbc529f54$export$b8f834386ea30952(hits, queryID) {
    if (!queryID) return hits;
    return hits.map(function(hit) {
        return $fa5e32afbc529f54$var$_objectSpread($fa5e32afbc529f54$var$_objectSpread({}, hit), {}, {
            __queryID: queryID
        });
    });
}

});

parcelRegister("7TXRe", function(module, exports) {

$parcel$export(module.exports, "createSendEventForHits", () => $5c0c19f228d61d58$export$4139f3a7130239e3);
$parcel$export(module.exports, "createBindEventForHits", () => $5c0c19f228d61d58$export$5a3d9973824d9b76);

var $hPGc5 = parcelRequire("hPGc5");
function $5c0c19f228d61d58$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5c0c19f228d61d58$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $5c0c19f228d61d58$var$ownKeys(Object(source), !0).forEach(function(key) {
            $5c0c19f228d61d58$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $5c0c19f228d61d58$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5c0c19f228d61d58$var$_defineProperty(obj, key, value) {
    key = $5c0c19f228d61d58$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5c0c19f228d61d58$var$_toPropertyKey(arg) {
    var key = $5c0c19f228d61d58$var$_toPrimitive(arg, "string");
    return $5c0c19f228d61d58$var$_typeof(key) === "symbol" ? key : String(key);
}
function $5c0c19f228d61d58$var$_toPrimitive(input, hint) {
    if ($5c0c19f228d61d58$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($5c0c19f228d61d58$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $5c0c19f228d61d58$var$_slicedToArray(arr, i) {
    return $5c0c19f228d61d58$var$_arrayWithHoles(arr) || $5c0c19f228d61d58$var$_iterableToArrayLimit(arr, i) || $5c0c19f228d61d58$var$_unsupportedIterableToArray(arr, i) || $5c0c19f228d61d58$var$_nonIterableRest();
}
function $5c0c19f228d61d58$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5c0c19f228d61d58$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5c0c19f228d61d58$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5c0c19f228d61d58$var$_arrayLikeToArray(o, minLen);
}
function $5c0c19f228d61d58$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $5c0c19f228d61d58$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $5c0c19f228d61d58$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $5c0c19f228d61d58$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $5c0c19f228d61d58$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $5c0c19f228d61d58$var$_typeof(obj);
}
function $5c0c19f228d61d58$var$chunk(arr) {
    var chunkSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
    var chunks = [];
    for(var i = 0; i < Math.ceil(arr.length / chunkSize); i++)chunks.push(arr.slice(i * chunkSize, (i + 1) * chunkSize));
    return chunks;
}
function $5c0c19f228d61d58$export$2f82a8f6391c6db9(_ref) {
    var getIndex = _ref.getIndex, widgetType = _ref.widgetType, methodName = _ref.methodName, args = _ref.args, instantSearchInstance = _ref.instantSearchInstance;
    // when there's only one argument, that means it's custom
    if (args.length === 1 && $5c0c19f228d61d58$var$_typeof(args[0]) === "object") return [
        args[0]
    ];
    var _args$0$split = args[0].split(":"), _args$0$split2 = $5c0c19f228d61d58$var$_slicedToArray(_args$0$split, 2), eventType = _args$0$split2[0], eventModifier = _args$0$split2[1];
    var hits = args[1];
    var eventName = args[2];
    var additionalData = args[3] || {};
    if (!hits) return [];
    if ((eventType === "click" || eventType === "conversion") && !eventName) return [];
    var hitsArray = Array.isArray(hits) ? hits : [
        hits
    ];
    if (hitsArray.length === 0) return [];
    var queryID = hitsArray[0].__queryID;
    var hitsChunks = $5c0c19f228d61d58$var$chunk(hitsArray);
    var objectIDsByChunk = hitsChunks.map(function(batch) {
        return batch.map(function(hit) {
            return hit.objectID;
        });
    });
    var positionsByChunk = hitsChunks.map(function(batch) {
        return batch.map(function(hit) {
            return hit.__position;
        });
    });
    if (eventType === "view") {
        if (instantSearchInstance.status !== "idle") return [];
        return hitsChunks.map(function(batch, i) {
            return {
                insightsMethod: "viewedObjectIDs",
                widgetType: widgetType,
                eventType: eventType,
                payload: $5c0c19f228d61d58$var$_objectSpread({
                    eventName: eventName || "Hits Viewed",
                    index: getIndex(),
                    objectIDs: objectIDsByChunk[i]
                }, additionalData),
                hits: batch,
                eventModifier: eventModifier
            };
        });
    } else if (eventType === "click") return hitsChunks.map(function(batch, i) {
        return {
            insightsMethod: "clickedObjectIDsAfterSearch",
            widgetType: widgetType,
            eventType: eventType,
            payload: $5c0c19f228d61d58$var$_objectSpread({
                eventName: eventName || "Hit Clicked",
                index: getIndex(),
                queryID: queryID,
                objectIDs: objectIDsByChunk[i],
                positions: positionsByChunk[i]
            }, additionalData),
            hits: batch,
            eventModifier: eventModifier
        };
    });
    else if (eventType === "conversion") return hitsChunks.map(function(batch, i) {
        return {
            insightsMethod: "convertedObjectIDsAfterSearch",
            widgetType: widgetType,
            eventType: eventType,
            payload: $5c0c19f228d61d58$var$_objectSpread({
                eventName: eventName || "Hit Converted",
                index: getIndex(),
                queryID: queryID,
                objectIDs: objectIDsByChunk[i]
            }, additionalData),
            hits: batch,
            eventModifier: eventModifier
        };
    });
    else return [];
}
function $5c0c19f228d61d58$export$4139f3a7130239e3(_ref2) {
    var instantSearchInstance = _ref2.instantSearchInstance, getIndex = _ref2.getIndex, widgetType = _ref2.widgetType;
    var sentEvents = {};
    var timer = undefined;
    var sendEventForHits = function sendEventForHits() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var payloads = $5c0c19f228d61d58$export$2f82a8f6391c6db9({
            widgetType: widgetType,
            getIndex: getIndex,
            methodName: "sendEvent",
            args: args,
            instantSearchInstance: instantSearchInstance
        });
        payloads.forEach(function(payload) {
            if (payload.eventType === "click" && payload.eventModifier === "internal" && sentEvents[payload.eventType]) return;
            sentEvents[payload.eventType] = true;
            instantSearchInstance.sendEventToInsights(payload);
        });
        clearTimeout(timer);
        timer = setTimeout(function() {
            sentEvents = {};
        }, 0);
    };
    return sendEventForHits;
}
function $5c0c19f228d61d58$export$5a3d9973824d9b76(_ref3) {
    var getIndex = _ref3.getIndex, widgetType = _ref3.widgetType, instantSearchInstance = _ref3.instantSearchInstance;
    var bindEventForHits = function bindEventForHits() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var payloads = $5c0c19f228d61d58$export$2f82a8f6391c6db9({
            widgetType: widgetType,
            getIndex: getIndex,
            methodName: "bindEvent",
            args: args,
            instantSearchInstance: instantSearchInstance
        });
        return payloads.length ? "data-insights-event=".concat((0, $hPGc5.serializePayload)(payloads)) : "";
    };
    return bindEventForHits;
}

});




//# sourceMappingURL=navigation-geo.3209fe58.js.map
